!(function (e) {
  var t = {};

  function n(i) {
    if (t[i]) return t[i].exports;
    var r = (t[i] = {
      i: i,
      l: !1,
      exports: {},
    });
    return e[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
  }
  (n.m = e),
    (n.c = t),
    (n.d = function (e, t, i) {
      n.o(e, t) ||
        Object.defineProperty(e, t, {
          enumerable: !0,
          get: i,
        });
    }),
    (n.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module",
        }),
        Object.defineProperty(e, "__esModule", {
          value: !0,
        });
    }),
    (n.t = function (e, t) {
      if ((1 & t && (e = n(e)), 8 & t)) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var i = Object.create(null);
      if (
        (n.r(i),
        Object.defineProperty(i, "default", {
          enumerable: !0,
          value: e,
        }),
        2 & t && "string" != typeof e)
      )
        for (var r in e)
          n.d(
            i,
            r,
            function (t) {
              return e[t];
            }.bind(null, r)
          );
      return i;
    }),
    (n.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return n.d(t, "a", t), t;
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.p = ""),
    n((n.s = 14));
})([
  function (e, t, n) {
    var i;
    /*!
     * jQuery JavaScript Library v3.6.0
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright OpenJS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2021-03-02T17:08Z
     */
    !(function (t, n) {
      "use strict";
      "object" == typeof e.exports
        ? (e.exports = t.document
            ? n(t, !0)
            : function (e) {
                if (!e.document)
                  throw new Error("jQuery requires a window with a document");
                return n(e);
              })
        : n(t);
    })("undefined" != typeof window ? window : this, function (n, r) {
      "use strict";
      var s = [],
        a = Object.getPrototypeOf,
        o = s.slice,
        l = s.flat
          ? function (e) {
              return s.flat.call(e);
            }
          : function (e) {
              return s.concat.apply([], e);
            },
        c = s.push,
        u = s.indexOf,
        d = {},
        p = d.toString,
        f = d.hasOwnProperty,
        h = f.toString,
        m = h.call(Object),
        g = {},
        v = function (e) {
          return (
            "function" == typeof e &&
            "number" != typeof e.nodeType &&
            "function" != typeof e.item
          );
        },
        y = function (e) {
          return null != e && e === e.window;
        },
        b = n.document,
        _ = {
          type: !0,
          src: !0,
          nonce: !0,
          noModule: !0,
        };

      function w(e, t, n) {
        var i,
          r,
          s = (n = n || b).createElement("script");
        if (((s.text = e), t))
          for (i in _)
            (r = t[i] || (t.getAttribute && t.getAttribute(i))) &&
              s.setAttribute(i, r);
        n.head.appendChild(s).parentNode.removeChild(s);
      }

      function x(e) {
        return null == e
          ? e + ""
          : "object" == typeof e || "function" == typeof e
          ? d[p.call(e)] || "object"
          : typeof e;
      }
      var C = function (e, t) {
        return new C.fn.init(e, t);
      };

      function T(e) {
        var t = !!e && "length" in e && e.length,
          n = x(e);
        return (
          !v(e) &&
          !y(e) &&
          ("array" === n ||
            0 === t ||
            ("number" == typeof t && t > 0 && t - 1 in e))
        );
      }
      (C.fn = C.prototype =
        {
          jquery: "3.6.0",
          constructor: C,
          length: 0,
          toArray: function () {
            return o.call(this);
          },
          get: function (e) {
            return null == e
              ? o.call(this)
              : e < 0
              ? this[e + this.length]
              : this[e];
          },
          pushStack: function (e) {
            var t = C.merge(this.constructor(), e);
            return (t.prevObject = this), t;
          },
          each: function (e) {
            return C.each(this, e);
          },
          map: function (e) {
            return this.pushStack(
              C.map(this, function (t, n) {
                return e.call(t, n, t);
              })
            );
          },
          slice: function () {
            return this.pushStack(o.apply(this, arguments));
          },
          first: function () {
            return this.eq(0);
          },
          last: function () {
            return this.eq(-1);
          },
          even: function () {
            return this.pushStack(
              C.grep(this, function (e, t) {
                return (t + 1) % 2;
              })
            );
          },
          odd: function () {
            return this.pushStack(
              C.grep(this, function (e, t) {
                return t % 2;
              })
            );
          },
          eq: function (e) {
            var t = this.length,
              n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
          },
          end: function () {
            return this.prevObject || this.constructor();
          },
          push: c,
          sort: s.sort,
          splice: s.splice,
        }),
        (C.extend = C.fn.extend =
          function () {
            var e,
              t,
              n,
              i,
              r,
              s,
              a = arguments[0] || {},
              o = 1,
              l = arguments.length,
              c = !1;
            for (
              "boolean" == typeof a && ((c = a), (a = arguments[o] || {}), o++),
                "object" == typeof a || v(a) || (a = {}),
                o === l && ((a = this), o--);
              o < l;
              o++
            )
              if (null != (e = arguments[o]))
                for (t in e)
                  (i = e[t]),
                    "__proto__" !== t &&
                      a !== i &&
                      (c && i && (C.isPlainObject(i) || (r = Array.isArray(i)))
                        ? ((n = a[t]),
                          (s =
                            r && !Array.isArray(n)
                              ? []
                              : r || C.isPlainObject(n)
                              ? n
                              : {}),
                          (r = !1),
                          (a[t] = C.extend(c, s, i)))
                        : void 0 !== i && (a[t] = i));
            return a;
          }),
        C.extend({
          expando: "jQuery" + ("3.6.0" + Math.random()).replace(/\D/g, ""),
          isReady: !0,
          error: function (e) {
            throw new Error(e);
          },
          noop: function () {},
          isPlainObject: function (e) {
            var t, n;
            return (
              !(!e || "[object Object]" !== p.call(e)) &&
              (!(t = a(e)) ||
                ("function" ==
                  typeof (n = f.call(t, "constructor") && t.constructor) &&
                  h.call(n) === m))
            );
          },
          isEmptyObject: function (e) {
            var t;
            for (t in e) return !1;
            return !0;
          },
          globalEval: function (e, t, n) {
            w(
              e,
              {
                nonce: t && t.nonce,
              },
              n
            );
          },
          each: function (e, t) {
            var n,
              i = 0;
            if (T(e))
              for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
            else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
            return e;
          },
          makeArray: function (e, t) {
            var n = t || [];
            return (
              null != e &&
                (T(Object(e))
                  ? C.merge(n, "string" == typeof e ? [e] : e)
                  : c.call(n, e)),
              n
            );
          },
          inArray: function (e, t, n) {
            return null == t ? -1 : u.call(t, e, n);
          },
          merge: function (e, t) {
            for (var n = +t.length, i = 0, r = e.length; i < n; i++)
              e[r++] = t[i];
            return (e.length = r), e;
          },
          grep: function (e, t, n) {
            for (var i = [], r = 0, s = e.length, a = !n; r < s; r++)
              !t(e[r], r) !== a && i.push(e[r]);
            return i;
          },
          map: function (e, t, n) {
            var i,
              r,
              s = 0,
              a = [];
            if (T(e))
              for (i = e.length; s < i; s++)
                null != (r = t(e[s], s, n)) && a.push(r);
            else for (s in e) null != (r = t(e[s], s, n)) && a.push(r);
            return l(a);
          },
          guid: 1,
          support: g,
        }),
        "function" == typeof Symbol &&
          (C.fn[Symbol.iterator] = s[Symbol.iterator]),
        C.each(
          "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
            " "
          ),
          function (e, t) {
            d["[object " + t + "]"] = t.toLowerCase();
          }
        );
      var k =
        /*!
         * Sizzle CSS Selector Engine v2.3.6
         * https://sizzlejs.com/
         *
         * Copyright JS Foundation and other contributors
         * Released under the MIT license
         * https://js.foundation/
         *
         * Date: 2021-02-16
         */
        (function (e) {
          var t,
            n,
            i,
            r,
            s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g,
            v,
            y,
            b,
            _ = "sizzle" + 1 * new Date(),
            w = e.document,
            x = 0,
            C = 0,
            T = le(),
            k = le(),
            S = le(),
            E = le(),
            O = function (e, t) {
              return e === t && (d = !0), 0;
            },
            P = {}.hasOwnProperty,
            M = [],
            A = M.pop,
            D = M.push,
            I = M.push,
            L = M.slice,
            j = function (e, t) {
              for (var n = 0, i = e.length; n < i; n++)
                if (e[n] === t) return n;
              return -1;
            },
            N =
              "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            B = "[\\x20\\t\\r\\n\\f]",
            $ =
              "(?:\\\\[\\da-fA-F]{1,6}" +
              B +
              "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            z =
              "\\[" +
              B +
              "*(" +
              $ +
              ")(?:" +
              B +
              "*([*^$|!~]?=)" +
              B +
              "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
              $ +
              "))|)" +
              B +
              "*\\]",
            R =
              ":(" +
              $ +
              ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
              z +
              ")*)|.*)\\)|)",
            H = new RegExp(B + "+", "g"),
            F = new RegExp(
              "^" + B + "+|((?:^|[^\\\\])(?:\\\\.)*)" + B + "+$",
              "g"
            ),
            q = new RegExp("^" + B + "*," + B + "*"),
            W = new RegExp("^" + B + "*([>+~]|" + B + ")" + B + "*"),
            V = new RegExp(B + "|>"),
            G = new RegExp(R),
            X = new RegExp("^" + $ + "$"),
            Y = {
              ID: new RegExp("^#(" + $ + ")"),
              CLASS: new RegExp("^\\.(" + $ + ")"),
              TAG: new RegExp("^(" + $ + "|[*])"),
              ATTR: new RegExp("^" + z),
              PSEUDO: new RegExp("^" + R),
              CHILD: new RegExp(
                "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                  B +
                  "*(even|odd|(([+-]|)(\\d*)n|)" +
                  B +
                  "*(?:([+-]|)" +
                  B +
                  "*(\\d+)|))" +
                  B +
                  "*\\)|)",
                "i"
              ),
              bool: new RegExp("^(?:" + N + ")$", "i"),
              needsContext: new RegExp(
                "^" +
                  B +
                  "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                  B +
                  "*((?:-\\d)?\\d*)" +
                  B +
                  "*\\)|)(?=[^-]|$)",
                "i"
              ),
            },
            U = /HTML$/i,
            Q = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            K = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp(
              "\\\\[\\da-fA-F]{1,6}" + B + "?|\\\\([^\\r\\n\\f])",
              "g"
            ),
            ne = function (e, t) {
              var n = "0x" + e.slice(1) - 65536;
              return (
                t ||
                (n < 0
                  ? String.fromCharCode(n + 65536)
                  : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
              );
            },
            ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            re = function (e, t) {
              return t
                ? "\0" === e
                  ? "�"
                  : e.slice(0, -1) +
                    "\\" +
                    e.charCodeAt(e.length - 1).toString(16) +
                    " "
                : "\\" + e;
            },
            se = function () {
              p();
            },
            ae = _e(
              function (e) {
                return (
                  !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                );
              },
              {
                dir: "parentNode",
                next: "legend",
              }
            );
          try {
            I.apply((M = L.call(w.childNodes)), w.childNodes),
              M[w.childNodes.length].nodeType;
          } catch (e) {
            I = {
              apply: M.length
                ? function (e, t) {
                    D.apply(e, L.call(t));
                  }
                : function (e, t) {
                    for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                    e.length = n - 1;
                  },
            };
          }

          function oe(e, t, i, r) {
            var s,
              o,
              c,
              u,
              d,
              h,
              v,
              y = t && t.ownerDocument,
              w = t ? t.nodeType : 9;
            if (
              ((i = i || []),
              "string" != typeof e || !e || (1 !== w && 9 !== w && 11 !== w))
            )
              return i;
            if (!r && (p(t), (t = t || f), m)) {
              if (11 !== w && (d = Z.exec(e)))
                if ((s = d[1])) {
                  if (9 === w) {
                    if (!(c = t.getElementById(s))) return i;
                    if (c.id === s) return i.push(c), i;
                  } else if (
                    y &&
                    (c = y.getElementById(s)) &&
                    b(t, c) &&
                    c.id === s
                  )
                    return i.push(c), i;
                } else {
                  if (d[2]) return I.apply(i, t.getElementsByTagName(e)), i;
                  if (
                    (s = d[3]) &&
                    n.getElementsByClassName &&
                    t.getElementsByClassName
                  )
                    return I.apply(i, t.getElementsByClassName(s)), i;
                }
              if (
                n.qsa &&
                !E[e + " "] &&
                (!g || !g.test(e)) &&
                (1 !== w || "object" !== t.nodeName.toLowerCase())
              ) {
                if (((v = e), (y = t), 1 === w && (V.test(e) || W.test(e)))) {
                  for (
                    ((y = (ee.test(e) && ve(t.parentNode)) || t) === t &&
                      n.scope) ||
                      ((u = t.getAttribute("id"))
                        ? (u = u.replace(ie, re))
                        : t.setAttribute("id", (u = _))),
                      o = (h = a(e)).length;
                    o--;

                  )
                    h[o] = (u ? "#" + u : ":scope") + " " + be(h[o]);
                  v = h.join(",");
                }
                try {
                  return I.apply(i, y.querySelectorAll(v)), i;
                } catch (t) {
                  E(e, !0);
                } finally {
                  u === _ && t.removeAttribute("id");
                }
              }
            }
            return l(e.replace(F, "$1"), t, i, r);
          }

          function le() {
            var e = [];
            return function t(n, r) {
              return (
                e.push(n + " ") > i.cacheLength && delete t[e.shift()],
                (t[n + " "] = r)
              );
            };
          }

          function ce(e) {
            return (e[_] = !0), e;
          }

          function ue(e) {
            var t = f.createElement("fieldset");
            try {
              return !!e(t);
            } catch (e) {
              return !1;
            } finally {
              t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
          }

          function de(e, t) {
            for (var n = e.split("|"), r = n.length; r--; )
              i.attrHandle[n[r]] = t;
          }

          function pe(e, t) {
            var n = t && e,
              i =
                n &&
                1 === e.nodeType &&
                1 === t.nodeType &&
                e.sourceIndex - t.sourceIndex;
            if (i) return i;
            if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
            return e ? 1 : -1;
          }

          function fe(e) {
            return function (t) {
              return "input" === t.nodeName.toLowerCase() && t.type === e;
            };
          }

          function he(e) {
            return function (t) {
              var n = t.nodeName.toLowerCase();
              return ("input" === n || "button" === n) && t.type === e;
            };
          }

          function me(e) {
            return function (t) {
              return "form" in t
                ? t.parentNode && !1 === t.disabled
                  ? "label" in t
                    ? "label" in t.parentNode
                      ? t.parentNode.disabled === e
                      : t.disabled === e
                    : t.isDisabled === e || (t.isDisabled !== !e && ae(t) === e)
                  : t.disabled === e
                : "label" in t && t.disabled === e;
            };
          }

          function ge(e) {
            return ce(function (t) {
              return (
                (t = +t),
                ce(function (n, i) {
                  for (var r, s = e([], n.length, t), a = s.length; a--; )
                    n[(r = s[a])] && (n[r] = !(i[r] = n[r]));
                })
              );
            });
          }

          function ve(e) {
            return e && void 0 !== e.getElementsByTagName && e;
          }
          for (t in ((n = oe.support = {}),
          (s = oe.isXML =
            function (e) {
              var t = e && e.namespaceURI,
                n = e && (e.ownerDocument || e).documentElement;
              return !U.test(t || (n && n.nodeName) || "HTML");
            }),
          (p = oe.setDocument =
            function (e) {
              var t,
                r,
                a = e ? e.ownerDocument || e : w;
              return a != f && 9 === a.nodeType && a.documentElement
                ? ((h = (f = a).documentElement),
                  (m = !s(f)),
                  w != f &&
                    (r = f.defaultView) &&
                    r.top !== r &&
                    (r.addEventListener
                      ? r.addEventListener("unload", se, !1)
                      : r.attachEvent && r.attachEvent("onunload", se)),
                  (n.scope = ue(function (e) {
                    return (
                      h.appendChild(e).appendChild(f.createElement("div")),
                      void 0 !== e.querySelectorAll &&
                        !e.querySelectorAll(":scope fieldset div").length
                    );
                  })),
                  (n.attributes = ue(function (e) {
                    return (e.className = "i"), !e.getAttribute("className");
                  })),
                  (n.getElementsByTagName = ue(function (e) {
                    return (
                      e.appendChild(f.createComment("")),
                      !e.getElementsByTagName("*").length
                    );
                  })),
                  (n.getElementsByClassName = K.test(f.getElementsByClassName)),
                  (n.getById = ue(function (e) {
                    return (
                      (h.appendChild(e).id = _),
                      !f.getElementsByName || !f.getElementsByName(_).length
                    );
                  })),
                  n.getById
                    ? ((i.filter.ID = function (e) {
                        var t = e.replace(te, ne);
                        return function (e) {
                          return e.getAttribute("id") === t;
                        };
                      }),
                      (i.find.ID = function (e, t) {
                        if (void 0 !== t.getElementById && m) {
                          var n = t.getElementById(e);
                          return n ? [n] : [];
                        }
                      }))
                    : ((i.filter.ID = function (e) {
                        var t = e.replace(te, ne);
                        return function (e) {
                          var n =
                            void 0 !== e.getAttributeNode &&
                            e.getAttributeNode("id");
                          return n && n.value === t;
                        };
                      }),
                      (i.find.ID = function (e, t) {
                        if (void 0 !== t.getElementById && m) {
                          var n,
                            i,
                            r,
                            s = t.getElementById(e);
                          if (s) {
                            if ((n = s.getAttributeNode("id")) && n.value === e)
                              return [s];
                            for (
                              r = t.getElementsByName(e), i = 0;
                              (s = r[i++]);

                            )
                              if (
                                (n = s.getAttributeNode("id")) &&
                                n.value === e
                              )
                                return [s];
                          }
                          return [];
                        }
                      })),
                  (i.find.TAG = n.getElementsByTagName
                    ? function (e, t) {
                        return void 0 !== t.getElementsByTagName
                          ? t.getElementsByTagName(e)
                          : n.qsa
                          ? t.querySelectorAll(e)
                          : void 0;
                      }
                    : function (e, t) {
                        var n,
                          i = [],
                          r = 0,
                          s = t.getElementsByTagName(e);
                        if ("*" === e) {
                          for (; (n = s[r++]); ) 1 === n.nodeType && i.push(n);
                          return i;
                        }
                        return s;
                      }),
                  (i.find.CLASS =
                    n.getElementsByClassName &&
                    function (e, t) {
                      if (void 0 !== t.getElementsByClassName && m)
                        return t.getElementsByClassName(e);
                    }),
                  (v = []),
                  (g = []),
                  (n.qsa = K.test(f.querySelectorAll)) &&
                    (ue(function (e) {
                      var t;
                      (h.appendChild(e).innerHTML =
                        "<a id='" +
                        _ +
                        "'></a><select id='" +
                        _ +
                        "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                        e.querySelectorAll("[msallowcapture^='']").length &&
                          g.push("[*^$]=" + B + "*(?:''|\"\")"),
                        e.querySelectorAll("[selected]").length ||
                          g.push("\\[" + B + "*(?:value|" + N + ")"),
                        e.querySelectorAll("[id~=" + _ + "-]").length ||
                          g.push("~="),
                        (t = f.createElement("input")).setAttribute("name", ""),
                        e.appendChild(t),
                        e.querySelectorAll("[name='']").length ||
                          g.push(
                            "\\[" + B + "*name" + B + "*=" + B + "*(?:''|\"\")"
                          ),
                        e.querySelectorAll(":checked").length ||
                          g.push(":checked"),
                        e.querySelectorAll("a#" + _ + "+*").length ||
                          g.push(".#.+[+~]"),
                        e.querySelectorAll("\\\f"),
                        g.push("[\\r\\n\\f]");
                    }),
                    ue(function (e) {
                      e.innerHTML =
                        "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                      var t = f.createElement("input");
                      t.setAttribute("type", "hidden"),
                        e.appendChild(t).setAttribute("name", "D"),
                        e.querySelectorAll("[name=d]").length &&
                          g.push("name" + B + "*[*^$|!~]?="),
                        2 !== e.querySelectorAll(":enabled").length &&
                          g.push(":enabled", ":disabled"),
                        (h.appendChild(e).disabled = !0),
                        2 !== e.querySelectorAll(":disabled").length &&
                          g.push(":enabled", ":disabled"),
                        e.querySelectorAll("*,:x"),
                        g.push(",.*:");
                    })),
                  (n.matchesSelector = K.test(
                    (y =
                      h.matches ||
                      h.webkitMatchesSelector ||
                      h.mozMatchesSelector ||
                      h.oMatchesSelector ||
                      h.msMatchesSelector)
                  )) &&
                    ue(function (e) {
                      (n.disconnectedMatch = y.call(e, "*")),
                        y.call(e, "[s!='']:x"),
                        v.push("!=", R);
                    }),
                  (g = g.length && new RegExp(g.join("|"))),
                  (v = v.length && new RegExp(v.join("|"))),
                  (t = K.test(h.compareDocumentPosition)),
                  (b =
                    t || K.test(h.contains)
                      ? function (e, t) {
                          var n = 9 === e.nodeType ? e.documentElement : e,
                            i = t && t.parentNode;
                          return (
                            e === i ||
                            !(
                              !i ||
                              1 !== i.nodeType ||
                              !(n.contains
                                ? n.contains(i)
                                : e.compareDocumentPosition &&
                                  16 & e.compareDocumentPosition(i))
                            )
                          );
                        }
                      : function (e, t) {
                          if (t)
                            for (; (t = t.parentNode); ) if (t === e) return !0;
                          return !1;
                        }),
                  (O = t
                    ? function (e, t) {
                        if (e === t) return (d = !0), 0;
                        var i =
                          !e.compareDocumentPosition -
                          !t.compareDocumentPosition;
                        return (
                          i ||
                          (1 &
                            (i =
                              (e.ownerDocument || e) == (t.ownerDocument || t)
                                ? e.compareDocumentPosition(t)
                                : 1) ||
                          (!n.sortDetached &&
                            t.compareDocumentPosition(e) === i)
                            ? e == f || (e.ownerDocument == w && b(w, e))
                              ? -1
                              : t == f || (t.ownerDocument == w && b(w, t))
                              ? 1
                              : u
                              ? j(u, e) - j(u, t)
                              : 0
                            : 4 & i
                            ? -1
                            : 1)
                        );
                      }
                    : function (e, t) {
                        if (e === t) return (d = !0), 0;
                        var n,
                          i = 0,
                          r = e.parentNode,
                          s = t.parentNode,
                          a = [e],
                          o = [t];
                        if (!r || !s)
                          return e == f
                            ? -1
                            : t == f
                            ? 1
                            : r
                            ? -1
                            : s
                            ? 1
                            : u
                            ? j(u, e) - j(u, t)
                            : 0;
                        if (r === s) return pe(e, t);
                        for (n = e; (n = n.parentNode); ) a.unshift(n);
                        for (n = t; (n = n.parentNode); ) o.unshift(n);
                        for (; a[i] === o[i]; ) i++;
                        return i
                          ? pe(a[i], o[i])
                          : a[i] == w
                          ? -1
                          : o[i] == w
                          ? 1
                          : 0;
                      }),
                  f)
                : f;
            }),
          (oe.matches = function (e, t) {
            return oe(e, null, null, t);
          }),
          (oe.matchesSelector = function (e, t) {
            if (
              (p(e),
              n.matchesSelector &&
                m &&
                !E[t + " "] &&
                (!v || !v.test(t)) &&
                (!g || !g.test(t)))
            )
              try {
                var i = y.call(e, t);
                if (
                  i ||
                  n.disconnectedMatch ||
                  (e.document && 11 !== e.document.nodeType)
                )
                  return i;
              } catch (e) {
                E(t, !0);
              }
            return oe(t, f, null, [e]).length > 0;
          }),
          (oe.contains = function (e, t) {
            return (e.ownerDocument || e) != f && p(e), b(e, t);
          }),
          (oe.attr = function (e, t) {
            (e.ownerDocument || e) != f && p(e);
            var r = i.attrHandle[t.toLowerCase()],
              s =
                r && P.call(i.attrHandle, t.toLowerCase())
                  ? r(e, t, !m)
                  : void 0;
            return void 0 !== s
              ? s
              : n.attributes || !m
              ? e.getAttribute(t)
              : (s = e.getAttributeNode(t)) && s.specified
              ? s.value
              : null;
          }),
          (oe.escape = function (e) {
            return (e + "").replace(ie, re);
          }),
          (oe.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
          }),
          (oe.uniqueSort = function (e) {
            var t,
              i = [],
              r = 0,
              s = 0;
            if (
              ((d = !n.detectDuplicates),
              (u = !n.sortStable && e.slice(0)),
              e.sort(O),
              d)
            ) {
              for (; (t = e[s++]); ) t === e[s] && (r = i.push(s));
              for (; r--; ) e.splice(i[r], 1);
            }
            return (u = null), e;
          }),
          (r = oe.getText =
            function (e) {
              var t,
                n = "",
                i = 0,
                s = e.nodeType;
              if (s) {
                if (1 === s || 9 === s || 11 === s) {
                  if ("string" == typeof e.textContent) return e.textContent;
                  for (e = e.firstChild; e; e = e.nextSibling) n += r(e);
                } else if (3 === s || 4 === s) return e.nodeValue;
              } else for (; (t = e[i++]); ) n += r(t);
              return n;
            }),
          ((i = oe.selectors =
            {
              cacheLength: 50,
              createPseudo: ce,
              match: Y,
              attrHandle: {},
              find: {},
              relative: {
                ">": {
                  dir: "parentNode",
                  first: !0,
                },
                " ": {
                  dir: "parentNode",
                },
                "+": {
                  dir: "previousSibling",
                  first: !0,
                },
                "~": {
                  dir: "previousSibling",
                },
              },
              preFilter: {
                ATTR: function (e) {
                  return (
                    (e[1] = e[1].replace(te, ne)),
                    (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                  );
                },
                CHILD: function (e) {
                  return (
                    (e[1] = e[1].toLowerCase()),
                    "nth" === e[1].slice(0, 3)
                      ? (e[3] || oe.error(e[0]),
                        (e[4] = +(e[4]
                          ? e[5] + (e[6] || 1)
                          : 2 * ("even" === e[3] || "odd" === e[3]))),
                        (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                      : e[3] && oe.error(e[0]),
                    e
                  );
                },
                PSEUDO: function (e) {
                  var t,
                    n = !e[6] && e[2];
                  return Y.CHILD.test(e[0])
                    ? null
                    : (e[3]
                        ? (e[2] = e[4] || e[5] || "")
                        : n &&
                          G.test(n) &&
                          (t = a(n, !0)) &&
                          (t = n.indexOf(")", n.length - t) - n.length) &&
                          ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                      e.slice(0, 3));
                },
              },
              filter: {
                TAG: function (e) {
                  var t = e.replace(te, ne).toLowerCase();
                  return "*" === e
                    ? function () {
                        return !0;
                      }
                    : function (e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t;
                      };
                },
                CLASS: function (e) {
                  var t = T[e + " "];
                  return (
                    t ||
                    ((t = new RegExp("(^|" + B + ")" + e + "(" + B + "|$)")) &&
                      T(e, function (e) {
                        return t.test(
                          ("string" == typeof e.className && e.className) ||
                            (void 0 !== e.getAttribute &&
                              e.getAttribute("class")) ||
                            ""
                        );
                      }))
                  );
                },
                ATTR: function (e, t, n) {
                  return function (i) {
                    var r = oe.attr(i, e);
                    return null == r
                      ? "!=" === t
                      : !t ||
                          ((r += ""),
                          "=" === t
                            ? r === n
                            : "!=" === t
                            ? r !== n
                            : "^=" === t
                            ? n && 0 === r.indexOf(n)
                            : "*=" === t
                            ? n && r.indexOf(n) > -1
                            : "$=" === t
                            ? n && r.slice(-n.length) === n
                            : "~=" === t
                            ? (" " + r.replace(H, " ") + " ").indexOf(n) > -1
                            : "|=" === t &&
                              (r === n ||
                                r.slice(0, n.length + 1) === n + "-"));
                  };
                },
                CHILD: function (e, t, n, i, r) {
                  var s = "nth" !== e.slice(0, 3),
                    a = "last" !== e.slice(-4),
                    o = "of-type" === t;
                  return 1 === i && 0 === r
                    ? function (e) {
                        return !!e.parentNode;
                      }
                    : function (t, n, l) {
                        var c,
                          u,
                          d,
                          p,
                          f,
                          h,
                          m = s !== a ? "nextSibling" : "previousSibling",
                          g = t.parentNode,
                          v = o && t.nodeName.toLowerCase(),
                          y = !l && !o,
                          b = !1;
                        if (g) {
                          if (s) {
                            for (; m; ) {
                              for (p = t; (p = p[m]); )
                                if (
                                  o
                                    ? p.nodeName.toLowerCase() === v
                                    : 1 === p.nodeType
                                )
                                  return !1;
                              h = m = "only" === e && !h && "nextSibling";
                            }
                            return !0;
                          }
                          if (
                            ((h = [a ? g.firstChild : g.lastChild]), a && y)
                          ) {
                            for (
                              b =
                                (f =
                                  (c =
                                    (u =
                                      (d = (p = g)[_] || (p[_] = {}))[
                                        p.uniqueID
                                      ] || (d[p.uniqueID] = {}))[e] ||
                                    [])[0] === x && c[1]) && c[2],
                                p = f && g.childNodes[f];
                              (p =
                                (++f && p && p[m]) || (b = f = 0) || h.pop());

                            )
                              if (1 === p.nodeType && ++b && p === t) {
                                u[e] = [x, f, b];
                                break;
                              }
                          } else if (
                            (y &&
                              (b = f =
                                (c =
                                  (u =
                                    (d = (p = t)[_] || (p[_] = {}))[
                                      p.uniqueID
                                    ] || (d[p.uniqueID] = {}))[e] || [])[0] ===
                                  x && c[1]),
                            !1 === b)
                          )
                            for (
                              ;
                              (p =
                                (++f && p && p[m]) || (b = f = 0) || h.pop()) &&
                              ((o
                                ? p.nodeName.toLowerCase() !== v
                                : 1 !== p.nodeType) ||
                                !++b ||
                                (y &&
                                  ((u =
                                    (d = p[_] || (p[_] = {}))[p.uniqueID] ||
                                    (d[p.uniqueID] = {}))[e] = [x, b]),
                                p !== t));

                            );
                          return (b -= r) === i || (b % i == 0 && b / i >= 0);
                        }
                      };
                },
                PSEUDO: function (e, t) {
                  var n,
                    r =
                      i.pseudos[e] ||
                      i.setFilters[e.toLowerCase()] ||
                      oe.error("unsupported pseudo: " + e);
                  return r[_]
                    ? r(t)
                    : r.length > 1
                    ? ((n = [e, e, "", t]),
                      i.setFilters.hasOwnProperty(e.toLowerCase())
                        ? ce(function (e, n) {
                            for (var i, s = r(e, t), a = s.length; a--; )
                              e[(i = j(e, s[a]))] = !(n[i] = s[a]);
                          })
                        : function (e) {
                            return r(e, 0, n);
                          })
                    : r;
                },
              },
              pseudos: {
                not: ce(function (e) {
                  var t = [],
                    n = [],
                    i = o(e.replace(F, "$1"));
                  return i[_]
                    ? ce(function (e, t, n, r) {
                        for (var s, a = i(e, null, r, []), o = e.length; o--; )
                          (s = a[o]) && (e[o] = !(t[o] = s));
                      })
                    : function (e, r, s) {
                        return (
                          (t[0] = e), i(t, null, s, n), (t[0] = null), !n.pop()
                        );
                      };
                }),
                has: ce(function (e) {
                  return function (t) {
                    return oe(e, t).length > 0;
                  };
                }),
                contains: ce(function (e) {
                  return (
                    (e = e.replace(te, ne)),
                    function (t) {
                      return (t.textContent || r(t)).indexOf(e) > -1;
                    }
                  );
                }),
                lang: ce(function (e) {
                  return (
                    X.test(e || "") || oe.error("unsupported lang: " + e),
                    (e = e.replace(te, ne).toLowerCase()),
                    function (t) {
                      var n;
                      do {
                        if (
                          (n = m
                            ? t.lang
                            : t.getAttribute("xml:lang") ||
                              t.getAttribute("lang"))
                        )
                          return (
                            (n = n.toLowerCase()) === e ||
                            0 === n.indexOf(e + "-")
                          );
                      } while ((t = t.parentNode) && 1 === t.nodeType);
                      return !1;
                    }
                  );
                }),
                target: function (t) {
                  var n = e.location && e.location.hash;
                  return n && n.slice(1) === t.id;
                },
                root: function (e) {
                  return e === h;
                },
                focus: function (e) {
                  return (
                    e === f.activeElement &&
                    (!f.hasFocus || f.hasFocus()) &&
                    !!(e.type || e.href || ~e.tabIndex)
                  );
                },
                enabled: me(!1),
                disabled: me(!0),
                checked: function (e) {
                  var t = e.nodeName.toLowerCase();
                  return (
                    ("input" === t && !!e.checked) ||
                    ("option" === t && !!e.selected)
                  );
                },
                selected: function (e) {
                  return (
                    e.parentNode && e.parentNode.selectedIndex,
                    !0 === e.selected
                  );
                },
                empty: function (e) {
                  for (e = e.firstChild; e; e = e.nextSibling)
                    if (e.nodeType < 6) return !1;
                  return !0;
                },
                parent: function (e) {
                  return !i.pseudos.empty(e);
                },
                header: function (e) {
                  return J.test(e.nodeName);
                },
                input: function (e) {
                  return Q.test(e.nodeName);
                },
                button: function (e) {
                  var t = e.nodeName.toLowerCase();
                  return (
                    ("input" === t && "button" === e.type) || "button" === t
                  );
                },
                text: function (e) {
                  var t;
                  return (
                    "input" === e.nodeName.toLowerCase() &&
                    "text" === e.type &&
                    (null == (t = e.getAttribute("type")) ||
                      "text" === t.toLowerCase())
                  );
                },
                first: ge(function () {
                  return [0];
                }),
                last: ge(function (e, t) {
                  return [t - 1];
                }),
                eq: ge(function (e, t, n) {
                  return [n < 0 ? n + t : n];
                }),
                even: ge(function (e, t) {
                  for (var n = 0; n < t; n += 2) e.push(n);
                  return e;
                }),
                odd: ge(function (e, t) {
                  for (var n = 1; n < t; n += 2) e.push(n);
                  return e;
                }),
                lt: ge(function (e, t, n) {
                  for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0; )
                    e.push(i);
                  return e;
                }),
                gt: ge(function (e, t, n) {
                  for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                  return e;
                }),
              },
            }).pseudos.nth = i.pseudos.eq),
          {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0,
          }))
            i.pseudos[t] = fe(t);
          for (t in {
            submit: !0,
            reset: !0,
          })
            i.pseudos[t] = he(t);

          function ye() {}

          function be(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i;
          }

          function _e(e, t, n) {
            var i = t.dir,
              r = t.next,
              s = r || i,
              a = n && "parentNode" === s,
              o = C++;
            return t.first
              ? function (t, n, r) {
                  for (; (t = t[i]); )
                    if (1 === t.nodeType || a) return e(t, n, r);
                  return !1;
                }
              : function (t, n, l) {
                  var c,
                    u,
                    d,
                    p = [x, o];
                  if (l) {
                    for (; (t = t[i]); )
                      if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                  } else
                    for (; (t = t[i]); )
                      if (1 === t.nodeType || a)
                        if (
                          ((u =
                            (d = t[_] || (t[_] = {}))[t.uniqueID] ||
                            (d[t.uniqueID] = {})),
                          r && r === t.nodeName.toLowerCase())
                        )
                          t = t[i] || t;
                        else {
                          if ((c = u[s]) && c[0] === x && c[1] === o)
                            return (p[2] = c[2]);
                          if (((u[s] = p), (p[2] = e(t, n, l)))) return !0;
                        }
                  return !1;
                };
          }

          function we(e) {
            return e.length > 1
              ? function (t, n, i) {
                  for (var r = e.length; r--; ) if (!e[r](t, n, i)) return !1;
                  return !0;
                }
              : e[0];
          }

          function xe(e, t, n, i, r) {
            for (var s, a = [], o = 0, l = e.length, c = null != t; o < l; o++)
              (s = e[o]) && ((n && !n(s, i, r)) || (a.push(s), c && t.push(o)));
            return a;
          }

          function Ce(e, t, n, i, r, s) {
            return (
              i && !i[_] && (i = Ce(i)),
              r && !r[_] && (r = Ce(r, s)),
              ce(function (s, a, o, l) {
                var c,
                  u,
                  d,
                  p = [],
                  f = [],
                  h = a.length,
                  m =
                    s ||
                    (function (e, t, n) {
                      for (var i = 0, r = t.length; i < r; i++) oe(e, t[i], n);
                      return n;
                    })(t || "*", o.nodeType ? [o] : o, []),
                  g = !e || (!s && t) ? m : xe(m, p, e, o, l),
                  v = n ? (r || (s ? e : h || i) ? [] : a) : g;
                if ((n && n(g, v, o, l), i))
                  for (c = xe(v, f), i(c, [], o, l), u = c.length; u--; )
                    (d = c[u]) && (v[f[u]] = !(g[f[u]] = d));
                if (s) {
                  if (r || e) {
                    if (r) {
                      for (c = [], u = v.length; u--; )
                        (d = v[u]) && c.push((g[u] = d));
                      r(null, (v = []), c, l);
                    }
                    for (u = v.length; u--; )
                      (d = v[u]) &&
                        (c = r ? j(s, d) : p[u]) > -1 &&
                        (s[c] = !(a[c] = d));
                  }
                } else (v = xe(v === a ? v.splice(h, v.length) : v)), r ? r(null, a, v, l) : I.apply(a, v);
              })
            );
          }

          function Te(e) {
            for (
              var t,
                n,
                r,
                s = e.length,
                a = i.relative[e[0].type],
                o = a || i.relative[" "],
                l = a ? 1 : 0,
                u = _e(
                  function (e) {
                    return e === t;
                  },
                  o,
                  !0
                ),
                d = _e(
                  function (e) {
                    return j(t, e) > -1;
                  },
                  o,
                  !0
                ),
                p = [
                  function (e, n, i) {
                    var r =
                      (!a && (i || n !== c)) ||
                      ((t = n).nodeType ? u(e, n, i) : d(e, n, i));
                    return (t = null), r;
                  },
                ];
              l < s;
              l++
            )
              if ((n = i.relative[e[l].type])) p = [_e(we(p), n)];
              else {
                if ((n = i.filter[e[l].type].apply(null, e[l].matches))[_]) {
                  for (r = ++l; r < s && !i.relative[e[r].type]; r++);
                  return Ce(
                    l > 1 && we(p),
                    l > 1 &&
                      be(
                        e.slice(0, l - 1).concat({
                          value: " " === e[l - 2].type ? "*" : "",
                        })
                      ).replace(F, "$1"),
                    n,
                    l < r && Te(e.slice(l, r)),
                    r < s && Te((e = e.slice(r))),
                    r < s && be(e)
                  );
                }
                p.push(n);
              }
            return we(p);
          }
          return (
            (ye.prototype = i.filters = i.pseudos),
            (i.setFilters = new ye()),
            (a = oe.tokenize =
              function (e, t) {
                var n,
                  r,
                  s,
                  a,
                  o,
                  l,
                  c,
                  u = k[e + " "];
                if (u) return t ? 0 : u.slice(0);
                for (o = e, l = [], c = i.preFilter; o; ) {
                  for (a in ((n && !(r = q.exec(o))) ||
                    (r && (o = o.slice(r[0].length) || o), l.push((s = []))),
                  (n = !1),
                  (r = W.exec(o)) &&
                    ((n = r.shift()),
                    s.push({
                      value: n,
                      type: r[0].replace(F, " "),
                    }),
                    (o = o.slice(n.length))),
                  i.filter))
                    !(r = Y[a].exec(o)) ||
                      (c[a] && !(r = c[a](r))) ||
                      ((n = r.shift()),
                      s.push({
                        value: n,
                        type: a,
                        matches: r,
                      }),
                      (o = o.slice(n.length)));
                  if (!n) break;
                }
                return t ? o.length : o ? oe.error(e) : k(e, l).slice(0);
              }),
            (o = oe.compile =
              function (e, t) {
                var n,
                  r = [],
                  s = [],
                  o = S[e + " "];
                if (!o) {
                  for (t || (t = a(e)), n = t.length; n--; )
                    (o = Te(t[n]))[_] ? r.push(o) : s.push(o);
                  (o = S(
                    e,
                    (function (e, t) {
                      var n = t.length > 0,
                        r = e.length > 0,
                        s = function (s, a, o, l, u) {
                          var d,
                            h,
                            g,
                            v = 0,
                            y = "0",
                            b = s && [],
                            _ = [],
                            w = c,
                            C = s || (r && i.find.TAG("*", u)),
                            T = (x += null == w ? 1 : Math.random() || 0.1),
                            k = C.length;
                          for (
                            u && (c = a == f || a || u);
                            y !== k && null != (d = C[y]);
                            y++
                          ) {
                            if (r && d) {
                              for (
                                h = 0,
                                  a || d.ownerDocument == f || (p(d), (o = !m));
                                (g = e[h++]);

                              )
                                if (g(d, a || f, o)) {
                                  l.push(d);
                                  break;
                                }
                              u && (x = T);
                            }
                            n && ((d = !g && d) && v--, s && b.push(d));
                          }
                          if (((v += y), n && y !== v)) {
                            for (h = 0; (g = t[h++]); ) g(b, _, a, o);
                            if (s) {
                              if (v > 0)
                                for (; y--; )
                                  b[y] || _[y] || (_[y] = A.call(l));
                              _ = xe(_);
                            }
                            I.apply(l, _),
                              u &&
                                !s &&
                                _.length > 0 &&
                                v + t.length > 1 &&
                                oe.uniqueSort(l);
                          }
                          return u && ((x = T), (c = w)), b;
                        };
                      return n ? ce(s) : s;
                    })(s, r)
                  )).selector = e;
                }
                return o;
              }),
            (l = oe.select =
              function (e, t, n, r) {
                var s,
                  l,
                  c,
                  u,
                  d,
                  p = "function" == typeof e && e,
                  f = !r && a((e = p.selector || e));
                if (((n = n || []), 1 === f.length)) {
                  if (
                    (l = f[0] = f[0].slice(0)).length > 2 &&
                    "ID" === (c = l[0]).type &&
                    9 === t.nodeType &&
                    m &&
                    i.relative[l[1].type]
                  ) {
                    if (
                      !(t = (i.find.ID(c.matches[0].replace(te, ne), t) ||
                        [])[0])
                    )
                      return n;
                    p && (t = t.parentNode),
                      (e = e.slice(l.shift().value.length));
                  }
                  for (
                    s = Y.needsContext.test(e) ? 0 : l.length;
                    s-- && ((c = l[s]), !i.relative[(u = c.type)]);

                  )
                    if (
                      (d = i.find[u]) &&
                      (r = d(
                        c.matches[0].replace(te, ne),
                        (ee.test(l[0].type) && ve(t.parentNode)) || t
                      ))
                    ) {
                      if ((l.splice(s, 1), !(e = r.length && be(l))))
                        return I.apply(n, r), n;
                      break;
                    }
                }
                return (
                  (p || o(e, f))(
                    r,
                    t,
                    !m,
                    n,
                    !t || (ee.test(e) && ve(t.parentNode)) || t
                  ),
                  n
                );
              }),
            (n.sortStable = _.split("").sort(O).join("") === _),
            (n.detectDuplicates = !!d),
            p(),
            (n.sortDetached = ue(function (e) {
              return 1 & e.compareDocumentPosition(f.createElement("fieldset"));
            })),
            ue(function (e) {
              return (
                (e.innerHTML = "<a href='#'></a>"),
                "#" === e.firstChild.getAttribute("href")
              );
            }) ||
              de("type|href|height|width", function (e, t, n) {
                if (!n)
                  return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
              }),
            (n.attributes &&
              ue(function (e) {
                return (
                  (e.innerHTML = "<input/>"),
                  e.firstChild.setAttribute("value", ""),
                  "" === e.firstChild.getAttribute("value")
                );
              })) ||
              de("value", function (e, t, n) {
                if (!n && "input" === e.nodeName.toLowerCase())
                  return e.defaultValue;
              }),
            ue(function (e) {
              return null == e.getAttribute("disabled");
            }) ||
              de(N, function (e, t, n) {
                var i;
                if (!n)
                  return !0 === e[t]
                    ? t.toLowerCase()
                    : (i = e.getAttributeNode(t)) && i.specified
                    ? i.value
                    : null;
              }),
            oe
          );
        })(n);
      (C.find = k),
        (C.expr = k.selectors),
        (C.expr[":"] = C.expr.pseudos),
        (C.uniqueSort = C.unique = k.uniqueSort),
        (C.text = k.getText),
        (C.isXMLDoc = k.isXML),
        (C.contains = k.contains),
        (C.escapeSelector = k.escape);
      var S = function (e, t, n) {
          for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
            if (1 === e.nodeType) {
              if (r && C(e).is(n)) break;
              i.push(e);
            }
          return i;
        },
        E = function (e, t) {
          for (var n = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && n.push(e);
          return n;
        },
        O = C.expr.match.needsContext;

      function P(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
      }
      var M = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

      function A(e, t, n) {
        return v(t)
          ? C.grep(e, function (e, i) {
              return !!t.call(e, i, e) !== n;
            })
          : t.nodeType
          ? C.grep(e, function (e) {
              return (e === t) !== n;
            })
          : "string" != typeof t
          ? C.grep(e, function (e) {
              return u.call(t, e) > -1 !== n;
            })
          : C.filter(t, e, n);
      }
      (C.filter = function (e, t, n) {
        var i = t[0];
        return (
          n && (e = ":not(" + e + ")"),
          1 === t.length && 1 === i.nodeType
            ? C.find.matchesSelector(i, e)
              ? [i]
              : []
            : C.find.matches(
                e,
                C.grep(t, function (e) {
                  return 1 === e.nodeType;
                })
              )
        );
      }),
        C.fn.extend({
          find: function (e) {
            var t,
              n,
              i = this.length,
              r = this;
            if ("string" != typeof e)
              return this.pushStack(
                C(e).filter(function () {
                  for (t = 0; t < i; t++) if (C.contains(r[t], this)) return !0;
                })
              );
            for (n = this.pushStack([]), t = 0; t < i; t++) C.find(e, r[t], n);
            return i > 1 ? C.uniqueSort(n) : n;
          },
          filter: function (e) {
            return this.pushStack(A(this, e || [], !1));
          },
          not: function (e) {
            return this.pushStack(A(this, e || [], !0));
          },
          is: function (e) {
            return !!A(
              this,
              "string" == typeof e && O.test(e) ? C(e) : e || [],
              !1
            ).length;
          },
        });
      var D,
        I = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      ((C.fn.init = function (e, t, n) {
        var i, r;
        if (!e) return this;
        if (((n = n || D), "string" == typeof e)) {
          if (
            !(i =
              "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                ? [null, e, null]
                : I.exec(e)) ||
            (!i[1] && t)
          )
            return !t || t.jquery
              ? (t || n).find(e)
              : this.constructor(t).find(e);
          if (i[1]) {
            if (
              ((t = t instanceof C ? t[0] : t),
              C.merge(
                this,
                C.parseHTML(
                  i[1],
                  t && t.nodeType ? t.ownerDocument || t : b,
                  !0
                )
              ),
              M.test(i[1]) && C.isPlainObject(t))
            )
              for (i in t) v(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this;
          }
          return (
            (r = b.getElementById(i[2])) && ((this[0] = r), (this.length = 1)),
            this
          );
        }
        return e.nodeType
          ? ((this[0] = e), (this.length = 1), this)
          : v(e)
          ? void 0 !== n.ready
            ? n.ready(e)
            : e(C)
          : C.makeArray(e, this);
      }).prototype = C.fn),
        (D = C(b));
      var L = /^(?:parents|prev(?:Until|All))/,
        j = {
          children: !0,
          contents: !0,
          next: !0,
          prev: !0,
        };

      function N(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; );
        return e;
      }
      C.fn.extend({
        has: function (e) {
          var t = C(e, this),
            n = t.length;
          return this.filter(function () {
            for (var e = 0; e < n; e++) if (C.contains(this, t[e])) return !0;
          });
        },
        closest: function (e, t) {
          var n,
            i = 0,
            r = this.length,
            s = [],
            a = "string" != typeof e && C(e);
          if (!O.test(e))
            for (; i < r; i++)
              for (n = this[i]; n && n !== t; n = n.parentNode)
                if (
                  n.nodeType < 11 &&
                  (a
                    ? a.index(n) > -1
                    : 1 === n.nodeType && C.find.matchesSelector(n, e))
                ) {
                  s.push(n);
                  break;
                }
          return this.pushStack(s.length > 1 ? C.uniqueSort(s) : s);
        },
        index: function (e) {
          return e
            ? "string" == typeof e
              ? u.call(C(e), this[0])
              : u.call(this, e.jquery ? e[0] : e)
            : this[0] && this[0].parentNode
            ? this.first().prevAll().length
            : -1;
        },
        add: function (e, t) {
          return this.pushStack(C.uniqueSort(C.merge(this.get(), C(e, t))));
        },
        addBack: function (e) {
          return this.add(
            null == e ? this.prevObject : this.prevObject.filter(e)
          );
        },
      }),
        C.each(
          {
            parent: function (e) {
              var t = e.parentNode;
              return t && 11 !== t.nodeType ? t : null;
            },
            parents: function (e) {
              return S(e, "parentNode");
            },
            parentsUntil: function (e, t, n) {
              return S(e, "parentNode", n);
            },
            next: function (e) {
              return N(e, "nextSibling");
            },
            prev: function (e) {
              return N(e, "previousSibling");
            },
            nextAll: function (e) {
              return S(e, "nextSibling");
            },
            prevAll: function (e) {
              return S(e, "previousSibling");
            },
            nextUntil: function (e, t, n) {
              return S(e, "nextSibling", n);
            },
            prevUntil: function (e, t, n) {
              return S(e, "previousSibling", n);
            },
            siblings: function (e) {
              return E((e.parentNode || {}).firstChild, e);
            },
            children: function (e) {
              return E(e.firstChild);
            },
            contents: function (e) {
              return null != e.contentDocument && a(e.contentDocument)
                ? e.contentDocument
                : (P(e, "template") && (e = e.content || e),
                  C.merge([], e.childNodes));
            },
          },
          function (e, t) {
            C.fn[e] = function (n, i) {
              var r = C.map(this, t, n);
              return (
                "Until" !== e.slice(-5) && (i = n),
                i && "string" == typeof i && (r = C.filter(i, r)),
                this.length > 1 &&
                  (j[e] || C.uniqueSort(r), L.test(e) && r.reverse()),
                this.pushStack(r)
              );
            };
          }
        );
      var B = /[^\x20\t\r\n\f]+/g;

      function $(e) {
        return e;
      }

      function z(e) {
        throw e;
      }

      function R(e, t, n, i) {
        var r;
        try {
          e && v((r = e.promise))
            ? r.call(e).done(t).fail(n)
            : e && v((r = e.then))
            ? r.call(e, t, n)
            : t.apply(void 0, [e].slice(i));
        } catch (e) {
          n.apply(void 0, [e]);
        }
      }
      (C.Callbacks = function (e) {
        e =
          "string" == typeof e
            ? (function (e) {
                var t = {};
                return (
                  C.each(e.match(B) || [], function (e, n) {
                    t[n] = !0;
                  }),
                  t
                );
              })(e)
            : C.extend({}, e);
        var t,
          n,
          i,
          r,
          s = [],
          a = [],
          o = -1,
          l = function () {
            for (r = r || e.once, i = t = !0; a.length; o = -1)
              for (n = a.shift(); ++o < s.length; )
                !1 === s[o].apply(n[0], n[1]) &&
                  e.stopOnFalse &&
                  ((o = s.length), (n = !1));
            e.memory || (n = !1), (t = !1), r && (s = n ? [] : "");
          },
          c = {
            add: function () {
              return (
                s &&
                  (n && !t && ((o = s.length - 1), a.push(n)),
                  (function t(n) {
                    C.each(n, function (n, i) {
                      v(i)
                        ? (e.unique && c.has(i)) || s.push(i)
                        : i && i.length && "string" !== x(i) && t(i);
                    });
                  })(arguments),
                  n && !t && l()),
                this
              );
            },
            remove: function () {
              return (
                C.each(arguments, function (e, t) {
                  for (var n; (n = C.inArray(t, s, n)) > -1; )
                    s.splice(n, 1), n <= o && o--;
                }),
                this
              );
            },
            has: function (e) {
              return e ? C.inArray(e, s) > -1 : s.length > 0;
            },
            empty: function () {
              return s && (s = []), this;
            },
            disable: function () {
              return (r = a = []), (s = n = ""), this;
            },
            disabled: function () {
              return !s;
            },
            lock: function () {
              return (r = a = []), n || t || (s = n = ""), this;
            },
            locked: function () {
              return !!r;
            },
            fireWith: function (e, n) {
              return (
                r ||
                  ((n = [e, (n = n || []).slice ? n.slice() : n]),
                  a.push(n),
                  t || l()),
                this
              );
            },
            fire: function () {
              return c.fireWith(this, arguments), this;
            },
            fired: function () {
              return !!i;
            },
          };
        return c;
      }),
        C.extend({
          Deferred: function (e) {
            var t = [
                [
                  "notify",
                  "progress",
                  C.Callbacks("memory"),
                  C.Callbacks("memory"),
                  2,
                ],
                [
                  "resolve",
                  "done",
                  C.Callbacks("once memory"),
                  C.Callbacks("once memory"),
                  0,
                  "resolved",
                ],
                [
                  "reject",
                  "fail",
                  C.Callbacks("once memory"),
                  C.Callbacks("once memory"),
                  1,
                  "rejected",
                ],
              ],
              i = "pending",
              r = {
                state: function () {
                  return i;
                },
                always: function () {
                  return s.done(arguments).fail(arguments), this;
                },
                catch: function (e) {
                  return r.then(null, e);
                },
                pipe: function () {
                  var e = arguments;
                  return C.Deferred(function (n) {
                    C.each(t, function (t, i) {
                      var r = v(e[i[4]]) && e[i[4]];
                      s[i[1]](function () {
                        var e = r && r.apply(this, arguments);
                        e && v(e.promise)
                          ? e
                              .promise()
                              .progress(n.notify)
                              .done(n.resolve)
                              .fail(n.reject)
                          : n[i[0] + "With"](this, r ? [e] : arguments);
                      });
                    }),
                      (e = null);
                  }).promise();
                },
                then: function (e, i, r) {
                  var s = 0;

                  function a(e, t, i, r) {
                    return function () {
                      var o = this,
                        l = arguments,
                        c = function () {
                          var n, c;
                          if (!(e < s)) {
                            if ((n = i.apply(o, l)) === t.promise())
                              throw new TypeError("Thenable self-resolution");
                            (c =
                              n &&
                              ("object" == typeof n ||
                                "function" == typeof n) &&
                              n.then),
                              v(c)
                                ? r
                                  ? c.call(n, a(s, t, $, r), a(s, t, z, r))
                                  : (s++,
                                    c.call(
                                      n,
                                      a(s, t, $, r),
                                      a(s, t, z, r),
                                      a(s, t, $, t.notifyWith)
                                    ))
                                : (i !== $ && ((o = void 0), (l = [n])),
                                  (r || t.resolveWith)(o, l));
                          }
                        },
                        u = r
                          ? c
                          : function () {
                              try {
                                c();
                              } catch (n) {
                                C.Deferred.exceptionHook &&
                                  C.Deferred.exceptionHook(n, u.stackTrace),
                                  e + 1 >= s &&
                                    (i !== z && ((o = void 0), (l = [n])),
                                    t.rejectWith(o, l));
                              }
                            };
                      e
                        ? u()
                        : (C.Deferred.getStackHook &&
                            (u.stackTrace = C.Deferred.getStackHook()),
                          n.setTimeout(u));
                    };
                  }
                  return C.Deferred(function (n) {
                    t[0][3].add(a(0, n, v(r) ? r : $, n.notifyWith)),
                      t[1][3].add(a(0, n, v(e) ? e : $)),
                      t[2][3].add(a(0, n, v(i) ? i : z));
                  }).promise();
                },
                promise: function (e) {
                  return null != e ? C.extend(e, r) : r;
                },
              },
              s = {};
            return (
              C.each(t, function (e, n) {
                var a = n[2],
                  o = n[5];
                (r[n[1]] = a.add),
                  o &&
                    a.add(
                      function () {
                        i = o;
                      },
                      t[3 - e][2].disable,
                      t[3 - e][3].disable,
                      t[0][2].lock,
                      t[0][3].lock
                    ),
                  a.add(n[3].fire),
                  (s[n[0]] = function () {
                    return (
                      s[n[0] + "With"](this === s ? void 0 : this, arguments),
                      this
                    );
                  }),
                  (s[n[0] + "With"] = a.fireWith);
              }),
              r.promise(s),
              e && e.call(s, s),
              s
            );
          },
          when: function (e) {
            var t = arguments.length,
              n = t,
              i = Array(n),
              r = o.call(arguments),
              s = C.Deferred(),
              a = function (e) {
                return function (n) {
                  (i[e] = this),
                    (r[e] = arguments.length > 1 ? o.call(arguments) : n),
                    --t || s.resolveWith(i, r);
                };
              };
            if (
              t <= 1 &&
              (R(e, s.done(a(n)).resolve, s.reject, !t),
              "pending" === s.state() || v(r[n] && r[n].then))
            )
              return s.then();
            for (; n--; ) R(r[n], a(n), s.reject);
            return s.promise();
          },
        });
      var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      (C.Deferred.exceptionHook = function (e, t) {
        n.console &&
          n.console.warn &&
          e &&
          H.test(e.name) &&
          n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
      }),
        (C.readyException = function (e) {
          n.setTimeout(function () {
            throw e;
          });
        });
      var F = C.Deferred();

      function q() {
        b.removeEventListener("DOMContentLoaded", q),
          n.removeEventListener("load", q),
          C.ready();
      }
      (C.fn.ready = function (e) {
        return (
          F.then(e).catch(function (e) {
            C.readyException(e);
          }),
          this
        );
      }),
        C.extend({
          isReady: !1,
          readyWait: 1,
          ready: function (e) {
            (!0 === e ? --C.readyWait : C.isReady) ||
              ((C.isReady = !0),
              (!0 !== e && --C.readyWait > 0) || F.resolveWith(b, [C]));
          },
        }),
        (C.ready.then = F.then),
        "complete" === b.readyState ||
        ("loading" !== b.readyState && !b.documentElement.doScroll)
          ? n.setTimeout(C.ready)
          : (b.addEventListener("DOMContentLoaded", q),
            n.addEventListener("load", q));
      var W = function (e, t, n, i, r, s, a) {
          var o = 0,
            l = e.length,
            c = null == n;
          if ("object" === x(n))
            for (o in ((r = !0), n)) W(e, t, o, n[o], !0, s, a);
          else if (
            void 0 !== i &&
            ((r = !0),
            v(i) || (a = !0),
            c &&
              (a
                ? (t.call(e, i), (t = null))
                : ((c = t),
                  (t = function (e, t, n) {
                    return c.call(C(e), n);
                  }))),
            t)
          )
            for (; o < l; o++) t(e[o], n, a ? i : i.call(e[o], o, t(e[o], n)));
          return r ? e : c ? t.call(e) : l ? t(e[0], n) : s;
        },
        V = /^-ms-/,
        G = /-([a-z])/g;

      function X(e, t) {
        return t.toUpperCase();
      }

      function Y(e) {
        return e.replace(V, "ms-").replace(G, X);
      }
      var U = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
      };

      function Q() {
        this.expando = C.expando + Q.uid++;
      }
      (Q.uid = 1),
        (Q.prototype = {
          cache: function (e) {
            var t = e[this.expando];
            return (
              t ||
                ((t = {}),
                U(e) &&
                  (e.nodeType
                    ? (e[this.expando] = t)
                    : Object.defineProperty(e, this.expando, {
                        value: t,
                        configurable: !0,
                      }))),
              t
            );
          },
          set: function (e, t, n) {
            var i,
              r = this.cache(e);
            if ("string" == typeof t) r[Y(t)] = n;
            else for (i in t) r[Y(i)] = t[i];
            return r;
          },
          get: function (e, t) {
            return void 0 === t
              ? this.cache(e)
              : e[this.expando] && e[this.expando][Y(t)];
          },
          access: function (e, t, n) {
            return void 0 === t || (t && "string" == typeof t && void 0 === n)
              ? this.get(e, t)
              : (this.set(e, t, n), void 0 !== n ? n : t);
          },
          remove: function (e, t) {
            var n,
              i = e[this.expando];
            if (void 0 !== i) {
              if (void 0 !== t) {
                n = (t = Array.isArray(t)
                  ? t.map(Y)
                  : (t = Y(t)) in i
                  ? [t]
                  : t.match(B) || []).length;
                for (; n--; ) delete i[t[n]];
              }
              (void 0 === t || C.isEmptyObject(i)) &&
                (e.nodeType
                  ? (e[this.expando] = void 0)
                  : delete e[this.expando]);
            }
          },
          hasData: function (e) {
            var t = e[this.expando];
            return void 0 !== t && !C.isEmptyObject(t);
          },
        });
      var J = new Q(),
        K = new Q(),
        Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        ee = /[A-Z]/g;

      function te(e, t, n) {
        var i;
        if (void 0 === n && 1 === e.nodeType)
          if (
            ((i = "data-" + t.replace(ee, "-$&").toLowerCase()),
            "string" == typeof (n = e.getAttribute(i)))
          ) {
            try {
              n = (function (e) {
                return (
                  "true" === e ||
                  ("false" !== e &&
                    ("null" === e
                      ? null
                      : e === +e + ""
                      ? +e
                      : Z.test(e)
                      ? JSON.parse(e)
                      : e))
                );
              })(n);
            } catch (e) {}
            K.set(e, t, n);
          } else n = void 0;
        return n;
      }
      C.extend({
        hasData: function (e) {
          return K.hasData(e) || J.hasData(e);
        },
        data: function (e, t, n) {
          return K.access(e, t, n);
        },
        removeData: function (e, t) {
          K.remove(e, t);
        },
        _data: function (e, t, n) {
          return J.access(e, t, n);
        },
        _removeData: function (e, t) {
          J.remove(e, t);
        },
      }),
        C.fn.extend({
          data: function (e, t) {
            var n,
              i,
              r,
              s = this[0],
              a = s && s.attributes;
            if (void 0 === e) {
              if (
                this.length &&
                ((r = K.get(s)), 1 === s.nodeType && !J.get(s, "hasDataAttrs"))
              ) {
                for (n = a.length; n--; )
                  a[n] &&
                    0 === (i = a[n].name).indexOf("data-") &&
                    ((i = Y(i.slice(5))), te(s, i, r[i]));
                J.set(s, "hasDataAttrs", !0);
              }
              return r;
            }
            return "object" == typeof e
              ? this.each(function () {
                  K.set(this, e);
                })
              : W(
                  this,
                  function (t) {
                    var n;
                    if (s && void 0 === t)
                      return void 0 !== (n = K.get(s, e)) ||
                        void 0 !== (n = te(s, e))
                        ? n
                        : void 0;
                    this.each(function () {
                      K.set(this, e, t);
                    });
                  },
                  null,
                  t,
                  arguments.length > 1,
                  null,
                  !0
                );
          },
          removeData: function (e) {
            return this.each(function () {
              K.remove(this, e);
            });
          },
        }),
        C.extend({
          queue: function (e, t, n) {
            var i;
            if (e)
              return (
                (t = (t || "fx") + "queue"),
                (i = J.get(e, t)),
                n &&
                  (!i || Array.isArray(n)
                    ? (i = J.access(e, t, C.makeArray(n)))
                    : i.push(n)),
                i || []
              );
          },
          dequeue: function (e, t) {
            t = t || "fx";
            var n = C.queue(e, t),
              i = n.length,
              r = n.shift(),
              s = C._queueHooks(e, t);
            "inprogress" === r && ((r = n.shift()), i--),
              r &&
                ("fx" === t && n.unshift("inprogress"),
                delete s.stop,
                r.call(
                  e,
                  function () {
                    C.dequeue(e, t);
                  },
                  s
                )),
              !i && s && s.empty.fire();
          },
          _queueHooks: function (e, t) {
            var n = t + "queueHooks";
            return (
              J.get(e, n) ||
              J.access(e, n, {
                empty: C.Callbacks("once memory").add(function () {
                  J.remove(e, [t + "queue", n]);
                }),
              })
            );
          },
        }),
        C.fn.extend({
          queue: function (e, t) {
            var n = 2;
            return (
              "string" != typeof e && ((t = e), (e = "fx"), n--),
              arguments.length < n
                ? C.queue(this[0], e)
                : void 0 === t
                ? this
                : this.each(function () {
                    var n = C.queue(this, e, t);
                    C._queueHooks(this, e),
                      "fx" === e && "inprogress" !== n[0] && C.dequeue(this, e);
                  })
            );
          },
          dequeue: function (e) {
            return this.each(function () {
              C.dequeue(this, e);
            });
          },
          clearQueue: function (e) {
            return this.queue(e || "fx", []);
          },
          promise: function (e, t) {
            var n,
              i = 1,
              r = C.Deferred(),
              s = this,
              a = this.length,
              o = function () {
                --i || r.resolveWith(s, [s]);
              };
            for (
              "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
              a--;

            )
              (n = J.get(s[a], e + "queueHooks")) &&
                n.empty &&
                (i++, n.empty.add(o));
            return o(), r.promise(t);
          },
        });
      var ne = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        ie = new RegExp("^(?:([+-])=|)(" + ne + ")([a-z%]*)$", "i"),
        re = ["Top", "Right", "Bottom", "Left"],
        se = b.documentElement,
        ae = function (e) {
          return C.contains(e.ownerDocument, e);
        },
        oe = {
          composed: !0,
        };
      se.getRootNode &&
        (ae = function (e) {
          return (
            C.contains(e.ownerDocument, e) ||
            e.getRootNode(oe) === e.ownerDocument
          );
        });
      var le = function (e, t) {
        return (
          "none" === (e = t || e).style.display ||
          ("" === e.style.display && ae(e) && "none" === C.css(e, "display"))
        );
      };

      function ce(e, t, n, i) {
        var r,
          s,
          a = 20,
          o = i
            ? function () {
                return i.cur();
              }
            : function () {
                return C.css(e, t, "");
              },
          l = o(),
          c = (n && n[3]) || (C.cssNumber[t] ? "" : "px"),
          u =
            e.nodeType &&
            (C.cssNumber[t] || ("px" !== c && +l)) &&
            ie.exec(C.css(e, t));
        if (u && u[3] !== c) {
          for (l /= 2, c = c || u[3], u = +l || 1; a--; )
            C.style(e, t, u + c),
              (1 - s) * (1 - (s = o() / l || 0.5)) <= 0 && (a = 0),
              (u /= s);
          (u *= 2), C.style(e, t, u + c), (n = n || []);
        }
        return (
          n &&
            ((u = +u || +l || 0),
            (r = n[1] ? u + (n[1] + 1) * n[2] : +n[2]),
            i && ((i.unit = c), (i.start = u), (i.end = r))),
          r
        );
      }
      var ue = {};

      function de(e) {
        var t,
          n = e.ownerDocument,
          i = e.nodeName,
          r = ue[i];
        return (
          r ||
          ((t = n.body.appendChild(n.createElement(i))),
          (r = C.css(t, "display")),
          t.parentNode.removeChild(t),
          "none" === r && (r = "block"),
          (ue[i] = r),
          r)
        );
      }

      function pe(e, t) {
        for (var n, i, r = [], s = 0, a = e.length; s < a; s++)
          (i = e[s]).style &&
            ((n = i.style.display),
            t
              ? ("none" === n &&
                  ((r[s] = J.get(i, "display") || null),
                  r[s] || (i.style.display = "")),
                "" === i.style.display && le(i) && (r[s] = de(i)))
              : "none" !== n && ((r[s] = "none"), J.set(i, "display", n)));
        for (s = 0; s < a; s++) null != r[s] && (e[s].style.display = r[s]);
        return e;
      }
      C.fn.extend({
        show: function () {
          return pe(this, !0);
        },
        hide: function () {
          return pe(this);
        },
        toggle: function (e) {
          return "boolean" == typeof e
            ? e
              ? this.show()
              : this.hide()
            : this.each(function () {
                le(this) ? C(this).show() : C(this).hide();
              });
        },
      });
      var fe,
        he,
        me = /^(?:checkbox|radio)$/i,
        ge = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        ve = /^$|^module$|\/(?:java|ecma)script/i;
      (fe = b.createDocumentFragment().appendChild(b.createElement("div"))),
        (he = b.createElement("input")).setAttribute("type", "radio"),
        he.setAttribute("checked", "checked"),
        he.setAttribute("name", "t"),
        fe.appendChild(he),
        (g.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (fe.innerHTML = "<textarea>x</textarea>"),
        (g.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue),
        (fe.innerHTML = "<option></option>"),
        (g.option = !!fe.lastChild);
      var ye = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
      };

      function be(e, t) {
        var n;
        return (
          (n =
            void 0 !== e.getElementsByTagName
              ? e.getElementsByTagName(t || "*")
              : void 0 !== e.querySelectorAll
              ? e.querySelectorAll(t || "*")
              : []),
          void 0 === t || (t && P(e, t)) ? C.merge([e], n) : n
        );
      }

      function _e(e, t) {
        for (var n = 0, i = e.length; n < i; n++)
          J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"));
      }
      (ye.tbody = ye.tfoot = ye.colgroup = ye.caption = ye.thead),
        (ye.th = ye.td),
        g.option ||
          (ye.optgroup = ye.option =
            [1, "<select multiple='multiple'>", "</select>"]);
      var we = /<|&#?\w+;/;

      function xe(e, t, n, i, r) {
        for (
          var s,
            a,
            o,
            l,
            c,
            u,
            d = t.createDocumentFragment(),
            p = [],
            f = 0,
            h = e.length;
          f < h;
          f++
        )
          if ((s = e[f]) || 0 === s)
            if ("object" === x(s)) C.merge(p, s.nodeType ? [s] : s);
            else if (we.test(s)) {
              for (
                a = a || d.appendChild(t.createElement("div")),
                  o = (ge.exec(s) || ["", ""])[1].toLowerCase(),
                  l = ye[o] || ye._default,
                  a.innerHTML = l[1] + C.htmlPrefilter(s) + l[2],
                  u = l[0];
                u--;

              )
                a = a.lastChild;
              C.merge(p, a.childNodes), ((a = d.firstChild).textContent = "");
            } else p.push(t.createTextNode(s));
        for (d.textContent = "", f = 0; (s = p[f++]); )
          if (i && C.inArray(s, i) > -1) r && r.push(s);
          else if (
            ((c = ae(s)), (a = be(d.appendChild(s), "script")), c && _e(a), n)
          )
            for (u = 0; (s = a[u++]); ) ve.test(s.type || "") && n.push(s);
        return d;
      }
      var Ce = /^([^.]*)(?:\.(.+)|)/;

      function Te() {
        return !0;
      }

      function ke() {
        return !1;
      }

      function Se(e, t) {
        return (
          (e ===
            (function () {
              try {
                return b.activeElement;
              } catch (e) {}
            })()) ==
          ("focus" === t)
        );
      }

      function Ee(e, t, n, i, r, s) {
        var a, o;
        if ("object" == typeof t) {
          for (o in ("string" != typeof n && ((i = i || n), (n = void 0)), t))
            Ee(e, o, n, i, t[o], s);
          return e;
        }
        if (
          (null == i && null == r
            ? ((r = n), (i = n = void 0))
            : null == r &&
              ("string" == typeof n
                ? ((r = i), (i = void 0))
                : ((r = i), (i = n), (n = void 0))),
          !1 === r)
        )
          r = ke;
        else if (!r) return e;
        return (
          1 === s &&
            ((a = r),
            ((r = function (e) {
              return C().off(e), a.apply(this, arguments);
            }).guid = a.guid || (a.guid = C.guid++))),
          e.each(function () {
            C.event.add(this, t, r, i, n);
          })
        );
      }

      function Oe(e, t, n) {
        n
          ? (J.set(e, t, !1),
            C.event.add(e, t, {
              namespace: !1,
              handler: function (e) {
                var i,
                  r,
                  s = J.get(this, t);
                if (1 & e.isTrigger && this[t]) {
                  if (s.length)
                    (C.event.special[t] || {}).delegateType &&
                      e.stopPropagation();
                  else if (
                    ((s = o.call(arguments)),
                    J.set(this, t, s),
                    (i = n(this, t)),
                    this[t](),
                    s !== (r = J.get(this, t)) || i
                      ? J.set(this, t, !1)
                      : (r = {}),
                    s !== r)
                  )
                    return (
                      e.stopImmediatePropagation(),
                      e.preventDefault(),
                      r && r.value
                    );
                } else
                  s.length &&
                    (J.set(this, t, {
                      value: C.event.trigger(
                        C.extend(s[0], C.Event.prototype),
                        s.slice(1),
                        this
                      ),
                    }),
                    e.stopImmediatePropagation());
              },
            }))
          : void 0 === J.get(e, t) && C.event.add(e, t, Te);
      }
      (C.event = {
        global: {},
        add: function (e, t, n, i, r) {
          var s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g = J.get(e);
          if (U(e))
            for (
              n.handler && ((n = (s = n).handler), (r = s.selector)),
                r && C.find.matchesSelector(se, r),
                n.guid || (n.guid = C.guid++),
                (l = g.events) || (l = g.events = Object.create(null)),
                (a = g.handle) ||
                  (a = g.handle =
                    function (t) {
                      return void 0 !== C && C.event.triggered !== t.type
                        ? C.event.dispatch.apply(e, arguments)
                        : void 0;
                    }),
                c = (t = (t || "").match(B) || [""]).length;
              c--;

            )
              (f = m = (o = Ce.exec(t[c]) || [])[1]),
                (h = (o[2] || "").split(".").sort()),
                f &&
                  ((d = C.event.special[f] || {}),
                  (f = (r ? d.delegateType : d.bindType) || f),
                  (d = C.event.special[f] || {}),
                  (u = C.extend(
                    {
                      type: f,
                      origType: m,
                      data: i,
                      handler: n,
                      guid: n.guid,
                      selector: r,
                      needsContext: r && C.expr.match.needsContext.test(r),
                      namespace: h.join("."),
                    },
                    s
                  )),
                  (p = l[f]) ||
                    (((p = l[f] = []).delegateCount = 0),
                    (d.setup && !1 !== d.setup.call(e, i, h, a)) ||
                      (e.addEventListener && e.addEventListener(f, a))),
                  d.add &&
                    (d.add.call(e, u),
                    u.handler.guid || (u.handler.guid = n.guid)),
                  r ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                  (C.event.global[f] = !0));
        },
        remove: function (e, t, n, i, r) {
          var s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g = J.hasData(e) && J.get(e);
          if (g && (l = g.events)) {
            for (c = (t = (t || "").match(B) || [""]).length; c--; )
              if (
                ((f = m = (o = Ce.exec(t[c]) || [])[1]),
                (h = (o[2] || "").split(".").sort()),
                f)
              ) {
                for (
                  d = C.event.special[f] || {},
                    p = l[(f = (i ? d.delegateType : d.bindType) || f)] || [],
                    o =
                      o[2] &&
                      new RegExp(
                        "(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"
                      ),
                    a = s = p.length;
                  s--;

                )
                  (u = p[s]),
                    (!r && m !== u.origType) ||
                      (n && n.guid !== u.guid) ||
                      (o && !o.test(u.namespace)) ||
                      (i && i !== u.selector && ("**" !== i || !u.selector)) ||
                      (p.splice(s, 1),
                      u.selector && p.delegateCount--,
                      d.remove && d.remove.call(e, u));
                a &&
                  !p.length &&
                  ((d.teardown && !1 !== d.teardown.call(e, h, g.handle)) ||
                    C.removeEvent(e, f, g.handle),
                  delete l[f]);
              } else for (f in l) C.event.remove(e, f + t[c], n, i, !0);
            C.isEmptyObject(l) && J.remove(e, "handle events");
          }
        },
        dispatch: function (e) {
          var t,
            n,
            i,
            r,
            s,
            a,
            o = new Array(arguments.length),
            l = C.event.fix(e),
            c = (J.get(this, "events") || Object.create(null))[l.type] || [],
            u = C.event.special[l.type] || {};
          for (o[0] = l, t = 1; t < arguments.length; t++) o[t] = arguments[t];
          if (
            ((l.delegateTarget = this),
            !u.preDispatch || !1 !== u.preDispatch.call(this, l))
          ) {
            for (
              a = C.event.handlers.call(this, l, c), t = 0;
              (r = a[t++]) && !l.isPropagationStopped();

            )
              for (
                l.currentTarget = r.elem, n = 0;
                (s = r.handlers[n++]) && !l.isImmediatePropagationStopped();

              )
                (l.rnamespace &&
                  !1 !== s.namespace &&
                  !l.rnamespace.test(s.namespace)) ||
                  ((l.handleObj = s),
                  (l.data = s.data),
                  void 0 !==
                    (i = (
                      (C.event.special[s.origType] || {}).handle || s.handler
                    ).apply(r.elem, o)) &&
                    !1 === (l.result = i) &&
                    (l.preventDefault(), l.stopPropagation()));
            return u.postDispatch && u.postDispatch.call(this, l), l.result;
          }
        },
        handlers: function (e, t) {
          var n,
            i,
            r,
            s,
            a,
            o = [],
            l = t.delegateCount,
            c = e.target;
          if (l && c.nodeType && !("click" === e.type && e.button >= 1))
            for (; c !== this; c = c.parentNode || this)
              if (
                1 === c.nodeType &&
                ("click" !== e.type || !0 !== c.disabled)
              ) {
                for (s = [], a = {}, n = 0; n < l; n++)
                  void 0 === a[(r = (i = t[n]).selector + " ")] &&
                    (a[r] = i.needsContext
                      ? C(r, this).index(c) > -1
                      : C.find(r, this, null, [c]).length),
                    a[r] && s.push(i);
                s.length &&
                  o.push({
                    elem: c,
                    handlers: s,
                  });
              }
          return (
            (c = this),
            l < t.length &&
              o.push({
                elem: c,
                handlers: t.slice(l),
              }),
            o
          );
        },
        addProp: function (e, t) {
          Object.defineProperty(C.Event.prototype, e, {
            enumerable: !0,
            configurable: !0,
            get: v(t)
              ? function () {
                  if (this.originalEvent) return t(this.originalEvent);
                }
              : function () {
                  if (this.originalEvent) return this.originalEvent[e];
                },
            set: function (t) {
              Object.defineProperty(this, e, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: t,
              });
            },
          });
        },
        fix: function (e) {
          return e[C.expando] ? e : new C.Event(e);
        },
        special: {
          load: {
            noBubble: !0,
          },
          click: {
            setup: function (e) {
              var t = this || e;
              return (
                me.test(t.type) &&
                  t.click &&
                  P(t, "input") &&
                  Oe(t, "click", Te),
                !1
              );
            },
            trigger: function (e) {
              var t = this || e;
              return (
                me.test(t.type) && t.click && P(t, "input") && Oe(t, "click"),
                !0
              );
            },
            _default: function (e) {
              var t = e.target;
              return (
                (me.test(t.type) &&
                  t.click &&
                  P(t, "input") &&
                  J.get(t, "click")) ||
                P(t, "a")
              );
            },
          },
          beforeunload: {
            postDispatch: function (e) {
              void 0 !== e.result &&
                e.originalEvent &&
                (e.originalEvent.returnValue = e.result);
            },
          },
        },
      }),
        (C.removeEvent = function (e, t, n) {
          e.removeEventListener && e.removeEventListener(t, n);
        }),
        (C.Event = function (e, t) {
          if (!(this instanceof C.Event)) return new C.Event(e, t);
          e && e.type
            ? ((this.originalEvent = e),
              (this.type = e.type),
              (this.isDefaultPrevented =
                e.defaultPrevented ||
                (void 0 === e.defaultPrevented && !1 === e.returnValue)
                  ? Te
                  : ke),
              (this.target =
                e.target && 3 === e.target.nodeType
                  ? e.target.parentNode
                  : e.target),
              (this.currentTarget = e.currentTarget),
              (this.relatedTarget = e.relatedTarget))
            : (this.type = e),
            t && C.extend(this, t),
            (this.timeStamp = (e && e.timeStamp) || Date.now()),
            (this[C.expando] = !0);
        }),
        (C.Event.prototype = {
          constructor: C.Event,
          isDefaultPrevented: ke,
          isPropagationStopped: ke,
          isImmediatePropagationStopped: ke,
          isSimulated: !1,
          preventDefault: function () {
            var e = this.originalEvent;
            (this.isDefaultPrevented = Te),
              e && !this.isSimulated && e.preventDefault();
          },
          stopPropagation: function () {
            var e = this.originalEvent;
            (this.isPropagationStopped = Te),
              e && !this.isSimulated && e.stopPropagation();
          },
          stopImmediatePropagation: function () {
            var e = this.originalEvent;
            (this.isImmediatePropagationStopped = Te),
              e && !this.isSimulated && e.stopImmediatePropagation(),
              this.stopPropagation();
          },
        }),
        C.each(
          {
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            code: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: !0,
          },
          C.event.addProp
        ),
        C.each(
          {
            focus: "focusin",
            blur: "focusout",
          },
          function (e, t) {
            C.event.special[e] = {
              setup: function () {
                return Oe(this, e, Se), !1;
              },
              trigger: function () {
                return Oe(this, e), !0;
              },
              _default: function () {
                return !0;
              },
              delegateType: t,
            };
          }
        ),
        C.each(
          {
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout",
          },
          function (e, t) {
            C.event.special[e] = {
              delegateType: t,
              bindType: t,
              handle: function (e) {
                var n,
                  i = this,
                  r = e.relatedTarget,
                  s = e.handleObj;
                return (
                  (r && (r === i || C.contains(i, r))) ||
                    ((e.type = s.origType),
                    (n = s.handler.apply(this, arguments)),
                    (e.type = t)),
                  n
                );
              },
            };
          }
        ),
        C.fn.extend({
          on: function (e, t, n, i) {
            return Ee(this, e, t, n, i);
          },
          one: function (e, t, n, i) {
            return Ee(this, e, t, n, i, 1);
          },
          off: function (e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj)
              return (
                (i = e.handleObj),
                C(e.delegateTarget).off(
                  i.namespace ? i.origType + "." + i.namespace : i.origType,
                  i.selector,
                  i.handler
                ),
                this
              );
            if ("object" == typeof e) {
              for (r in e) this.off(r, t, e[r]);
              return this;
            }
            return (
              (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
              !1 === n && (n = ke),
              this.each(function () {
                C.event.remove(this, e, n, t);
              })
            );
          },
        });
      var Pe = /<script|<style|<link/i,
        Me = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Ae = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

      function De(e, t) {
        return (
          (P(e, "table") &&
            P(11 !== t.nodeType ? t : t.firstChild, "tr") &&
            C(e).children("tbody")[0]) ||
          e
        );
      }

      function Ie(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
      }

      function Le(e) {
        return (
          "true/" === (e.type || "").slice(0, 5)
            ? (e.type = e.type.slice(5))
            : e.removeAttribute("type"),
          e
        );
      }

      function je(e, t) {
        var n, i, r, s, a, o;
        if (1 === t.nodeType) {
          if (J.hasData(e) && (o = J.get(e).events))
            for (r in (J.remove(t, "handle events"), o))
              for (n = 0, i = o[r].length; n < i; n++)
                C.event.add(t, r, o[r][n]);
          K.hasData(e) &&
            ((s = K.access(e)), (a = C.extend({}, s)), K.set(t, a));
        }
      }

      function Ne(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && me.test(e.type)
          ? (t.checked = e.checked)
          : ("input" !== n && "textarea" !== n) ||
            (t.defaultValue = e.defaultValue);
      }

      function Be(e, t, n, i) {
        t = l(t);
        var r,
          s,
          a,
          o,
          c,
          u,
          d = 0,
          p = e.length,
          f = p - 1,
          h = t[0],
          m = v(h);
        if (m || (p > 1 && "string" == typeof h && !g.checkClone && Me.test(h)))
          return e.each(function (r) {
            var s = e.eq(r);
            m && (t[0] = h.call(this, r, s.html())), Be(s, t, n, i);
          });
        if (
          p &&
          ((s = (r = xe(t, e[0].ownerDocument, !1, e, i)).firstChild),
          1 === r.childNodes.length && (r = s),
          s || i)
        ) {
          for (o = (a = C.map(be(r, "script"), Ie)).length; d < p; d++)
            (c = r),
              d !== f &&
                ((c = C.clone(c, !0, !0)), o && C.merge(a, be(c, "script"))),
              n.call(e[d], c, d);
          if (o)
            for (
              u = a[a.length - 1].ownerDocument, C.map(a, Le), d = 0;
              d < o;
              d++
            )
              (c = a[d]),
                ve.test(c.type || "") &&
                  !J.access(c, "globalEval") &&
                  C.contains(u, c) &&
                  (c.src && "module" !== (c.type || "").toLowerCase()
                    ? C._evalUrl &&
                      !c.noModule &&
                      C._evalUrl(
                        c.src,
                        {
                          nonce: c.nonce || c.getAttribute("nonce"),
                        },
                        u
                      )
                    : w(c.textContent.replace(Ae, ""), c, u));
        }
        return e;
      }

      function $e(e, t, n) {
        for (var i, r = t ? C.filter(t, e) : e, s = 0; null != (i = r[s]); s++)
          n || 1 !== i.nodeType || C.cleanData(be(i)),
            i.parentNode &&
              (n && ae(i) && _e(be(i, "script")), i.parentNode.removeChild(i));
        return e;
      }
      C.extend({
        htmlPrefilter: function (e) {
          return e;
        },
        clone: function (e, t, n) {
          var i,
            r,
            s,
            a,
            o = e.cloneNode(!0),
            l = ae(e);
          if (
            !(
              g.noCloneChecked ||
              (1 !== e.nodeType && 11 !== e.nodeType) ||
              C.isXMLDoc(e)
            )
          )
            for (a = be(o), i = 0, r = (s = be(e)).length; i < r; i++)
              Ne(s[i], a[i]);
          if (t)
            if (n)
              for (
                s = s || be(e), a = a || be(o), i = 0, r = s.length;
                i < r;
                i++
              )
                je(s[i], a[i]);
            else je(e, o);
          return (
            (a = be(o, "script")).length > 0 && _e(a, !l && be(e, "script")), o
          );
        },
        cleanData: function (e) {
          for (
            var t, n, i, r = C.event.special, s = 0;
            void 0 !== (n = e[s]);
            s++
          )
            if (U(n)) {
              if ((t = n[J.expando])) {
                if (t.events)
                  for (i in t.events)
                    r[i] ? C.event.remove(n, i) : C.removeEvent(n, i, t.handle);
                n[J.expando] = void 0;
              }
              n[K.expando] && (n[K.expando] = void 0);
            }
        },
      }),
        C.fn.extend({
          detach: function (e) {
            return $e(this, e, !0);
          },
          remove: function (e) {
            return $e(this, e);
          },
          text: function (e) {
            return W(
              this,
              function (e) {
                return void 0 === e
                  ? C.text(this)
                  : this.empty().each(function () {
                      (1 !== this.nodeType &&
                        11 !== this.nodeType &&
                        9 !== this.nodeType) ||
                        (this.textContent = e);
                    });
              },
              null,
              e,
              arguments.length
            );
          },
          append: function () {
            return Be(this, arguments, function (e) {
              (1 !== this.nodeType &&
                11 !== this.nodeType &&
                9 !== this.nodeType) ||
                De(this, e).appendChild(e);
            });
          },
          prepend: function () {
            return Be(this, arguments, function (e) {
              if (
                1 === this.nodeType ||
                11 === this.nodeType ||
                9 === this.nodeType
              ) {
                var t = De(this, e);
                t.insertBefore(e, t.firstChild);
              }
            });
          },
          before: function () {
            return Be(this, arguments, function (e) {
              this.parentNode && this.parentNode.insertBefore(e, this);
            });
          },
          after: function () {
            return Be(this, arguments, function (e) {
              this.parentNode &&
                this.parentNode.insertBefore(e, this.nextSibling);
            });
          },
          empty: function () {
            for (var e, t = 0; null != (e = this[t]); t++)
              1 === e.nodeType &&
                (C.cleanData(be(e, !1)), (e.textContent = ""));
            return this;
          },
          clone: function (e, t) {
            return (
              (e = null != e && e),
              (t = null == t ? e : t),
              this.map(function () {
                return C.clone(this, e, t);
              })
            );
          },
          html: function (e) {
            return W(
              this,
              function (e) {
                var t = this[0] || {},
                  n = 0,
                  i = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if (
                  "string" == typeof e &&
                  !Pe.test(e) &&
                  !ye[(ge.exec(e) || ["", ""])[1].toLowerCase()]
                ) {
                  e = C.htmlPrefilter(e);
                  try {
                    for (; n < i; n++)
                      1 === (t = this[n] || {}).nodeType &&
                        (C.cleanData(be(t, !1)), (t.innerHTML = e));
                    t = 0;
                  } catch (e) {}
                }
                t && this.empty().append(e);
              },
              null,
              e,
              arguments.length
            );
          },
          replaceWith: function () {
            var e = [];
            return Be(
              this,
              arguments,
              function (t) {
                var n = this.parentNode;
                C.inArray(this, e) < 0 &&
                  (C.cleanData(be(this)), n && n.replaceChild(t, this));
              },
              e
            );
          },
        }),
        C.each(
          {
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith",
          },
          function (e, t) {
            C.fn[e] = function (e) {
              for (
                var n, i = [], r = C(e), s = r.length - 1, a = 0;
                a <= s;
                a++
              )
                (n = a === s ? this : this.clone(!0)),
                  C(r[a])[t](n),
                  c.apply(i, n.get());
              return this.pushStack(i);
            };
          }
        );
      var ze = new RegExp("^(" + ne + ")(?!px)[a-z%]+$", "i"),
        Re = function (e) {
          var t = e.ownerDocument.defaultView;
          return (t && t.opener) || (t = n), t.getComputedStyle(e);
        },
        He = function (e, t, n) {
          var i,
            r,
            s = {};
          for (r in t) (s[r] = e.style[r]), (e.style[r] = t[r]);
          for (r in ((i = n.call(e)), t)) e.style[r] = s[r];
          return i;
        },
        Fe = new RegExp(re.join("|"), "i");

      function qe(e, t, n) {
        var i,
          r,
          s,
          a,
          o = e.style;
        return (
          (n = n || Re(e)) &&
            ("" !== (a = n.getPropertyValue(t) || n[t]) ||
              ae(e) ||
              (a = C.style(e, t)),
            !g.pixelBoxStyles() &&
              ze.test(a) &&
              Fe.test(t) &&
              ((i = o.width),
              (r = o.minWidth),
              (s = o.maxWidth),
              (o.minWidth = o.maxWidth = o.width = a),
              (a = n.width),
              (o.width = i),
              (o.minWidth = r),
              (o.maxWidth = s))),
          void 0 !== a ? a + "" : a
        );
      }

      function We(e, t) {
        return {
          get: function () {
            if (!e()) return (this.get = t).apply(this, arguments);
            delete this.get;
          },
        };
      }
      !(function () {
        function e() {
          if (u) {
            (c.style.cssText =
              "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
              (u.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
              se.appendChild(c).appendChild(u);
            var e = n.getComputedStyle(u);
            (i = "1%" !== e.top),
              (l = 12 === t(e.marginLeft)),
              (u.style.right = "60%"),
              (a = 36 === t(e.right)),
              (r = 36 === t(e.width)),
              (u.style.position = "absolute"),
              (s = 12 === t(u.offsetWidth / 3)),
              se.removeChild(c),
              (u = null);
          }
        }

        function t(e) {
          return Math.round(parseFloat(e));
        }
        var i,
          r,
          s,
          a,
          o,
          l,
          c = b.createElement("div"),
          u = b.createElement("div");
        u.style &&
          ((u.style.backgroundClip = "content-box"),
          (u.cloneNode(!0).style.backgroundClip = ""),
          (g.clearCloneStyle = "content-box" === u.style.backgroundClip),
          C.extend(g, {
            boxSizingReliable: function () {
              return e(), r;
            },
            pixelBoxStyles: function () {
              return e(), a;
            },
            pixelPosition: function () {
              return e(), i;
            },
            reliableMarginLeft: function () {
              return e(), l;
            },
            scrollboxSize: function () {
              return e(), s;
            },
            reliableTrDimensions: function () {
              var e, t, i, r;
              return (
                null == o &&
                  ((e = b.createElement("table")),
                  (t = b.createElement("tr")),
                  (i = b.createElement("div")),
                  (e.style.cssText =
                    "position:absolute;left:-11111px;border-collapse:separate"),
                  (t.style.cssText = "border:1px solid"),
                  (t.style.height = "1px"),
                  (i.style.height = "9px"),
                  (i.style.display = "block"),
                  se.appendChild(e).appendChild(t).appendChild(i),
                  (r = n.getComputedStyle(t)),
                  (o =
                    parseInt(r.height, 10) +
                      parseInt(r.borderTopWidth, 10) +
                      parseInt(r.borderBottomWidth, 10) ===
                    t.offsetHeight),
                  se.removeChild(e)),
                o
              );
            },
          }));
      })();
      var Ve = ["Webkit", "Moz", "ms"],
        Ge = b.createElement("div").style,
        Xe = {};

      function Ye(e) {
        var t = C.cssProps[e] || Xe[e];
        return (
          t ||
          (e in Ge
            ? e
            : (Xe[e] =
                (function (e) {
                  for (
                    var t = e[0].toUpperCase() + e.slice(1), n = Ve.length;
                    n--;

                  )
                    if ((e = Ve[n] + t) in Ge) return e;
                })(e) || e))
        );
      }
      var Ue = /^(none|table(?!-c[ea]).+)/,
        Qe = /^--/,
        Je = {
          position: "absolute",
          visibility: "hidden",
          display: "block",
        },
        Ke = {
          letterSpacing: "0",
          fontWeight: "400",
        };

      function Ze(e, t, n) {
        var i = ie.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
      }

      function et(e, t, n, i, r, s) {
        var a = "width" === t ? 1 : 0,
          o = 0,
          l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; a < 4; a += 2)
          "margin" === n && (l += C.css(e, n + re[a], !0, r)),
            i
              ? ("content" === n && (l -= C.css(e, "padding" + re[a], !0, r)),
                "margin" !== n &&
                  (l -= C.css(e, "border" + re[a] + "Width", !0, r)))
              : ((l += C.css(e, "padding" + re[a], !0, r)),
                "padding" !== n
                  ? (l += C.css(e, "border" + re[a] + "Width", !0, r))
                  : (o += C.css(e, "border" + re[a] + "Width", !0, r)));
        return (
          !i &&
            s >= 0 &&
            (l +=
              Math.max(
                0,
                Math.ceil(
                  e["offset" + t[0].toUpperCase() + t.slice(1)] -
                    s -
                    l -
                    o -
                    0.5
                )
              ) || 0),
          l
        );
      }

      function tt(e, t, n) {
        var i = Re(e),
          r =
            (!g.boxSizingReliable() || n) &&
            "border-box" === C.css(e, "boxSizing", !1, i),
          s = r,
          a = qe(e, t, i),
          o = "offset" + t[0].toUpperCase() + t.slice(1);
        if (ze.test(a)) {
          if (!n) return a;
          a = "auto";
        }
        return (
          ((!g.boxSizingReliable() && r) ||
            (!g.reliableTrDimensions() && P(e, "tr")) ||
            "auto" === a ||
            (!parseFloat(a) && "inline" === C.css(e, "display", !1, i))) &&
            e.getClientRects().length &&
            ((r = "border-box" === C.css(e, "boxSizing", !1, i)),
            (s = o in e) && (a = e[o])),
          (a = parseFloat(a) || 0) +
            et(e, t, n || (r ? "border" : "content"), s, i, a) +
            "px"
        );
      }

      function nt(e, t, n, i, r) {
        return new nt.prototype.init(e, t, n, i, r);
      }
      C.extend({
        cssHooks: {
          opacity: {
            get: function (e, t) {
              if (t) {
                var n = qe(e, "opacity");
                return "" === n ? "1" : n;
              }
            },
          },
        },
        cssNumber: {
          animationIterationCount: !0,
          columnCount: !0,
          fillOpacity: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          gridArea: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnStart: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowStart: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
        },
        cssProps: {},
        style: function (e, t, n, i) {
          if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
            var r,
              s,
              a,
              o = Y(t),
              l = Qe.test(t),
              c = e.style;
            if (
              (l || (t = Ye(o)),
              (a = C.cssHooks[t] || C.cssHooks[o]),
              void 0 === n)
            )
              return a && "get" in a && void 0 !== (r = a.get(e, !1, i))
                ? r
                : c[t];
            "string" === (s = typeof n) &&
              (r = ie.exec(n)) &&
              r[1] &&
              ((n = ce(e, t, r)), (s = "number")),
              null != n &&
                n == n &&
                ("number" !== s ||
                  l ||
                  (n += (r && r[3]) || (C.cssNumber[o] ? "" : "px")),
                g.clearCloneStyle ||
                  "" !== n ||
                  0 !== t.indexOf("background") ||
                  (c[t] = "inherit"),
                (a && "set" in a && void 0 === (n = a.set(e, n, i))) ||
                  (l ? c.setProperty(t, n) : (c[t] = n)));
          }
        },
        css: function (e, t, n, i) {
          var r,
            s,
            a,
            o = Y(t);
          return (
            Qe.test(t) || (t = Ye(o)),
            (a = C.cssHooks[t] || C.cssHooks[o]) &&
              "get" in a &&
              (r = a.get(e, !0, n)),
            void 0 === r && (r = qe(e, t, i)),
            "normal" === r && t in Ke && (r = Ke[t]),
            "" === n || n
              ? ((s = parseFloat(r)), !0 === n || isFinite(s) ? s || 0 : r)
              : r
          );
        },
      }),
        C.each(["height", "width"], function (e, t) {
          C.cssHooks[t] = {
            get: function (e, n, i) {
              if (n)
                return !Ue.test(C.css(e, "display")) ||
                  (e.getClientRects().length && e.getBoundingClientRect().width)
                  ? tt(e, t, i)
                  : He(e, Je, function () {
                      return tt(e, t, i);
                    });
            },
            set: function (e, n, i) {
              var r,
                s = Re(e),
                a = !g.scrollboxSize() && "absolute" === s.position,
                o = (a || i) && "border-box" === C.css(e, "boxSizing", !1, s),
                l = i ? et(e, t, i, o, s) : 0;
              return (
                o &&
                  a &&
                  (l -= Math.ceil(
                    e["offset" + t[0].toUpperCase() + t.slice(1)] -
                      parseFloat(s[t]) -
                      et(e, t, "border", !1, s) -
                      0.5
                  )),
                l &&
                  (r = ie.exec(n)) &&
                  "px" !== (r[3] || "px") &&
                  ((e.style[t] = n), (n = C.css(e, t))),
                Ze(0, n, l)
              );
            },
          };
        }),
        (C.cssHooks.marginLeft = We(g.reliableMarginLeft, function (e, t) {
          if (t)
            return (
              (parseFloat(qe(e, "marginLeft")) ||
                e.getBoundingClientRect().left -
                  He(
                    e,
                    {
                      marginLeft: 0,
                    },
                    function () {
                      return e.getBoundingClientRect().left;
                    }
                  )) + "px"
            );
        })),
        C.each(
          {
            margin: "",
            padding: "",
            border: "Width",
          },
          function (e, t) {
            (C.cssHooks[e + t] = {
              expand: function (n) {
                for (
                  var i = 0,
                    r = {},
                    s = "string" == typeof n ? n.split(" ") : [n];
                  i < 4;
                  i++
                )
                  r[e + re[i] + t] = s[i] || s[i - 2] || s[0];
                return r;
              },
            }),
              "margin" !== e && (C.cssHooks[e + t].set = Ze);
          }
        ),
        C.fn.extend({
          css: function (e, t) {
            return W(
              this,
              function (e, t, n) {
                var i,
                  r,
                  s = {},
                  a = 0;
                if (Array.isArray(t)) {
                  for (i = Re(e), r = t.length; a < r; a++)
                    s[t[a]] = C.css(e, t[a], !1, i);
                  return s;
                }
                return void 0 !== n ? C.style(e, t, n) : C.css(e, t);
              },
              e,
              t,
              arguments.length > 1
            );
          },
        }),
        (C.Tween = nt),
        (nt.prototype = {
          constructor: nt,
          init: function (e, t, n, i, r, s) {
            (this.elem = e),
              (this.prop = n),
              (this.easing = r || C.easing._default),
              (this.options = t),
              (this.start = this.now = this.cur()),
              (this.end = i),
              (this.unit = s || (C.cssNumber[n] ? "" : "px"));
          },
          cur: function () {
            var e = nt.propHooks[this.prop];
            return e && e.get ? e.get(this) : nt.propHooks._default.get(this);
          },
          run: function (e) {
            var t,
              n = nt.propHooks[this.prop];
            return (
              this.options.duration
                ? (this.pos = t =
                    C.easing[this.easing](
                      e,
                      this.options.duration * e,
                      0,
                      1,
                      this.options.duration
                    ))
                : (this.pos = t = e),
              (this.now = (this.end - this.start) * t + this.start),
              this.options.step &&
                this.options.step.call(this.elem, this.now, this),
              n && n.set ? n.set(this) : nt.propHooks._default.set(this),
              this
            );
          },
        }),
        (nt.prototype.init.prototype = nt.prototype),
        (nt.propHooks = {
          _default: {
            get: function (e) {
              var t;
              return 1 !== e.elem.nodeType ||
                (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                ? e.elem[e.prop]
                : (t = C.css(e.elem, e.prop, "")) && "auto" !== t
                ? t
                : 0;
            },
            set: function (e) {
              C.fx.step[e.prop]
                ? C.fx.step[e.prop](e)
                : 1 !== e.elem.nodeType ||
                  (!C.cssHooks[e.prop] && null == e.elem.style[Ye(e.prop)])
                ? (e.elem[e.prop] = e.now)
                : C.style(e.elem, e.prop, e.now + e.unit);
            },
          },
        }),
        (nt.propHooks.scrollTop = nt.propHooks.scrollLeft =
          {
            set: function (e) {
              e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
          }),
        (C.easing = {
          linear: function (e) {
            return e;
          },
          swing: function (e) {
            return 0.5 - Math.cos(e * Math.PI) / 2;
          },
          _default: "swing",
        }),
        (C.fx = nt.prototype.init),
        (C.fx.step = {});
      var it,
        rt,
        st = /^(?:toggle|show|hide)$/,
        at = /queueHooks$/;

      function ot() {
        rt &&
          (!1 === b.hidden && n.requestAnimationFrame
            ? n.requestAnimationFrame(ot)
            : n.setTimeout(ot, C.fx.interval),
          C.fx.tick());
      }

      function lt() {
        return (
          n.setTimeout(function () {
            it = void 0;
          }),
          (it = Date.now())
        );
      }

      function ct(e, t) {
        var n,
          i = 0,
          r = {
            height: e,
          };
        for (t = t ? 1 : 0; i < 4; i += 2 - t)
          r["margin" + (n = re[i])] = r["padding" + n] = e;
        return t && (r.opacity = r.width = e), r;
      }

      function ut(e, t, n) {
        for (
          var i,
            r = (dt.tweeners[t] || []).concat(dt.tweeners["*"]),
            s = 0,
            a = r.length;
          s < a;
          s++
        )
          if ((i = r[s].call(n, t, e))) return i;
      }

      function dt(e, t, n) {
        var i,
          r,
          s = 0,
          a = dt.prefilters.length,
          o = C.Deferred().always(function () {
            delete l.elem;
          }),
          l = function () {
            if (r) return !1;
            for (
              var t = it || lt(),
                n = Math.max(0, c.startTime + c.duration - t),
                i = 1 - (n / c.duration || 0),
                s = 0,
                a = c.tweens.length;
              s < a;
              s++
            )
              c.tweens[s].run(i);
            return (
              o.notifyWith(e, [c, i, n]),
              i < 1 && a
                ? n
                : (a || o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c]), !1)
            );
          },
          c = o.promise({
            elem: e,
            props: C.extend({}, t),
            opts: C.extend(
              !0,
              {
                specialEasing: {},
                easing: C.easing._default,
              },
              n
            ),
            originalProperties: t,
            originalOptions: n,
            startTime: it || lt(),
            duration: n.duration,
            tweens: [],
            createTween: function (t, n) {
              var i = C.Tween(
                e,
                c.opts,
                t,
                n,
                c.opts.specialEasing[t] || c.opts.easing
              );
              return c.tweens.push(i), i;
            },
            stop: function (t) {
              var n = 0,
                i = t ? c.tweens.length : 0;
              if (r) return this;
              for (r = !0; n < i; n++) c.tweens[n].run(1);
              return (
                t
                  ? (o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c, t]))
                  : o.rejectWith(e, [c, t]),
                this
              );
            },
          }),
          u = c.props;
        for (
          !(function (e, t) {
            var n, i, r, s, a;
            for (n in e)
              if (
                ((r = t[(i = Y(n))]),
                (s = e[n]),
                Array.isArray(s) && ((r = s[1]), (s = e[n] = s[0])),
                n !== i && ((e[i] = s), delete e[n]),
                (a = C.cssHooks[i]) && ("expand" in a))
              )
                for (n in ((s = a.expand(s)), delete e[i], s))
                  (n in e) || ((e[n] = s[n]), (t[n] = r));
              else t[i] = r;
          })(u, c.opts.specialEasing);
          s < a;
          s++
        )
          if ((i = dt.prefilters[s].call(c, e, u, c.opts)))
            return (
              v(i.stop) &&
                (C._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
              i
            );
        return (
          C.map(u, ut, c),
          v(c.opts.start) && c.opts.start.call(e, c),
          c
            .progress(c.opts.progress)
            .done(c.opts.done, c.opts.complete)
            .fail(c.opts.fail)
            .always(c.opts.always),
          C.fx.timer(
            C.extend(l, {
              elem: e,
              anim: c,
              queue: c.opts.queue,
            })
          ),
          c
        );
      }
      (C.Animation = C.extend(dt, {
        tweeners: {
          "*": [
            function (e, t) {
              var n = this.createTween(e, t);
              return ce(n.elem, e, ie.exec(t), n), n;
            },
          ],
        },
        tweener: function (e, t) {
          v(e) ? ((t = e), (e = ["*"])) : (e = e.match(B));
          for (var n, i = 0, r = e.length; i < r; i++)
            (n = e[i]),
              (dt.tweeners[n] = dt.tweeners[n] || []),
              dt.tweeners[n].unshift(t);
        },
        prefilters: [
          function (e, t, n) {
            var i,
              r,
              s,
              a,
              o,
              l,
              c,
              u,
              d = "width" in t || "height" in t,
              p = this,
              f = {},
              h = e.style,
              m = e.nodeType && le(e),
              g = J.get(e, "fxshow");
            for (i in (n.queue ||
              (null == (a = C._queueHooks(e, "fx")).unqueued &&
                ((a.unqueued = 0),
                (o = a.empty.fire),
                (a.empty.fire = function () {
                  a.unqueued || o();
                })),
              a.unqueued++,
              p.always(function () {
                p.always(function () {
                  a.unqueued--, C.queue(e, "fx").length || a.empty.fire();
                });
              })),
            t))
              if (((r = t[i]), st.test(r))) {
                if (
                  (delete t[i],
                  (s = s || "toggle" === r),
                  r === (m ? "hide" : "show"))
                ) {
                  if ("show" !== r || !g || void 0 === g[i]) continue;
                  m = !0;
                }
                f[i] = (g && g[i]) || C.style(e, i);
              }
            if ((l = !C.isEmptyObject(t)) || !C.isEmptyObject(f))
              for (i in (d &&
                1 === e.nodeType &&
                ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                null == (c = g && g.display) && (c = J.get(e, "display")),
                "none" === (u = C.css(e, "display")) &&
                  (c
                    ? (u = c)
                    : (pe([e], !0),
                      (c = e.style.display || c),
                      (u = C.css(e, "display")),
                      pe([e]))),
                ("inline" === u || ("inline-block" === u && null != c)) &&
                  "none" === C.css(e, "float") &&
                  (l ||
                    (p.done(function () {
                      h.display = c;
                    }),
                    null == c &&
                      ((u = h.display), (c = "none" === u ? "" : u))),
                  (h.display = "inline-block"))),
              n.overflow &&
                ((h.overflow = "hidden"),
                p.always(function () {
                  (h.overflow = n.overflow[0]),
                    (h.overflowX = n.overflow[1]),
                    (h.overflowY = n.overflow[2]);
                })),
              (l = !1),
              f))
                l ||
                  (g
                    ? "hidden" in g && (m = g.hidden)
                    : (g = J.access(e, "fxshow", {
                        display: c,
                      })),
                  s && (g.hidden = !m),
                  m && pe([e], !0),
                  p.done(function () {
                    for (i in (m || pe([e]), J.remove(e, "fxshow"), f))
                      C.style(e, i, f[i]);
                  })),
                  (l = ut(m ? g[i] : 0, i, p)),
                  i in g ||
                    ((g[i] = l.start), m && ((l.end = l.start), (l.start = 0)));
          },
        ],
        prefilter: function (e, t) {
          t ? dt.prefilters.unshift(e) : dt.prefilters.push(e);
        },
      })),
        (C.speed = function (e, t, n) {
          var i =
            e && "object" == typeof e
              ? C.extend({}, e)
              : {
                  complete: n || (!n && t) || (v(e) && e),
                  duration: e,
                  easing: (n && t) || (t && !v(t) && t),
                };
          return (
            C.fx.off
              ? (i.duration = 0)
              : "number" != typeof i.duration &&
                (i.duration in C.fx.speeds
                  ? (i.duration = C.fx.speeds[i.duration])
                  : (i.duration = C.fx.speeds._default)),
            (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
            (i.old = i.complete),
            (i.complete = function () {
              v(i.old) && i.old.call(this), i.queue && C.dequeue(this, i.queue);
            }),
            i
          );
        }),
        C.fn.extend({
          fadeTo: function (e, t, n, i) {
            return this.filter(le).css("opacity", 0).show().end().animate(
              {
                opacity: t,
              },
              e,
              n,
              i
            );
          },
          animate: function (e, t, n, i) {
            var r = C.isEmptyObject(e),
              s = C.speed(t, n, i),
              a = function () {
                var t = dt(this, C.extend({}, e), s);
                (r || J.get(this, "finish")) && t.stop(!0);
              };
            return (
              (a.finish = a),
              r || !1 === s.queue ? this.each(a) : this.queue(s.queue, a)
            );
          },
          stop: function (e, t, n) {
            var i = function (e) {
              var t = e.stop;
              delete e.stop, t(n);
            };
            return (
              "string" != typeof e && ((n = t), (t = e), (e = void 0)),
              t && this.queue(e || "fx", []),
              this.each(function () {
                var t = !0,
                  r = null != e && e + "queueHooks",
                  s = C.timers,
                  a = J.get(this);
                if (r) a[r] && a[r].stop && i(a[r]);
                else for (r in a) a[r] && a[r].stop && at.test(r) && i(a[r]);
                for (r = s.length; r--; )
                  s[r].elem !== this ||
                    (null != e && s[r].queue !== e) ||
                    (s[r].anim.stop(n), (t = !1), s.splice(r, 1));
                (!t && n) || C.dequeue(this, e);
              })
            );
          },
          finish: function (e) {
            return (
              !1 !== e && (e = e || "fx"),
              this.each(function () {
                var t,
                  n = J.get(this),
                  i = n[e + "queue"],
                  r = n[e + "queueHooks"],
                  s = C.timers,
                  a = i ? i.length : 0;
                for (
                  n.finish = !0,
                    C.queue(this, e, []),
                    r && r.stop && r.stop.call(this, !0),
                    t = s.length;
                  t--;

                )
                  s[t].elem === this &&
                    s[t].queue === e &&
                    (s[t].anim.stop(!0), s.splice(t, 1));
                for (t = 0; t < a; t++)
                  i[t] && i[t].finish && i[t].finish.call(this);
                delete n.finish;
              })
            );
          },
        }),
        C.each(["toggle", "show", "hide"], function (e, t) {
          var n = C.fn[t];
          C.fn[t] = function (e, i, r) {
            return null == e || "boolean" == typeof e
              ? n.apply(this, arguments)
              : this.animate(ct(t, !0), e, i, r);
          };
        }),
        C.each(
          {
            slideDown: ct("show"),
            slideUp: ct("hide"),
            slideToggle: ct("toggle"),
            fadeIn: {
              opacity: "show",
            },
            fadeOut: {
              opacity: "hide",
            },
            fadeToggle: {
              opacity: "toggle",
            },
          },
          function (e, t) {
            C.fn[e] = function (e, n, i) {
              return this.animate(t, e, n, i);
            };
          }
        ),
        (C.timers = []),
        (C.fx.tick = function () {
          var e,
            t = 0,
            n = C.timers;
          for (it = Date.now(); t < n.length; t++)
            (e = n[t])() || n[t] !== e || n.splice(t--, 1);
          n.length || C.fx.stop(), (it = void 0);
        }),
        (C.fx.timer = function (e) {
          C.timers.push(e), C.fx.start();
        }),
        (C.fx.interval = 13),
        (C.fx.start = function () {
          rt || ((rt = !0), ot());
        }),
        (C.fx.stop = function () {
          rt = null;
        }),
        (C.fx.speeds = {
          slow: 600,
          fast: 200,
          _default: 400,
        }),
        (C.fn.delay = function (e, t) {
          return (
            (e = (C.fx && C.fx.speeds[e]) || e),
            (t = t || "fx"),
            this.queue(t, function (t, i) {
              var r = n.setTimeout(t, e);
              i.stop = function () {
                n.clearTimeout(r);
              };
            })
          );
        }),
        (function () {
          var e = b.createElement("input"),
            t = b
              .createElement("select")
              .appendChild(b.createElement("option"));
          (e.type = "checkbox"),
            (g.checkOn = "" !== e.value),
            (g.optSelected = t.selected),
            ((e = b.createElement("input")).value = "t"),
            (e.type = "radio"),
            (g.radioValue = "t" === e.value);
        })();
      var pt,
        ft = C.expr.attrHandle;
      C.fn.extend({
        attr: function (e, t) {
          return W(this, C.attr, e, t, arguments.length > 1);
        },
        removeAttr: function (e) {
          return this.each(function () {
            C.removeAttr(this, e);
          });
        },
      }),
        C.extend({
          attr: function (e, t, n) {
            var i,
              r,
              s = e.nodeType;
            if (3 !== s && 8 !== s && 2 !== s)
              return void 0 === e.getAttribute
                ? C.prop(e, t, n)
                : ((1 === s && C.isXMLDoc(e)) ||
                    (r =
                      C.attrHooks[t.toLowerCase()] ||
                      (C.expr.match.bool.test(t) ? pt : void 0)),
                  void 0 !== n
                    ? null === n
                      ? void C.removeAttr(e, t)
                      : r && "set" in r && void 0 !== (i = r.set(e, n, t))
                      ? i
                      : (e.setAttribute(t, n + ""), n)
                    : r && "get" in r && null !== (i = r.get(e, t))
                    ? i
                    : null == (i = C.find.attr(e, t))
                    ? void 0
                    : i);
          },
          attrHooks: {
            type: {
              set: function (e, t) {
                if (!g.radioValue && "radio" === t && P(e, "input")) {
                  var n = e.value;
                  return e.setAttribute("type", t), n && (e.value = n), t;
                }
              },
            },
          },
          removeAttr: function (e, t) {
            var n,
              i = 0,
              r = t && t.match(B);
            if (r && 1 === e.nodeType)
              for (; (n = r[i++]); ) e.removeAttribute(n);
          },
        }),
        (pt = {
          set: function (e, t, n) {
            return !1 === t ? C.removeAttr(e, n) : e.setAttribute(n, n), n;
          },
        }),
        C.each(C.expr.match.bool.source.match(/\w+/g), function (e, t) {
          var n = ft[t] || C.find.attr;
          ft[t] = function (e, t, i) {
            var r,
              s,
              a = t.toLowerCase();
            return (
              i ||
                ((s = ft[a]),
                (ft[a] = r),
                (r = null != n(e, t, i) ? a : null),
                (ft[a] = s)),
              r
            );
          };
        });
      var ht = /^(?:input|select|textarea|button)$/i,
        mt = /^(?:a|area)$/i;

      function gt(e) {
        return (e.match(B) || []).join(" ");
      }

      function vt(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
      }

      function yt(e) {
        return Array.isArray(e)
          ? e
          : ("string" == typeof e && e.match(B)) || [];
      }
      C.fn.extend({
        prop: function (e, t) {
          return W(this, C.prop, e, t, arguments.length > 1);
        },
        removeProp: function (e) {
          return this.each(function () {
            delete this[C.propFix[e] || e];
          });
        },
      }),
        C.extend({
          prop: function (e, t, n) {
            var i,
              r,
              s = e.nodeType;
            if (3 !== s && 8 !== s && 2 !== s)
              return (
                (1 === s && C.isXMLDoc(e)) ||
                  ((t = C.propFix[t] || t), (r = C.propHooks[t])),
                void 0 !== n
                  ? r && "set" in r && void 0 !== (i = r.set(e, n, t))
                    ? i
                    : (e[t] = n)
                  : r && "get" in r && null !== (i = r.get(e, t))
                  ? i
                  : e[t]
              );
          },
          propHooks: {
            tabIndex: {
              get: function (e) {
                var t = C.find.attr(e, "tabindex");
                return t
                  ? parseInt(t, 10)
                  : ht.test(e.nodeName) || (mt.test(e.nodeName) && e.href)
                  ? 0
                  : -1;
              },
            },
          },
          propFix: {
            for: "htmlFor",
            class: "className",
          },
        }),
        g.optSelected ||
          (C.propHooks.selected = {
            get: function (e) {
              var t = e.parentNode;
              return t && t.parentNode && t.parentNode.selectedIndex, null;
            },
            set: function (e) {
              var t = e.parentNode;
              t &&
                (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
            },
          }),
        C.each(
          [
            "tabIndex",
            "readOnly",
            "maxLength",
            "cellSpacing",
            "cellPadding",
            "rowSpan",
            "colSpan",
            "useMap",
            "frameBorder",
            "contentEditable",
          ],
          function () {
            C.propFix[this.toLowerCase()] = this;
          }
        ),
        C.fn.extend({
          addClass: function (e) {
            var t,
              n,
              i,
              r,
              s,
              a,
              o,
              l = 0;
            if (v(e))
              return this.each(function (t) {
                C(this).addClass(e.call(this, t, vt(this)));
              });
            if ((t = yt(e)).length)
              for (; (n = this[l++]); )
                if (
                  ((r = vt(n)), (i = 1 === n.nodeType && " " + gt(r) + " "))
                ) {
                  for (a = 0; (s = t[a++]); )
                    i.indexOf(" " + s + " ") < 0 && (i += s + " ");
                  r !== (o = gt(i)) && n.setAttribute("class", o);
                }
            return this;
          },
          removeClass: function (e) {
            var t,
              n,
              i,
              r,
              s,
              a,
              o,
              l = 0;
            if (v(e))
              return this.each(function (t) {
                C(this).removeClass(e.call(this, t, vt(this)));
              });
            if (!arguments.length) return this.attr("class", "");
            if ((t = yt(e)).length)
              for (; (n = this[l++]); )
                if (
                  ((r = vt(n)), (i = 1 === n.nodeType && " " + gt(r) + " "))
                ) {
                  for (a = 0; (s = t[a++]); )
                    for (; i.indexOf(" " + s + " ") > -1; )
                      i = i.replace(" " + s + " ", " ");
                  r !== (o = gt(i)) && n.setAttribute("class", o);
                }
            return this;
          },
          toggleClass: function (e, t) {
            var n = typeof e,
              i = "string" === n || Array.isArray(e);
            return "boolean" == typeof t && i
              ? t
                ? this.addClass(e)
                : this.removeClass(e)
              : v(e)
              ? this.each(function (n) {
                  C(this).toggleClass(e.call(this, n, vt(this), t), t);
                })
              : this.each(function () {
                  var t, r, s, a;
                  if (i)
                    for (r = 0, s = C(this), a = yt(e); (t = a[r++]); )
                      s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
                  else
                    (void 0 !== e && "boolean" !== n) ||
                      ((t = vt(this)) && J.set(this, "__className__", t),
                      this.setAttribute &&
                        this.setAttribute(
                          "class",
                          t || !1 === e
                            ? ""
                            : J.get(this, "__className__") || ""
                        ));
                });
          },
          hasClass: function (e) {
            var t,
              n,
              i = 0;
            for (t = " " + e + " "; (n = this[i++]); )
              if (1 === n.nodeType && (" " + gt(vt(n)) + " ").indexOf(t) > -1)
                return !0;
            return !1;
          },
        });
      var bt = /\r/g;
      C.fn.extend({
        val: function (e) {
          var t,
            n,
            i,
            r = this[0];
          return arguments.length
            ? ((i = v(e)),
              this.each(function (n) {
                var r;
                1 === this.nodeType &&
                  (null == (r = i ? e.call(this, n, C(this).val()) : e)
                    ? (r = "")
                    : "number" == typeof r
                    ? (r += "")
                    : Array.isArray(r) &&
                      (r = C.map(r, function (e) {
                        return null == e ? "" : e + "";
                      })),
                  ((t =
                    C.valHooks[this.type] ||
                    C.valHooks[this.nodeName.toLowerCase()]) &&
                    "set" in t &&
                    void 0 !== t.set(this, r, "value")) ||
                    (this.value = r));
              }))
            : r
            ? (t =
                C.valHooks[r.type] || C.valHooks[r.nodeName.toLowerCase()]) &&
              "get" in t &&
              void 0 !== (n = t.get(r, "value"))
              ? n
              : "string" == typeof (n = r.value)
              ? n.replace(bt, "")
              : null == n
              ? ""
              : n
            : void 0;
        },
      }),
        C.extend({
          valHooks: {
            option: {
              get: function (e) {
                var t = C.find.attr(e, "value");
                return null != t ? t : gt(C.text(e));
              },
            },
            select: {
              get: function (e) {
                var t,
                  n,
                  i,
                  r = e.options,
                  s = e.selectedIndex,
                  a = "select-one" === e.type,
                  o = a ? null : [],
                  l = a ? s + 1 : r.length;
                for (i = s < 0 ? l : a ? s : 0; i < l; i++)
                  if (
                    ((n = r[i]).selected || i === s) &&
                    !n.disabled &&
                    (!n.parentNode.disabled || !P(n.parentNode, "optgroup"))
                  ) {
                    if (((t = C(n).val()), a)) return t;
                    o.push(t);
                  }
                return o;
              },
              set: function (e, t) {
                for (
                  var n, i, r = e.options, s = C.makeArray(t), a = r.length;
                  a--;

                )
                  ((i = r[a]).selected =
                    C.inArray(C.valHooks.option.get(i), s) > -1) && (n = !0);
                return n || (e.selectedIndex = -1), s;
              },
            },
          },
        }),
        C.each(["radio", "checkbox"], function () {
          (C.valHooks[this] = {
            set: function (e, t) {
              if (Array.isArray(t))
                return (e.checked = C.inArray(C(e).val(), t) > -1);
            },
          }),
            g.checkOn ||
              (C.valHooks[this].get = function (e) {
                return null === e.getAttribute("value") ? "on" : e.value;
              });
        }),
        (g.focusin = "onfocusin" in n);
      var _t = /^(?:focusinfocus|focusoutblur)$/,
        wt = function (e) {
          e.stopPropagation();
        };
      C.extend(C.event, {
        trigger: function (e, t, i, r) {
          var s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            h = [i || b],
            m = f.call(e, "type") ? e.type : e,
            g = f.call(e, "namespace") ? e.namespace.split(".") : [];
          if (
            ((a = p = o = i = i || b),
            3 !== i.nodeType &&
              8 !== i.nodeType &&
              !_t.test(m + C.event.triggered) &&
              (m.indexOf(".") > -1 &&
                ((g = m.split(".")), (m = g.shift()), g.sort()),
              (c = m.indexOf(":") < 0 && "on" + m),
              ((e = e[C.expando]
                ? e
                : new C.Event(m, "object" == typeof e && e)).isTrigger = r
                ? 2
                : 3),
              (e.namespace = g.join(".")),
              (e.rnamespace = e.namespace
                ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)")
                : null),
              (e.result = void 0),
              e.target || (e.target = i),
              (t = null == t ? [e] : C.makeArray(t, [e])),
              (d = C.event.special[m] || {}),
              r || !d.trigger || !1 !== d.trigger.apply(i, t)))
          ) {
            if (!r && !d.noBubble && !y(i)) {
              for (
                l = d.delegateType || m, _t.test(l + m) || (a = a.parentNode);
                a;
                a = a.parentNode
              )
                h.push(a), (o = a);
              o === (i.ownerDocument || b) &&
                h.push(o.defaultView || o.parentWindow || n);
            }
            for (s = 0; (a = h[s++]) && !e.isPropagationStopped(); )
              (p = a),
                (e.type = s > 1 ? l : d.bindType || m),
                (u =
                  (J.get(a, "events") || Object.create(null))[e.type] &&
                  J.get(a, "handle")) && u.apply(a, t),
                (u = c && a[c]) &&
                  u.apply &&
                  U(a) &&
                  ((e.result = u.apply(a, t)),
                  !1 === e.result && e.preventDefault());
            return (
              (e.type = m),
              r ||
                e.isDefaultPrevented() ||
                (d._default && !1 !== d._default.apply(h.pop(), t)) ||
                !U(i) ||
                (c &&
                  v(i[m]) &&
                  !y(i) &&
                  ((o = i[c]) && (i[c] = null),
                  (C.event.triggered = m),
                  e.isPropagationStopped() && p.addEventListener(m, wt),
                  i[m](),
                  e.isPropagationStopped() && p.removeEventListener(m, wt),
                  (C.event.triggered = void 0),
                  o && (i[c] = o))),
              e.result
            );
          }
        },
        simulate: function (e, t, n) {
          var i = C.extend(new C.Event(), n, {
            type: e,
            isSimulated: !0,
          });
          C.event.trigger(i, null, t);
        },
      }),
        C.fn.extend({
          trigger: function (e, t) {
            return this.each(function () {
              C.event.trigger(e, t, this);
            });
          },
          triggerHandler: function (e, t) {
            var n = this[0];
            if (n) return C.event.trigger(e, t, n, !0);
          },
        }),
        g.focusin ||
          C.each(
            {
              focus: "focusin",
              blur: "focusout",
            },
            function (e, t) {
              var n = function (e) {
                C.event.simulate(t, e.target, C.event.fix(e));
              };
              C.event.special[t] = {
                setup: function () {
                  var i = this.ownerDocument || this.document || this,
                    r = J.access(i, t);
                  r || i.addEventListener(e, n, !0),
                    J.access(i, t, (r || 0) + 1);
                },
                teardown: function () {
                  var i = this.ownerDocument || this.document || this,
                    r = J.access(i, t) - 1;
                  r
                    ? J.access(i, t, r)
                    : (i.removeEventListener(e, n, !0), J.remove(i, t));
                },
              };
            }
          );
      var xt = n.location,
        Ct = {
          guid: Date.now(),
        },
        Tt = /\?/;
      C.parseXML = function (e) {
        var t, i;
        if (!e || "string" != typeof e) return null;
        try {
          t = new n.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {}
        return (
          (i = t && t.getElementsByTagName("parsererror")[0]),
          (t && !i) ||
            C.error(
              "Invalid XML: " +
                (i
                  ? C.map(i.childNodes, function (e) {
                      return e.textContent;
                    }).join("\n")
                  : e)
            ),
          t
        );
      };
      var kt = /\[\]$/,
        St = /\r?\n/g,
        Et = /^(?:submit|button|image|reset|file)$/i,
        Ot = /^(?:input|select|textarea|keygen)/i;

      function Pt(e, t, n, i) {
        var r;
        if (Array.isArray(t))
          C.each(t, function (t, r) {
            n || kt.test(e)
              ? i(e, r)
              : Pt(
                  e + "[" + ("object" == typeof r && null != r ? t : "") + "]",
                  r,
                  n,
                  i
                );
          });
        else if (n || "object" !== x(t)) i(e, t);
        else for (r in t) Pt(e + "[" + r + "]", t[r], n, i);
      }
      (C.param = function (e, t) {
        var n,
          i = [],
          r = function (e, t) {
            var n = v(t) ? t() : t;
            i[i.length] =
              encodeURIComponent(e) +
              "=" +
              encodeURIComponent(null == n ? "" : n);
          };
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !C.isPlainObject(e)))
          C.each(e, function () {
            r(this.name, this.value);
          });
        else for (n in e) Pt(n, e[n], t, r);
        return i.join("&");
      }),
        C.fn.extend({
          serialize: function () {
            return C.param(this.serializeArray());
          },
          serializeArray: function () {
            return this.map(function () {
              var e = C.prop(this, "elements");
              return e ? C.makeArray(e) : this;
            })
              .filter(function () {
                var e = this.type;
                return (
                  this.name &&
                  !C(this).is(":disabled") &&
                  Ot.test(this.nodeName) &&
                  !Et.test(e) &&
                  (this.checked || !me.test(e))
                );
              })
              .map(function (e, t) {
                var n = C(this).val();
                return null == n
                  ? null
                  : Array.isArray(n)
                  ? C.map(n, function (e) {
                      return {
                        name: t.name,
                        value: e.replace(St, "\r\n"),
                      };
                    })
                  : {
                      name: t.name,
                      value: n.replace(St, "\r\n"),
                    };
              })
              .get();
          },
        });
      var Mt = /%20/g,
        At = /#.*$/,
        Dt = /([?&])_=[^&]*/,
        It = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Lt = /^(?:GET|HEAD)$/,
        jt = /^\/\//,
        Nt = {},
        Bt = {},
        $t = "*/".concat("*"),
        zt = b.createElement("a");

      function Rt(e) {
        return function (t, n) {
          "string" != typeof t && ((n = t), (t = "*"));
          var i,
            r = 0,
            s = t.toLowerCase().match(B) || [];
          if (v(n))
            for (; (i = s[r++]); )
              "+" === i[0]
                ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
                : (e[i] = e[i] || []).push(n);
        };
      }

      function Ht(e, t, n, i) {
        var r = {},
          s = e === Bt;

        function a(o) {
          var l;
          return (
            (r[o] = !0),
            C.each(e[o] || [], function (e, o) {
              var c = o(t, n, i);
              return "string" != typeof c || s || r[c]
                ? s
                  ? !(l = c)
                  : void 0
                : (t.dataTypes.unshift(c), a(c), !1);
            }),
            l
          );
        }
        return a(t.dataTypes[0]) || (!r["*"] && a("*"));
      }

      function Ft(e, t) {
        var n,
          i,
          r = C.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
        return i && C.extend(!0, e, i), e;
      }
      (zt.href = xt.href),
        C.extend({
          active: 0,
          lastModified: {},
          etag: {},
          ajaxSettings: {
            url: xt.href,
            type: "GET",
            isLocal:
              /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                xt.protocol
              ),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
              "*": $t,
              text: "text/plain",
              html: "text/html",
              xml: "application/xml, text/xml",
              json: "application/json, text/javascript",
            },
            contents: {
              xml: /\bxml\b/,
              html: /\bhtml/,
              json: /\bjson\b/,
            },
            responseFields: {
              xml: "responseXML",
              text: "responseText",
              json: "responseJSON",
            },
            converters: {
              "* text": String,
              "text html": !0,
              "text json": JSON.parse,
              "text xml": C.parseXML,
            },
            flatOptions: {
              url: !0,
              context: !0,
            },
          },
          ajaxSetup: function (e, t) {
            return t ? Ft(Ft(e, C.ajaxSettings), t) : Ft(C.ajaxSettings, e);
          },
          ajaxPrefilter: Rt(Nt),
          ajaxTransport: Rt(Bt),
          ajax: function (e, t) {
            "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
            var i,
              r,
              s,
              a,
              o,
              l,
              c,
              u,
              d,
              p,
              f = C.ajaxSetup({}, t),
              h = f.context || f,
              m = f.context && (h.nodeType || h.jquery) ? C(h) : C.event,
              g = C.Deferred(),
              v = C.Callbacks("once memory"),
              y = f.statusCode || {},
              _ = {},
              w = {},
              x = "canceled",
              T = {
                readyState: 0,
                getResponseHeader: function (e) {
                  var t;
                  if (c) {
                    if (!a)
                      for (a = {}; (t = It.exec(s)); )
                        a[t[1].toLowerCase() + " "] = (
                          a[t[1].toLowerCase() + " "] || []
                        ).concat(t[2]);
                    t = a[e.toLowerCase() + " "];
                  }
                  return null == t ? null : t.join(", ");
                },
                getAllResponseHeaders: function () {
                  return c ? s : null;
                },
                setRequestHeader: function (e, t) {
                  return (
                    null == c &&
                      ((e = w[e.toLowerCase()] = w[e.toLowerCase()] || e),
                      (_[e] = t)),
                    this
                  );
                },
                overrideMimeType: function (e) {
                  return null == c && (f.mimeType = e), this;
                },
                statusCode: function (e) {
                  var t;
                  if (e)
                    if (c) T.always(e[T.status]);
                    else for (t in e) y[t] = [y[t], e[t]];
                  return this;
                },
                abort: function (e) {
                  var t = e || x;
                  return i && i.abort(t), k(0, t), this;
                },
              };
            if (
              (g.promise(T),
              (f.url = ((e || f.url || xt.href) + "").replace(
                jt,
                xt.protocol + "//"
              )),
              (f.type = t.method || t.type || f.method || f.type),
              (f.dataTypes = (f.dataType || "*").toLowerCase().match(B) || [
                "",
              ]),
              null == f.crossDomain)
            ) {
              l = b.createElement("a");
              try {
                (l.href = f.url),
                  (l.href = l.href),
                  (f.crossDomain =
                    zt.protocol + "//" + zt.host != l.protocol + "//" + l.host);
              } catch (e) {
                f.crossDomain = !0;
              }
            }
            if (
              (f.data &&
                f.processData &&
                "string" != typeof f.data &&
                (f.data = C.param(f.data, f.traditional)),
              Ht(Nt, f, t, T),
              c)
            )
              return T;
            for (d in ((u = C.event && f.global) &&
              0 == C.active++ &&
              C.event.trigger("ajaxStart"),
            (f.type = f.type.toUpperCase()),
            (f.hasContent = !Lt.test(f.type)),
            (r = f.url.replace(At, "")),
            f.hasContent
              ? f.data &&
                f.processData &&
                0 ===
                  (f.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                (f.data = f.data.replace(Mt, "+"))
              : ((p = f.url.slice(r.length)),
                f.data &&
                  (f.processData || "string" == typeof f.data) &&
                  ((r += (Tt.test(r) ? "&" : "?") + f.data), delete f.data),
                !1 === f.cache &&
                  ((r = r.replace(Dt, "$1")),
                  (p = (Tt.test(r) ? "&" : "?") + "_=" + Ct.guid++ + p)),
                (f.url = r + p)),
            f.ifModified &&
              (C.lastModified[r] &&
                T.setRequestHeader("If-Modified-Since", C.lastModified[r]),
              C.etag[r] && T.setRequestHeader("If-None-Match", C.etag[r])),
            ((f.data && f.hasContent && !1 !== f.contentType) ||
              t.contentType) &&
              T.setRequestHeader("Content-Type", f.contentType),
            T.setRequestHeader(
              "Accept",
              f.dataTypes[0] && f.accepts[f.dataTypes[0]]
                ? f.accepts[f.dataTypes[0]] +
                    ("*" !== f.dataTypes[0] ? ", " + $t + "; q=0.01" : "")
                : f.accepts["*"]
            ),
            f.headers))
              T.setRequestHeader(d, f.headers[d]);
            if (f.beforeSend && (!1 === f.beforeSend.call(h, T, f) || c))
              return T.abort();
            if (
              ((x = "abort"),
              v.add(f.complete),
              T.done(f.success),
              T.fail(f.error),
              (i = Ht(Bt, f, t, T)))
            ) {
              if (((T.readyState = 1), u && m.trigger("ajaxSend", [T, f]), c))
                return T;
              f.async &&
                f.timeout > 0 &&
                (o = n.setTimeout(function () {
                  T.abort("timeout");
                }, f.timeout));
              try {
                (c = !1), i.send(_, k);
              } catch (e) {
                if (c) throw e;
                k(-1, e);
              }
            } else k(-1, "No Transport");

            function k(e, t, a, l) {
              var d,
                p,
                b,
                _,
                w,
                x = t;
              c ||
                ((c = !0),
                o && n.clearTimeout(o),
                (i = void 0),
                (s = l || ""),
                (T.readyState = e > 0 ? 4 : 0),
                (d = (e >= 200 && e < 300) || 304 === e),
                a &&
                  (_ = (function (e, t, n) {
                    for (
                      var i, r, s, a, o = e.contents, l = e.dataTypes;
                      "*" === l[0];

                    )
                      l.shift(),
                        void 0 === i &&
                          (i =
                            e.mimeType || t.getResponseHeader("Content-Type"));
                    if (i)
                      for (r in o)
                        if (o[r] && o[r].test(i)) {
                          l.unshift(r);
                          break;
                        }
                    if (l[0] in n) s = l[0];
                    else {
                      for (r in n) {
                        if (!l[0] || e.converters[r + " " + l[0]]) {
                          s = r;
                          break;
                        }
                        a || (a = r);
                      }
                      s = s || a;
                    }
                    if (s) return s !== l[0] && l.unshift(s), n[s];
                  })(f, T, a)),
                !d &&
                  C.inArray("script", f.dataTypes) > -1 &&
                  C.inArray("json", f.dataTypes) < 0 &&
                  (f.converters["text script"] = function () {}),
                (_ = (function (e, t, n, i) {
                  var r,
                    s,
                    a,
                    o,
                    l,
                    c = {},
                    u = e.dataTypes.slice();
                  if (u[1])
                    for (a in e.converters)
                      c[a.toLowerCase()] = e.converters[a];
                  for (s = u.shift(); s; )
                    if (
                      (e.responseFields[s] && (n[e.responseFields[s]] = t),
                      !l &&
                        i &&
                        e.dataFilter &&
                        (t = e.dataFilter(t, e.dataType)),
                      (l = s),
                      (s = u.shift()))
                    )
                      if ("*" === s) s = l;
                      else if ("*" !== l && l !== s) {
                        if (!(a = c[l + " " + s] || c["* " + s]))
                          for (r in c)
                            if (
                              (o = r.split(" "))[1] === s &&
                              (a = c[l + " " + o[0]] || c["* " + o[0]])
                            ) {
                              !0 === a
                                ? (a = c[r])
                                : !0 !== c[r] && ((s = o[0]), u.unshift(o[1]));
                              break;
                            }
                        if (!0 !== a)
                          if (a && e.throws) t = a(t);
                          else
                            try {
                              t = a(t);
                            } catch (e) {
                              return {
                                state: "parsererror",
                                error: a
                                  ? e
                                  : "No conversion from " + l + " to " + s,
                              };
                            }
                      }
                  return {
                    state: "success",
                    data: t,
                  };
                })(f, _, T, d)),
                d
                  ? (f.ifModified &&
                      ((w = T.getResponseHeader("Last-Modified")) &&
                        (C.lastModified[r] = w),
                      (w = T.getResponseHeader("etag")) && (C.etag[r] = w)),
                    204 === e || "HEAD" === f.type
                      ? (x = "nocontent")
                      : 304 === e
                      ? (x = "notmodified")
                      : ((x = _.state), (p = _.data), (d = !(b = _.error))))
                  : ((b = x), (!e && x) || ((x = "error"), e < 0 && (e = 0))),
                (T.status = e),
                (T.statusText = (t || x) + ""),
                d ? g.resolveWith(h, [p, x, T]) : g.rejectWith(h, [T, x, b]),
                T.statusCode(y),
                (y = void 0),
                u &&
                  m.trigger(d ? "ajaxSuccess" : "ajaxError", [T, f, d ? p : b]),
                v.fireWith(h, [T, x]),
                u &&
                  (m.trigger("ajaxComplete", [T, f]),
                  --C.active || C.event.trigger("ajaxStop")));
            }
            return T;
          },
          getJSON: function (e, t, n) {
            return C.get(e, t, n, "json");
          },
          getScript: function (e, t) {
            return C.get(e, void 0, t, "script");
          },
        }),
        C.each(["get", "post"], function (e, t) {
          C[t] = function (e, n, i, r) {
            return (
              v(n) && ((r = r || i), (i = n), (n = void 0)),
              C.ajax(
                C.extend(
                  {
                    url: e,
                    type: t,
                    dataType: r,
                    data: n,
                    success: i,
                  },
                  C.isPlainObject(e) && e
                )
              )
            );
          };
        }),
        C.ajaxPrefilter(function (e) {
          var t;
          for (t in e.headers)
            "content-type" === t.toLowerCase() &&
              (e.contentType = e.headers[t] || "");
        }),
        (C._evalUrl = function (e, t, n) {
          return C.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
              "text script": function () {},
            },
            dataFilter: function (e) {
              C.globalEval(e, t, n);
            },
          });
        }),
        C.fn.extend({
          wrapAll: function (e) {
            var t;
            return (
              this[0] &&
                (v(e) && (e = e.call(this[0])),
                (t = C(e, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && t.insertBefore(this[0]),
                t
                  .map(function () {
                    for (var e = this; e.firstElementChild; )
                      e = e.firstElementChild;
                    return e;
                  })
                  .append(this)),
              this
            );
          },
          wrapInner: function (e) {
            return v(e)
              ? this.each(function (t) {
                  C(this).wrapInner(e.call(this, t));
                })
              : this.each(function () {
                  var t = C(this),
                    n = t.contents();
                  n.length ? n.wrapAll(e) : t.append(e);
                });
          },
          wrap: function (e) {
            var t = v(e);
            return this.each(function (n) {
              C(this).wrapAll(t ? e.call(this, n) : e);
            });
          },
          unwrap: function (e) {
            return (
              this.parent(e)
                .not("body")
                .each(function () {
                  C(this).replaceWith(this.childNodes);
                }),
              this
            );
          },
        }),
        (C.expr.pseudos.hidden = function (e) {
          return !C.expr.pseudos.visible(e);
        }),
        (C.expr.pseudos.visible = function (e) {
          return !!(
            e.offsetWidth ||
            e.offsetHeight ||
            e.getClientRects().length
          );
        }),
        (C.ajaxSettings.xhr = function () {
          try {
            return new n.XMLHttpRequest();
          } catch (e) {}
        });
      var qt = {
          0: 200,
          1223: 204,
        },
        Wt = C.ajaxSettings.xhr();
      (g.cors = !!Wt && "withCredentials" in Wt),
        (g.ajax = Wt = !!Wt),
        C.ajaxTransport(function (e) {
          var t, i;
          if (g.cors || (Wt && !e.crossDomain))
            return {
              send: function (r, s) {
                var a,
                  o = e.xhr();
                if (
                  (o.open(e.type, e.url, e.async, e.username, e.password),
                  e.xhrFields)
                )
                  for (a in e.xhrFields) o[a] = e.xhrFields[a];
                for (a in (e.mimeType &&
                  o.overrideMimeType &&
                  o.overrideMimeType(e.mimeType),
                e.crossDomain ||
                  r["X-Requested-With"] ||
                  (r["X-Requested-With"] = "XMLHttpRequest"),
                r))
                  o.setRequestHeader(a, r[a]);
                (t = function (e) {
                  return function () {
                    t &&
                      ((t =
                        i =
                        o.onload =
                        o.onerror =
                        o.onabort =
                        o.ontimeout =
                        o.onreadystatechange =
                          null),
                      "abort" === e
                        ? o.abort()
                        : "error" === e
                        ? "number" != typeof o.status
                          ? s(0, "error")
                          : s(o.status, o.statusText)
                        : s(
                            qt[o.status] || o.status,
                            o.statusText,
                            "text" !== (o.responseType || "text") ||
                              "string" != typeof o.responseText
                              ? {
                                  binary: o.response,
                                }
                              : {
                                  text: o.responseText,
                                },
                            o.getAllResponseHeaders()
                          ));
                  };
                }),
                  (o.onload = t()),
                  (i = o.onerror = o.ontimeout = t("error")),
                  void 0 !== o.onabort
                    ? (o.onabort = i)
                    : (o.onreadystatechange = function () {
                        4 === o.readyState &&
                          n.setTimeout(function () {
                            t && i();
                          });
                      }),
                  (t = t("abort"));
                try {
                  o.send((e.hasContent && e.data) || null);
                } catch (e) {
                  if (t) throw e;
                }
              },
              abort: function () {
                t && t();
              },
            };
        }),
        C.ajaxPrefilter(function (e) {
          e.crossDomain && (e.contents.script = !1);
        }),
        C.ajaxSetup({
          accepts: {
            script:
              "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
          },
          contents: {
            script: /\b(?:java|ecma)script\b/,
          },
          converters: {
            "text script": function (e) {
              return C.globalEval(e), e;
            },
          },
        }),
        C.ajaxPrefilter("script", function (e) {
          void 0 === e.cache && (e.cache = !1),
            e.crossDomain && (e.type = "GET");
        }),
        C.ajaxTransport("script", function (e) {
          var t, n;
          if (e.crossDomain || e.scriptAttrs)
            return {
              send: function (i, r) {
                (t = C("<script>")
                  .attr(e.scriptAttrs || {})
                  .prop({
                    charset: e.scriptCharset,
                    src: e.url,
                  })
                  .on(
                    "load error",
                    (n = function (e) {
                      t.remove(),
                        (n = null),
                        e && r("error" === e.type ? 404 : 200, e.type);
                    })
                  )),
                  b.head.appendChild(t[0]);
              },
              abort: function () {
                n && n();
              },
            };
        });
      var Vt,
        Gt = [],
        Xt = /(=)\?(?=&|$)|\?\?/;
      C.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
          var e = Gt.pop() || C.expando + "_" + Ct.guid++;
          return (this[e] = !0), e;
        },
      }),
        C.ajaxPrefilter("json jsonp", function (e, t, i) {
          var r,
            s,
            a,
            o =
              !1 !== e.jsonp &&
              (Xt.test(e.url)
                ? "url"
                : "string" == typeof e.data &&
                  0 ===
                    (e.contentType || "").indexOf(
                      "application/x-www-form-urlencoded"
                    ) &&
                  Xt.test(e.data) &&
                  "data");
          if (o || "jsonp" === e.dataTypes[0])
            return (
              (r = e.jsonpCallback =
                v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
              o
                ? (e[o] = e[o].replace(Xt, "$1" + r))
                : !1 !== e.jsonp &&
                  (e.url += (Tt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
              (e.converters["script json"] = function () {
                return a || C.error(r + " was not called"), a[0];
              }),
              (e.dataTypes[0] = "json"),
              (s = n[r]),
              (n[r] = function () {
                a = arguments;
              }),
              i.always(function () {
                void 0 === s ? C(n).removeProp(r) : (n[r] = s),
                  e[r] && ((e.jsonpCallback = t.jsonpCallback), Gt.push(r)),
                  a && v(s) && s(a[0]),
                  (a = s = void 0);
              }),
              "script"
            );
        }),
        (g.createHTMLDocument =
          (((Vt = b.implementation.createHTMLDocument("").body).innerHTML =
            "<form></form><form></form>"),
          2 === Vt.childNodes.length)),
        (C.parseHTML = function (e, t, n) {
          return "string" != typeof e
            ? []
            : ("boolean" == typeof t && ((n = t), (t = !1)),
              t ||
                (g.createHTMLDocument
                  ? (((i = (t =
                      b.implementation.createHTMLDocument("")).createElement(
                      "base"
                    )).href = b.location.href),
                    t.head.appendChild(i))
                  : (t = b)),
              (s = !n && []),
              (r = M.exec(e))
                ? [t.createElement(r[1])]
                : ((r = xe([e], t, s)),
                  s && s.length && C(s).remove(),
                  C.merge([], r.childNodes)));
          var i, r, s;
        }),
        (C.fn.load = function (e, t, n) {
          var i,
            r,
            s,
            a = this,
            o = e.indexOf(" ");
          return (
            o > -1 && ((i = gt(e.slice(o))), (e = e.slice(0, o))),
            v(t)
              ? ((n = t), (t = void 0))
              : t && "object" == typeof t && (r = "POST"),
            a.length > 0 &&
              C.ajax({
                url: e,
                type: r || "GET",
                dataType: "html",
                data: t,
              })
                .done(function (e) {
                  (s = arguments),
                    a.html(i ? C("<div>").append(C.parseHTML(e)).find(i) : e);
                })
                .always(
                  n &&
                    function (e, t) {
                      a.each(function () {
                        n.apply(this, s || [e.responseText, t, e]);
                      });
                    }
                ),
            this
          );
        }),
        (C.expr.pseudos.animated = function (e) {
          return C.grep(C.timers, function (t) {
            return e === t.elem;
          }).length;
        }),
        (C.offset = {
          setOffset: function (e, t, n) {
            var i,
              r,
              s,
              a,
              o,
              l,
              c = C.css(e, "position"),
              u = C(e),
              d = {};
            "static" === c && (e.style.position = "relative"),
              (o = u.offset()),
              (s = C.css(e, "top")),
              (l = C.css(e, "left")),
              ("absolute" === c || "fixed" === c) &&
              (s + l).indexOf("auto") > -1
                ? ((a = (i = u.position()).top), (r = i.left))
                : ((a = parseFloat(s) || 0), (r = parseFloat(l) || 0)),
              v(t) && (t = t.call(e, n, C.extend({}, o))),
              null != t.top && (d.top = t.top - o.top + a),
              null != t.left && (d.left = t.left - o.left + r),
              "using" in t ? t.using.call(e, d) : u.css(d);
          },
        }),
        C.fn.extend({
          offset: function (e) {
            if (arguments.length)
              return void 0 === e
                ? this
                : this.each(function (t) {
                    C.offset.setOffset(this, e, t);
                  });
            var t,
              n,
              i = this[0];
            return i
              ? i.getClientRects().length
                ? ((t = i.getBoundingClientRect()),
                  (n = i.ownerDocument.defaultView),
                  {
                    top: t.top + n.pageYOffset,
                    left: t.left + n.pageXOffset,
                  })
                : {
                    top: 0,
                    left: 0,
                  }
              : void 0;
          },
          position: function () {
            if (this[0]) {
              var e,
                t,
                n,
                i = this[0],
                r = {
                  top: 0,
                  left: 0,
                };
              if ("fixed" === C.css(i, "position"))
                t = i.getBoundingClientRect();
              else {
                for (
                  t = this.offset(),
                    n = i.ownerDocument,
                    e = i.offsetParent || n.documentElement;
                  e &&
                  (e === n.body || e === n.documentElement) &&
                  "static" === C.css(e, "position");

                )
                  e = e.parentNode;
                e &&
                  e !== i &&
                  1 === e.nodeType &&
                  (((r = C(e).offset()).top += C.css(e, "borderTopWidth", !0)),
                  (r.left += C.css(e, "borderLeftWidth", !0)));
              }
              return {
                top: t.top - r.top - C.css(i, "marginTop", !0),
                left: t.left - r.left - C.css(i, "marginLeft", !0),
              };
            }
          },
          offsetParent: function () {
            return this.map(function () {
              for (
                var e = this.offsetParent;
                e && "static" === C.css(e, "position");

              )
                e = e.offsetParent;
              return e || se;
            });
          },
        }),
        C.each(
          {
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset",
          },
          function (e, t) {
            var n = "pageYOffset" === t;
            C.fn[e] = function (i) {
              return W(
                this,
                function (e, i, r) {
                  var s;
                  if (
                    (y(e) ? (s = e) : 9 === e.nodeType && (s = e.defaultView),
                    void 0 === r)
                  )
                    return s ? s[t] : e[i];
                  s
                    ? s.scrollTo(n ? s.pageXOffset : r, n ? r : s.pageYOffset)
                    : (e[i] = r);
                },
                e,
                i,
                arguments.length
              );
            };
          }
        ),
        C.each(["top", "left"], function (e, t) {
          C.cssHooks[t] = We(g.pixelPosition, function (e, n) {
            if (n)
              return (n = qe(e, t)), ze.test(n) ? C(e).position()[t] + "px" : n;
          });
        }),
        C.each(
          {
            Height: "height",
            Width: "width",
          },
          function (e, t) {
            C.each(
              {
                padding: "inner" + e,
                content: t,
                "": "outer" + e,
              },
              function (n, i) {
                C.fn[i] = function (r, s) {
                  var a = arguments.length && (n || "boolean" != typeof r),
                    o = n || (!0 === r || !0 === s ? "margin" : "border");
                  return W(
                    this,
                    function (t, n, r) {
                      var s;
                      return y(t)
                        ? 0 === i.indexOf("outer")
                          ? t["inner" + e]
                          : t.document.documentElement["client" + e]
                        : 9 === t.nodeType
                        ? ((s = t.documentElement),
                          Math.max(
                            t.body["scroll" + e],
                            s["scroll" + e],
                            t.body["offset" + e],
                            s["offset" + e],
                            s["client" + e]
                          ))
                        : void 0 === r
                        ? C.css(t, n, o)
                        : C.style(t, n, r, o);
                    },
                    t,
                    a ? r : void 0,
                    a
                  );
                };
              }
            );
          }
        ),
        C.each(
          [
            "ajaxStart",
            "ajaxStop",
            "ajaxComplete",
            "ajaxError",
            "ajaxSuccess",
            "ajaxSend",
          ],
          function (e, t) {
            C.fn[t] = function (e) {
              return this.on(t, e);
            };
          }
        ),
        C.fn.extend({
          bind: function (e, t, n) {
            return this.on(e, null, t, n);
          },
          unbind: function (e, t) {
            return this.off(e, null, t);
          },
          delegate: function (e, t, n, i) {
            return this.on(t, e, n, i);
          },
          undelegate: function (e, t, n) {
            return 1 === arguments.length
              ? this.off(e, "**")
              : this.off(t, e || "**", n);
          },
          hover: function (e, t) {
            return this.mouseenter(e).mouseleave(t || e);
          },
        }),
        C.each(
          "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
            " "
          ),
          function (e, t) {
            C.fn[t] = function (e, n) {
              return arguments.length > 0
                ? this.on(t, null, e, n)
                : this.trigger(t);
            };
          }
        );
      var Yt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      (C.proxy = function (e, t) {
        var n, i, r;
        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
          return (
            (i = o.call(arguments, 2)),
            ((r = function () {
              return e.apply(t || this, i.concat(o.call(arguments)));
            }).guid = e.guid =
              e.guid || C.guid++),
            r
          );
      }),
        (C.holdReady = function (e) {
          e ? C.readyWait++ : C.ready(!0);
        }),
        (C.isArray = Array.isArray),
        (C.parseJSON = JSON.parse),
        (C.nodeName = P),
        (C.isFunction = v),
        (C.isWindow = y),
        (C.camelCase = Y),
        (C.type = x),
        (C.now = Date.now),
        (C.isNumeric = function (e) {
          var t = C.type(e);
          return (
            ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
          );
        }),
        (C.trim = function (e) {
          return null == e ? "" : (e + "").replace(Yt, "");
        }),
        void 0 ===
          (i = function () {
            return C;
          }.apply(t, [])) || (e.exports = i);
      var Ut = n.jQuery,
        Qt = n.$;
      return (
        (C.noConflict = function (e) {
          return (
            n.$ === C && (n.$ = Qt), e && n.jQuery === C && (n.jQuery = Ut), C
          );
        }),
        void 0 === r && (n.jQuery = n.$ = C),
        C
      );
    });
  },
  function (e, t, n) {
    e.exports = (function () {
      "use strict";

      function e() {
        return (e =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var i in n)
                Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
            }
            return e;
          }).apply(this, arguments);
      }
      var t = "undefined" != typeof window,
        n =
          (t && !("onscroll" in window)) ||
          ("undefined" != typeof navigator &&
            /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)),
        i = t && "IntersectionObserver" in window,
        r = t && "classList" in document.createElement("p"),
        s = t && window.devicePixelRatio > 1,
        a = {
          elements_selector: ".lazy",
          container: n || t ? document : null,
          threshold: 300,
          thresholds: null,
          data_src: "src",
          data_srcset: "srcset",
          data_sizes: "sizes",
          data_bg: "bg",
          data_bg_hidpi: "bg-hidpi",
          data_bg_multi: "bg-multi",
          data_bg_multi_hidpi: "bg-multi-hidpi",
          data_bg_set: "bg-set",
          data_poster: "poster",
          class_applied: "applied",
          class_loading: "loading",
          class_loaded: "loaded",
          class_error: "error",
          class_entered: "entered",
          class_exited: "exited",
          unobserve_completed: !0,
          unobserve_entered: !1,
          cancel_on_exit: !0,
          callback_enter: null,
          callback_exit: null,
          callback_applied: null,
          callback_loading: null,
          callback_loaded: null,
          callback_error: null,
          callback_finish: null,
          callback_cancel: null,
          use_native: !1,
          restore_on_error: !1,
        },
        o = function (t) {
          return e({}, a, t);
        },
        l = function (e, t) {
          var n,
            i = "LazyLoad::Initialized",
            r = new e(t);
          try {
            n = new CustomEvent(i, {
              detail: {
                instance: r,
              },
            });
          } catch (e) {
            (n = document.createEvent("CustomEvent")).initCustomEvent(
              i,
              !1,
              !1,
              {
                instance: r,
              }
            );
          }
          window.dispatchEvent(n);
        },
        c = "src",
        u = "srcset",
        d = "sizes",
        p = "poster",
        f = "llOriginalAttrs",
        h = "data",
        m = "loading",
        g = "loaded",
        v = "applied",
        y = "error",
        b = "native",
        _ = function (e, t) {
          return e.getAttribute("data-" + t);
        },
        w = function (e) {
          return _(e, "ll-status");
        },
        x = function (e, t) {
          return (function (e, t, n) {
            var i = "data-ll-status";
            null !== n ? e.setAttribute(i, n) : e.removeAttribute(i);
          })(e, 0, t);
        },
        C = function (e) {
          return x(e, null);
        },
        T = function (e) {
          return null === w(e);
        },
        k = function (e) {
          return w(e) === b;
        },
        S = [m, g, v, y],
        E = function (e, t, n, i) {
          e && (void 0 === i ? (void 0 === n ? e(t) : e(t, n)) : e(t, n, i));
        },
        O = function (e, t) {
          r
            ? e.classList.add(t)
            : (e.className += (e.className ? " " : "") + t);
        },
        P = function (e, t) {
          r
            ? e.classList.remove(t)
            : (e.className = e.className
                .replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ")
                .replace(/^\s+/, "")
                .replace(/\s+$/, ""));
        },
        M = function (e) {
          return e.llTempImage;
        },
        A = function (e, t) {
          if (t) {
            var n = t._observer;
            n && n.unobserve(e);
          }
        },
        D = function (e, t) {
          e && (e.loadingCount += t);
        },
        I = function (e, t) {
          e && (e.toLoadCount = t);
        },
        L = function (e) {
          for (var t, n = [], i = 0; (t = e.children[i]); i += 1)
            "SOURCE" === t.tagName && n.push(t);
          return n;
        },
        j = function (e, t) {
          var n = e.parentNode;
          n && "PICTURE" === n.tagName && L(n).forEach(t);
        },
        N = function (e, t) {
          L(e).forEach(t);
        },
        B = [c],
        $ = [c, p],
        z = [c, u, d],
        R = [h],
        H = function (e) {
          return !!e[f];
        },
        F = function (e) {
          return e[f];
        },
        q = function (e) {
          return delete e[f];
        },
        W = function (e, t) {
          if (!H(e)) {
            var n = {};
            t.forEach(function (t) {
              n[t] = e.getAttribute(t);
            }),
              (e[f] = n);
          }
        },
        V = function (e, t) {
          if (H(e)) {
            var n = F(e);
            t.forEach(function (t) {
              !(function (e, t, n) {
                n ? e.setAttribute(t, n) : e.removeAttribute(t);
              })(e, t, n[t]);
            });
          }
        },
        G = function (e, t, n) {
          O(e, t.class_applied),
            x(e, v),
            n &&
              (t.unobserve_completed && A(e, t), E(t.callback_applied, e, n));
        },
        X = function (e, t, n) {
          O(e, t.class_loading),
            x(e, m),
            n && (D(n, 1), E(t.callback_loading, e, n));
        },
        Y = function (e, t, n) {
          n && e.setAttribute(t, n);
        },
        U = function (e, t) {
          Y(e, d, _(e, t.data_sizes)),
            Y(e, u, _(e, t.data_srcset)),
            Y(e, c, _(e, t.data_src));
        },
        Q = {
          IMG: function (e, t) {
            j(e, function (e) {
              W(e, z), U(e, t);
            }),
              W(e, z),
              U(e, t);
          },
          IFRAME: function (e, t) {
            W(e, B), Y(e, c, _(e, t.data_src));
          },
          VIDEO: function (e, t) {
            N(e, function (e) {
              W(e, B), Y(e, c, _(e, t.data_src));
            }),
              W(e, $),
              Y(e, p, _(e, t.data_poster)),
              Y(e, c, _(e, t.data_src)),
              e.load();
          },
          OBJECT: function (e, t) {
            W(e, R), Y(e, h, _(e, t.data_src));
          },
        },
        J = ["IMG", "IFRAME", "VIDEO", "OBJECT"],
        K = function (e, t) {
          !t ||
            (function (e) {
              return e.loadingCount > 0;
            })(t) ||
            (function (e) {
              return e.toLoadCount > 0;
            })(t) ||
            E(e.callback_finish, t);
        },
        Z = function (e, t, n) {
          e.addEventListener(t, n), (e.llEvLisnrs[t] = n);
        },
        ee = function (e, t, n) {
          e.removeEventListener(t, n);
        },
        te = function (e) {
          return !!e.llEvLisnrs;
        },
        ne = function (e) {
          if (te(e)) {
            var t = e.llEvLisnrs;
            for (var n in t) {
              var i = t[n];
              ee(e, n, i);
            }
            delete e.llEvLisnrs;
          }
        },
        ie = function (e, t, n) {
          !(function (e) {
            delete e.llTempImage;
          })(e),
            D(n, -1),
            (function (e) {
              e && (e.toLoadCount -= 1);
            })(n),
            P(e, t.class_loading),
            t.unobserve_completed && A(e, n);
        },
        re = function (e, t, n) {
          var i = M(e) || e;
          te(i) ||
            (function (e, t, n) {
              te(e) || (e.llEvLisnrs = {});
              var i = "VIDEO" === e.tagName ? "loadeddata" : "load";
              Z(e, i, t), Z(e, "error", n);
            })(
              i,
              function (r) {
                !(function (e, t, n, i) {
                  var r = k(t);
                  ie(t, n, i),
                    O(t, n.class_loaded),
                    x(t, g),
                    E(n.callback_loaded, t, i),
                    r || K(n, i);
                })(0, e, t, n),
                  ne(i);
              },
              function (r) {
                !(function (e, t, n, i) {
                  var r = k(t);
                  ie(t, n, i),
                    O(t, n.class_error),
                    x(t, y),
                    E(n.callback_error, t, i),
                    n.restore_on_error && V(t, z),
                    r || K(n, i);
                })(0, e, t, n),
                  ne(i);
              }
            );
        },
        se = function (e, t, n) {
          !(function (e) {
            return J.indexOf(e.tagName) > -1;
          })(e)
            ? (function (e, t, n) {
                !(function (e) {
                  e.llTempImage = document.createElement("IMG");
                })(e),
                  re(e, t, n),
                  (function (e) {
                    H(e) ||
                      (e[f] = {
                        backgroundImage: e.style.backgroundImage,
                      });
                  })(e),
                  (function (e, t, n) {
                    var i = _(e, t.data_bg),
                      r = _(e, t.data_bg_hidpi),
                      a = s && r ? r : i;
                    a &&
                      ((e.style.backgroundImage = 'url("'.concat(a, '")')),
                      M(e).setAttribute(c, a),
                      X(e, t, n));
                  })(e, t, n),
                  (function (e, t, n) {
                    var i = _(e, t.data_bg_multi),
                      r = _(e, t.data_bg_multi_hidpi),
                      a = s && r ? r : i;
                    a && ((e.style.backgroundImage = a), G(e, t, n));
                  })(e, t, n),
                  (function (e, t, n) {
                    var i = _(e, t.data_bg_set);
                    if (i) {
                      var r = i.split("|"),
                        s = r.map(function (e) {
                          return "image-set(".concat(e, ")");
                        });
                      (e.style.backgroundImage = s.join()),
                        "" === e.style.backgroundImage &&
                          ((s = r.map(function (e) {
                            return "-webkit-image-set(".concat(e, ")");
                          })),
                          (e.style.backgroundImage = s.join())),
                        G(e, t, n);
                    }
                  })(e, t, n);
              })(e, t, n)
            : (function (e, t, n) {
                re(e, t, n),
                  (function (e, t, n) {
                    var i = Q[e.tagName];
                    i && (i(e, t), X(e, t, n));
                  })(e, t, n);
              })(e, t, n);
        },
        ae = function (e) {
          e.removeAttribute(c), e.removeAttribute(u), e.removeAttribute(d);
        },
        oe = function (e) {
          j(e, function (e) {
            V(e, z);
          }),
            V(e, z);
        },
        le = {
          IMG: oe,
          IFRAME: function (e) {
            V(e, B);
          },
          VIDEO: function (e) {
            N(e, function (e) {
              V(e, B);
            }),
              V(e, $),
              e.load();
          },
          OBJECT: function (e) {
            V(e, R);
          },
        },
        ce = ["IMG", "IFRAME", "VIDEO"],
        ue = function (e) {
          return e.use_native && "loading" in HTMLImageElement.prototype;
        },
        de = function (e) {
          return Array.prototype.slice.call(e);
        },
        pe = function (e) {
          return e.container.querySelectorAll(e.elements_selector);
        },
        fe = function (e) {
          return (function (e) {
            return w(e) === y;
          })(e);
        },
        he = function (e, t) {
          return (function (e) {
            return de(e).filter(T);
          })(e || pe(t));
        },
        me = function (e, n) {
          var r = o(e);
          (this._settings = r),
            (this.loadingCount = 0),
            (function (e, t) {
              i &&
                !ue(e) &&
                (t._observer = new IntersectionObserver(
                  function (n) {
                    !(function (e, t, n) {
                      e.forEach(function (e) {
                        return (function (e) {
                          return e.isIntersecting || e.intersectionRatio > 0;
                        })(e)
                          ? (function (e, t, n, i) {
                              var r = (function (e) {
                                return S.indexOf(w(e)) >= 0;
                              })(e);
                              x(e, "entered"),
                                O(e, n.class_entered),
                                P(e, n.class_exited),
                                (function (e, t, n) {
                                  t.unobserve_entered && A(e, n);
                                })(e, n, i),
                                E(n.callback_enter, e, t, i),
                                r || se(e, n, i);
                            })(e.target, e, t, n)
                          : (function (e, t, n, i) {
                              T(e) ||
                                (O(e, n.class_exited),
                                (function (e, t, n, i) {
                                  n.cancel_on_exit &&
                                    (function (e) {
                                      return w(e) === m;
                                    })(e) &&
                                    "IMG" === e.tagName &&
                                    (ne(e),
                                    (function (e) {
                                      j(e, function (e) {
                                        ae(e);
                                      }),
                                        ae(e);
                                    })(e),
                                    oe(e),
                                    P(e, n.class_loading),
                                    D(i, -1),
                                    C(e),
                                    E(n.callback_cancel, e, t, i));
                                })(e, t, n, i),
                                E(n.callback_exit, e, t, i));
                            })(e.target, e, t, n);
                      });
                    })(n, e, t);
                  },
                  (function (e) {
                    return {
                      root: e.container === document ? null : e.container,
                      rootMargin: e.thresholds || e.threshold + "px",
                    };
                  })(e)
                ));
            })(r, this),
            (function (e, n) {
              t &&
                window.addEventListener("online", function () {
                  !(function (e, t) {
                    var n;
                    ((n = pe(e)), de(n).filter(fe)).forEach(function (t) {
                      P(t, e.class_error), C(t);
                    }),
                      t.update();
                  })(e, n);
                });
            })(r, this),
            this.update(n);
        };
      return (
        (me.prototype = {
          update: function (e) {
            var t,
              r,
              s = this._settings,
              a = he(e, s);
            I(this, a.length),
              !n && i
                ? ue(s)
                  ? (function (e, t, n) {
                      e.forEach(function (e) {
                        -1 !== ce.indexOf(e.tagName) &&
                          (function (e, t, n) {
                            e.setAttribute("loading", "lazy"),
                              re(e, t, n),
                              (function (e, t) {
                                var n = Q[e.tagName];
                                n && n(e, t);
                              })(e, t),
                              x(e, b);
                          })(e, t, n);
                      }),
                        I(n, 0);
                    })(a, s, this)
                  : ((r = a),
                    (function (e) {
                      e.disconnect();
                    })((t = this._observer)),
                    (function (e, t) {
                      t.forEach(function (t) {
                        e.observe(t);
                      });
                    })(t, r))
                : this.loadAll(a);
          },
          destroy: function () {
            this._observer && this._observer.disconnect(),
              pe(this._settings).forEach(function (e) {
                q(e);
              }),
              delete this._observer,
              delete this._settings,
              delete this.loadingCount,
              delete this.toLoadCount;
          },
          loadAll: function (e) {
            var t = this,
              n = this._settings;
            he(e, n).forEach(function (e) {
              A(e, t), se(e, n, t);
            });
          },
          restoreAll: function () {
            var e = this._settings;
            pe(e).forEach(function (t) {
              !(function (e, t) {
                (function (e) {
                  var t = le[e.tagName];
                  t
                    ? t(e)
                    : (function (e) {
                        if (H(e)) {
                          var t = F(e);
                          e.style.backgroundImage = t.backgroundImage;
                        }
                      })(e);
                })(e),
                  (function (e, t) {
                    T(e) ||
                      k(e) ||
                      (P(e, t.class_entered),
                      P(e, t.class_exited),
                      P(e, t.class_applied),
                      P(e, t.class_loading),
                      P(e, t.class_loaded),
                      P(e, t.class_error));
                  })(e, t),
                  C(e),
                  q(e);
              })(t, e);
            });
          },
        }),
        (me.load = function (e, t) {
          var n = o(t);
          se(e, n);
        }),
        (me.resetStatus = function (e) {
          C(e);
        }),
        t &&
          (function (e, t) {
            if (t)
              if (t.length) for (var n, i = 0; (n = t[i]); i += 1) l(e, n);
              else l(e, t);
          })(me, window.lazyLoadOptions),
        me
      );
    })();
  },
  function (e, t, n) {
    var i, r, s, a;
    (a = function (e) {
      "use strict";
      var t = e(document),
        n = e(window),
        i = ["a", "e", "i", "o", "u", "n", "c", "y"],
        r = [
          /[\xE0-\xE5]/g,
          /[\xE8-\xEB]/g,
          /[\xEC-\xEF]/g,
          /[\xF2-\xF6]/g,
          /[\xF9-\xFC]/g,
          /[\xF1]/g,
          /[\xE7]/g,
          /[\xFD-\xFF]/g,
        ],
        s = function (t, n) {
          (this.element = t),
            (this.$element = e(t)),
            (this.state = {
              enabled: !1,
              opened: !1,
              currValue: -1,
              selectedIdx: -1,
            }),
            (this.eventTriggers = {
              open: this.open,
              close: this.close,
              destroy: this.destroy,
              refresh: this.refresh,
              init: this.init,
            }),
            this.init(n);
        };
      (s.prototype = {
        utils: {
          isMobile: function () {
            return /android|ip(hone|od|ad)/i.test(navigator.userAgent);
          },
          escapeRegExp: function (e) {
            return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          },
          replaceDiacritics: function (e) {
            for (var t = r.length; t--; )
              e = e.toLowerCase().replace(r[t], i[t]);
            return e;
          },
          format: function (e) {
            var t = arguments;
            return ("" + e).replace(/\{(?:(\d+)|(\w+))\}/g, function (e, n, i) {
              return i && t[1] ? t[1][i] : t[n];
            });
          },
          nextEnabledItem: function (e, t) {
            for (; e[(t = (t + 1) % e.length)].disabled; );
            return t;
          },
          previousEnabledItem: function (e, t) {
            for (; e[(t = (t > 0 ? t : e.length) - 1)].disabled; );
            return t;
          },
          toDash: function (e) {
            return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
          },
          triggerCallback: function (t, n) {
            var i = n.element,
              r = n.options["on" + t];
            e.isFunction(r) && r.call(i, i, n),
              e.fn.selectric.hooks[t] &&
                e.each(e.fn.selectric.hooks[t], function () {
                  this.call(i, i, n);
                }),
              e(i).trigger("selectric-" + this.toDash(t), n);
          },
        },
        init: function (t) {
          if (
            ((this.options = e.extend(
              !0,
              {},
              e.fn.selectric.defaults,
              this.options,
              t
            )),
            this.utils.triggerCallback("BeforeInit", this),
            this.destroy(!0),
            this.options.disableOnMobile && this.utils.isMobile())
          )
            this.disableOnMobile = !0;
          else {
            this.classes = this.getClassNames();
            var n = e("<input/>", {
                class: this.classes.input,
                readonly: this.utils.isMobile(),
              }),
              i = e("<div/>", {
                class: this.classes.items,
                tabindex: -1,
              }),
              r = e("<div/>", {
                class: this.classes.scroll,
              }),
              s = e("<div/>", {
                class: this.classes.prefix,
                html: this.options.arrowButtonMarkup,
              }),
              a = e("<span/>", {
                class: "label",
              }),
              o = this.$element
                .wrap("<div/>")
                .parent()
                .append(s.prepend(a), i, n);
            (this.elements = {
              input: n,
              items: i,
              itemsScroll: r,
              wrapper: s,
              label: a,
              outerWrapper: o,
            }),
              this.$element
                .on(this.eventTriggers)
                .wrap('<div class="' + this.classes.hideselect + '"/>'),
              (this.originalTabindex = this.$element.prop("tabindex")),
              this.$element.prop("tabindex", !1),
              this.populate(),
              this.activate(),
              this.utils.triggerCallback("Init", this);
          }
        },
        activate: function () {
          var e = this.$element.width();
          this.utils.triggerCallback("BeforeActivate", this),
            this.elements.outerWrapper.prop(
              "class",
              [
                this.classes.wrapper,
                this.$element
                  .prop("class")
                  .replace(/\S+/g, this.classes.prefix + "-$&"),
                this.options.responsive ? this.classes.responsive : "",
              ].join(" ")
            ),
            this.options.inheritOriginalWidth &&
              e > 0 &&
              this.elements.outerWrapper.width(e),
            this.$element.prop("disabled")
              ? (this.elements.outerWrapper.addClass(this.classes.disabled),
                this.elements.input.prop("disabled", !0))
              : ((this.state.enabled = !0),
                this.elements.outerWrapper.removeClass(this.classes.disabled),
                (this.$li = this.elements.items.removeAttr("style").find("li")),
                this.bindEvents()),
            this.utils.triggerCallback("Activate", this);
        },
        getClassNames: function () {
          var t = this,
            n = t.options.customClass,
            i = {};
          return (
            e.each(
              "Input Items Open Disabled TempShow HideSelect Wrapper Focus Hover Responsive Above Scroll Group GroupLabel".split(
                " "
              ),
              function (e, r) {
                var s = n.prefix + r;
                i[r.toLowerCase()] = n.camelCase ? s : t.utils.toDash(s);
              }
            ),
            (i.prefix = n.prefix),
            i
          );
        },
        setLabel: function () {
          var t = this.options.labelBuilder,
            n = this.lookupItems[this.state.currValue];
          this.elements.label.html(
            e.isFunction(t) ? t(n) : this.utils.format(t, n)
          );
        },
        populate: function () {
          var t = this,
            n = t.$element.children(),
            i = t.$element.find("option"),
            r = i.index(i.filter(":selected")),
            s = 0;
          (t.state.currValue = t.state.selected = ~r ? r : 0),
            (t.state.selectedIdx = t.state.currValue),
            (t.items = []),
            (t.lookupItems = []),
            n.length &&
              (n.each(function (n) {
                var i = e(this);
                if (i.is("optgroup")) {
                  var r = {
                    element: i,
                    label: i.prop("label"),
                    groupDisabled: i.prop("disabled"),
                    items: [],
                  };
                  i.children().each(function (n) {
                    var i = e(this),
                      a = i.html();
                    (r.items[n] = {
                      index: s,
                      element: i,
                      value: i.val(),
                      text: a,
                      slug: t.utils.replaceDiacritics(a),
                      disabled: r.groupDisabled,
                    }),
                      (t.lookupItems[s] = r.items[n]),
                      s++;
                  }),
                    (t.items[n] = r);
                } else {
                  var a = i.html();
                  (t.items[n] = {
                    index: s,
                    element: i,
                    value: i.val(),
                    text: a,
                    slug: t.utils.replaceDiacritics(a),
                    disabled: i.prop("disabled"),
                  }),
                    (t.lookupItems[s] = t.items[n]),
                    s++;
                }
              }),
              t.setLabel(),
              t.elements.items.append(
                t.elements.itemsScroll.html(t.getItemsMarkup(t.items))
              ));
        },
        getItemsMarkup: function (t) {
          var n = this,
            i = "<ul>";
          return (
            e.each(t, function (t, r) {
              void 0 !== r.label
                ? ((i += n.utils.format(
                    '<ul class="{1}"><li class="{2}">{3}</li>',
                    e.trim(
                      [
                        n.classes.group,
                        r.groupDisabled ? "disabled" : "",
                        r.element.prop("class"),
                      ].join(" ")
                    ),
                    n.classes.grouplabel,
                    r.element.prop("label")
                  )),
                  e.each(r.items, function (e, t) {
                    i += n.getItemMarkup(t.index, t);
                  }),
                  (i += "</ul>"))
                : (i += n.getItemMarkup(r.index, r));
            }),
            i + "</ul>"
          );
        },
        getItemMarkup: function (t, n) {
          var i = this.options.optionsItemBuilder;
          return this.utils.format(
            '<li data-index="{1}" class="{2}">{3}</li>',
            t,
            e.trim(
              [
                t === this.state.currValue ? "selected" : "",
                t === this.items.length - 1 ? "last" : "",
                n.disabled ? "disabled" : "",
              ].join(" ")
            ),
            e.isFunction(i) ? i(n, n.element, t) : this.utils.format(i, n)
          );
        },
        bindEvents: function () {
          var t = this;
          t.elements.wrapper
            .add(t.$element)
            .add(t.elements.outerWrapper)
            .add(t.elements.input)
            .off(".sl"),
            t.elements.outerWrapper.on(
              "mouseenter.sl mouseleave.sl",
              function (n) {
                e(this).toggleClass(t.classes.hover, "mouseenter" === n.type),
                  t.options.openOnHover &&
                    (clearTimeout(t.closeTimer),
                    "mouseleave" === n.type
                      ? (t.closeTimer = setTimeout(
                          e.proxy(t.close, t),
                          t.options.hoverIntentTimeout
                        ))
                      : t.open());
              }
            ),
            t.elements.wrapper.on("click.sl", function (e) {
              t.state.opened ? t.close() : t.open(e);
            }),
            t.elements.input
              .prop({
                tabindex: t.originalTabindex,
                disabled: !1,
              })
              .on("keydown.sl", e.proxy(t.handleKeys, t))
              .on("focusin.sl", function (e) {
                t.elements.outerWrapper.addClass(t.classes.focus),
                  t.elements.input.one("blur", function () {
                    t.elements.input.blur();
                  }),
                  t.options.openOnFocus && !t.state.opened && t.open(e);
              })
              .on("focusout.sl", function () {
                t.elements.outerWrapper.removeClass(t.classes.focus);
              })
              .on("input propertychange", function () {
                var n = t.elements.input.val();
                clearTimeout(t.resetStr),
                  (t.resetStr = setTimeout(function () {
                    t.elements.input.val("");
                  }, t.options.keySearchTimeout)),
                  n.length &&
                    e.each(t.items, function (e, i) {
                      if (
                        RegExp("^" + t.utils.escapeRegExp(n), "i").test(
                          i.slug
                        ) &&
                        !i.disabled
                      )
                        return t.select(e), !1;
                    });
              }),
            t.$li.on({
              mousedown: function (e) {
                e.preventDefault(), e.stopPropagation();
              },
              click: function () {
                return t.select(e(this).data("index"), !0), !1;
              },
            });
        },
        handleKeys: function (t) {
          var n = t.keyCode || t.which,
            i = this.options.keys,
            r = e.inArray(n, i.previous) > -1,
            s = e.inArray(n, i.next) > -1,
            a = e.inArray(n, i.select) > -1,
            o = e.inArray(n, i.open) > -1,
            l = this.state.selectedIdx,
            c = (r && 0 === l) || (s && l + 1 === this.items.length),
            u = 0;
          if (((13 !== n && 32 !== n) || t.preventDefault(), r || s)) {
            if (!this.options.allowWrap && c) return;
            r && (u = this.utils.previousEnabledItem(this.items, l)),
              s && (u = this.utils.nextEnabledItem(this.items, l)),
              this.select(u);
          }
          a && this.state.opened
            ? this.select(l, !0)
            : o && !this.state.opened && this.open();
        },
        refresh: function () {
          this.populate(),
            this.activate(),
            this.utils.triggerCallback("Refresh", this);
        },
        setOptionsDimensions: function () {
          var e = this.elements.items
              .closest(":visible")
              .children(":hidden")
              .addClass(this.classes.tempshow),
            t = this.options.maxHeight,
            n = this.elements.items.outerWidth(),
            i =
              this.elements.wrapper.outerWidth() -
              (n - this.elements.items.width());
          !this.options.expandToItemText || i > n
            ? (this.finalWidth = i)
            : (this.elements.items.css("overflow", "scroll"),
              this.elements.outerWrapper.width(9e4),
              (this.finalWidth = this.elements.items.width()),
              this.elements.items.css("overflow", ""),
              this.elements.outerWrapper.width("")),
            this.elements.items.width(this.finalWidth).height() > t &&
              this.elements.items.height(t),
            e.removeClass(this.classes.tempshow);
        },
        isInViewport: function () {
          var e = n.scrollTop(),
            t = n.height(),
            i = this.elements.outerWrapper.offset().top,
            r =
              i + this.elements.outerWrapper.outerHeight() + this.itemsHeight <=
              e + t,
            s = i - this.itemsHeight > e,
            a = !r && s;
          this.elements.outerWrapper.toggleClass(this.classes.above, a);
        },
        detectItemVisibility: function (e) {
          var t = this.$li.eq(e).outerHeight(),
            n = this.$li[e].offsetTop,
            i = this.elements.itemsScroll.scrollTop(),
            r = n + 2 * t;
          this.elements.itemsScroll.scrollTop(
            r > i + this.itemsHeight
              ? r - this.itemsHeight
              : n - t < i
              ? n - t
              : i
          );
        },
        open: function (n) {
          var i = this;
          i.utils.triggerCallback("BeforeOpen", i),
            n && (n.preventDefault(), n.stopPropagation()),
            i.state.enabled &&
              (i.setOptionsDimensions(),
              e("." + i.classes.hideselect, "." + i.classes.open)
                .children()
                .selectric("close"),
              (i.state.opened = !0),
              (i.itemsHeight = i.elements.items.outerHeight()),
              (i.itemsInnerHeight = i.elements.items.height()),
              i.elements.outerWrapper.addClass(i.classes.open),
              i.elements.input.val(""),
              n && "focusin" !== n.type && i.elements.input.focus(),
              t
                .on("click.sl", e.proxy(i.close, i))
                .on("scroll.sl", e.proxy(i.isInViewport, i)),
              i.isInViewport(),
              i.options.preventWindowScroll &&
                t.on(
                  "mousewheel.sl DOMMouseScroll.sl",
                  "." + i.classes.scroll,
                  function (t) {
                    var n = t.originalEvent,
                      r = e(this).scrollTop(),
                      s = 0;
                    "detail" in n && (s = -1 * n.detail),
                      "wheelDelta" in n && (s = n.wheelDelta),
                      "wheelDeltaY" in n && (s = n.wheelDeltaY),
                      "deltaY" in n && (s = -1 * n.deltaY),
                      ((r === this.scrollHeight - i.itemsInnerHeight &&
                        s < 0) ||
                        (0 === r && s > 0)) &&
                        t.preventDefault();
                  }
                ),
              i.detectItemVisibility(i.state.selectedIdx),
              i.utils.triggerCallback("Open", i));
        },
        close: function () {
          this.utils.triggerCallback("BeforeClose", this),
            this.change(),
            t.off(".sl"),
            this.elements.outerWrapper.removeClass(this.classes.open),
            (this.state.opened = !1),
            this.utils.triggerCallback("Close", this);
        },
        change: function () {
          this.utils.triggerCallback("BeforeChange", this),
            this.state.currValue !== this.state.selectedIdx &&
              (this.$element
                .prop(
                  "selectedIndex",
                  (this.state.currValue = this.state.selectedIdx)
                )
                .data("value", this.lookupItems[this.state.selectedIdx].text),
              this.setLabel()),
            this.utils.triggerCallback("Change", this);
        },
        select: function (e, t) {
          void 0 !== e &&
            (this.lookupItems[e].disabled ||
              (this.$li
                .filter("[data-index]")
                .removeClass("selected")
                .eq((this.state.selectedIdx = e))
                .addClass("selected"),
              this.detectItemVisibility(e),
              t && this.close()));
        },
        destroy: function (e) {
          this.state &&
            this.state.enabled &&
            (this.elements.items
              .add(this.elements.wrapper)
              .add(this.elements.input)
              .remove(),
            e || this.$element.removeData("selectric").removeData("value"),
            this.$element
              .prop("tabindex", this.originalTabindex)
              .off(".sl")
              .off(this.eventTriggers)
              .unwrap()
              .unwrap(),
            (this.state.enabled = !1));
        },
      }),
        (e.fn.selectric = function (t) {
          return this.each(function () {
            var n = e.data(this, "selectric");
            n && !n.disableOnMobile
              ? "string" == typeof t && n[t]
                ? n[t]()
                : n.init(t)
              : e.data(this, "selectric", new s(this, t));
          });
        }),
        (e.fn.selectric.hooks = {
          add: function (e, t, n) {
            this[e] || (this[e] = {}), (this[e][t] = n);
          },
          remove: function (e, t) {
            delete this[e][t];
          },
        }),
        (e.fn.selectric.defaults = {
          onChange: function (t) {
            e(t).change();
          },
          maxHeight: 300,
          keySearchTimeout: 500,
          arrowButtonMarkup: '<b class="button">&#x25be;</b>',
          disableOnMobile: !0,
          openOnFocus: !0,
          openOnHover: !1,
          hoverIntentTimeout: 500,
          expandToItemText: !1,
          responsive: !1,
          preventWindowScroll: !0,
          inheritOriginalWidth: !1,
          allowWrap: !0,
          optionsItemBuilder: "{text}",
          labelBuilder: "{text}",
          keys: {
            previous: [37, 38],
            next: [39, 40],
            select: [9, 13, 27],
            open: [13, 32, 37, 38, 39, 40],
            close: [9, 27],
          },
          customClass: {
            prefix: "selectric",
            camelCase: !1,
          },
        });
    }),
      "object" == typeof e.exports
        ? a(n(0))
        : ((r = []),
          (i = a(window.jQuery)),
          void 0 === (s = "function" == typeof i ? i.apply(t, r) : i) ||
            (e.exports = s));
  },
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  function (e, t, n) {
    var i, r, s;
    /*!
     * jQuery Cookie Plugin v1.4.1
     * https://github.com/carhartl/jquery-cookie
     *
     * Copyright 2013 Klaus Hartl
     * Released under the MIT license
     */
    (r = [n(0)]),
      void 0 ===
        (s =
          "function" ==
          typeof (i = function (e) {
            var t = /\+/g;

            function n(e) {
              return s.raw ? e : encodeURIComponent(e);
            }

            function i(e) {
              return n(s.json ? JSON.stringify(e) : String(e));
            }

            function r(n, i) {
              var r = s.raw
                ? n
                : (function (e) {
                    0 === e.indexOf('"') &&
                      (e = e
                        .slice(1, -1)
                        .replace(/\\"/g, '"')
                        .replace(/\\\\/g, "\\"));
                    try {
                      return (
                        (e = decodeURIComponent(e.replace(t, " "))),
                        s.json ? JSON.parse(e) : e
                      );
                    } catch (e) {}
                  })(n);
              return e.isFunction(i) ? i(r) : r;
            }
            var s = (e.cookie = function (t, a, o) {
              if (void 0 !== a && !e.isFunction(a)) {
                if (
                  "number" == typeof (o = e.extend({}, s.defaults, o)).expires
                ) {
                  var l = o.expires,
                    c = (o.expires = new Date());
                  c.setTime(+c + 864e5 * l);
                }
                return (document.cookie = [
                  n(t),
                  "=",
                  i(a),
                  o.expires ? "; expires=" + o.expires.toUTCString() : "",
                  o.path ? "; path=" + o.path : "",
                  o.domain ? "; domain=" + o.domain : "",
                  o.secure ? "; secure" : "",
                ].join(""));
              }
              for (
                var u,
                  d = t ? void 0 : {},
                  p = document.cookie ? document.cookie.split("; ") : [],
                  f = 0,
                  h = p.length;
                f < h;
                f++
              ) {
                var m = p[f].split("="),
                  g = ((u = m.shift()), s.raw ? u : decodeURIComponent(u)),
                  v = m.join("=");
                if (t && t === g) {
                  d = r(v, a);
                  break;
                }
                t || void 0 === (v = r(v)) || (d[g] = v);
              }
              return d;
            });
            (s.defaults = {}),
              (e.removeCookie = function (t, n) {
                return (
                  void 0 !== e.cookie(t) &&
                  (e.cookie(
                    t,
                    "",
                    e.extend({}, n, {
                      expires: -1,
                    })
                  ),
                  !e.cookie(t))
                );
              });
          })
            ? i.apply(t, r)
            : i) || (e.exports = s);
  },
  function (e, t, n) {
    "use strict";
    n.r(t);
    var i = n(0),
      r = n.n(i),
      s = (n(2), n(1)),
      a = n.n(s);
    n(13);

    function o(e, t) {
      var n = !1;
      return function () {
        n ||
          (e.apply(this, arguments),
          (n = !0),
          setTimeout(function () {
            n = !1;
          }, t));
      };
    }

    function l(e, t, n) {
      var i = "string" == typeof e && document.querySelector(e),
        r = "string" == typeof e && t;
      if (i) {
        document.addEventListener("click", function (t) {
          var s;
          (function (e) {
            if (!(e instanceof Element))
              throw Error("DomUtil: elem is not an element.");
            var t = getComputedStyle(e);
            if ("none" === t.display) return !1;
            if ("visible" !== t.visibility) return !1;
            if (t.opacity < 0.1) return !1;
            if (
              e.offsetWidth +
                e.offsetHeight +
                e.getBoundingClientRect().height +
                e.getBoundingClientRect().width ===
              0
            )
              return !1;
            var n = {
              x: e.getBoundingClientRect().left + e.offsetWidth / 2,
              y: e.getBoundingClientRect().top + e.offsetHeight / 2,
            };
            if (n.x < 0) return !1;
            if (
              n.x > (document.documentElement.clientWidth || window.innerWidth)
            )
              return !1;
            if (n.y < 0) return !1;
            if (
              n.y >
              (document.documentElement.clientHeight || window.innerHeight)
            )
              return !1;
            var i = document.elementFromPoint(n.x, n.y);
            do {
              if (i === e) return !0;
            } while ((i = i.parentNode));
            return !1;
          })(i) &&
            ((s = t.target).closest(e) || s.closest(r) || (n && n(i, s)));
        });
      }
    }

    function c(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var u = (function () {
      function e() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          this.init();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              this.initcookie(), this.newsletter(), this.currency();
            },
          },
          {
            key: "initcookie",
            value: function () {
              var e = r()(".cookie");
              r.a.cookie("cookie") || e.fadeIn(),
                r()(".cookie__btn").on("click", function (e) {
                  e.preventDefault(),
                    r()(this).parents(".cookie").fadeOut(200),
                    r.a.cookie("cookie", !0, {
                      path: "/",
                      expires: 7,
                    }),
                    r()("body").removeClass("cookie-visible");
                });
            },
          },
          {
            key: "newsletter",
            value: function () {
              var e,
                t = r()(window).height(),
                n = r()(".newsletter-popup");
              r.a.cookie("newsletter") ||
                (r()(window).on(
                  "scroll",
                  o(function () {
                    r()(window).scrollTop() >= t
                      ? (r.a.cookie("cookie") ||
                          r()("body").addClass("cookie-visible"),
                        n.fadeIn())
                      : (n.fadeOut(),
                        r.a.cookie("cookie") ||
                          r()("body").removeClass("cookie-visible"));
                  }, 100)
                ),
                (e = r()(".newsletter__submit")),
                r()(".newsletter__input").on("keyup", function (t) {
                  var n = r()(t.target);
                  setTimeout(function () {
                    n.val().length > 0
                      ? e.addClass("newsletter__submit--active")
                      : e.removeClass("newsletter__submit--active");
                  }, 100);
                })),
                r()(".newsletter-popup__close").on("click", function () {
                  n.fadeOut().remove(),
                    r.a.cookie("newsletter", !0, {
                      path: "/",
                      expires: 7,
                    });
                });
            },
          },
          {
            key: "currency",
            value: function () {
              r()("[data-currency-selector]").on("change", function () {
                r()(this).parents("form").submit();
              });
            },
          },
        ]) && c(t.prototype, n),
        i && c(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function d(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var p = -1,
      f = null,
      h = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.search = r()(".search")),
            (this.searchBtn = r()(".nav__link--search")),
            (this.searchInput = r()(".search__input")),
            (this.searchResult = r()(".search__body")),
            (this.searchSuggestion = r()(".search__suggestion")),
            (this.searchProducts = r()(".search__products")),
            (this.currentPage = 1);
        }
        var t, n, i;
        return (
          (t = e),
          (n = [
            {
              key: "applySearch",
              value: function (e) {
                var t = this;
                this.currentSearch = e;
                this.loading = true;
                null != f && f.abort(),
                  clearTimeout(p),
                  (p = setTimeout(function () {
                    f = r.a.ajax({
                      url:
                        "/search?view=ajax&q=" +
                        e +
                        "&resources[type]=product&page=" +
                        t.currentPage,
                      success: function (e) {
                        if (t.appendSearch) {
                          var results = r()(e).find(".search-product");
                          var search_grid = t.searchResult.find(
                            ".search__products-grid"
                          );
                          search_grid.append(results);
                        } else {
                          t.searchResult.html(e);
                        }
                        t.loading = false;
                      },
                    });
                  }, 250));
              },
            },
            {
              key: "init",
              value: function () {
                var e = this;
                r()(this.searchBtn).on("click", this.toggleSearch.bind(this)),
                  r()(this.searchInput).on(
                    "change keyup",
                    this.showSearchResult.bind(this)
                  ),
                  r()(".search__reset").on(
                    "click",
                    this.clearSearch.bind(this)
                  ),
                  r()(window).width() > 992
                    ? r()(".search__reset").on(
                        "click",
                        this.clearSearch.bind(this)
                      )
                    : r()(".search__reset").on(
                        "click",
                        this.toggleSearch.bind(this)
                      ),
                  r()(document).on("click", function (t) {
                    if (e.search.is(":visible")) {
                      if (
                        r()(t.target).closest(".search__form").length ||
                        r()(t.target).closest(".search__result").length ||
                        r()(t.target).closest(".nav-toggler").length
                      )
                        return;
                      r()(e.search).fadeOut(200);
                      document
                        .querySelector("html")
                        .classList.toggle("search-open");
                    }
                  });
                // When the menu toggler (top-left ✕) is tapped while the search
                // overlay is open on mobile, close the search and return to the
                // menu drawer instead of toggling the drawer underneath. Capture
                // phase runs this before the toggler's own click handler, and
                // stopping propagation keeps the still-open drawer in place so it
                // is revealed once the overlay fades out.
                document.addEventListener(
                  "click",
                  function (t) {
                    if (r()(window).width() > 991.8) return;
                    if (!e.search.is(":visible")) return;
                    if (!t.target.closest || !t.target.closest(".nav-toggler"))
                      return;
                    t.preventDefault();
                    t.stopPropagation();
                    t.stopImmediatePropagation();
                    r()(e.search).stop(true, true).fadeOut(200);
                    document
                      .querySelector("html")
                      .classList.remove("search-open");
                  },
                  true
                );
                this.search[0].addEventListener(
                  "scroll",
                  this.loadMore.bind(this),
                  false
                );
                var t = this;
                this.searchInput.on("keyup keypress", function (e) {
                  // Live/predictive search: TRAILING wildcard only ("pie" -> "pie*").
                  // Shopify does not support a leading wildcard, so the old "*term*"
                  // matched nothing until a space was typed.
                  t.appendSearch = false;
                  t.currentPage = 1;
                  var n = r()(this).val() + "*";
                  // Enter keeps results in the styled overlay (prevents jumping to the
                  // theme's bare /search results page).
                  if ((t.applySearch(n), 13 === e.which))
                    return e.preventDefault(), !1;
                });
              },
            },
            {
              key: "toggleSearch",
              value: function (e) {
                console.log(e),
                  e.preventDefault(),
                  e.stopPropagation(),
                  this.search.fadeToggle(200),
                  this.searchInput.focus(),
                  document
                    .querySelector("html")
                    .classList.toggle("search-open");
              },
            },
            {
              key: "loadMore",
              value: function (e) {
                // var search_bar = document.querySelector('.search');
                var results_container =
                  this.search[0].querySelector(".search__result");
                var results_count = results_container.getAttribute("count");
                var current_scroll =
                  this.search[0].scrollTop + this.search[0].offsetHeight;
                var scroll_percentage =
                  (current_scroll / this.search[0].scrollHeight) * 100;
                console.log(this.loading);
                if (
                  parseInt(results_count) > 50 &&
                  scroll_percentage > 70 &&
                  !this.loading
                ) {
                  var max = Math.ceil(parseInt(results_count) / 50);
                  this.currentPage = this.currentPage + 1;
                  if (max >= this.currentPage) {
                    this.appendSearch = true;
                    this.applySearch(this.currentSearch);
                  }
                }
              },
            },
            {
              key: "showSearchResult",
              value: function (e) {
                r()(e.target).val().length >= 1
                  ? this.searchProducts.fadeIn(0)
                  : this.searchProducts.fadeOut(0);
              },
            },
            {
              key: "clearSearch",
              value: function () {
                this.appendSearch = false;
                this.searchInput.val(""),
                  this.searchProducts.fadeOut(0),
                  this.applySearch("");
                console.log(this.search[0]);
                this.search[0].removeEventListener("scroll", false);
                this.search[0].removeEventListener(
                  "scroll",
                  this.loadMore.bind(this),
                  false
                );
              },
            },
          ]) && d(t.prototype, n),
          i && d(t, i),
          Object.defineProperty(t, "prototype", {
            writable: !1,
          }),
          e
        );
      })();

    function m(e) {
      return (
        null !== e &&
        "object" == typeof e &&
        "constructor" in e &&
        e.constructor === Object
      );
    }

    function g(e = {}, t = {}) {
      Object.keys(t).forEach((n) => {
        void 0 === e[n]
          ? (e[n] = t[n])
          : m(t[n]) && m(e[n]) && Object.keys(t[n]).length > 0 && g(e[n], t[n]);
      });
    }
    const v = {
      body: {},
      addEventListener() {},
      removeEventListener() {},
      activeElement: {
        blur() {},
        nodeName: "",
      },
      querySelector: () => null,
      querySelectorAll: () => [],
      getElementById: () => null,
      createEvent: () => ({
        initEvent() {},
      }),
      createElement: () => ({
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {},
        getElementsByTagName: () => [],
      }),
      createElementNS: () => ({}),
      importNode: () => null,
      location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: "",
      },
    };

    function y() {
      const e = "undefined" != typeof document ? document : {};
      return g(e, v), e;
    }
    const b = {
      document: v,
      navigator: {
        userAgent: "",
      },
      location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: "",
      },
      history: {
        replaceState() {},
        pushState() {},
        go() {},
        back() {},
      },
      CustomEvent: function () {
        return this;
      },
      addEventListener() {},
      removeEventListener() {},
      getComputedStyle: () => ({
        getPropertyValue: () => "",
      }),
      Image() {},
      Date() {},
      screen: {},
      setTimeout() {},
      clearTimeout() {},
      matchMedia: () => ({}),
      requestAnimationFrame: (e) =>
        "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
      cancelAnimationFrame(e) {
        "undefined" != typeof setTimeout && clearTimeout(e);
      },
    };

    function _() {
      const e = "undefined" != typeof window ? window : {};
      return g(e, b), e;
    }
    class w extends Array {
      constructor(e) {
        "number" == typeof e
          ? super(e)
          : (super(...(e || [])),
            (function (e) {
              const t = e.__proto__;
              Object.defineProperty(e, "__proto__", {
                get: () => t,
                set(e) {
                  t.__proto__ = e;
                },
              });
            })(this));
      }
    }

    function x(e = []) {
      const t = [];
      return (
        e.forEach((e) => {
          Array.isArray(e) ? t.push(...x(e)) : t.push(e);
        }),
        t
      );
    }

    function C(e, t) {
      return Array.prototype.filter.call(e, t);
    }

    function T(e, t) {
      const n = _(),
        i = y();
      let r = [];
      if (!t && e instanceof w) return e;
      if (!e) return new w(r);
      if ("string" == typeof e) {
        const n = e.trim();
        if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
          let e = "div";
          0 === n.indexOf("<li") && (e = "ul"),
            0 === n.indexOf("<tr") && (e = "tbody"),
            (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
            0 === n.indexOf("<tbody") && (e = "table"),
            0 === n.indexOf("<option") && (e = "select");
          const t = i.createElement(e);
          t.innerHTML = n;
          for (let e = 0; e < t.childNodes.length; e += 1)
            r.push(t.childNodes[e]);
        } else
          r = (function (e, t) {
            if ("string" != typeof e) return [e];
            const n = [],
              i = t.querySelectorAll(e);
            for (let e = 0; e < i.length; e += 1) n.push(i[e]);
            return n;
          })(e.trim(), t || i);
      } else if (e.nodeType || e === n || e === i) r.push(e);
      else if (Array.isArray(e)) {
        if (e instanceof w) return e;
        r = e;
      }
      return new w(
        (function (e) {
          const t = [];
          for (let n = 0; n < e.length; n += 1)
            -1 === t.indexOf(e[n]) && t.push(e[n]);
          return t;
        })(r)
      );
    }
    T.fn = w.prototype;
    const k = "resize scroll".split(" ");

    function S(e) {
      return function (...t) {
        if (void 0 === t[0]) {
          for (let t = 0; t < this.length; t += 1)
            k.indexOf(e) < 0 &&
              (e in this[t] ? this[t][e]() : T(this[t]).trigger(e));
          return this;
        }
        return this.on(e, ...t);
      };
    }
    S("click"),
      S("blur"),
      S("focus"),
      S("focusin"),
      S("focusout"),
      S("keyup"),
      S("keydown"),
      S("keypress"),
      S("submit"),
      S("change"),
      S("mousedown"),
      S("mousemove"),
      S("mouseup"),
      S("mouseenter"),
      S("mouseleave"),
      S("mouseout"),
      S("mouseover"),
      S("touchstart"),
      S("touchend"),
      S("touchmove"),
      S("resize"),
      S("scroll");
    const E = {
      addClass: function (...e) {
        const t = x(e.map((e) => e.split(" ")));
        return (
          this.forEach((e) => {
            e.classList.add(...t);
          }),
          this
        );
      },
      removeClass: function (...e) {
        const t = x(e.map((e) => e.split(" ")));
        return (
          this.forEach((e) => {
            e.classList.remove(...t);
          }),
          this
        );
      },
      hasClass: function (...e) {
        const t = x(e.map((e) => e.split(" ")));
        return (
          C(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0)
            .length > 0
        );
      },
      toggleClass: function (...e) {
        const t = x(e.map((e) => e.split(" ")));
        this.forEach((e) => {
          t.forEach((t) => {
            e.classList.toggle(t);
          });
        });
      },
      attr: function (e, t) {
        if (1 === arguments.length && "string" == typeof e)
          return this[0] ? this[0].getAttribute(e) : void 0;
        for (let n = 0; n < this.length; n += 1)
          if (2 === arguments.length) this[n].setAttribute(e, t);
          else
            for (const t in e)
              (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
        return this;
      },
      removeAttr: function (e) {
        for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
        return this;
      },
      transform: function (e) {
        for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
        return this;
      },
      transition: function (e) {
        for (let t = 0; t < this.length; t += 1)
          this[t].style.transitionDuration =
            "string" != typeof e ? e + "ms" : e;
        return this;
      },
      on: function (...e) {
        let [t, n, i, r] = e;

        function s(e) {
          const t = e.target;
          if (!t) return;
          const r = e.target.dom7EventData || [];
          if ((r.indexOf(e) < 0 && r.unshift(e), T(t).is(n))) i.apply(t, r);
          else {
            const e = T(t).parents();
            for (let t = 0; t < e.length; t += 1)
              T(e[t]).is(n) && i.apply(e[t], r);
          }
        }

        function a(e) {
          const t = (e && e.target && e.target.dom7EventData) || [];
          t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t);
        }
        "function" == typeof e[1] && (([t, i, r] = e), (n = void 0)),
          r || (r = !1);
        const o = t.split(" ");
        let l;
        for (let e = 0; e < this.length; e += 1) {
          const t = this[e];
          if (n)
            for (l = 0; l < o.length; l += 1) {
              const e = o[l];
              t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                t.dom7LiveListeners[e].push({
                  listener: i,
                  proxyListener: s,
                }),
                t.addEventListener(e, s, r);
            }
          else
            for (l = 0; l < o.length; l += 1) {
              const e = o[l];
              t.dom7Listeners || (t.dom7Listeners = {}),
                t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                t.dom7Listeners[e].push({
                  listener: i,
                  proxyListener: a,
                }),
                t.addEventListener(e, a, r);
            }
        }
        return this;
      },
      off: function (...e) {
        let [t, n, i, r] = e;
        "function" == typeof e[1] && (([t, i, r] = e), (n = void 0)),
          r || (r = !1);
        const s = t.split(" ");
        for (let e = 0; e < s.length; e += 1) {
          const t = s[e];
          for (let e = 0; e < this.length; e += 1) {
            const s = this[e];
            let a;
            if (
              (!n && s.dom7Listeners
                ? (a = s.dom7Listeners[t])
                : n && s.dom7LiveListeners && (a = s.dom7LiveListeners[t]),
              a && a.length)
            )
              for (let e = a.length - 1; e >= 0; e -= 1) {
                const n = a[e];
                (i && n.listener === i) ||
                (i &&
                  n.listener &&
                  n.listener.dom7proxy &&
                  n.listener.dom7proxy === i)
                  ? (s.removeEventListener(t, n.proxyListener, r),
                    a.splice(e, 1))
                  : i ||
                    (s.removeEventListener(t, n.proxyListener, r),
                    a.splice(e, 1));
              }
          }
        }
        return this;
      },
      trigger: function (...e) {
        const t = _(),
          n = e[0].split(" "),
          i = e[1];
        for (let r = 0; r < n.length; r += 1) {
          const s = n[r];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n];
            if (t.CustomEvent) {
              const n = new t.CustomEvent(s, {
                detail: i,
                bubbles: !0,
                cancelable: !0,
              });
              (r.dom7EventData = e.filter((e, t) => t > 0)),
                r.dispatchEvent(n),
                (r.dom7EventData = []),
                delete r.dom7EventData;
            }
          }
        }
        return this;
      },
      transitionEnd: function (e) {
        const t = this;
        return (
          e &&
            t.on("transitionend", function n(i) {
              i.target === this && (e.call(this, i), t.off("transitionend", n));
            }),
          this
        );
      },
      outerWidth: function (e) {
        if (this.length > 0) {
          if (e) {
            const e = this.styles();
            return (
              this[0].offsetWidth +
              parseFloat(e.getPropertyValue("margin-right")) +
              parseFloat(e.getPropertyValue("margin-left"))
            );
          }
          return this[0].offsetWidth;
        }
        return null;
      },
      outerHeight: function (e) {
        if (this.length > 0) {
          if (e) {
            const e = this.styles();
            return (
              this[0].offsetHeight +
              parseFloat(e.getPropertyValue("margin-top")) +
              parseFloat(e.getPropertyValue("margin-bottom"))
            );
          }
          return this[0].offsetHeight;
        }
        return null;
      },
      styles: function () {
        const e = _();
        return this[0] ? e.getComputedStyle(this[0], null) : {};
      },
      offset: function () {
        if (this.length > 0) {
          const e = _(),
            t = y(),
            n = this[0],
            i = n.getBoundingClientRect(),
            r = t.body,
            s = n.clientTop || r.clientTop || 0,
            a = n.clientLeft || r.clientLeft || 0,
            o = n === e ? e.scrollY : n.scrollTop,
            l = n === e ? e.scrollX : n.scrollLeft;
          return {
            top: i.top + o - s,
            left: i.left + l - a,
          };
        }
        return null;
      },
      css: function (e, t) {
        const n = _();
        let i;
        if (1 === arguments.length) {
          if ("string" != typeof e) {
            for (i = 0; i < this.length; i += 1)
              for (const t in e) this[i].style[t] = e[t];
            return this;
          }
          if (this[0])
            return n.getComputedStyle(this[0], null).getPropertyValue(e);
        }
        if (2 === arguments.length && "string" == typeof e) {
          for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
          return this;
        }
        return this;
      },
      each: function (e) {
        return e
          ? (this.forEach((t, n) => {
              e.apply(t, [t, n]);
            }),
            this)
          : this;
      },
      html: function (e) {
        if (void 0 === e) return this[0] ? this[0].innerHTML : null;
        for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
        return this;
      },
      text: function (e) {
        if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
        for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
        return this;
      },
      is: function (e) {
        const t = _(),
          n = y(),
          i = this[0];
        let r, s;
        if (!i || void 0 === e) return !1;
        if ("string" == typeof e) {
          if (i.matches) return i.matches(e);
          if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
          if (i.msMatchesSelector) return i.msMatchesSelector(e);
          for (r = T(e), s = 0; s < r.length; s += 1) if (r[s] === i) return !0;
          return !1;
        }
        if (e === n) return i === n;
        if (e === t) return i === t;
        if (e.nodeType || e instanceof w) {
          for (r = e.nodeType ? [e] : e, s = 0; s < r.length; s += 1)
            if (r[s] === i) return !0;
          return !1;
        }
        return !1;
      },
      index: function () {
        let e,
          t = this[0];
        if (t) {
          for (e = 0; null !== (t = t.previousSibling); )
            1 === t.nodeType && (e += 1);
          return e;
        }
      },
      eq: function (e) {
        if (void 0 === e) return this;
        const t = this.length;
        if (e > t - 1) return T([]);
        if (e < 0) {
          const n = t + e;
          return T(n < 0 ? [] : [this[n]]);
        }
        return T([this[e]]);
      },
      append: function (...e) {
        let t;
        const n = y();
        for (let i = 0; i < e.length; i += 1) {
          t = e[i];
          for (let e = 0; e < this.length; e += 1)
            if ("string" == typeof t) {
              const i = n.createElement("div");
              for (i.innerHTML = t; i.firstChild; )
                this[e].appendChild(i.firstChild);
            } else if (t instanceof w)
              for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
            else this[e].appendChild(t);
        }
        return this;
      },
      prepend: function (e) {
        const t = y();
        let n, i;
        for (n = 0; n < this.length; n += 1)
          if ("string" == typeof e) {
            const r = t.createElement("div");
            for (r.innerHTML = e, i = r.childNodes.length - 1; i >= 0; i -= 1)
              this[n].insertBefore(r.childNodes[i], this[n].childNodes[0]);
          } else if (e instanceof w)
            for (i = 0; i < e.length; i += 1)
              this[n].insertBefore(e[i], this[n].childNodes[0]);
          else this[n].insertBefore(e, this[n].childNodes[0]);
        return this;
      },
      next: function (e) {
        return this.length > 0
          ? e
            ? this[0].nextElementSibling && T(this[0].nextElementSibling).is(e)
              ? T([this[0].nextElementSibling])
              : T([])
            : this[0].nextElementSibling
            ? T([this[0].nextElementSibling])
            : T([])
          : T([]);
      },
      nextAll: function (e) {
        const t = [];
        let n = this[0];
        if (!n) return T([]);
        for (; n.nextElementSibling; ) {
          const i = n.nextElementSibling;
          e ? T(i).is(e) && t.push(i) : t.push(i), (n = i);
        }
        return T(t);
      },
      prev: function (e) {
        if (this.length > 0) {
          const t = this[0];
          return e
            ? t.previousElementSibling && T(t.previousElementSibling).is(e)
              ? T([t.previousElementSibling])
              : T([])
            : t.previousElementSibling
            ? T([t.previousElementSibling])
            : T([]);
        }
        return T([]);
      },
      prevAll: function (e) {
        const t = [];
        let n = this[0];
        if (!n) return T([]);
        for (; n.previousElementSibling; ) {
          const i = n.previousElementSibling;
          e ? T(i).is(e) && t.push(i) : t.push(i), (n = i);
        }
        return T(t);
      },
      parent: function (e) {
        const t = [];
        for (let n = 0; n < this.length; n += 1)
          null !== this[n].parentNode &&
            (e
              ? T(this[n].parentNode).is(e) && t.push(this[n].parentNode)
              : t.push(this[n].parentNode));
        return T(t);
      },
      parents: function (e) {
        const t = [];
        for (let n = 0; n < this.length; n += 1) {
          let i = this[n].parentNode;
          for (; i; )
            e ? T(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode);
        }
        return T(t);
      },
      closest: function (e) {
        let t = this;
        return void 0 === e ? T([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
      },
      find: function (e) {
        const t = [];
        for (let n = 0; n < this.length; n += 1) {
          const i = this[n].querySelectorAll(e);
          for (let e = 0; e < i.length; e += 1) t.push(i[e]);
        }
        return T(t);
      },
      children: function (e) {
        const t = [];
        for (let n = 0; n < this.length; n += 1) {
          const i = this[n].children;
          for (let n = 0; n < i.length; n += 1)
            (e && !T(i[n]).is(e)) || t.push(i[n]);
        }
        return T(t);
      },
      filter: function (e) {
        return T(C(this, e));
      },
      remove: function () {
        for (let e = 0; e < this.length; e += 1)
          this[e].parentNode && this[e].parentNode.removeChild(this[e]);
        return this;
      },
    };
    Object.keys(E).forEach((e) => {
      Object.defineProperty(T.fn, e, {
        value: E[e],
        writable: !0,
      });
    });
    var O = T;

    function P(e, t) {
      return void 0 === t && (t = 0), setTimeout(e, t);
    }

    function M() {
      return Date.now();
    }

    function A(e, t) {
      void 0 === t && (t = "x");
      const n = _();
      let i, r, s;
      const a = (function (e) {
        const t = _();
        let n;
        return (
          t.getComputedStyle && (n = t.getComputedStyle(e, null)),
          !n && e.currentStyle && (n = e.currentStyle),
          n || (n = e.style),
          n
        );
      })(e);
      return (
        n.WebKitCSSMatrix
          ? ((r = a.transform || a.webkitTransform),
            r.split(",").length > 6 &&
              (r = r
                .split(", ")
                .map((e) => e.replace(",", "."))
                .join(", ")),
            (s = new n.WebKitCSSMatrix("none" === r ? "" : r)))
          : ((s =
              a.MozTransform ||
              a.OTransform ||
              a.MsTransform ||
              a.msTransform ||
              a.transform ||
              a
                .getPropertyValue("transform")
                .replace("translate(", "matrix(1, 0, 0, 1,")),
            (i = s.toString().split(","))),
        "x" === t &&
          (r = n.WebKitCSSMatrix
            ? s.m41
            : 16 === i.length
            ? parseFloat(i[12])
            : parseFloat(i[4])),
        "y" === t &&
          (r = n.WebKitCSSMatrix
            ? s.m42
            : 16 === i.length
            ? parseFloat(i[13])
            : parseFloat(i[5])),
        r || 0
      );
    }

    function D(e) {
      return (
        "object" == typeof e &&
        null !== e &&
        e.constructor &&
        "Object" === Object.prototype.toString.call(e).slice(8, -1)
      );
    }

    function I(e) {
      return "undefined" != typeof window && void 0 !== window.HTMLElement
        ? e instanceof HTMLElement
        : e && (1 === e.nodeType || 11 === e.nodeType);
    }

    function L() {
      const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
        t = ["__proto__", "constructor", "prototype"];
      for (let n = 1; n < arguments.length; n += 1) {
        const i = n < 0 || arguments.length <= n ? void 0 : arguments[n];
        if (null != i && !I(i)) {
          const n = Object.keys(Object(i)).filter((e) => t.indexOf(e) < 0);
          for (let t = 0, r = n.length; t < r; t += 1) {
            const r = n[t],
              s = Object.getOwnPropertyDescriptor(i, r);
            void 0 !== s &&
              s.enumerable &&
              (D(e[r]) && D(i[r])
                ? i[r].__swiper__
                  ? (e[r] = i[r])
                  : L(e[r], i[r])
                : !D(e[r]) && D(i[r])
                ? ((e[r] = {}), i[r].__swiper__ ? (e[r] = i[r]) : L(e[r], i[r]))
                : (e[r] = i[r]));
          }
        }
      }
      return e;
    }

    function j(e, t, n) {
      e.style.setProperty(t, n);
    }

    function N(e) {
      let { swiper: t, targetPosition: n, side: i } = e;
      const r = _(),
        s = -t.translate;
      let a,
        o = null;
      const l = t.params.speed;
      (t.wrapperEl.style.scrollSnapType = "none"),
        r.cancelAnimationFrame(t.cssModeFrameID);
      const c = n > s ? "next" : "prev",
        u = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
        d = () => {
          (a = new Date().getTime()), null === o && (o = a);
          const e = Math.max(Math.min((a - o) / l, 1), 0),
            c = 0.5 - Math.cos(e * Math.PI) / 2;
          let p = s + c * (n - s);
          if (
            (u(p, n) && (p = n),
            t.wrapperEl.scrollTo({
              [i]: p,
            }),
            u(p, n))
          )
            return (
              (t.wrapperEl.style.overflow = "hidden"),
              (t.wrapperEl.style.scrollSnapType = ""),
              setTimeout(() => {
                (t.wrapperEl.style.overflow = ""),
                  t.wrapperEl.scrollTo({
                    [i]: p,
                  });
              }),
              void r.cancelAnimationFrame(t.cssModeFrameID)
            );
          t.cssModeFrameID = r.requestAnimationFrame(d);
        };
      d();
    }
    let B, z, R;

    function H() {
      return (
        B ||
          (B = (function () {
            const e = _(),
              t = y();
            return {
              smoothScroll:
                t.documentElement &&
                "scrollBehavior" in t.documentElement.style,
              touch: !!(
                "ontouchstart" in e ||
                (e.DocumentTouch && t instanceof e.DocumentTouch)
              ),
              passiveListener: (function () {
                let t = !1;
                try {
                  const n = Object.defineProperty({}, "passive", {
                    get() {
                      t = !0;
                    },
                  });
                  e.addEventListener("testPassiveListener", null, n);
                } catch (e) {}
                return t;
              })(),
              gestures: "ongesturestart" in e,
            };
          })()),
        B
      );
    }

    function F(e) {
      return (
        void 0 === e && (e = {}),
        z ||
          (z = (function (e) {
            let { userAgent: t } = void 0 === e ? {} : e;
            const n = H(),
              i = _(),
              r = i.navigator.platform,
              s = t || i.navigator.userAgent,
              a = {
                ios: !1,
                android: !1,
              },
              o = i.screen.width,
              l = i.screen.height,
              c = s.match(/(Android);?[\s\/]+([\d.]+)?/);
            let u = s.match(/(iPad).*OS\s([\d_]+)/);
            const d = s.match(/(iPod)(.*OS\s([\d_]+))?/),
              p = !u && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
              f = "Win32" === r;
            let h = "MacIntel" === r;
            return (
              !u &&
                h &&
                n.touch &&
                [
                  "1024x1366",
                  "1366x1024",
                  "834x1194",
                  "1194x834",
                  "834x1112",
                  "1112x834",
                  "768x1024",
                  "1024x768",
                  "820x1180",
                  "1180x820",
                  "810x1080",
                  "1080x810",
                ].indexOf(`${o}x${l}`) >= 0 &&
                ((u = s.match(/(Version)\/([\d.]+)/)),
                u || (u = [0, 1, "13_0_0"]),
                (h = !1)),
              c && !f && ((a.os = "android"), (a.android = !0)),
              (u || p || d) && ((a.os = "ios"), (a.ios = !0)),
              a
            );
          })(e)),
        z
      );
    }

    function q() {
      return (
        R ||
          (R = (function () {
            const e = _();
            return {
              isSafari: (function () {
                const t = e.navigator.userAgent.toLowerCase();
                return (
                  t.indexOf("safari") >= 0 &&
                  t.indexOf("chrome") < 0 &&
                  t.indexOf("android") < 0
                );
              })(),
              isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                e.navigator.userAgent
              ),
            };
          })()),
        R
      );
    }

    function W(e) {
      let { swiper: t, runCallbacks: n, direction: i, step: r } = e;
      const { activeIndex: s, previousIndex: a } = t;
      let o = i;
      if (
        (o || (o = s > a ? "next" : s < a ? "prev" : "reset"),
        t.emit("transition" + r),
        n && s !== a)
      ) {
        if ("reset" === o) return void t.emit("slideResetTransition" + r);
        t.emit("slideChangeTransition" + r),
          "next" === o
            ? t.emit("slideNextTransition" + r)
            : t.emit("slidePrevTransition" + r);
      }
    }

    function V(e) {
      const t = this,
        n = y(),
        i = _(),
        r = t.touchEventsData,
        { params: s, touches: a, enabled: o } = t;
      if (!o) return;
      if (t.animating && s.preventInteractionOnTransition) return;
      !t.animating && s.cssMode && s.loop && t.loopFix();
      let l = e;
      l.originalEvent && (l = l.originalEvent);
      let c = O(l.target);
      if ("wrapper" === s.touchEventsTarget && !c.closest(t.wrapperEl).length)
        return;
      if (
        ((r.isTouchEvent = "touchstart" === l.type),
        !r.isTouchEvent && "which" in l && 3 === l.which)
      )
        return;
      if (!r.isTouchEvent && "button" in l && l.button > 0) return;
      if (r.isTouched && r.isMoved) return;
      !!s.noSwipingClass &&
        "" !== s.noSwipingClass &&
        l.target &&
        l.target.shadowRoot &&
        e.path &&
        e.path[0] &&
        (c = O(e.path[0]));
      const u = s.noSwipingSelector
          ? s.noSwipingSelector
          : "." + s.noSwipingClass,
        d = !(!l.target || !l.target.shadowRoot);
      if (
        s.noSwiping &&
        (d
          ? (function (e, t) {
              return (
                void 0 === t && (t = this),
                (function t(n) {
                  return n && n !== y() && n !== _()
                    ? (n.assignedSlot && (n = n.assignedSlot),
                      n.closest(e) || t(n.getRootNode().host))
                    : null;
                })(t)
              );
            })(u, l.target)
          : c.closest(u)[0])
      )
        return void (t.allowClick = !0);
      if (s.swipeHandler && !c.closest(s.swipeHandler)[0]) return;
      (a.currentX =
        "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
        (a.currentY =
          "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
      const p = a.currentX,
        f = a.currentY,
        h = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection,
        m = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
      if (h && (p <= m || p >= i.innerWidth - m)) {
        if ("prevent" !== h) return;
        e.preventDefault();
      }
      if (
        (Object.assign(r, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
        (a.startX = p),
        (a.startY = f),
        (r.touchStartTime = M()),
        (t.allowClick = !0),
        t.updateSize(),
        (t.swipeDirection = void 0),
        s.threshold > 0 && (r.allowThresholdMove = !1),
        "touchstart" !== l.type)
      ) {
        let e = !0;
        c.is(r.focusableElements) &&
          ((e = !1), "SELECT" === c[0].nodeName && (r.isTouched = !1)),
          n.activeElement &&
            O(n.activeElement).is(r.focusableElements) &&
            n.activeElement !== c[0] &&
            n.activeElement.blur();
        const i = e && t.allowTouchMove && s.touchStartPreventDefault;
        (!s.touchStartForcePreventDefault && !i) ||
          c[0].isContentEditable ||
          l.preventDefault();
      }
      t.params.freeMode &&
        t.params.freeMode.enabled &&
        t.freeMode &&
        t.animating &&
        !s.cssMode &&
        t.freeMode.onTouchStart(),
        t.emit("touchStart", l);
    }

    function G(e) {
      const t = y(),
        n = this,
        i = n.touchEventsData,
        { params: r, touches: s, rtlTranslate: a, enabled: o } = n;
      if (!o) return;
      let l = e;
      if ((l.originalEvent && (l = l.originalEvent), !i.isTouched))
        return void (
          i.startMoving &&
          i.isScrolling &&
          n.emit("touchMoveOpposite", l)
        );
      if (i.isTouchEvent && "touchmove" !== l.type) return;
      const c =
          "touchmove" === l.type &&
          l.targetTouches &&
          (l.targetTouches[0] || l.changedTouches[0]),
        u = "touchmove" === l.type ? c.pageX : l.pageX,
        d = "touchmove" === l.type ? c.pageY : l.pageY;
      if (l.preventedByNestedSwiper) return (s.startX = u), void (s.startY = d);
      if (!n.allowTouchMove)
        return (
          O(l.target).is(i.focusableElements) || (n.allowClick = !1),
          void (
            i.isTouched &&
            (Object.assign(s, {
              startX: u,
              startY: d,
              currentX: u,
              currentY: d,
            }),
            (i.touchStartTime = M()))
          )
        );
      if (i.isTouchEvent && r.touchReleaseOnEdges && !r.loop)
        if (n.isVertical()) {
          if (
            (d < s.startY && n.translate <= n.maxTranslate()) ||
            (d > s.startY && n.translate >= n.minTranslate())
          )
            return (i.isTouched = !1), void (i.isMoved = !1);
        } else if (
          (u < s.startX && n.translate <= n.maxTranslate()) ||
          (u > s.startX && n.translate >= n.minTranslate())
        )
          return;
      if (
        i.isTouchEvent &&
        t.activeElement &&
        l.target === t.activeElement &&
        O(l.target).is(i.focusableElements)
      )
        return (i.isMoved = !0), void (n.allowClick = !1);
      if (
        (i.allowTouchCallbacks && n.emit("touchMove", l),
        l.targetTouches && l.targetTouches.length > 1)
      )
        return;
      (s.currentX = u), (s.currentY = d);
      const p = s.currentX - s.startX,
        f = s.currentY - s.startY;
      if (n.params.threshold && Math.sqrt(p ** 2 + f ** 2) < n.params.threshold)
        return;
      if (void 0 === i.isScrolling) {
        let e;
        (n.isHorizontal() && s.currentY === s.startY) ||
        (n.isVertical() && s.currentX === s.startX)
          ? (i.isScrolling = !1)
          : p * p + f * f >= 25 &&
            ((e = (180 * Math.atan2(Math.abs(f), Math.abs(p))) / Math.PI),
            (i.isScrolling = n.isHorizontal()
              ? e > r.touchAngle
              : 90 - e > r.touchAngle));
      }
      if (
        (i.isScrolling && n.emit("touchMoveOpposite", l),
        void 0 === i.startMoving &&
          ((s.currentX === s.startX && s.currentY === s.startY) ||
            (i.startMoving = !0)),
        i.isScrolling)
      )
        return void (i.isTouched = !1);
      if (!i.startMoving) return;
      (n.allowClick = !1),
        !r.cssMode && l.cancelable && l.preventDefault(),
        r.touchMoveStopPropagation && !r.nested && l.stopPropagation(),
        i.isMoved ||
          (r.loop && !r.cssMode && n.loopFix(),
          (i.startTranslate = n.getTranslate()),
          n.setTransition(0),
          n.animating &&
            n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
          (i.allowMomentumBounce = !1),
          !r.grabCursor ||
            (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) ||
            n.setGrabCursor(!0),
          n.emit("sliderFirstMove", l)),
        n.emit("sliderMove", l),
        (i.isMoved = !0);
      let h = n.isHorizontal() ? p : f;
      (s.diff = h),
        (h *= r.touchRatio),
        a && (h = -h),
        (n.swipeDirection = h > 0 ? "prev" : "next"),
        (i.currentTranslate = h + i.startTranslate);
      let m = !0,
        g = r.resistanceRatio;
      if (
        (r.touchReleaseOnEdges && (g = 0),
        h > 0 && i.currentTranslate > n.minTranslate()
          ? ((m = !1),
            r.resistance &&
              (i.currentTranslate =
                n.minTranslate() -
                1 +
                (-n.minTranslate() + i.startTranslate + h) ** g))
          : h < 0 &&
            i.currentTranslate < n.maxTranslate() &&
            ((m = !1),
            r.resistance &&
              (i.currentTranslate =
                n.maxTranslate() +
                1 -
                (n.maxTranslate() - i.startTranslate - h) ** g)),
        m && (l.preventedByNestedSwiper = !0),
        !n.allowSlideNext &&
          "next" === n.swipeDirection &&
          i.currentTranslate < i.startTranslate &&
          (i.currentTranslate = i.startTranslate),
        !n.allowSlidePrev &&
          "prev" === n.swipeDirection &&
          i.currentTranslate > i.startTranslate &&
          (i.currentTranslate = i.startTranslate),
        n.allowSlidePrev ||
          n.allowSlideNext ||
          (i.currentTranslate = i.startTranslate),
        r.threshold > 0)
      ) {
        if (!(Math.abs(h) > r.threshold || i.allowThresholdMove))
          return void (i.currentTranslate = i.startTranslate);
        if (!i.allowThresholdMove)
          return (
            (i.allowThresholdMove = !0),
            (s.startX = s.currentX),
            (s.startY = s.currentY),
            (i.currentTranslate = i.startTranslate),
            void (s.diff = n.isHorizontal()
              ? s.currentX - s.startX
              : s.currentY - s.startY)
          );
      }
      r.followFinger &&
        !r.cssMode &&
        (((r.freeMode && r.freeMode.enabled && n.freeMode) ||
          r.watchSlidesProgress) &&
          (n.updateActiveIndex(), n.updateSlidesClasses()),
        n.params.freeMode &&
          r.freeMode.enabled &&
          n.freeMode &&
          n.freeMode.onTouchMove(),
        n.updateProgress(i.currentTranslate),
        n.setTranslate(i.currentTranslate));
    }

    function X(e) {
      const t = this,
        n = t.touchEventsData,
        {
          params: i,
          touches: r,
          rtlTranslate: s,
          slidesGrid: a,
          enabled: o,
        } = t;
      if (!o) return;
      let l = e;
      if (
        (l.originalEvent && (l = l.originalEvent),
        n.allowTouchCallbacks && t.emit("touchEnd", l),
        (n.allowTouchCallbacks = !1),
        !n.isTouched)
      )
        return (
          n.isMoved && i.grabCursor && t.setGrabCursor(!1),
          (n.isMoved = !1),
          void (n.startMoving = !1)
        );
      i.grabCursor &&
        n.isMoved &&
        n.isTouched &&
        (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
        t.setGrabCursor(!1);
      const c = M(),
        u = c - n.touchStartTime;
      if (t.allowClick) {
        const e = l.path || (l.composedPath && l.composedPath());
        t.updateClickedSlide((e && e[0]) || l.target),
          t.emit("tap click", l),
          u < 300 &&
            c - n.lastClickTime < 300 &&
            t.emit("doubleTap doubleClick", l);
      }
      if (
        ((n.lastClickTime = M()),
        P(() => {
          t.destroyed || (t.allowClick = !0);
        }),
        !n.isTouched ||
          !n.isMoved ||
          !t.swipeDirection ||
          0 === r.diff ||
          n.currentTranslate === n.startTranslate)
      )
        return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
      let d;
      if (
        ((n.isTouched = !1),
        (n.isMoved = !1),
        (n.startMoving = !1),
        (d = i.followFinger
          ? s
            ? t.translate
            : -t.translate
          : -n.currentTranslate),
        i.cssMode)
      )
        return;
      if (t.params.freeMode && i.freeMode.enabled)
        return void t.freeMode.onTouchEnd({
          currentPos: d,
        });
      let p = 0,
        f = t.slidesSizesGrid[0];
      for (
        let e = 0;
        e < a.length;
        e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
      ) {
        const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        void 0 !== a[e + t]
          ? d >= a[e] && d < a[e + t] && ((p = e), (f = a[e + t] - a[e]))
          : d >= a[e] && ((p = e), (f = a[a.length - 1] - a[a.length - 2]));
      }
      let h = null,
        m = null;
      i.rewind &&
        (t.isBeginning
          ? (m =
              t.params.virtual && t.params.virtual.enabled && t.virtual
                ? t.virtual.slides.length - 1
                : t.slides.length - 1)
          : t.isEnd && (h = 0));
      const g = (d - a[p]) / f,
        v = p < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
      if (u > i.longSwipesMs) {
        if (!i.longSwipes) return void t.slideTo(t.activeIndex);
        "next" === t.swipeDirection &&
          (g >= i.longSwipesRatio
            ? t.slideTo(i.rewind && t.isEnd ? h : p + v)
            : t.slideTo(p)),
          "prev" === t.swipeDirection &&
            (g > 1 - i.longSwipesRatio
              ? t.slideTo(p + v)
              : null !== m && g < 0 && Math.abs(g) > i.longSwipesRatio
              ? t.slideTo(m)
              : t.slideTo(p));
      } else {
        if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
        t.navigation &&
        (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl)
          ? l.target === t.navigation.nextEl
            ? t.slideTo(p + v)
            : t.slideTo(p)
          : ("next" === t.swipeDirection && t.slideTo(null !== h ? h : p + v),
            "prev" === t.swipeDirection && t.slideTo(null !== m ? m : p));
      }
    }

    function Y() {
      const e = this,
        { params: t, el: n } = e;
      if (n && 0 === n.offsetWidth) return;
      t.breakpoints && e.setBreakpoint();
      const { allowSlideNext: i, allowSlidePrev: r, snapGrid: s } = e;
      (e.allowSlideNext = !0),
        (e.allowSlidePrev = !0),
        e.updateSize(),
        e.updateSlides(),
        e.updateSlidesClasses(),
        ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
        e.isEnd &&
        !e.isBeginning &&
        !e.params.centeredSlides
          ? e.slideTo(e.slides.length - 1, 0, !1, !0)
          : e.slideTo(e.activeIndex, 0, !1, !0),
        e.autoplay &&
          e.autoplay.running &&
          e.autoplay.paused &&
          e.autoplay.run(),
        (e.allowSlidePrev = r),
        (e.allowSlideNext = i),
        e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
    }

    function U(e) {
      const t = this;
      t.enabled &&
        (t.allowClick ||
          (t.params.preventClicks && e.preventDefault(),
          t.params.preventClicksPropagation &&
            t.animating &&
            (e.stopPropagation(), e.stopImmediatePropagation())));
    }

    function Q() {
      const e = this,
        { wrapperEl: t, rtlTranslate: n, enabled: i } = e;
      if (!i) return;
      let r;
      (e.previousTranslate = e.translate),
        e.isHorizontal()
          ? (e.translate = -t.scrollLeft)
          : (e.translate = -t.scrollTop),
        0 === e.translate && (e.translate = 0),
        e.updateActiveIndex(),
        e.updateSlidesClasses();
      const s = e.maxTranslate() - e.minTranslate();
      (r = 0 === s ? 0 : (e.translate - e.minTranslate()) / s),
        r !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
        e.emit("setTranslate", e.translate, !1);
    }
    let J = !1;

    function K() {}
    const Z = (e, t) => {
      const n = y(),
        {
          params: i,
          touchEvents: r,
          el: s,
          wrapperEl: a,
          device: o,
          support: l,
        } = e,
        c = !!i.nested,
        u = "on" === t ? "addEventListener" : "removeEventListener",
        d = t;
      if (l.touch) {
        const t = !(
          "touchstart" !== r.start ||
          !l.passiveListener ||
          !i.passiveListeners
        ) && {
          passive: !0,
          capture: !1,
        };
        s[u](r.start, e.onTouchStart, t),
          s[u](
            r.move,
            e.onTouchMove,
            l.passiveListener
              ? {
                  passive: !1,
                  capture: c,
                }
              : c
          ),
          s[u](r.end, e.onTouchEnd, t),
          r.cancel && s[u](r.cancel, e.onTouchEnd, t);
      } else
        s[u](r.start, e.onTouchStart, !1),
          n[u](r.move, e.onTouchMove, c),
          n[u](r.end, e.onTouchEnd, !1);
      (i.preventClicks || i.preventClicksPropagation) &&
        s[u]("click", e.onClick, !0),
        i.cssMode && a[u]("scroll", e.onScroll),
        i.updateOnWindowResize
          ? e[d](
              o.ios || o.android
                ? "resize orientationchange observerUpdate"
                : "resize observerUpdate",
              Y,
              !0
            )
          : e[d]("observerUpdate", Y, !0);
    };
    const ee = (e, t) => e.grid && t.grid && t.grid.rows > 1;
    var te = {
      init: !0,
      direction: "horizontal",
      touchEventsTarget: "wrapper",
      initialSlide: 0,
      speed: 300,
      cssMode: !1,
      updateOnWindowResize: !0,
      resizeObserver: !0,
      nested: !1,
      createElements: !1,
      enabled: !0,
      focusableElements:
        "input, select, option, textarea, button, video, label",
      width: null,
      height: null,
      preventInteractionOnTransition: !1,
      userAgent: null,
      url: null,
      edgeSwipeDetection: !1,
      edgeSwipeThreshold: 20,
      autoHeight: !1,
      setWrapperSize: !1,
      virtualTranslate: !1,
      effect: "slide",
      breakpoints: void 0,
      breakpointsBase: "window",
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: !1,
      centeredSlides: !1,
      centeredSlidesBounds: !1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: !0,
      centerInsufficientSlides: !1,
      watchOverflow: !0,
      roundLengths: !1,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: !0,
      shortSwipes: !0,
      longSwipes: !0,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: !0,
      allowTouchMove: !0,
      threshold: 0,
      touchMoveStopPropagation: !1,
      touchStartPreventDefault: !0,
      touchStartForcePreventDefault: !1,
      touchReleaseOnEdges: !1,
      uniqueNavElements: !0,
      resistance: !0,
      resistanceRatio: 0.85,
      watchSlidesProgress: !1,
      grabCursor: !1,
      preventClicks: !0,
      preventClicksPropagation: !0,
      slideToClickedSlide: !1,
      preloadImages: !0,
      updateOnImagesReady: !0,
      loop: !1,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: !1,
      loopPreventsSlide: !0,
      rewind: !1,
      allowSlidePrev: !0,
      allowSlideNext: !0,
      swipeHandler: null,
      noSwiping: !0,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: !0,
      maxBackfaceHiddenSlides: 10,
      containerModifierClass: "swiper-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-invisible-blank",
      slideActiveClass: "swiper-slide-active",
      slideDuplicateActiveClass: "swiper-slide-duplicate-active",
      slideVisibleClass: "swiper-slide-visible",
      slideDuplicateClass: "swiper-slide-duplicate",
      slideNextClass: "swiper-slide-next",
      slideDuplicateNextClass: "swiper-slide-duplicate-next",
      slidePrevClass: "swiper-slide-prev",
      slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
      wrapperClass: "swiper-wrapper",
      runCallbacksOnInit: !0,
      _emitClasses: !1,
    };

    function ne(e, t) {
      return function (n) {
        void 0 === n && (n = {});
        const i = Object.keys(n)[0],
          r = n[i];
        "object" == typeof r && null !== r
          ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 &&
              !0 === e[i] &&
              (e[i] = {
                auto: !0,
              }),
            i in e && "enabled" in r
              ? (!0 === e[i] &&
                  (e[i] = {
                    enabled: !0,
                  }),
                "object" != typeof e[i] ||
                  "enabled" in e[i] ||
                  (e[i].enabled = !0),
                e[i] ||
                  (e[i] = {
                    enabled: !1,
                  }),
                L(t, n))
              : L(t, n))
          : L(t, n);
      };
    }
    const ie = {
        eventsEmitter: {
          on(e, t, n) {
            const i = this;
            if (!i.eventsListeners || i.destroyed) return i;
            if ("function" != typeof t) return i;
            const r = n ? "unshift" : "push";
            return (
              e.split(" ").forEach((e) => {
                i.eventsListeners[e] || (i.eventsListeners[e] = []),
                  i.eventsListeners[e][r](t);
              }),
              i
            );
          },
          once(e, t, n) {
            const i = this;
            if (!i.eventsListeners || i.destroyed) return i;
            if ("function" != typeof t) return i;

            function r() {
              i.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
              for (
                var n = arguments.length, s = new Array(n), a = 0;
                a < n;
                a++
              )
                s[a] = arguments[a];
              t.apply(i, s);
            }
            return (r.__emitterProxy = t), i.on(e, r, n);
          },
          onAny(e, t) {
            const n = this;
            if (!n.eventsListeners || n.destroyed) return n;
            if ("function" != typeof e) return n;
            const i = t ? "unshift" : "push";
            return (
              n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[i](e),
              n
            );
          },
          offAny(e) {
            const t = this;
            if (!t.eventsListeners || t.destroyed) return t;
            if (!t.eventsAnyListeners) return t;
            const n = t.eventsAnyListeners.indexOf(e);
            return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
          },
          off(e, t) {
            const n = this;
            return !n.eventsListeners || n.destroyed
              ? n
              : n.eventsListeners
              ? (e.split(" ").forEach((e) => {
                  void 0 === t
                    ? (n.eventsListeners[e] = [])
                    : n.eventsListeners[e] &&
                      n.eventsListeners[e].forEach((i, r) => {
                        (i === t ||
                          (i.__emitterProxy && i.__emitterProxy === t)) &&
                          n.eventsListeners[e].splice(r, 1);
                      });
                }),
                n)
              : n;
          },
          emit() {
            const e = this;
            if (!e.eventsListeners || e.destroyed) return e;
            if (!e.eventsListeners) return e;
            let t, n, i;
            for (var r = arguments.length, s = new Array(r), a = 0; a < r; a++)
              s[a] = arguments[a];
            "string" == typeof s[0] || Array.isArray(s[0])
              ? ((t = s[0]), (n = s.slice(1, s.length)), (i = e))
              : ((t = s[0].events), (n = s[0].data), (i = s[0].context || e)),
              n.unshift(i);
            return (
              (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
                e.eventsAnyListeners &&
                  e.eventsAnyListeners.length &&
                  e.eventsAnyListeners.forEach((e) => {
                    e.apply(i, [t, ...n]);
                  }),
                  e.eventsListeners &&
                    e.eventsListeners[t] &&
                    e.eventsListeners[t].forEach((e) => {
                      e.apply(i, n);
                    });
              }),
              e
            );
          },
        },
        update: {
          updateSize: function () {
            const e = this;
            let t, n;
            const i = e.$el;
            (t =
              void 0 !== e.params.width && null !== e.params.width
                ? e.params.width
                : i[0].clientWidth),
              (n =
                void 0 !== e.params.height && null !== e.params.height
                  ? e.params.height
                  : i[0].clientHeight),
              (0 === t && e.isHorizontal()) ||
                (0 === n && e.isVertical()) ||
                ((t =
                  t -
                  parseInt(i.css("padding-left") || 0, 10) -
                  parseInt(i.css("padding-right") || 0, 10)),
                (n =
                  n -
                  parseInt(i.css("padding-top") || 0, 10) -
                  parseInt(i.css("padding-bottom") || 0, 10)),
                Number.isNaN(t) && (t = 0),
                Number.isNaN(n) && (n = 0),
                Object.assign(e, {
                  width: t,
                  height: n,
                  size: e.isHorizontal() ? t : n,
                }));
          },
          updateSlides: function () {
            const e = this;

            function t(t) {
              return e.isHorizontal()
                ? t
                : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom",
                  }[t];
            }

            function n(e, n) {
              return parseFloat(e.getPropertyValue(t(n)) || 0);
            }
            const i = e.params,
              { $wrapperEl: r, size: s, rtlTranslate: a, wrongRTL: o } = e,
              l = e.virtual && i.virtual.enabled,
              c = l ? e.virtual.slides.length : e.slides.length,
              u = r.children("." + e.params.slideClass),
              d = l ? e.virtual.slides.length : u.length;
            let p = [];
            const f = [],
              h = [];
            let m = i.slidesOffsetBefore;
            "function" == typeof m && (m = i.slidesOffsetBefore.call(e));
            let g = i.slidesOffsetAfter;
            "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
            const v = e.snapGrid.length,
              y = e.slidesGrid.length;
            let b = i.spaceBetween,
              _ = -m,
              w = 0,
              x = 0;
            if (void 0 === s) return;
            "string" == typeof b &&
              b.indexOf("%") >= 0 &&
              (b = (parseFloat(b.replace("%", "")) / 100) * s),
              (e.virtualSize = -b),
              a
                ? u.css({
                    marginLeft: "",
                    marginBottom: "",
                    marginTop: "",
                  })
                : u.css({
                    marginRight: "",
                    marginBottom: "",
                    marginTop: "",
                  }),
              i.centeredSlides &&
                i.cssMode &&
                (j(e.wrapperEl, "--swiper-centered-offset-before", ""),
                j(e.wrapperEl, "--swiper-centered-offset-after", ""));
            const C = i.grid && i.grid.rows > 1 && e.grid;
            let T;
            C && e.grid.initSlides(d);
            const k =
              "auto" === i.slidesPerView &&
              i.breakpoints &&
              Object.keys(i.breakpoints).filter(
                (e) => void 0 !== i.breakpoints[e].slidesPerView
              ).length > 0;
            for (let r = 0; r < d; r += 1) {
              T = 0;
              const a = u.eq(r);
              if (
                (C && e.grid.updateSlide(r, a, d, t),
                "none" !== a.css("display"))
              ) {
                if ("auto" === i.slidesPerView) {
                  k && (u[r].style[t("width")] = "");
                  const s = getComputedStyle(a[0]),
                    o = a[0].style.transform,
                    l = a[0].style.webkitTransform;
                  if (
                    (o && (a[0].style.transform = "none"),
                    l && (a[0].style.webkitTransform = "none"),
                    i.roundLengths)
                  )
                    T = e.isHorizontal() ? a.outerWidth(!0) : a.outerHeight(!0);
                  else {
                    const e = n(s, "width"),
                      t = n(s, "padding-left"),
                      i = n(s, "padding-right"),
                      r = n(s, "margin-left"),
                      o = n(s, "margin-right"),
                      l = s.getPropertyValue("box-sizing");
                    if (l && "border-box" === l) T = e + r + o;
                    else {
                      const { clientWidth: n, offsetWidth: s } = a[0];
                      T = e + t + i + r + o + (s - n);
                    }
                  }
                  o && (a[0].style.transform = o),
                    l && (a[0].style.webkitTransform = l),
                    i.roundLengths && (T = Math.floor(T));
                } else
                  (T = (s - (i.slidesPerView - 1) * b) / i.slidesPerView),
                    i.roundLengths && (T = Math.floor(T)),
                    u[r] && (u[r].style[t("width")] = T + "px");
                u[r] && (u[r].swiperSlideSize = T),
                  h.push(T),
                  i.centeredSlides
                    ? ((_ = _ + T / 2 + w / 2 + b),
                      0 === w && 0 !== r && (_ = _ - s / 2 - b),
                      0 === r && (_ = _ - s / 2 - b),
                      Math.abs(_) < 0.001 && (_ = 0),
                      i.roundLengths && (_ = Math.floor(_)),
                      x % i.slidesPerGroup == 0 && p.push(_),
                      f.push(_))
                    : (i.roundLengths && (_ = Math.floor(_)),
                      (x - Math.min(e.params.slidesPerGroupSkip, x)) %
                        e.params.slidesPerGroup ==
                        0 && p.push(_),
                      f.push(_),
                      (_ = _ + T + b)),
                  (e.virtualSize += T + b),
                  (w = T),
                  (x += 1);
              }
            }
            if (
              ((e.virtualSize = Math.max(e.virtualSize, s) + g),
              a &&
                o &&
                ("slide" === i.effect || "coverflow" === i.effect) &&
                r.css({
                  width: e.virtualSize + i.spaceBetween + "px",
                }),
              i.setWrapperSize &&
                r.css({
                  [t("width")]: e.virtualSize + i.spaceBetween + "px",
                }),
              C && e.grid.updateWrapperSize(T, p, t),
              !i.centeredSlides)
            ) {
              const t = [];
              for (let n = 0; n < p.length; n += 1) {
                let r = p[n];
                i.roundLengths && (r = Math.floor(r)),
                  p[n] <= e.virtualSize - s && t.push(r);
              }
              (p = t),
                Math.floor(e.virtualSize - s) - Math.floor(p[p.length - 1]) >
                  1 && p.push(e.virtualSize - s);
            }
            if ((0 === p.length && (p = [0]), 0 !== i.spaceBetween)) {
              const n = e.isHorizontal() && a ? "marginLeft" : t("marginRight");
              u.filter((e, t) => !i.cssMode || t !== u.length - 1).css({
                [n]: b + "px",
              });
            }
            if (i.centeredSlides && i.centeredSlidesBounds) {
              let e = 0;
              h.forEach((t) => {
                e += t + (i.spaceBetween ? i.spaceBetween : 0);
              }),
                (e -= i.spaceBetween);
              const t = e - s;
              p = p.map((e) => (e < 0 ? -m : e > t ? t + g : e));
            }
            if (i.centerInsufficientSlides) {
              let e = 0;
              if (
                (h.forEach((t) => {
                  e += t + (i.spaceBetween ? i.spaceBetween : 0);
                }),
                (e -= i.spaceBetween),
                e < s)
              ) {
                const t = (s - e) / 2;
                p.forEach((e, n) => {
                  p[n] = e - t;
                }),
                  f.forEach((e, n) => {
                    f[n] = e + t;
                  });
              }
            }
            if (
              (Object.assign(e, {
                slides: u,
                snapGrid: p,
                slidesGrid: f,
                slidesSizesGrid: h,
              }),
              i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
            ) {
              j(e.wrapperEl, "--swiper-centered-offset-before", -p[0] + "px"),
                j(
                  e.wrapperEl,
                  "--swiper-centered-offset-after",
                  e.size / 2 - h[h.length - 1] / 2 + "px"
                );
              const t = -e.snapGrid[0],
                n = -e.slidesGrid[0];
              (e.snapGrid = e.snapGrid.map((e) => e + t)),
                (e.slidesGrid = e.slidesGrid.map((e) => e + n));
            }
            if (
              (d !== c && e.emit("slidesLengthChange"),
              p.length !== v &&
                (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              f.length !== y && e.emit("slidesGridLengthChange"),
              i.watchSlidesProgress && e.updateSlidesOffset(),
              !(
                l ||
                i.cssMode ||
                ("slide" !== i.effect && "fade" !== i.effect)
              ))
            ) {
              const t = i.containerModifierClass + "backface-hidden",
                n = e.$el.hasClass(t);
              d <= i.maxBackfaceHiddenSlides
                ? n || e.$el.addClass(t)
                : n && e.$el.removeClass(t);
            }
          },
          updateAutoHeight: function (e) {
            const t = this,
              n = [],
              i = t.virtual && t.params.virtual.enabled;
            let r,
              s = 0;
            "number" == typeof e
              ? t.setTransition(e)
              : !0 === e && t.setTransition(t.params.speed);
            const a = (e) =>
              i
                ? t.slides.filter(
                    (t) =>
                      parseInt(
                        t.getAttribute("data-swiper-slide-index"),
                        10
                      ) === e
                  )[0]
                : t.slides.eq(e)[0];
            if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
              if (t.params.centeredSlides)
                t.visibleSlides.each((e) => {
                  n.push(e);
                });
              else
                for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
                  const e = t.activeIndex + r;
                  if (e > t.slides.length && !i) break;
                  n.push(a(e));
                }
            else n.push(a(t.activeIndex));
            for (r = 0; r < n.length; r += 1)
              if (void 0 !== n[r]) {
                const e = n[r].offsetHeight;
                s = e > s ? e : s;
              }
            (s || 0 === s) && t.$wrapperEl.css("height", s + "px");
          },
          updateSlidesOffset: function () {
            const e = this,
              t = e.slides;
            for (let n = 0; n < t.length; n += 1)
              t[n].swiperSlideOffset = e.isHorizontal()
                ? t[n].offsetLeft
                : t[n].offsetTop;
          },
          updateSlidesProgress: function (e) {
            void 0 === e && (e = (this && this.translate) || 0);
            const t = this,
              n = t.params,
              { slides: i, rtlTranslate: r, snapGrid: s } = t;
            if (0 === i.length) return;
            void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
            let a = -e;
            r && (a = e),
              i.removeClass(n.slideVisibleClass),
              (t.visibleSlidesIndexes = []),
              (t.visibleSlides = []);
            for (let e = 0; e < i.length; e += 1) {
              const o = i[e];
              let l = o.swiperSlideOffset;
              n.cssMode && n.centeredSlides && (l -= i[0].swiperSlideOffset);
              const c =
                  (a + (n.centeredSlides ? t.minTranslate() : 0) - l) /
                  (o.swiperSlideSize + n.spaceBetween),
                u =
                  (a - s[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) /
                  (o.swiperSlideSize + n.spaceBetween),
                d = -(a - l),
                p = d + t.slidesSizesGrid[e];
              ((d >= 0 && d < t.size - 1) ||
                (p > 1 && p <= t.size) ||
                (d <= 0 && p >= t.size)) &&
                (t.visibleSlides.push(o),
                t.visibleSlidesIndexes.push(e),
                i.eq(e).addClass(n.slideVisibleClass)),
                (o.progress = r ? -c : c),
                (o.originalProgress = r ? -u : u);
            }
            t.visibleSlides = O(t.visibleSlides);
          },
          updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
              const n = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * n) || 0;
            }
            const n = t.params,
              i = t.maxTranslate() - t.minTranslate();
            let { progress: r, isBeginning: s, isEnd: a } = t;
            const o = s,
              l = a;
            0 === i
              ? ((r = 0), (s = !0), (a = !0))
              : ((r = (e - t.minTranslate()) / i), (s = r <= 0), (a = r >= 1)),
              Object.assign(t, {
                progress: r,
                isBeginning: s,
                isEnd: a,
              }),
              (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
                t.updateSlidesProgress(e),
              s && !o && t.emit("reachBeginning toEdge"),
              a && !l && t.emit("reachEnd toEdge"),
              ((o && !s) || (l && !a)) && t.emit("fromEdge"),
              t.emit("progress", r);
          },
          updateSlidesClasses: function () {
            const e = this,
              {
                slides: t,
                params: n,
                $wrapperEl: i,
                activeIndex: r,
                realIndex: s,
              } = e,
              a = e.virtual && n.virtual.enabled;
            let o;
            t.removeClass(
              `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
            ),
              (o = a
                ? e.$wrapperEl.find(
                    `.${n.slideClass}[data-swiper-slide-index="${r}"]`
                  )
                : t.eq(r)),
              o.addClass(n.slideActiveClass),
              n.loop &&
                (o.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${s}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass)
                  : i
                      .children(
                        `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${s}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass));
            let l = o
              .nextAll("." + n.slideClass)
              .eq(0)
              .addClass(n.slideNextClass);
            n.loop &&
              0 === l.length &&
              ((l = t.eq(0)), l.addClass(n.slideNextClass));
            let c = o
              .prevAll("." + n.slideClass)
              .eq(0)
              .addClass(n.slidePrevClass);
            n.loop &&
              0 === c.length &&
              ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
              n.loop &&
                (l.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass)
                  : i
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass),
                c.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${c.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)
                  : i
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${c.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)),
              e.emitSlidesClasses();
          },
          updateActiveIndex: function (e) {
            const t = this,
              n = t.rtlTranslate ? t.translate : -t.translate,
              {
                slidesGrid: i,
                snapGrid: r,
                params: s,
                activeIndex: a,
                realIndex: o,
                snapIndex: l,
              } = t;
            let c,
              u = e;
            if (void 0 === u) {
              for (let e = 0; e < i.length; e += 1)
                void 0 !== i[e + 1]
                  ? n >= i[e] && n < i[e + 1] - (i[e + 1] - i[e]) / 2
                    ? (u = e)
                    : n >= i[e] && n < i[e + 1] && (u = e + 1)
                  : n >= i[e] && (u = e);
              s.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
            }
            if (r.indexOf(n) >= 0) c = r.indexOf(n);
            else {
              const e = Math.min(s.slidesPerGroupSkip, u);
              c = e + Math.floor((u - e) / s.slidesPerGroup);
            }
            if ((c >= r.length && (c = r.length - 1), u === a))
              return void (
                c !== l && ((t.snapIndex = c), t.emit("snapIndexChange"))
              );
            const d = parseInt(
              t.slides.eq(u).attr("data-swiper-slide-index") || u,
              10
            );
            Object.assign(t, {
              snapIndex: c,
              realIndex: d,
              previousIndex: a,
              activeIndex: u,
            }),
              t.emit("activeIndexChange"),
              t.emit("snapIndexChange"),
              o !== d && t.emit("realIndexChange"),
              (t.initialized || t.params.runCallbacksOnInit) &&
                t.emit("slideChange");
          },
          updateClickedSlide: function (e) {
            const t = this,
              n = t.params,
              i = O(e).closest("." + n.slideClass)[0];
            let r,
              s = !1;
            if (i)
              for (let e = 0; e < t.slides.length; e += 1)
                if (t.slides[e] === i) {
                  (s = !0), (r = e);
                  break;
                }
            if (!i || !s)
              return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = i),
              t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(
                    O(i).attr("data-swiper-slide-index"),
                    10
                  ))
                : (t.clickedIndex = r),
              n.slideToClickedSlide &&
                void 0 !== t.clickedIndex &&
                t.clickedIndex !== t.activeIndex &&
                t.slideToClickedSlide();
          },
        },
        translate: {
          getTranslate: function (e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            const {
              params: t,
              rtlTranslate: n,
              translate: i,
              $wrapperEl: r,
            } = this;
            if (t.virtualTranslate) return n ? -i : i;
            if (t.cssMode) return i;
            let s = A(r[0], e);
            return n && (s = -s), s || 0;
          },
          setTranslate: function (e, t) {
            const n = this,
              {
                rtlTranslate: i,
                params: r,
                $wrapperEl: s,
                wrapperEl: a,
                progress: o,
              } = n;
            let l,
              c = 0,
              u = 0;
            n.isHorizontal() ? (c = i ? -e : e) : (u = e),
              r.roundLengths && ((c = Math.floor(c)), (u = Math.floor(u))),
              r.cssMode
                ? (a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                    n.isHorizontal() ? -c : -u)
                : r.virtualTranslate ||
                  s.transform(`translate3d(${c}px, ${u}px, 0px)`),
              (n.previousTranslate = n.translate),
              (n.translate = n.isHorizontal() ? c : u);
            const d = n.maxTranslate() - n.minTranslate();
            (l = 0 === d ? 0 : (e - n.minTranslate()) / d),
              l !== o && n.updateProgress(e),
              n.emit("setTranslate", n.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (e, t, n, i, r) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0),
              void 0 === i && (i = !0);
            const s = this,
              { params: a, wrapperEl: o } = s;
            if (s.animating && a.preventInteractionOnTransition) return !1;
            const l = s.minTranslate(),
              c = s.maxTranslate();
            let u;
            if (
              ((u = i && e > l ? l : i && e < c ? c : e),
              s.updateProgress(u),
              a.cssMode)
            ) {
              const e = s.isHorizontal();
              if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -u;
              else {
                if (!s.support.smoothScroll)
                  return (
                    N({
                      swiper: s,
                      targetPosition: -u,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                o.scrollTo({
                  [e ? "left" : "top"]: -u,
                  behavior: "smooth",
                });
              }
              return !0;
            }
            return (
              0 === t
                ? (s.setTransition(0),
                  s.setTranslate(u),
                  n &&
                    (s.emit("beforeTransitionStart", t, r),
                    s.emit("transitionEnd")))
                : (s.setTransition(t),
                  s.setTranslate(u),
                  n &&
                    (s.emit("beforeTransitionStart", t, r),
                    s.emit("transitionStart")),
                  s.animating ||
                    ((s.animating = !0),
                    s.onTranslateToWrapperTransitionEnd ||
                      (s.onTranslateToWrapperTransitionEnd = function (e) {
                        s &&
                          !s.destroyed &&
                          e.target === this &&
                          (s.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            s.onTranslateToWrapperTransitionEnd
                          ),
                          s.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            s.onTranslateToWrapperTransitionEnd
                          ),
                          (s.onTranslateToWrapperTransitionEnd = null),
                          delete s.onTranslateToWrapperTransitionEnd,
                          n && s.emit("transitionEnd"));
                      }),
                    s.$wrapperEl[0].addEventListener(
                      "transitionend",
                      s.onTranslateToWrapperTransitionEnd
                    ),
                    s.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      s.onTranslateToWrapperTransitionEnd
                    ))),
              !0
            );
          },
        },
        transition: {
          setTransition: function (e, t) {
            const n = this;
            n.params.cssMode || n.$wrapperEl.transition(e),
              n.emit("setTransition", e, t);
          },
          transitionStart: function (e, t) {
            void 0 === e && (e = !0);
            const n = this,
              { params: i } = n;
            i.cssMode ||
              (i.autoHeight && n.updateAutoHeight(),
              W({
                swiper: n,
                runCallbacks: e,
                direction: t,
                step: "Start",
              }));
          },
          transitionEnd: function (e, t) {
            void 0 === e && (e = !0);
            const { params: n } = this;
            (this.animating = !1),
              n.cssMode ||
                (this.setTransition(0),
                W({
                  swiper: this,
                  runCallbacks: e,
                  direction: t,
                  step: "End",
                }));
          },
        },
        slide: {
          slideTo: function (e, t, n, i, r) {
            if (
              (void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0),
              "number" != typeof e && "string" != typeof e)
            )
              throw new Error(
                `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
              );
            if ("string" == typeof e) {
              const t = parseInt(e, 10);
              if (!isFinite(t))
                throw new Error(
                  `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
                );
              e = t;
            }
            const s = this;
            let a = e;
            a < 0 && (a = 0);
            const {
              params: o,
              snapGrid: l,
              slidesGrid: c,
              previousIndex: u,
              activeIndex: d,
              rtlTranslate: p,
              wrapperEl: f,
              enabled: h,
            } = s;
            if (
              (s.animating && o.preventInteractionOnTransition) ||
              (!h && !i && !r)
            )
              return !1;
            const m = Math.min(s.params.slidesPerGroupSkip, a);
            let g = m + Math.floor((a - m) / s.params.slidesPerGroup);
            g >= l.length && (g = l.length - 1),
              (d || o.initialSlide || 0) === (u || 0) &&
                n &&
                s.emit("beforeSlideChangeStart");
            const v = -l[g];
            if ((s.updateProgress(v), o.normalizeSlideIndex))
              for (let e = 0; e < c.length; e += 1) {
                const t = -Math.floor(100 * v),
                  n = Math.floor(100 * c[e]),
                  i = Math.floor(100 * c[e + 1]);
                void 0 !== c[e + 1]
                  ? t >= n && t < i - (i - n) / 2
                    ? (a = e)
                    : t >= n && t < i && (a = e + 1)
                  : t >= n && (a = e);
              }
            if (s.initialized && a !== d) {
              if (!s.allowSlideNext && v < s.translate && v < s.minTranslate())
                return !1;
              if (
                !s.allowSlidePrev &&
                v > s.translate &&
                v > s.maxTranslate() &&
                (d || 0) !== a
              )
                return !1;
            }
            let y;
            if (
              ((y = a > d ? "next" : a < d ? "prev" : "reset"),
              (p && -v === s.translate) || (!p && v === s.translate))
            )
              return (
                s.updateActiveIndex(a),
                o.autoHeight && s.updateAutoHeight(),
                s.updateSlidesClasses(),
                "slide" !== o.effect && s.setTranslate(v),
                "reset" !== y &&
                  (s.transitionStart(n, y), s.transitionEnd(n, y)),
                !1
              );
            if (o.cssMode) {
              const e = s.isHorizontal(),
                n = p ? v : -v;
              if (0 === t) {
                const t = s.virtual && s.params.virtual.enabled;
                t &&
                  ((s.wrapperEl.style.scrollSnapType = "none"),
                  (s._immediateVirtual = !0)),
                  (f[e ? "scrollLeft" : "scrollTop"] = n),
                  t &&
                    requestAnimationFrame(() => {
                      (s.wrapperEl.style.scrollSnapType = ""),
                        (s._swiperImmediateVirtual = !1);
                    });
              } else {
                if (!s.support.smoothScroll)
                  return (
                    N({
                      swiper: s,
                      targetPosition: n,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                f.scrollTo({
                  [e ? "left" : "top"]: n,
                  behavior: "smooth",
                });
              }
              return !0;
            }
            return (
              s.setTransition(t),
              s.setTranslate(v),
              s.updateActiveIndex(a),
              s.updateSlidesClasses(),
              s.emit("beforeTransitionStart", t, i),
              s.transitionStart(n, y),
              0 === t
                ? s.transitionEnd(n, y)
                : s.animating ||
                  ((s.animating = !0),
                  s.onSlideToWrapperTransitionEnd ||
                    (s.onSlideToWrapperTransitionEnd = function (e) {
                      s &&
                        !s.destroyed &&
                        e.target === this &&
                        (s.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          s.onSlideToWrapperTransitionEnd
                        ),
                        s.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          s.onSlideToWrapperTransitionEnd
                        ),
                        (s.onSlideToWrapperTransitionEnd = null),
                        delete s.onSlideToWrapperTransitionEnd,
                        s.transitionEnd(n, y));
                    }),
                  s.$wrapperEl[0].addEventListener(
                    "transitionend",
                    s.onSlideToWrapperTransitionEnd
                  ),
                  s.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    s.onSlideToWrapperTransitionEnd
                  )),
              !0
            );
          },
          slideToLoop: function (e, t, n, i) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === n && (n = !0);
            const r = this;
            let s = e;
            return (
              r.params.loop && (s += r.loopedSlides), r.slideTo(s, t, n, i)
            );
          },
          slideNext: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const i = this,
              { animating: r, enabled: s, params: a } = i;
            if (!s) return i;
            let o = a.slidesPerGroup;
            "auto" === a.slidesPerView &&
              1 === a.slidesPerGroup &&
              a.slidesPerGroupAuto &&
              (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
            const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : o;
            if (a.loop) {
              if (r && a.loopPreventsSlide) return !1;
              i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
            }
            return a.rewind && i.isEnd
              ? i.slideTo(0, e, t, n)
              : i.slideTo(i.activeIndex + l, e, t, n);
          },
          slidePrev: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const i = this,
              {
                params: r,
                animating: s,
                snapGrid: a,
                slidesGrid: o,
                rtlTranslate: l,
                enabled: c,
              } = i;
            if (!c) return i;
            if (r.loop) {
              if (s && r.loopPreventsSlide) return !1;
              i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
            }

            function u(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const d = u(l ? i.translate : -i.translate),
              p = a.map((e) => u(e));
            let f = a[p.indexOf(d) - 1];
            if (void 0 === f && r.cssMode) {
              let e;
              a.forEach((t, n) => {
                d >= t && (e = n);
              }),
                void 0 !== e && (f = a[e > 0 ? e - 1 : e]);
            }
            let h = 0;
            if (
              (void 0 !== f &&
                ((h = o.indexOf(f)),
                h < 0 && (h = i.activeIndex - 1),
                "auto" === r.slidesPerView &&
                  1 === r.slidesPerGroup &&
                  r.slidesPerGroupAuto &&
                  ((h = h - i.slidesPerViewDynamic("previous", !0) + 1),
                  (h = Math.max(h, 0)))),
              r.rewind && i.isBeginning)
            ) {
              const r =
                i.params.virtual && i.params.virtual.enabled && i.virtual
                  ? i.virtual.slides.length - 1
                  : i.slides.length - 1;
              return i.slideTo(r, e, t, n);
            }
            return i.slideTo(h, e, t, n);
          },
          slideReset: function (e, t, n) {
            return (
              void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              this.slideTo(this.activeIndex, e, t, n)
            );
          },
          slideToClosest: function (e, t, n, i) {
            void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              void 0 === i && (i = 0.5);
            const r = this;
            let s = r.activeIndex;
            const a = Math.min(r.params.slidesPerGroupSkip, s),
              o = a + Math.floor((s - a) / r.params.slidesPerGroup),
              l = r.rtlTranslate ? r.translate : -r.translate;
            if (l >= r.snapGrid[o]) {
              const e = r.snapGrid[o];
              l - e > (r.snapGrid[o + 1] - e) * i &&
                (s += r.params.slidesPerGroup);
            } else {
              const e = r.snapGrid[o - 1];
              l - e <= (r.snapGrid[o] - e) * i &&
                (s -= r.params.slidesPerGroup);
            }
            return (
              (s = Math.max(s, 0)),
              (s = Math.min(s, r.slidesGrid.length - 1)),
              r.slideTo(s, e, t, n)
            );
          },
          slideToClickedSlide: function () {
            const e = this,
              { params: t, $wrapperEl: n } = e,
              i =
                "auto" === t.slidesPerView
                  ? e.slidesPerViewDynamic()
                  : t.slidesPerView;
            let r,
              s = e.clickedIndex;
            if (t.loop) {
              if (e.animating) return;
              (r = parseInt(
                O(e.clickedSlide).attr("data-swiper-slide-index"),
                10
              )),
                t.centeredSlides
                  ? s < e.loopedSlides - i / 2 ||
                    s > e.slides.length - e.loopedSlides + i / 2
                    ? (e.loopFix(),
                      (s = n
                        .children(
                          `.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`
                        )
                        .eq(0)
                        .index()),
                      P(() => {
                        e.slideTo(s);
                      }))
                    : e.slideTo(s)
                  : s > e.slides.length - i
                  ? (e.loopFix(),
                    (s = n
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    P(() => {
                      e.slideTo(s);
                    }))
                  : e.slideTo(s);
            } else e.slideTo(s);
          },
        },
        loop: {
          loopCreate: function () {
            const e = this,
              t = y(),
              { params: n, $wrapperEl: i } = e,
              r = i.children().length > 0 ? O(i.children()[0].parentNode) : i;
            r.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
            let s = r.children("." + n.slideClass);
            if (n.loopFillGroupWithBlank) {
              const e = n.slidesPerGroup - (s.length % n.slidesPerGroup);
              if (e !== n.slidesPerGroup) {
                for (let i = 0; i < e; i += 1) {
                  const e = O(t.createElement("div")).addClass(
                    `${n.slideClass} ${n.slideBlankClass}`
                  );
                  r.append(e);
                }
                s = r.children("." + n.slideClass);
              }
            }
            "auto" !== n.slidesPerView ||
              n.loopedSlides ||
              (n.loopedSlides = s.length),
              (e.loopedSlides = Math.ceil(
                parseFloat(n.loopedSlides || n.slidesPerView, 10)
              )),
              (e.loopedSlides += n.loopAdditionalSlides),
              e.loopedSlides > s.length && (e.loopedSlides = s.length);
            const a = [],
              o = [];
            s.each((t, n) => {
              const i = O(t);
              n < e.loopedSlides && o.push(t),
                n < s.length && n >= s.length - e.loopedSlides && a.push(t),
                i.attr("data-swiper-slide-index", n);
            });
            for (let e = 0; e < o.length; e += 1)
              r.append(O(o[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
            for (let e = a.length - 1; e >= 0; e -= 1)
              r.prepend(O(a[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
          },
          loopFix: function () {
            const e = this;
            e.emit("beforeLoopFix");
            const {
              activeIndex: t,
              slides: n,
              loopedSlides: i,
              allowSlidePrev: r,
              allowSlideNext: s,
              snapGrid: a,
              rtlTranslate: o,
            } = e;
            let l;
            (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
            const c = -a[t] - e.getTranslate();
            if (t < i) {
              (l = n.length - 3 * i + t), (l += i);
              e.slideTo(l, 0, !1, !0) &&
                0 !== c &&
                e.setTranslate((o ? -e.translate : e.translate) - c);
            } else if (t >= n.length - i) {
              (l = -n.length + t + i), (l += i);
              e.slideTo(l, 0, !1, !0) &&
                0 !== c &&
                e.setTranslate((o ? -e.translate : e.translate) - c);
            }
            (e.allowSlidePrev = r), (e.allowSlideNext = s), e.emit("loopFix");
          },
          loopDestroy: function () {
            const { $wrapperEl: e, params: t, slides: n } = this;
            e
              .children(
                `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
              )
              .remove(),
              n.removeAttr("data-swiper-slide-index");
          },
        },
        grabCursor: {
          setGrabCursor: function (e) {
            if (
              this.support.touch ||
              !this.params.simulateTouch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode
            )
              return;
            const t =
              "container" === this.params.touchEventsTarget
                ? this.el
                : this.wrapperEl;
            (t.style.cursor = "move"),
              (t.style.cursor = e ? "grabbing" : "grab");
          },
          unsetGrabCursor: function () {
            this.support.touch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode ||
              (this[
                "container" === this.params.touchEventsTarget
                  ? "el"
                  : "wrapperEl"
              ].style.cursor = "");
          },
        },
        events: {
          attachEvents: function () {
            const e = this,
              t = y(),
              { params: n, support: i } = e;
            (e.onTouchStart = V.bind(e)),
              (e.onTouchMove = G.bind(e)),
              (e.onTouchEnd = X.bind(e)),
              n.cssMode && (e.onScroll = Q.bind(e)),
              (e.onClick = U.bind(e)),
              i.touch && !J && (t.addEventListener("touchstart", K), (J = !0)),
              Z(e, "on");
          },
          detachEvents: function () {
            Z(this, "off");
          },
        },
        breakpoints: {
          setBreakpoint: function () {
            const e = this,
              {
                activeIndex: t,
                initialized: n,
                loopedSlides: i = 0,
                params: r,
                $el: s,
              } = e,
              a = r.breakpoints;
            if (!a || (a && 0 === Object.keys(a).length)) return;
            const o = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
            if (!o || e.currentBreakpoint === o) return;
            const l = (o in a ? a[o] : void 0) || e.originalParams,
              c = ee(e, r),
              u = ee(e, l),
              d = r.enabled;
            c && !u
              ? (s.removeClass(
                  `${r.containerModifierClass}grid ${r.containerModifierClass}grid-column`
                ),
                e.emitContainerClasses())
              : !c &&
                u &&
                (s.addClass(r.containerModifierClass + "grid"),
                ((l.grid.fill && "column" === l.grid.fill) ||
                  (!l.grid.fill && "column" === r.grid.fill)) &&
                  s.addClass(r.containerModifierClass + "grid-column"),
                e.emitContainerClasses());
            const p = l.direction && l.direction !== r.direction,
              f = r.loop && (l.slidesPerView !== r.slidesPerView || p);
            p && n && e.changeDirection(), L(e.params, l);
            const h = e.params.enabled;
            Object.assign(e, {
              allowTouchMove: e.params.allowTouchMove,
              allowSlideNext: e.params.allowSlideNext,
              allowSlidePrev: e.params.allowSlidePrev,
            }),
              d && !h ? e.disable() : !d && h && e.enable(),
              (e.currentBreakpoint = o),
              e.emit("_beforeBreakpoint", l),
              f &&
                n &&
                (e.loopDestroy(),
                e.loopCreate(),
                e.updateSlides(),
                e.slideTo(t - i + e.loopedSlides, 0, !1)),
              e.emit("breakpoint", l);
          },
          getBreakpoint: function (e, t, n) {
            if (
              (void 0 === t && (t = "window"), !e || ("container" === t && !n))
            )
              return;
            let i = !1;
            const r = _(),
              s = "window" === t ? r.innerHeight : n.clientHeight,
              a = Object.keys(e).map((e) => {
                if ("string" == typeof e && 0 === e.indexOf("@")) {
                  const t = parseFloat(e.substr(1));
                  return {
                    value: s * t,
                    point: e,
                  };
                }
                return {
                  value: e,
                  point: e,
                };
              });
            a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
            for (let e = 0; e < a.length; e += 1) {
              const { point: s, value: o } = a[e];
              "window" === t
                ? r.matchMedia(`(min-width: ${o}px)`).matches && (i = s)
                : o <= n.clientWidth && (i = s);
            }
            return i || "max";
          },
        },
        checkOverflow: {
          checkOverflow: function () {
            const e = this,
              { isLocked: t, params: n } = e,
              { slidesOffsetBefore: i } = n;
            if (i) {
              const t = e.slides.length - 1,
                n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
              e.isLocked = e.size > n;
            } else e.isLocked = 1 === e.snapGrid.length;
            !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
              !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
              t && t !== e.isLocked && (e.isEnd = !1),
              t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
          },
        },
        classes: {
          addClasses: function () {
            const {
                classNames: e,
                params: t,
                rtl: n,
                $el: i,
                device: r,
                support: s,
              } = this,
              a = (function (e, t) {
                const n = [];
                return (
                  e.forEach((e) => {
                    "object" == typeof e
                      ? Object.keys(e).forEach((i) => {
                          e[i] && n.push(t + i);
                        })
                      : "string" == typeof e && n.push(t + e);
                  }),
                  n
                );
              })(
                [
                  "initialized",
                  t.direction,
                  {
                    "pointer-events": !s.touch,
                  },
                  {
                    "free-mode": this.params.freeMode && t.freeMode.enabled,
                  },
                  {
                    autoheight: t.autoHeight,
                  },
                  {
                    rtl: n,
                  },
                  {
                    grid: t.grid && t.grid.rows > 1,
                  },
                  {
                    "grid-column":
                      t.grid && t.grid.rows > 1 && "column" === t.grid.fill,
                  },
                  {
                    android: r.android,
                  },
                  {
                    ios: r.ios,
                  },
                  {
                    "css-mode": t.cssMode,
                  },
                  {
                    centered: t.cssMode && t.centeredSlides,
                  },
                  {
                    "watch-progress": t.watchSlidesProgress,
                  },
                ],
                t.containerModifierClass
              );
            e.push(...a),
              i.addClass([...e].join(" ")),
              this.emitContainerClasses();
          },
          removeClasses: function () {
            const { $el: e, classNames: t } = this;
            e.removeClass(t.join(" ")), this.emitContainerClasses();
          },
        },
        images: {
          loadImage: function (e, t, n, i, r, s) {
            const a = _();
            let o;

            function l() {
              s && s();
            }
            O(e).parent("picture")[0] || (e.complete && r)
              ? l()
              : t
              ? ((o = new a.Image()),
                (o.onload = l),
                (o.onerror = l),
                i && (o.sizes = i),
                n && (o.srcset = n),
                t && (o.src = t))
              : l();
          },
          preloadImages: function () {
            const e = this;

            function t() {
              null != e &&
                e &&
                !e.destroyed &&
                (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                e.imagesLoaded === e.imagesToLoad.length &&
                  (e.params.updateOnImagesReady && e.update(),
                  e.emit("imagesReady")));
            }
            e.imagesToLoad = e.$el.find("img");
            for (let n = 0; n < e.imagesToLoad.length; n += 1) {
              const i = e.imagesToLoad[n];
              e.loadImage(
                i,
                i.currentSrc || i.getAttribute("src"),
                i.srcset || i.getAttribute("srcset"),
                i.sizes || i.getAttribute("sizes"),
                !0,
                t
              );
            }
          },
        },
      },
      re = {};
    class se {
      constructor() {
        let e, t;
        for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++)
          i[r] = arguments[r];
        if (
          (1 === i.length &&
          i[0].constructor &&
          "Object" === Object.prototype.toString.call(i[0]).slice(8, -1)
            ? (t = i[0])
            : ([e, t] = i),
          t || (t = {}),
          (t = L({}, t)),
          e && !t.el && (t.el = e),
          t.el && O(t.el).length > 1)
        ) {
          const e = [];
          return (
            O(t.el).each((n) => {
              const i = L({}, t, {
                el: n,
              });
              e.push(new se(i));
            }),
            e
          );
        }
        const s = this;
        (s.__swiper__ = !0),
          (s.support = H()),
          (s.device = F({
            userAgent: t.userAgent,
          })),
          (s.browser = q()),
          (s.eventsListeners = {}),
          (s.eventsAnyListeners = []),
          (s.modules = [...s.__modules__]),
          t.modules && Array.isArray(t.modules) && s.modules.push(...t.modules);
        const a = {};
        s.modules.forEach((e) => {
          e({
            swiper: s,
            extendParams: ne(t, a),
            on: s.on.bind(s),
            once: s.once.bind(s),
            off: s.off.bind(s),
            emit: s.emit.bind(s),
          });
        });
        const o = L({}, te, a);
        return (
          (s.params = L({}, o, re, t)),
          (s.originalParams = L({}, s.params)),
          (s.passedParams = L({}, t)),
          s.params &&
            s.params.on &&
            Object.keys(s.params.on).forEach((e) => {
              s.on(e, s.params.on[e]);
            }),
          s.params && s.params.onAny && s.onAny(s.params.onAny),
          (s.$ = O),
          Object.assign(s, {
            enabled: s.params.enabled,
            el: e,
            classNames: [],
            slides: O(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal: () => "horizontal" === s.params.direction,
            isVertical: () => "vertical" === s.params.direction,
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            allowSlideNext: s.params.allowSlideNext,
            allowSlidePrev: s.params.allowSlidePrev,
            touchEvents: (function () {
              const e = ["touchstart", "touchmove", "touchend", "touchcancel"],
                t = ["pointerdown", "pointermove", "pointerup"];
              return (
                (s.touchEventsTouch = {
                  start: e[0],
                  move: e[1],
                  end: e[2],
                  cancel: e[3],
                }),
                (s.touchEventsDesktop = {
                  start: t[0],
                  move: t[1],
                  end: t[2],
                }),
                s.support.touch || !s.params.simulateTouch
                  ? s.touchEventsTouch
                  : s.touchEventsDesktop
              );
            })(),
            touchEventsData: {
              isTouched: void 0,
              isMoved: void 0,
              allowTouchCallbacks: void 0,
              touchStartTime: void 0,
              isScrolling: void 0,
              currentTranslate: void 0,
              startTranslate: void 0,
              allowThresholdMove: void 0,
              focusableElements: s.params.focusableElements,
              lastClickTime: M(),
              clickTimeout: void 0,
              velocities: [],
              allowMomentumBounce: void 0,
              isTouchEvent: void 0,
              startMoving: void 0,
            },
            allowClick: !0,
            allowTouchMove: s.params.allowTouchMove,
            touches: {
              startX: 0,
              startY: 0,
              currentX: 0,
              currentY: 0,
              diff: 0,
            },
            imagesToLoad: [],
            imagesLoaded: 0,
          }),
          s.emit("_swiper"),
          s.params.init && s.init(),
          s
        );
      }
      enable() {
        const e = this;
        e.enabled ||
          ((e.enabled = !0),
          e.params.grabCursor && e.setGrabCursor(),
          e.emit("enable"));
      }
      disable() {
        const e = this;
        e.enabled &&
          ((e.enabled = !1),
          e.params.grabCursor && e.unsetGrabCursor(),
          e.emit("disable"));
      }
      setProgress(e, t) {
        e = Math.min(Math.max(e, 0), 1);
        const n = this.minTranslate(),
          i = (this.maxTranslate() - n) * e + n;
        this.translateTo(i, void 0 === t ? 0 : t),
          this.updateActiveIndex(),
          this.updateSlidesClasses();
      }
      emitContainerClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el) return;
        const t = e.el.className
          .split(" ")
          .filter(
            (t) =>
              0 === t.indexOf("swiper") ||
              0 === t.indexOf(e.params.containerModifierClass)
          );
        e.emit("_containerClasses", t.join(" "));
      }
      getSlideClasses(e) {
        const t = this;
        return t.destroyed
          ? ""
          : e.className
              .split(" ")
              .filter(
                (e) =>
                  0 === e.indexOf("swiper-slide") ||
                  0 === e.indexOf(t.params.slideClass)
              )
              .join(" ");
      }
      emitSlidesClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el) return;
        const t = [];
        e.slides.each((n) => {
          const i = e.getSlideClasses(n);
          t.push({
            slideEl: n,
            classNames: i,
          }),
            e.emit("_slideClass", n, i);
        }),
          e.emit("_slideClasses", t);
      }
      slidesPerViewDynamic(e, t) {
        void 0 === e && (e = "current"), void 0 === t && (t = !1);
        const {
          params: n,
          slides: i,
          slidesGrid: r,
          slidesSizesGrid: s,
          size: a,
          activeIndex: o,
        } = this;
        let l = 1;
        if (n.centeredSlides) {
          let e,
            t = i[o].swiperSlideSize;
          for (let n = o + 1; n < i.length; n += 1)
            i[n] &&
              !e &&
              ((t += i[n].swiperSlideSize), (l += 1), t > a && (e = !0));
          for (let n = o - 1; n >= 0; n -= 1)
            i[n] &&
              !e &&
              ((t += i[n].swiperSlideSize), (l += 1), t > a && (e = !0));
        } else if ("current" === e)
          for (let e = o + 1; e < i.length; e += 1) {
            (t ? r[e] + s[e] - r[o] < a : r[e] - r[o] < a) && (l += 1);
          }
        else
          for (let e = o - 1; e >= 0; e -= 1) {
            r[o] - r[e] < a && (l += 1);
          }
        return l;
      }
      update() {
        const e = this;
        if (!e || e.destroyed) return;
        const { snapGrid: t, params: n } = e;

        function i() {
          const t = e.rtlTranslate ? -1 * e.translate : e.translate,
            n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
          e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
        }
        let r;
        n.breakpoints && e.setBreakpoint(),
          e.updateSize(),
          e.updateSlides(),
          e.updateProgress(),
          e.updateSlidesClasses(),
          e.params.freeMode && e.params.freeMode.enabled
            ? (i(), e.params.autoHeight && e.updateAutoHeight())
            : ((r =
                ("auto" === e.params.slidesPerView ||
                  e.params.slidesPerView > 1) &&
                e.isEnd &&
                !e.params.centeredSlides
                  ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                  : e.slideTo(e.activeIndex, 0, !1, !0)),
              r || i()),
          n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
          e.emit("update");
      }
      changeDirection(e, t) {
        void 0 === t && (t = !0);
        const n = this,
          i = n.params.direction;
        return (
          e || (e = "horizontal" === i ? "vertical" : "horizontal"),
          e === i ||
            ("horizontal" !== e && "vertical" !== e) ||
            (n.$el
              .removeClass(`${n.params.containerModifierClass}${i}`)
              .addClass(`${n.params.containerModifierClass}${e}`),
            n.emitContainerClasses(),
            (n.params.direction = e),
            n.slides.each((t) => {
              "vertical" === e ? (t.style.width = "") : (t.style.height = "");
            }),
            n.emit("changeDirection"),
            t && n.update()),
          n
        );
      }
      mount(e) {
        const t = this;
        if (t.mounted) return !0;
        const n = O(e || t.params.el);
        if (!(e = n[0])) return !1;
        e.swiper = t;
        const i = () =>
          "." + (t.params.wrapperClass || "").trim().split(" ").join(".");
        let r = (() => {
          if (e && e.shadowRoot && e.shadowRoot.querySelector) {
            const t = O(e.shadowRoot.querySelector(i()));
            return (t.children = (e) => n.children(e)), t;
          }
          return n.children(i());
        })();
        if (0 === r.length && t.params.createElements) {
          const e = y().createElement("div");
          (r = O(e)),
            (e.className = t.params.wrapperClass),
            n.append(e),
            n.children("." + t.params.slideClass).each((e) => {
              r.append(e);
            });
        }
        return (
          Object.assign(t, {
            $el: n,
            el: e,
            $wrapperEl: r,
            wrapperEl: r[0],
            mounted: !0,
            rtl: "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
            rtlTranslate:
              "horizontal" === t.params.direction &&
              ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
            wrongRTL: "-webkit-box" === r.css("display"),
          }),
          !0
        );
      }
      init(e) {
        const t = this;
        if (t.initialized) return t;
        return (
          !1 === t.mount(e) ||
            (t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.params.loop && t.loopCreate(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.params.preloadImages && t.preloadImages(),
            t.params.loop
              ? t.slideTo(
                  t.params.initialSlide + t.loopedSlides,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0
                )
              : t.slideTo(
                  t.params.initialSlide,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
            t.attachEvents(),
            (t.initialized = !0),
            t.emit("init"),
            t.emit("afterInit")),
          t
        );
      }
      destroy(e, t) {
        void 0 === e && (e = !0), void 0 === t && (t = !0);
        const n = this,
          { params: i, $el: r, $wrapperEl: s, slides: a } = n;
        return (
          void 0 === n.params ||
            n.destroyed ||
            (n.emit("beforeDestroy"),
            (n.initialized = !1),
            n.detachEvents(),
            i.loop && n.loopDestroy(),
            t &&
              (n.removeClasses(),
              r.removeAttr("style"),
              s.removeAttr("style"),
              a &&
                a.length &&
                a
                  .removeClass(
                    [
                      i.slideVisibleClass,
                      i.slideActiveClass,
                      i.slideNextClass,
                      i.slidePrevClass,
                    ].join(" ")
                  )
                  .removeAttr("style")
                  .removeAttr("data-swiper-slide-index")),
            n.emit("destroy"),
            Object.keys(n.eventsListeners).forEach((e) => {
              n.off(e);
            }),
            !1 !== e &&
              ((n.$el[0].swiper = null),
              (function (e) {
                const t = e;
                Object.keys(t).forEach((e) => {
                  try {
                    t[e] = null;
                  } catch (e) {}
                  try {
                    delete t[e];
                  } catch (e) {}
                });
              })(n)),
            (n.destroyed = !0)),
          null
        );
      }
      static extendDefaults(e) {
        L(re, e);
      }
      static get extendedDefaults() {
        return re;
      }
      static get defaults() {
        return te;
      }
      static installModule(e) {
        se.prototype.__modules__ || (se.prototype.__modules__ = []);
        const t = se.prototype.__modules__;
        "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
      }
      static use(e) {
        return Array.isArray(e)
          ? (e.forEach((e) => se.installModule(e)), se)
          : (se.installModule(e), se);
      }
    }
    Object.keys(ie).forEach((e) => {
      Object.keys(ie[e]).forEach((t) => {
        se.prototype[t] = ie[e][t];
      });
    }),
      se.use([
        function (e) {
          let { swiper: t, on: n, emit: i } = e;
          const r = _();
          let s = null,
            a = null;
          const o = () => {
              t &&
                !t.destroyed &&
                t.initialized &&
                (i("beforeResize"), i("resize"));
            },
            l = () => {
              t && !t.destroyed && t.initialized && i("orientationchange");
            };
          n("init", () => {
            t.params.resizeObserver && void 0 !== r.ResizeObserver
              ? t &&
                !t.destroyed &&
                t.initialized &&
                ((s = new ResizeObserver((e) => {
                  a = r.requestAnimationFrame(() => {
                    const { width: n, height: i } = t;
                    let r = n,
                      s = i;
                    e.forEach((e) => {
                      let { contentBoxSize: n, contentRect: i, target: a } = e;
                      (a && a !== t.el) ||
                        ((r = i ? i.width : (n[0] || n).inlineSize),
                        (s = i ? i.height : (n[0] || n).blockSize));
                    }),
                      (r === n && s === i) || o();
                  });
                })),
                s.observe(t.el))
              : (r.addEventListener("resize", o),
                r.addEventListener("orientationchange", l));
          }),
            n("destroy", () => {
              a && r.cancelAnimationFrame(a),
                s && s.unobserve && t.el && (s.unobserve(t.el), (s = null)),
                r.removeEventListener("resize", o),
                r.removeEventListener("orientationchange", l);
            });
        },
        function (e) {
          let { swiper: t, extendParams: n, on: i, emit: r } = e;
          const s = [],
            a = _(),
            o = function (e, t) {
              void 0 === t && (t = {});
              const n = new (a.MutationObserver || a.WebkitMutationObserver)(
                (e) => {
                  if (1 === e.length) return void r("observerUpdate", e[0]);
                  const t = function () {
                    r("observerUpdate", e[0]);
                  };
                  a.requestAnimationFrame
                    ? a.requestAnimationFrame(t)
                    : a.setTimeout(t, 0);
                }
              );
              n.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData,
              }),
                s.push(n);
            };
          n({
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1,
          }),
            i("init", () => {
              if (t.params.observer) {
                if (t.params.observeParents) {
                  const e = t.$el.parents();
                  for (let t = 0; t < e.length; t += 1) o(e[t]);
                }
                o(t.$el[0], {
                  childList: t.params.observeSlideChildren,
                }),
                  o(t.$wrapperEl[0], {
                    attributes: !1,
                  });
              }
            }),
            i("destroy", () => {
              s.forEach((e) => {
                e.disconnect();
              }),
                s.splice(0, s.length);
            });
        },
      ]);
    var ae = se;

    function oe(e) {
      let { swiper: t, extendParams: n, on: i, emit: r } = e;
      const s = _();
      let a;
      n({
        mousewheel: {
          enabled: !1,
          releaseOnEdges: !1,
          invert: !1,
          forceToAxis: !1,
          sensitivity: 1,
          eventsTarget: "container",
          thresholdDelta: null,
          thresholdTime: null,
        },
      }),
        (t.mousewheel = {
          enabled: !1,
        });
      let o,
        l = M();
      const c = [];

      function u() {
        t.enabled && (t.mouseEntered = !0);
      }

      function d() {
        t.enabled && (t.mouseEntered = !1);
      }

      function p(e) {
        return (
          !(
            t.params.mousewheel.thresholdDelta &&
            e.delta < t.params.mousewheel.thresholdDelta
          ) &&
          !(
            t.params.mousewheel.thresholdTime &&
            M() - l < t.params.mousewheel.thresholdTime
          ) &&
          ((e.delta >= 6 && M() - l < 60) ||
            (e.direction < 0
              ? (t.isEnd && !t.params.loop) ||
                t.animating ||
                (t.slideNext(), r("scroll", e.raw))
              : (t.isBeginning && !t.params.loop) ||
                t.animating ||
                (t.slidePrev(), r("scroll", e.raw)),
            (l = new s.Date().getTime()),
            !1))
        );
      }

      function f(e) {
        let n = e,
          i = !0;
        if (!t.enabled) return;
        const s = t.params.mousewheel;
        t.params.cssMode && n.preventDefault();
        let l = t.$el;
        if (
          ("container" !== t.params.mousewheel.eventsTarget &&
            (l = O(t.params.mousewheel.eventsTarget)),
          !t.mouseEntered && !l[0].contains(n.target) && !s.releaseOnEdges)
        )
          return !0;
        n.originalEvent && (n = n.originalEvent);
        let u = 0;
        const d = t.rtlTranslate ? -1 : 1,
          f = (function (e) {
            let t = 0,
              n = 0,
              i = 0,
              r = 0;
            return (
              "detail" in e && (n = e.detail),
              "wheelDelta" in e && (n = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
              (i = 10 * t),
              (r = 10 * n),
              "deltaY" in e && (r = e.deltaY),
              "deltaX" in e && (i = e.deltaX),
              e.shiftKey && !i && ((i = r), (r = 0)),
              (i || r) &&
                e.deltaMode &&
                (1 === e.deltaMode
                  ? ((i *= 40), (r *= 40))
                  : ((i *= 800), (r *= 800))),
              i && !t && (t = i < 1 ? -1 : 1),
              r && !n && (n = r < 1 ? -1 : 1),
              {
                spinX: t,
                spinY: n,
                pixelX: i,
                pixelY: r,
              }
            );
          })(n);
        if (s.forceToAxis)
          if (t.isHorizontal()) {
            if (!(Math.abs(f.pixelX) > Math.abs(f.pixelY))) return !0;
            u = -f.pixelX * d;
          } else {
            if (!(Math.abs(f.pixelY) > Math.abs(f.pixelX))) return !0;
            u = -f.pixelY;
          }
        else
          u =
            Math.abs(f.pixelX) > Math.abs(f.pixelY) ? -f.pixelX * d : -f.pixelY;
        if (0 === u) return !0;
        s.invert && (u = -u);
        let h = t.getTranslate() + u * s.sensitivity;
        if (
          (h >= t.minTranslate() && (h = t.minTranslate()),
          h <= t.maxTranslate() && (h = t.maxTranslate()),
          (i =
            !!t.params.loop ||
            !(h === t.minTranslate() || h === t.maxTranslate())),
          i && t.params.nested && n.stopPropagation(),
          t.params.freeMode && t.params.freeMode.enabled)
        ) {
          const e = {
              time: M(),
              delta: Math.abs(u),
              direction: Math.sign(u),
            },
            i =
              o &&
              e.time < o.time + 500 &&
              e.delta <= o.delta &&
              e.direction === o.direction;
          if (!i) {
            (o = void 0), t.params.loop && t.loopFix();
            let l = t.getTranslate() + u * s.sensitivity;
            const d = t.isBeginning,
              p = t.isEnd;
            if (
              (l >= t.minTranslate() && (l = t.minTranslate()),
              l <= t.maxTranslate() && (l = t.maxTranslate()),
              t.setTransition(0),
              t.setTranslate(l),
              t.updateProgress(),
              t.updateActiveIndex(),
              t.updateSlidesClasses(),
              ((!d && t.isBeginning) || (!p && t.isEnd)) &&
                t.updateSlidesClasses(),
              t.params.freeMode.sticky)
            ) {
              clearTimeout(a), (a = void 0), c.length >= 15 && c.shift();
              const n = c.length ? c[c.length - 1] : void 0,
                i = c[0];
              if (
                (c.push(e),
                n && (e.delta > n.delta || e.direction !== n.direction))
              )
                c.splice(0);
              else if (
                c.length >= 15 &&
                e.time - i.time < 500 &&
                i.delta - e.delta >= 1 &&
                e.delta <= 6
              ) {
                const n = u > 0 ? 0.8 : 0.2;
                (o = e),
                  c.splice(0),
                  (a = P(() => {
                    t.slideToClosest(t.params.speed, !0, void 0, n);
                  }, 0));
              }
              a ||
                (a = P(() => {
                  (o = e),
                    c.splice(0),
                    t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                }, 500));
            }
            if (
              (i || r("scroll", n),
              t.params.autoplay &&
                t.params.autoplayDisableOnInteraction &&
                t.autoplay.stop(),
              l === t.minTranslate() || l === t.maxTranslate())
            )
              return !0;
          }
        } else {
          const n = {
            time: M(),
            delta: Math.abs(u),
            direction: Math.sign(u),
            raw: e,
          };
          c.length >= 2 && c.shift();
          const i = c.length ? c[c.length - 1] : void 0;
          if (
            (c.push(n),
            i
              ? (n.direction !== i.direction ||
                  n.delta > i.delta ||
                  n.time > i.time + 150) &&
                p(n)
              : p(n),
            (function (e) {
              const n = t.params.mousewheel;
              if (e.direction < 0) {
                if (t.isEnd && !t.params.loop && n.releaseOnEdges) return !0;
              } else if (t.isBeginning && !t.params.loop && n.releaseOnEdges)
                return !0;
              return !1;
            })(n))
          )
            return !0;
        }
        return n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1;
      }

      function h(e) {
        let n = t.$el;
        "container" !== t.params.mousewheel.eventsTarget &&
          (n = O(t.params.mousewheel.eventsTarget)),
          n[e]("mouseenter", u),
          n[e]("mouseleave", d),
          n[e]("wheel", f);
      }

      function m() {
        return t.params.cssMode
          ? (t.wrapperEl.removeEventListener("wheel", f), !0)
          : !t.mousewheel.enabled && (h("on"), (t.mousewheel.enabled = !0), !0);
      }

      function g() {
        return t.params.cssMode
          ? (t.wrapperEl.addEventListener(event, f), !0)
          : !!t.mousewheel.enabled &&
              (h("off"), (t.mousewheel.enabled = !1), !0);
      }
      i("init", () => {
        !t.params.mousewheel.enabled && t.params.cssMode && g(),
          t.params.mousewheel.enabled && m();
      }),
        i("destroy", () => {
          t.params.cssMode && m(), t.mousewheel.enabled && g();
        }),
        Object.assign(t.mousewheel, {
          enable: m,
          disable: g,
        });
    }

    function le(e, t, n, i) {
      const r = y();
      return (
        e.params.createElements &&
          Object.keys(i).forEach((s) => {
            if (!n[s] && !0 === n.auto) {
              let a = e.$el.children("." + i[s])[0];
              a ||
                ((a = r.createElement("div")),
                (a.className = i[s]),
                e.$el.append(a)),
                (n[s] = a),
                (t[s] = a);
            }
          }),
        n
      );
    }

    function ce(e) {
      let { swiper: t, extendParams: n, on: i, emit: r } = e;

      function s(e) {
        let n;
        return (
          e &&
            ((n = O(e)),
            t.params.uniqueNavElements &&
              "string" == typeof e &&
              n.length > 1 &&
              1 === t.$el.find(e).length &&
              (n = t.$el.find(e))),
          n
        );
      }

      function a(e, n) {
        const i = t.params.navigation;
        e &&
          e.length > 0 &&
          (e[n ? "addClass" : "removeClass"](i.disabledClass),
          e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = n),
          t.params.watchOverflow &&
            t.enabled &&
            e[t.isLocked ? "addClass" : "removeClass"](i.lockClass));
      }

      function o() {
        if (t.params.loop) return;
        const { $nextEl: e, $prevEl: n } = t.navigation;
        a(n, t.isBeginning && !t.params.rewind),
          a(e, t.isEnd && !t.params.rewind);
      }

      function l(e) {
        e.preventDefault(),
          (!t.isBeginning || t.params.loop || t.params.rewind) && t.slidePrev();
      }

      function c(e) {
        e.preventDefault(),
          (!t.isEnd || t.params.loop || t.params.rewind) && t.slideNext();
      }

      function u() {
        const e = t.params.navigation;
        if (
          ((t.params.navigation = le(
            t,
            t.originalParams.navigation,
            t.params.navigation,
            {
              nextEl: "swiper-button-next",
              prevEl: "swiper-button-prev",
            }
          )),
          !e.nextEl && !e.prevEl)
        )
          return;
        const n = s(e.nextEl),
          i = s(e.prevEl);
        n && n.length > 0 && n.on("click", c),
          i && i.length > 0 && i.on("click", l),
          Object.assign(t.navigation, {
            $nextEl: n,
            nextEl: n && n[0],
            $prevEl: i,
            prevEl: i && i[0],
          }),
          t.enabled ||
            (n && n.addClass(e.lockClass), i && i.addClass(e.lockClass));
      }

      function d() {
        const { $nextEl: e, $prevEl: n } = t.navigation;
        e &&
          e.length &&
          (e.off("click", c), e.removeClass(t.params.navigation.disabledClass)),
          n &&
            n.length &&
            (n.off("click", l),
            n.removeClass(t.params.navigation.disabledClass));
      }
      n({
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: !1,
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          lockClass: "swiper-button-lock",
        },
      }),
        (t.navigation = {
          nextEl: null,
          $nextEl: null,
          prevEl: null,
          $prevEl: null,
        }),
        i("init", () => {
          u(), o();
        }),
        i("toEdge fromEdge lock unlock", () => {
          o();
        }),
        i("destroy", () => {
          d();
        }),
        i("enable disable", () => {
          const { $nextEl: e, $prevEl: n } = t.navigation;
          e &&
            e[t.enabled ? "removeClass" : "addClass"](
              t.params.navigation.lockClass
            ),
            n &&
              n[t.enabled ? "removeClass" : "addClass"](
                t.params.navigation.lockClass
              );
        }),
        i("click", (e, n) => {
          const { $nextEl: i, $prevEl: s } = t.navigation,
            a = n.target;
          if (t.params.navigation.hideOnClick && !O(a).is(s) && !O(a).is(i)) {
            if (
              t.pagination &&
              t.params.pagination &&
              t.params.pagination.clickable &&
              (t.pagination.el === a || t.pagination.el.contains(a))
            )
              return;
            let e;
            i
              ? (e = i.hasClass(t.params.navigation.hiddenClass))
              : s && (e = s.hasClass(t.params.navigation.hiddenClass)),
              r(!0 === e ? "navigationShow" : "navigationHide"),
              i && i.toggleClass(t.params.navigation.hiddenClass),
              s && s.toggleClass(t.params.navigation.hiddenClass);
          }
        }),
        Object.assign(t.navigation, {
          update: o,
          init: u,
          destroy: d,
        });
    }

    function ue(e) {
      return (
        void 0 === e && (e = ""),
        "." +
          e
            .trim()
            .replace(/([\.:!\/])/g, "\\$1")
            .replace(/ /g, ".")
      );
    }

    function de(e) {
      let { swiper: t, extendParams: n, on: i, emit: r } = e;
      const s = "swiper-pagination";
      let a;
      n({
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: !1,
          hideOnClick: !1,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: !1,
          type: "bullets",
          dynamicBullets: !1,
          dynamicMainBullets: 1,
          formatFractionCurrent: (e) => e,
          formatFractionTotal: (e) => e,
          bulletClass: s + "-bullet",
          bulletActiveClass: s + "-bullet-active",
          modifierClass: s + "-",
          currentClass: s + "-current",
          totalClass: s + "-total",
          hiddenClass: s + "-hidden",
          progressbarFillClass: s + "-progressbar-fill",
          progressbarOppositeClass: s + "-progressbar-opposite",
          clickableClass: s + "-clickable",
          lockClass: s + "-lock",
          horizontalClass: s + "-horizontal",
          verticalClass: s + "-vertical",
        },
      }),
        (t.pagination = {
          el: null,
          $el: null,
          bullets: [],
        });
      let o = 0;

      function l() {
        return (
          !t.params.pagination.el ||
          !t.pagination.el ||
          !t.pagination.$el ||
          0 === t.pagination.$el.length
        );
      }

      function c(e, n) {
        const { bulletActiveClass: i } = t.params.pagination;
        e[n]().addClass(`${i}-${n}`)[n]().addClass(`${i}-${n}-${n}`);
      }

      function u() {
        const e = t.rtl,
          n = t.params.pagination;
        if (l()) return;
        const i =
            t.virtual && t.params.virtual.enabled
              ? t.virtual.slides.length
              : t.slides.length,
          s = t.pagination.$el;
        let u;
        const d = t.params.loop
          ? Math.ceil((i - 2 * t.loopedSlides) / t.params.slidesPerGroup)
          : t.snapGrid.length;
        if (
          (t.params.loop
            ? ((u = Math.ceil(
                (t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup
              )),
              u > i - 1 - 2 * t.loopedSlides && (u -= i - 2 * t.loopedSlides),
              u > d - 1 && (u -= d),
              u < 0 && "bullets" !== t.params.paginationType && (u = d + u))
            : (u = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0),
          "bullets" === n.type &&
            t.pagination.bullets &&
            t.pagination.bullets.length > 0)
        ) {
          const i = t.pagination.bullets;
          let r, l, d;
          if (
            (n.dynamicBullets &&
              ((a = i
                .eq(0)
                [t.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
              s.css(
                t.isHorizontal() ? "width" : "height",
                a * (n.dynamicMainBullets + 4) + "px"
              ),
              n.dynamicMainBullets > 1 &&
                void 0 !== t.previousIndex &&
                ((o += u - (t.previousIndex - t.loopedSlides || 0)),
                o > n.dynamicMainBullets - 1
                  ? (o = n.dynamicMainBullets - 1)
                  : o < 0 && (o = 0)),
              (r = Math.max(u - o, 0)),
              (l = r + (Math.min(i.length, n.dynamicMainBullets) - 1)),
              (d = (l + r) / 2)),
            i.removeClass(
              ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                .map((e) => `${n.bulletActiveClass}${e}`)
                .join(" ")
            ),
            s.length > 1)
          )
            i.each((e) => {
              const t = O(e),
                i = t.index();
              i === u && t.addClass(n.bulletActiveClass),
                n.dynamicBullets &&
                  (i >= r &&
                    i <= l &&
                    t.addClass(n.bulletActiveClass + "-main"),
                  i === r && c(t, "prev"),
                  i === l && c(t, "next"));
            });
          else {
            const e = i.eq(u),
              s = e.index();
            if ((e.addClass(n.bulletActiveClass), n.dynamicBullets)) {
              const e = i.eq(r),
                a = i.eq(l);
              for (let e = r; e <= l; e += 1)
                i.eq(e).addClass(n.bulletActiveClass + "-main");
              if (t.params.loop)
                if (s >= i.length) {
                  for (let e = n.dynamicMainBullets; e >= 0; e -= 1)
                    i.eq(i.length - e).addClass(n.bulletActiveClass + "-main");
                  i.eq(i.length - n.dynamicMainBullets - 1).addClass(
                    n.bulletActiveClass + "-prev"
                  );
                } else c(e, "prev"), c(a, "next");
              else c(e, "prev"), c(a, "next");
            }
          }
          if (n.dynamicBullets) {
            const r = Math.min(i.length, n.dynamicMainBullets + 4),
              s = (a * r - a) / 2 - d * a,
              o = e ? "right" : "left";
            i.css(t.isHorizontal() ? o : "top", s + "px");
          }
        }
        if (
          ("fraction" === n.type &&
            (s.find(ue(n.currentClass)).text(n.formatFractionCurrent(u + 1)),
            s.find(ue(n.totalClass)).text(n.formatFractionTotal(d))),
          "progressbar" === n.type)
        ) {
          let e;
          e = n.progressbarOpposite
            ? t.isHorizontal()
              ? "vertical"
              : "horizontal"
            : t.isHorizontal()
            ? "horizontal"
            : "vertical";
          const i = (u + 1) / d;
          let r = 1,
            a = 1;
          "horizontal" === e ? (r = i) : (a = i),
            s
              .find(ue(n.progressbarFillClass))
              .transform(`translate3d(0,0,0) scaleX(${r}) scaleY(${a})`)
              .transition(t.params.speed);
        }
        "custom" === n.type && n.renderCustom
          ? (s.html(n.renderCustom(t, u + 1, d)), r("paginationRender", s[0]))
          : r("paginationUpdate", s[0]),
          t.params.watchOverflow &&
            t.enabled &&
            s[t.isLocked ? "addClass" : "removeClass"](n.lockClass);
      }

      function d() {
        const e = t.params.pagination;
        if (l()) return;
        const n =
            t.virtual && t.params.virtual.enabled
              ? t.virtual.slides.length
              : t.slides.length,
          i = t.pagination.$el;
        let s = "";
        if ("bullets" === e.type) {
          let r = t.params.loop
            ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup)
            : t.snapGrid.length;
          t.params.freeMode &&
            t.params.freeMode.enabled &&
            !t.params.loop &&
            r > n &&
            (r = n);
          for (let n = 0; n < r; n += 1)
            e.renderBullet
              ? (s += e.renderBullet.call(t, n, e.bulletClass))
              : (s += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
          i.html(s), (t.pagination.bullets = i.find(ue(e.bulletClass)));
        }
        "fraction" === e.type &&
          ((s = e.renderFraction
            ? e.renderFraction.call(t, e.currentClass, e.totalClass)
            : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
          i.html(s)),
          "progressbar" === e.type &&
            ((s = e.renderProgressbar
              ? e.renderProgressbar.call(t, e.progressbarFillClass)
              : `<span class="${e.progressbarFillClass}"></span>`),
            i.html(s)),
          "custom" !== e.type && r("paginationRender", t.pagination.$el[0]);
      }

      function p() {
        t.params.pagination = le(
          t,
          t.originalParams.pagination,
          t.params.pagination,
          {
            el: "swiper-pagination",
          }
        );
        const e = t.params.pagination;
        if (!e.el) return;
        let n = O(e.el);
        0 !== n.length &&
          (t.params.uniqueNavElements &&
            "string" == typeof e.el &&
            n.length > 1 &&
            ((n = t.$el.find(e.el)),
            n.length > 1 &&
              (n = n.filter((e) => O(e).parents(".swiper")[0] === t.el))),
          "bullets" === e.type && e.clickable && n.addClass(e.clickableClass),
          n.addClass(e.modifierClass + e.type),
          n.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
          "bullets" === e.type &&
            e.dynamicBullets &&
            (n.addClass(`${e.modifierClass}${e.type}-dynamic`),
            (o = 0),
            e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
          "progressbar" === e.type &&
            e.progressbarOpposite &&
            n.addClass(e.progressbarOppositeClass),
          e.clickable &&
            n.on("click", ue(e.bulletClass), function (e) {
              e.preventDefault();
              let n = O(this).index() * t.params.slidesPerGroup;
              t.params.loop && (n += t.loopedSlides), t.slideTo(n);
            }),
          Object.assign(t.pagination, {
            $el: n,
            el: n[0],
          }),
          t.enabled || n.addClass(e.lockClass));
      }

      function f() {
        const e = t.params.pagination;
        if (l()) return;
        const n = t.pagination.$el;
        n.removeClass(e.hiddenClass),
          n.removeClass(e.modifierClass + e.type),
          n.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
          t.pagination.bullets &&
            t.pagination.bullets.removeClass &&
            t.pagination.bullets.removeClass(e.bulletActiveClass),
          e.clickable && n.off("click", ue(e.bulletClass));
      }
      i("init", () => {
        p(), d(), u();
      }),
        i("activeIndexChange", () => {
          (t.params.loop || void 0 === t.snapIndex) && u();
        }),
        i("snapIndexChange", () => {
          t.params.loop || u();
        }),
        i("slidesLengthChange", () => {
          t.params.loop && (d(), u());
        }),
        i("snapGridLengthChange", () => {
          t.params.loop || (d(), u());
        }),
        i("destroy", () => {
          f();
        }),
        i("enable disable", () => {
          const { $el: e } = t.pagination;
          e &&
            e[t.enabled ? "removeClass" : "addClass"](
              t.params.pagination.lockClass
            );
        }),
        i("lock unlock", () => {
          u();
        }),
        i("click", (e, n) => {
          const i = n.target,
            { $el: s } = t.pagination;
          if (
            t.params.pagination.el &&
            t.params.pagination.hideOnClick &&
            s.length > 0 &&
            !O(i).hasClass(t.params.pagination.bulletClass)
          ) {
            if (
              t.navigation &&
              ((t.navigation.nextEl && i === t.navigation.nextEl) ||
                (t.navigation.prevEl && i === t.navigation.prevEl))
            )
              return;
            const e = s.hasClass(t.params.pagination.hiddenClass);
            r(!0 === e ? "paginationShow" : "paginationHide"),
              s.toggleClass(t.params.pagination.hiddenClass);
          }
        }),
        Object.assign(t.pagination, {
          render: d,
          update: u,
          init: p,
          destroy: f,
        });
    }

    function pe(e) {
      let { swiper: t, extendParams: n, on: i, emit: r } = e;
      const s = y();
      let a,
        o,
        l,
        c,
        u = !1,
        d = null,
        p = null;

      function f() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
        const { scrollbar: e, rtlTranslate: n, progress: i } = t,
          { $dragEl: r, $el: s } = e,
          a = t.params.scrollbar;
        let c = o,
          u = (l - o) * i;
        n
          ? ((u = -u),
            u > 0 ? ((c = o - u), (u = 0)) : -u + o > l && (c = l + u))
          : u < 0
          ? ((c = o + u), (u = 0))
          : u + o > l && (c = l - u),
          t.isHorizontal()
            ? (r.transform(`translate3d(${u}px, 0, 0)`),
              (r[0].style.width = c + "px"))
            : (r.transform(`translate3d(0px, ${u}px, 0)`),
              (r[0].style.height = c + "px")),
          a.hide &&
            (clearTimeout(d),
            (s[0].style.opacity = 1),
            (d = setTimeout(() => {
              (s[0].style.opacity = 0), s.transition(400);
            }, 1e3)));
      }

      function h() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
        const { scrollbar: e } = t,
          { $dragEl: n, $el: i } = e;
        (n[0].style.width = ""),
          (n[0].style.height = ""),
          (l = t.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight),
          (c =
            t.size /
            (t.virtualSize +
              t.params.slidesOffsetBefore -
              (t.params.centeredSlides ? t.snapGrid[0] : 0))),
          (o =
            "auto" === t.params.scrollbar.dragSize
              ? l * c
              : parseInt(t.params.scrollbar.dragSize, 10)),
          t.isHorizontal()
            ? (n[0].style.width = o + "px")
            : (n[0].style.height = o + "px"),
          (i[0].style.display = c >= 1 ? "none" : ""),
          t.params.scrollbar.hide && (i[0].style.opacity = 0),
          t.params.watchOverflow &&
            t.enabled &&
            e.$el[t.isLocked ? "addClass" : "removeClass"](
              t.params.scrollbar.lockClass
            );
      }

      function m(e) {
        return t.isHorizontal()
          ? "touchstart" === e.type || "touchmove" === e.type
            ? e.targetTouches[0].clientX
            : e.clientX
          : "touchstart" === e.type || "touchmove" === e.type
          ? e.targetTouches[0].clientY
          : e.clientY;
      }

      function g(e) {
        const { scrollbar: n, rtlTranslate: i } = t,
          { $el: r } = n;
        let s;
        (s =
          (m(e) -
            r.offset()[t.isHorizontal() ? "left" : "top"] -
            (null !== a ? a : o / 2)) /
          (l - o)),
          (s = Math.max(Math.min(s, 1), 0)),
          i && (s = 1 - s);
        const c = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * s;
        t.updateProgress(c),
          t.setTranslate(c),
          t.updateActiveIndex(),
          t.updateSlidesClasses();
      }

      function v(e) {
        const n = t.params.scrollbar,
          { scrollbar: i, $wrapperEl: s } = t,
          { $el: o, $dragEl: l } = i;
        (u = !0),
          (a =
            e.target === l[0] || e.target === l
              ? m(e) -
                e.target.getBoundingClientRect()[
                  t.isHorizontal() ? "left" : "top"
                ]
              : null),
          e.preventDefault(),
          e.stopPropagation(),
          s.transition(100),
          l.transition(100),
          g(e),
          clearTimeout(p),
          o.transition(0),
          n.hide && o.css("opacity", 1),
          t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
          r("scrollbarDragStart", e);
      }

      function b(e) {
        const { scrollbar: n, $wrapperEl: i } = t,
          { $el: s, $dragEl: a } = n;
        u &&
          (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
          g(e),
          i.transition(0),
          s.transition(0),
          a.transition(0),
          r("scrollbarDragMove", e));
      }

      function _(e) {
        const n = t.params.scrollbar,
          { scrollbar: i, $wrapperEl: s } = t,
          { $el: a } = i;
        u &&
          ((u = !1),
          t.params.cssMode &&
            (t.$wrapperEl.css("scroll-snap-type", ""), s.transition("")),
          n.hide &&
            (clearTimeout(p),
            (p = P(() => {
              a.css("opacity", 0), a.transition(400);
            }, 1e3))),
          r("scrollbarDragEnd", e),
          n.snapOnRelease && t.slideToClosest());
      }

      function w(e) {
        const {
            scrollbar: n,
            touchEventsTouch: i,
            touchEventsDesktop: r,
            params: a,
            support: o,
          } = t,
          l = n.$el[0],
          c = !(!o.passiveListener || !a.passiveListeners) && {
            passive: !1,
            capture: !1,
          },
          u = !(!o.passiveListener || !a.passiveListeners) && {
            passive: !0,
            capture: !1,
          };
        if (!l) return;
        const d = "on" === e ? "addEventListener" : "removeEventListener";
        o.touch
          ? (l[d](i.start, v, c), l[d](i.move, b, c), l[d](i.end, _, u))
          : (l[d](r.start, v, c), s[d](r.move, b, c), s[d](r.end, _, u));
      }

      function x() {
        const { scrollbar: e, $el: n } = t;
        t.params.scrollbar = le(
          t,
          t.originalParams.scrollbar,
          t.params.scrollbar,
          {
            el: "swiper-scrollbar",
          }
        );
        const i = t.params.scrollbar;
        if (!i.el) return;
        let r = O(i.el);
        t.params.uniqueNavElements &&
          "string" == typeof i.el &&
          r.length > 1 &&
          1 === n.find(i.el).length &&
          (r = n.find(i.el));
        let s = r.find("." + t.params.scrollbar.dragClass);
        0 === s.length &&
          ((s = O(`<div class="${t.params.scrollbar.dragClass}"></div>`)),
          r.append(s)),
          Object.assign(e, {
            $el: r,
            el: r[0],
            $dragEl: s,
            dragEl: s[0],
          }),
          i.draggable && t.params.scrollbar.el && w("on"),
          r &&
            r[t.enabled ? "removeClass" : "addClass"](
              t.params.scrollbar.lockClass
            );
      }

      function C() {
        t.params.scrollbar.el && w("off");
      }
      n({
        scrollbar: {
          el: null,
          dragSize: "auto",
          hide: !1,
          draggable: !1,
          snapOnRelease: !0,
          lockClass: "swiper-scrollbar-lock",
          dragClass: "swiper-scrollbar-drag",
        },
      }),
        (t.scrollbar = {
          el: null,
          dragEl: null,
          $el: null,
          $dragEl: null,
        }),
        i("init", () => {
          x(), h(), f();
        }),
        i("update resize observerUpdate lock unlock", () => {
          h();
        }),
        i("setTranslate", () => {
          f();
        }),
        i("setTransition", (e, n) => {
          !(function (e) {
            t.params.scrollbar.el &&
              t.scrollbar.el &&
              t.scrollbar.$dragEl.transition(e);
          })(n);
        }),
        i("enable disable", () => {
          const { $el: e } = t.scrollbar;
          e &&
            e[t.enabled ? "removeClass" : "addClass"](
              t.params.scrollbar.lockClass
            );
        }),
        i("destroy", () => {
          C();
        }),
        Object.assign(t.scrollbar, {
          updateSize: h,
          setTranslate: f,
          init: x,
          destroy: C,
        });
    }

    function fe(e) {
      let t,
        { swiper: n, extendParams: i, on: r, emit: s } = e;

      function a() {
        const e = n.slides.eq(n.activeIndex);
        let i = n.params.autoplay.delay;
        e.attr("data-swiper-autoplay") &&
          (i = e.attr("data-swiper-autoplay") || n.params.autoplay.delay),
          clearTimeout(t),
          (t = P(() => {
            let e;
            n.params.autoplay.reverseDirection
              ? n.params.loop
                ? (n.loopFix(),
                  (e = n.slidePrev(n.params.speed, !0, !0)),
                  s("autoplay"))
                : n.isBeginning
                ? n.params.autoplay.stopOnLastSlide
                  ? l()
                  : ((e = n.slideTo(
                      n.slides.length - 1,
                      n.params.speed,
                      !0,
                      !0
                    )),
                    s("autoplay"))
                : ((e = n.slidePrev(n.params.speed, !0, !0)), s("autoplay"))
              : n.params.loop
              ? (n.loopFix(),
                (e = n.slideNext(n.params.speed, !0, !0)),
                s("autoplay"))
              : n.isEnd
              ? n.params.autoplay.stopOnLastSlide
                ? l()
                : ((e = n.slideTo(0, n.params.speed, !0, !0)), s("autoplay"))
              : ((e = n.slideNext(n.params.speed, !0, !0)), s("autoplay")),
              ((n.params.cssMode && n.autoplay.running) || !1 === e) && a();
          }, i));
      }

      function o() {
        return (
          void 0 === t &&
          !n.autoplay.running &&
          ((n.autoplay.running = !0), s("autoplayStart"), a(), !0)
        );
      }

      function l() {
        return (
          !!n.autoplay.running &&
          void 0 !== t &&
          (t && (clearTimeout(t), (t = void 0)),
          (n.autoplay.running = !1),
          s("autoplayStop"),
          !0)
        );
      }

      function c(e) {
        n.autoplay.running &&
          (n.autoplay.paused ||
            (t && clearTimeout(t),
            (n.autoplay.paused = !0),
            0 !== e && n.params.autoplay.waitForTransition
              ? ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                  n.$wrapperEl[0].addEventListener(e, d);
                })
              : ((n.autoplay.paused = !1), a())));
      }

      function u() {
        const e = y();
        "hidden" === e.visibilityState && n.autoplay.running && c(),
          "visible" === e.visibilityState &&
            n.autoplay.paused &&
            (a(), (n.autoplay.paused = !1));
      }

      function d(e) {
        n &&
          !n.destroyed &&
          n.$wrapperEl &&
          e.target === n.$wrapperEl[0] &&
          (["transitionend", "webkitTransitionEnd"].forEach((e) => {
            n.$wrapperEl[0].removeEventListener(e, d);
          }),
          (n.autoplay.paused = !1),
          n.autoplay.running ? a() : l());
      }

      function p() {
        n.params.autoplay.disableOnInteraction
          ? l()
          : (s("autoplayPause"), c()),
          ["transitionend", "webkitTransitionEnd"].forEach((e) => {
            n.$wrapperEl[0].removeEventListener(e, d);
          });
      }

      function f() {
        n.params.autoplay.disableOnInteraction ||
          ((n.autoplay.paused = !1), s("autoplayResume"), a());
      }
      (n.autoplay = {
        running: !1,
        paused: !1,
      }),
        i({
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !0,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        }),
        r("init", () => {
          if (n.params.autoplay.enabled) {
            o();
            y().addEventListener("visibilitychange", u),
              n.params.autoplay.pauseOnMouseEnter &&
                (n.$el.on("mouseenter", p), n.$el.on("mouseleave", f));
          }
        }),
        r("beforeTransitionStart", (e, t, i) => {
          n.autoplay.running &&
            (i || !n.params.autoplay.disableOnInteraction
              ? n.autoplay.pause(t)
              : l());
        }),
        r("sliderFirstMove", () => {
          n.autoplay.running &&
            (n.params.autoplay.disableOnInteraction ? l() : c());
        }),
        r("touchEnd", () => {
          n.params.cssMode &&
            n.autoplay.paused &&
            !n.params.autoplay.disableOnInteraction &&
            a();
        }),
        r("destroy", () => {
          n.$el.off("mouseenter", p),
            n.$el.off("mouseleave", f),
            n.autoplay.running && l();
          y().removeEventListener("visibilitychange", u);
        }),
        Object.assign(n.autoplay, {
          pause: c,
          run: a,
          start: o,
          stop: l,
        });
    }

    function he(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var me = (function () {
      function e() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e);
      }
      var t, n, i;
      return (
        (t = e),
        (i = [
          {
            key: "initPromoBar",
            value: function () {
              new ae("#promobar", {
                modules: [fe],
                slidesPerView: 1,
                loop: !0,
                speed: 500,
                autoplay: {
                  delay: 4e3,
                  disableOnInteraction: !1,
                },
              });
            },
          },
          {
            key: "initHeroSlider",
            value: function () {
              new ae("#hero-slide", {
                modules: [fe],
                slidesPerView: 1,
                autoHeight: !0,
                loop: !0,
                speed: 700,
                autoplay: {
                  delay: 4e3,
                  disableOnInteraction: !0,
                },
                on: {
                  afterInit: function (e) {
                    new a.a({
                      container: e.el,
                      cancel_on_exit: !1,
                    });
                  },
                },
              });
            },
          },
          {
            key: "initCollectionCarousel",
            value: function () {
              new ae(".collection-carousel", {
                modules: [de, ce],
                slidesPerView: 3,
                spaceBetween: 3,
                breakpoints: {
                  992: {
                    slidesPerView: 4,
                  },
                },
                navigation: {
                  prevEl: ".collection__content .swiper-button--prev",
                  nextEl: ".collection__content .swiper-button--next",
                },
                on: {
                  afterInit: function (e) {
                    new a.a({
                      container: e.el,
                      cancel_on_exit: !1,
                    });
                  },
                },
              });
            },
          },
          {
            key: "shopBundleCarousel",
            value: function () {
              r()(window).width() < 992 &&
                new ae(".shop-bundle-carousel", {
                  modules: [de],
                  slidesPerView: 3,
                  spaceBetween: 3,
                  pagination: {
                    type: "progressbar",
                    el: ".shop-bundle-carousel-progress",
                  },
                  on: {
                    afterInit: function (e) {
                      new a.a({
                        container: e.el,
                        cancel_on_exit: !1,
                      });
                    },
                  },
                });
            },
          },
          {
            key: "initJournalCarousel",
            value: function () {
              new ae("#journal-carousel", {
                modules: [de],
                slidesPerView: 1,
                pagination: {
                  type: "progressbar",
                  el: ".journal__progress",
                },
                breakpoints: {
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 3,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 3,
                  },
                },
                on: {
                  afterInit: function (e) {
                    new a.a({
                      container: e.el,
                      cancel_on_exit: !1,
                    });
                  },
                },
              });
            },
          },
          {
            key: "initPdpCarousel",
            value: function () {
              if (document.querySelector(".rm-thumbs") != undefined) {
                let thumbs = document
                  .querySelector(".rm-thumbs")
                  .querySelectorAll(".swiper-slide");
                let pdp_thumbs = new Swiper(".rm-thumbs", {
                  spaceBetween: 10,
                  slidesPerView: 5,
                  freeMode: true,
                  direction: "vertical",
                  loop: true,
                  breakpoints: {
                    999: {
                      slidesPerView: 8,
                    },
                  },
                });
                let pdp_carousel = new Swiper("#pdp-carousel", {
                  slidesPerView: 1,
                  centeredSlides: !0,
                  centeredSlidesBounds: !0,
                  spaceBetween: 5,
                  loop: true,
                  speed: 1e3,
                  autoHeight: true,
                  mousewheel: true,
                  navigation: {
                    nextEl: ".pdp-carousel-nav__btn--next",
                    prevEl: ".pdp-carousel-nav__btn--prev",
                  },
                  pagination: {
                    el: "#pdp-carousel-progressBar",
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: 1,
                  },
                  breakpoints: {
                    992: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                  },
                });

                var current_index = 0;
                var stop = false;
                pdp_carousel.on("slideChange", function (e) {
                  let active_index = pdp_carousel.realIndex;
                  if (current_index != active_index) {
                    current_index = active_index;
                    thumbs.forEach((thumb, index) => {
                      const index_0 = index;
                      if (index_0 == active_index) {
                        thumb.classList.add("thumb-active");
                      } else {
                        thumb.classList.remove("thumb-active");
                      }
                    });
                    if (window.innerWidth > 999) {
                      if (thumbs.length > 8 && !stop) {
                        pdp_thumbs.slideToLoop(active_index, 1e3, true);
                      }
                    } else {
                      // if (thumbs.length > 4 && !stop) {
                      //     pdp_thumbs.slideToLoop(active_index, 1e3, true);
                      // }
                    }
                  }
                });
                pdp_thumbs.on("slideChange", function (e) {
                  let active_index = pdp_thumbs.realIndex;
                  let carousel_index = pdp_carousel.realIndex;
                  if (current_index != active_index) {
                    current_index = active_index;
                    thumbs.forEach((thumb, index) => {
                      const index_0 = index;
                      if (index_0 == active_index) {
                        thumb.classList.add("thumb-active");
                      } else {
                        thumb.classList.remove("thumb-active");
                      }
                    });
                    if (current_index != carousel_index && !stop) {
                      pdp_carousel.slideToLoop(active_index, 1e3, true);
                    }
                  }
                });

                thumbs.forEach((thumb) => {
                  thumb.addEventListener("click", (e) => {
                    let active_index = parseInt(thumb.getAttribute("index"));
                    slideChange(
                      current_index,
                      active_index,
                      pdp_carousel,
                      thumbs,
                      thumb
                    );
                  });
                  thumb.addEventListener("mouseover", (e) => {
                    if (window.innerWidth > 999 && stop != true) {
                      stop = true;
                      let active_index = parseInt(thumb.getAttribute("index"));
                      slideChange(
                        current_index,
                        active_index,
                        pdp_carousel,
                        thumbs,
                        thumb
                      );
                    }
                  });
                  thumb.addEventListener("mouseout", (e) => {
                    stop = false;
                  });
                });

                function slideChange(
                  current_index,
                  active_index,
                  pdp_carousel,
                  thumbs,
                  thumb
                ) {
                  if (current_index != active_index) {
                    current_index = active_index;
                    pdp_carousel.slideToLoop(active_index, 300, false);

                    thumbs.forEach((t) => {
                      t.classList.remove("thumb-active");
                    });
                    thumb.classList.add("thumb-active");
                  }
                }
              }
            },
          },
          {
            key: "initPdpPairCarousel",
            value: function () {
              new ae(".pdp-pair-carousel", {
                slidesPerView: 3,
                spaceBetween: 4,
                modules: [de, ce, pe, oe],
                mousewheel: !0,
                loop: false,
                scrollbar: {
                  el: ".pdp-pair-carousel__progress",
                  draggable: !0,
                },
                pagination: {
                  type: "progressbar",
                  el: ".pdp-pair-carousel__progress",
                },
                navigation: {
                  nextEl: ".pair-carousel-nav .swiper-btn--next",
                  prevEl: ".pair-carousel-nav .swiper-btn--prev",
                },
                breakpoints: {
                  992: {
                    slidesPerView: 2.8,
                  },
                  1200: {
                    slidesPerView: 3.75,
                  },
                },
              });
            },
          },
          {
            key: "initRecentViewSlider",
            value: function () {
              new ae("#recent-viewed-carousel", {
                modules: [ce],
                slidesPerView: 2,
                spaceBetween: 5,
                navigation: {
                  nextEl: ".recent-viewed-nav .swiper-btn--next",
                  prevEl: ".recent-viewed-nav .swiper-btn--prev",
                },
                breakpoints: {
                  992: {
                    slidesPerView: 4,
                  },
                },
                on: {
                  afterInit: function (e) {
                    new a.a({
                      container: e.el,
                      cancel_on_exit: !1,
                    });
                  },
                },
              });
            },
          },
          {
            key: "initShopLookCarousel",
            value: function () {
              new ae("#shopLook-carousel-mobile", {
                modules: [ce],
                slidesPerView: 2,
                spaceBetween: 5,
                navigation: {
                  nextEl: ".shop-look-nav .swiper-btn--next",
                  prevEl: ".shop-look-nav .swiper-btn--prev",
                },
              });
            },
          },
          {
            key: "initShopBundle",
            value: function () {
              new ae("#shop-bundle", {
                modules: [ce, de],
                spaceBetween: 3,
                slidesPerView: 3,
                speed: 500,
                navigation: {
                  nextEl: ".shop-bundle .swiper-button--next",
                  prevEl: ".shop-bundle .swiper-button--prev",
                },
                pagination: {
                  type: "progressbar",
                  el: ".shop-bundle-carousel-progress",
                },
                on: {
                  afterInit: function (e) {
                    new a.a({
                      container: e.el,
                      cancel_on_exit: !1,
                    });
                  },
                },
              });
            },
          },
          {
            key: "initCartCarousel",
            value: function () {
              new ae(".cart-carousel .swiper", {
                modules: [ce],
                slidesPerView: 1,
                loop: !0,
                observer: !0,
                observeParents: !0,
                observeSlideChildren: !0,
                speed: 500,
                threshold: 1,
                navigation: {
                  nextEl: ".cart-carousel__nav-next",
                  prevEl: ".cart-carousel__nav-prev",
                },
              }),
                r()(".select").selectric({
                  disableOnMobile: !1,
                  nativeOnMobile: !1,
                });
            },
          },
          {
            key: "initInstagram",
            value: function () {
              r()(window).width() < 992 &&
                new ae("#instagram-carousel", {
                  modules: [de],
                  slidesPerView: 1,
                  pagination: {
                    type: "progressbar",
                    el: ".instagram__carousel-progress",
                  },
                  breakpoints: {
                    768: {
                      slidesPerView: 2,
                    },
                  },
                  on: {
                    afterInit: function (e) {
                      new a.a({
                        container: e.el,
                        cancel_on_exit: !1,
                      });
                    },
                  },
                });
            },
          },
          {
            key: "initLocations",
            value: function () {
              new ae("#location-slider", {
                modules: [ce],
                slidesPerView: 1,
                speed: 700,
                navigation: {
                  prevEl: ".location__slider--prev",
                  nextEl: ".location__slider--next",
                },
                on: {
                  afterInit: function (e) {
                    new a.a({
                      container: e.el,
                      cancel_on_exit: !1,
                    });
                  },
                },
              });
            },
          },
          {
            key: "initBoutiqueSlider",
            value: function () {
              new ae(".boutique-carousel", {
                modules: [ce],
                slidesPerView: 1.1,
                spaceBetween: 9,
                centeredSlides: !0,
                centeredSlidesBounds: !0,
                loop: !0,
                navigation: {
                  prevEl: ".boutique-nav__btn--prev",
                  nextEl: ".boutique-nav__btn--next",
                },
                breakpoints: {
                  992: {
                    spaceBetween: 75,
                    slidesPerView: 1.32,
                  },
                },
              });
            },
          },
        ]),
        (n = null) && he(t.prototype, n),
        i && he(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function ge(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var ve = (function () {
      function e(t) {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.config = t),
          (this.showOne = this.config || !1),
          this.init();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              var e = this;
              $(document).on("click", this.config.accHead, function (t) {
                t.preventDefault();
                var n = $(this).parent(e.config.ele);
                e.config.showOne &&
                  !n.hasClass(e.config.activeClass) &&
                  e.closeAll(),
                  e.config.showOne &&
                    n.siblings(e.config.ele).removeClass(e.config.activeClass),
                  e.config.showOne &&
                    n.siblings(e.config.ele).find(e.config.accBody).slideUp(),
                  n.toggleClass(e.config.activeClass),
                  n.find(e.config.accBody).slideToggle(),
                  e.config.callback && e.config.callback();
              });
            },
          },
          {
            key: "closeAll",
            value: function () {
              var e = this;
              $(this.config.ele).each(function (t, n) {
                $(n).hasClass(e.config.activeClass) &&
                  ($(n).removeClass(e.config.activeClass),
                  $(n).find(e.config.accBody).slideUp());
              });
            },
          },
        ]) && ge(t.prototype, n),
        i && ge(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function ye(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }

    function be(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var _e = (function () {
      function e() {
        var t =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        ye(this, e),
          (this.config = t),
          (this.buttons = r()(t.tabLink)),
          (this.content = r()(t.tabContent)),
          (this.defaultOpenIndex = this.config.defaultOpenIndex
            ? this.config.defaultOpenIndex
            : 0),
          this.event();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "event",
            value: function () {
              var e = this,
                t = this.buttons[this.defaultOpenIndex],
                n = this.content[this.defaultOpenIndex];
              this.defaultOpen(t, n),
                r()(this.buttons).on("click", function (t) {
                  t.preventDefault();
                  var n = r()(t.currentTarget);
                  e.config.onBeforeChange && e.config.onBeforeChange(n);
                  var i = r()(n).attr("href").replace("#", "");
                  n
                    .parent()
                    .siblings()
                    .find(e.config.tabLink)
                    .hasClass(e.config.activeClass) &&
                    (n
                      .parent()
                      .siblings()
                      .find(e.config.tabLink)
                      .removeClass(e.config.activeClass),
                    n.addClass(e.config.activeClass),
                    e.openContent(i)),
                    n.addClass(e.config.activeClass),
                    e.config.onChange && e.config.onChange(n);
                });
            },
          },
          {
            key: "openContent",
            value: function (e) {
              var t = this;
              r()(this.content).each(function (n, i) {
                r()(i).data("id") === e &&
                  (t.config.fade
                    ? (r()(i).fadeIn(300).addClass("active"),
                      r()(i)
                        .siblings(t.config.tabContent)
                        .fadeOut(0)
                        .removeClass("active"))
                    : (r()(i).show(0).addClass("active"),
                      r()(i)
                        .siblings(t.config.tabContent)
                        .hide(0)
                        .removeClass("active")));
              });
            },
          },
          {
            key: "defaultOpen",
            value: function (e, t) {
              e &&
                t &&
                (r()(e).addClass(this.config.activeClass),
                r()(t).show(0),
                r()(t).siblings(this.tabContent).hide(0));
            },
          },
        ]) && be(t.prototype, n),
        i && be(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function we(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var xe = (function () {
      function e() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          this.init();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              this.initPdpVariantSelectric(),
                this.initVariants(),
                this.initShopLookSlider(),
                this.initQuickViewModal(),
                this.lettersVariants(),
                this.pdpAccordion(),
                new _e({
                  tabLink: ".pdp-tab__nav-link",
                  tabContent: ".pdp-tab__item",
                  activeClass: "pdp-tab__nav-link--active",
                });
            },
          },
          {
            key: "initVariants",
            value: function () {
              var e = this;

              r()(".AddToCartForm").each(function (t, n) {
                e.handleVariantChange(r()(n));
              });
              // console.log("init variants")
              // var sticky_select = r()(".rm-sticky__selectors select");
              // console.log(sticky_select)
              // var parent_form = sticky_select.parents('.AddToCartForm');

              // sticky_select.on('change', (e)=> {
              //     console.log(sticky_select.val());
              //     var i = sticky_select.find(`option[value="${sticky_select.val()}"]`);
              //     var e = parent_form;
              //     if (i.length) {
              //         var s = e.find("[data-pdp-price]"),
              //             a = e.find("[data-compare-at-price]");
              //         a ? (s.html(i.data("price")), a.html(i.data("compare-at-price"))) : s.html(i.data("price")), i.data("available") ? (e.find(".pdp_add").removeClass("d-none"), e.find(".pdp_out").addClass("d-none")) : (e.find(".pdp_add").addClass("d-none"), e.find(".pdp_out").removeClass("d-none").attr("data-variant-id", i.val()))
              //     }
              // })
            },
          },
          {
            key: "initPdpVariantSelectric",
            value: function () {
              var e = this;
              console.log("ALL sticky select");
              // console.log(r()('.rm-sticky__selectors').find('select'))
              document
                .querySelectorAll(".rm-sticky__selectors select")
                .forEach((select) => {
                  select.addEventListener("change", (e) => {
                    let $this = e.target;
                    let name = $this.getAttribute("name");
                    let parent_form = $this.closest(".AddToCartForm");
                    let originalSelect = parent_form.querySelector(
                      `.pdp-variant-select.original[option_name="${name}"]`
                    );
                    let variantItem = originalSelect.querySelector(
                      `.variant-list__item[value="${$this.value}"]`
                    );

                    if (variantItem) {
                      variantItem.click();
                    }
                  });
                });

              // Custom select toggle

              document.addEventListener("click", function (event) {
                if (event.target.closest(".ctm-select .ctm-select__head")) {
                  let select = event.target.closest(".ctm-select");
                  document.querySelectorAll(".ctm-select").forEach((el) => {
                    if (
                      el !== select &&
                      el.classList.contains("ctm-select-open")
                    ) {
                      el.classList.remove("ctm-select-open");
                      el.querySelector(".ctm-select__body").style.display =
                        "none";
                    }
                  });
                  let body = select.querySelector(".ctm-select__body");
                  body.style.display =
                    body.style.display === "block" ? "none" : "block";
                  select.classList.toggle("ctm-select-open");
                }
              });

              // Variant selection

              document.addEventListener("click", function (event) {
                if (event.target.closest(".ctm-select .variant-list__item")) {
                  event.preventDefault();
                  let variantItem = event.target.closest(".variant-list__item");
                  let form = variantItem.closest(".AddToCartForm");
                  let option_name = variantItem.getAttribute("option_name");
                  let sub = form.querySelector(
                    `.pdp-variant-select.sticky-select[option_name="${option_name}"]`
                  );
                  let mobile_select = form.querySelector(
                    `select[name="${option_name}"]`
                  );
                  let originalSelect = form.querySelector(
                    `.pdp-variant-select.original[option_name="${option_name}"]`
                  );

                  originalSelect.classList.remove("ctm-select-open");
                  let color = variantItem.dataset.color;
                  let label = variantItem.querySelector(
                    ".ctm-select__option"
                  ).textContent;
                  sub.querySelector(".ctm-select__label").textContent = label;

                  if (mobile_select) {
                    mobile_select.value = label.replaceAll('"', "");
                  }

                  originalSelect.querySelector(".ctm-select__input").value =
                    label;
                  originalSelect.querySelector(
                    ".ctm-select__label"
                  ).textContent = label;

                  if (
                    originalSelect.querySelector(".ctm-select__head .color") !=
                    undefined
                  ) {
                    originalSelect.querySelector(
                      ".ctm-select__head .color"
                    ).style.backgroundColor = color;
                  }

                  variantItem.closest(".ctm-select__body").style.display =
                    "none";
                  document
                    .querySelectorAll(
                      ".ctm-select .variant-list__item.selected"
                    )
                    .forEach((item) => item.classList.remove("selected"));
                  variantItem.classList.add("selected");

                  // Call handleVariantChange if it exists
                  if (typeof e !== "undefined" && e.handleVariantChange) {
                    e.handleVariantChange(form);
                  }
                }
              });

              // Close dropdown when clicking outside

              document.addEventListener("click", function (event) {
                if (!event.target.closest(".ctm-select")) {
                  document.querySelectorAll(".ctm-select").forEach((select) => {
                    if (select.classList.contains("ctm-select-open")) {
                      select.querySelector(".ctm-select__body").style.display =
                        "none";
                      select.classList.remove("ctm-select-open");
                    }
                  });
                }
              });
            },
          },
          {
            key: "handleVariantChange",
            value: function (el) {
              var t = [];
              var e = r()(el);
              console.log(e);
              e.find('[name="option_value"]').each(function () {
                t.push(r()(this).val());
              });
              var n = e.find(".variant-id-hidden"),
                i = n.find("option[data-title='".concat(t.join(" / "), "']"));
              if (i.length) {
                n.val(i.val());
                var s = e.find("[data-pdp-price]"),
                  a = e.find("[data-compare-at-price]");
                e.find(".pdp_add").removeClass("disabled");
                e.find(".pdp_out").removeClass("disabled");
                e.find(".pdp_add").removeAttr("disabled");
                e.find(".pdp_out").removeAttr("disabled");
                let selector = document.querySelectorAll("[option_name]");
                selector.forEach((select) => {
                  let label = select
                    ?.querySelector(".ctm-select__label")
                    ?.textContent.toLowerCase();
                  if (!label?.includes("pick") && !label?.includes("choose")) {
                    select
                      .querySelector(".ctm-select__head")
                      ?.classList.remove("error");
                    select
                      .querySelector(".ctm-select__head")
                      ?.classList.add("has-selected");
                  }
                });
                a
                  ? (s.html(i.data("price")),
                    a.html(i.data("compare-at-price")))
                  : s.html(i.data("price")),
                  i.data("available")
                    ? (e.find(".pdp_add").removeClass("d-none"),
                      e.find(".pdp_out").addClass("d-none"))
                    : (e.find(".pdp_add").addClass("d-none"),
                      e
                        .find(".pdp_out")
                        .removeClass("d-none")
                        .attr("data-variant-id", i.val()));
              }
            },
          },
          {
            key: "initShopLookSlider",
            value: function () {},
          },
          {
            key: "initQuickViewModal",
            value: function () {
              var e = r()("#quick-view"),
                t = e.find(".modal__content-placeholder");

              function n() {
                var n = r()(this)
                  .parents(".pair-item")
                  .find(".pair__details")
                  .clone();
                t.html(n), e.fadeIn();
              }
              r()(".pair-item__thumb").on("click", function (e) {
                e.preventDefault(), n.call(this);
              }),
                r()(document).on(
                  "click",
                  "#quick-view .swym-add-to-wishlist-view-product",
                  function (e) {
                    e.preventDefault();
                    var t = r()(this).data("product-id");
                    r()(
                      ".pdp-pair .pair__details .swym-add-to-wishlist-view-product.product_".concat(
                        t
                      )
                    ).click();
                  }
                );
            },
          },
          {
            key: "lettersVariants",
            value: function () {
              r()(document).on("click", ".letter-id", function (e) {
                var t = r()(e.target),
                  i = t.parents(".letter"),
                  s = i.find(".letter-qt"),
                  a = i.find(".letter__count"),
                  o = t.data("inventory-quantity"),
                  l = t.data("variant-image");
                if (l) {
                  var c = r()(".first-image-slide");
                  c.find("img").attr("src", l),
                    c.find("source").attr("srcset", l);
                }
                if (t.is(":checked"))
                  return (
                    t.addClass("checked"),
                    s.attr("name", "items[][quantity]"),
                    void n()
                  );
                e.preventDefault(),
                  s.val() >= o ||
                    (s.val(function (e, t) {
                      return ++t;
                    }),
                    a.text(s.val()),
                    n());
              }),
                r()(document).on("click", ".letter__remove", function (e) {
                  var i = r()(e.target).parents(".letter");
                  t(i), n();
                }),
                r()(document).on(
                  "click",
                  ".pdp-quantity__button",
                  function (t) {
                    var n = r()(t.target),
                      i = parseInt(n.data("step"));
                    e(n, i);
                  }
                );
              var e = function (e, t) {
                  var i = r()(e).parents(".pdp-quantity"),
                    s = i.find(".letter-id"),
                    a = i.find(".letter-qt"),
                    o = parseInt(a.val()),
                    l = o + t;
                  l > 0
                    ? (s.addClass("checked"),
                      s.attr("name", "items[][id]"),
                      a.attr("name", "items[][quantity]"))
                    : (s.removeClass("checked"),
                      s.removeAttr("name"),
                      a.removeAttr("name"));
                  var c = i.data("variant-image"),
                    u = r()(".first-image-slide");
                  u.find("img").attr("src", c),
                    u.find("source").attr("srcset", c),
                    l >= 0 && a.val(o + t),
                    n();
                },
                t = function (e) {
                  var t = e.find(".letter-id"),
                    n = e.find(".letter-qt"),
                    i = e.find(".letter__count");
                  t.prop("checked", !1).removeClass("checked"),
                    n.val(1).removeAttr("name"),
                    i.text(1);
                },
                n = function () {
                  var e = r()(".letter-id.checked"),
                    t = r()("[data-pdp-price]"),
                    n = r()("[data-compare-at-price]"),
                    i = 0,
                    s = 0;
                  e.each(function (e, t) {
                    var n = r()(t),
                      a = n.parents(".letter").find(".letter-qt"),
                      o = n.data("price"),
                      l = n.data("discount-price"),
                      c = parseInt(a.val());
                    (s += l ? l * c : o * c), (i += o * c);
                  });
                  var a = ""
                      .concat(Shopify.api.formatMoney(i), " ")
                      .concat(Shopify.currency.active),
                    o = ""
                      .concat(Shopify.api.formatMoney(s), " ")
                      .concat(Shopify.currency.active);
                  s < i ? (n.html(a), t.html(o)) : t.html(a);
                };
            },
          },
          {
            key: "pdpAccordion",
            value: function () {
              new ve({
                ele: ".pdp-accordion",
                accHead: ".pdp-accordion__head",
                accBody: ".pdp-accordion__body",
                activeClass: "open",
                showOne: !0,
              }),
                r()(".pdp-accordion-carousel").each(function (e, t) {
                  new ae(t, {
                    modules: [ce, oe],
                    slidesPerView: "auto",
                    spaceBetween: 3,
                    loop: !0,
                    observer: !0,
                    navigation: {
                      nextEl: t.querySelector(".pdp-accordion__btn--next"),
                      prevEl: t.querySelector(".pdp-accordion__btn--prev"),
                    },
                    mousewheel: {
                      enabled: !0,
                      sensitivity: 5.5,
                    },
                    on: {
                      afterInit: function (e) {
                        new a.a({
                          container: e.el,
                          cancel_on_exit: !1,
                        });
                      },
                    },
                  });
                });
            },
          },
        ]) && we(t.prototype, n),
        i && we(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function Ce(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var Te = (function () {
      function e() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.header = r()(".header")),
          (this.cart = r()(".cart-sidebar")),
          (this.navToggler = r()(".nav-toggler")),
          (this.navCollapse = r()("#nav-collapse")),
          this.init();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              var e = this;
              console.log("Init loc dropdown");
              console.log(this);
              this.navToggler.on("click", this.toggleNav.bind(this)),
                r()(".nav__close").on("click", function () {
                  e.navCollapse.fadeOut(),
                    e.navToggler.removeClass("nav-toggler--open");
                }),
                r()(".header-overlay").on("click", function () {
                  r()(".header-overlay").fadeOut(),
                    e.navToggler.toggleClass("nav-toggler--open"),
                    e.navCollapse.fadeOut(),
                    r()(e.header).removeClass("header--nav-visible");
                }),
                r()(window).width() >= 992 &&
                  (r()(".location__dropdown--toggle").on(
                    "mouseover",
                    function () {
                      r()(".location__dropdown").fadeIn(200);
                    }
                  ),
                  r()(
                    ".nav__right .nav__list .nav__item:not(:nth-child(3))"
                  ).on("mouseover", function () {
                    r()(".location__dropdown").fadeOut(200);
                  }),
                  r()(".location__dropdown").on("mouseleave", function () {
                    r()(this).fadeOut(200);
                  })),
                r()(window).width() <= 991.8 &&
                  (r()(".location__dropdown--toggle").on("click", function (e) {
                    r()(this).parent().siblings().find(".dropdown").slideUp(),
                      r()(this)
                        .parent()
                        .siblings()
                        .removeClass("dropdown-open"),
                      r()(this).parent().toggleClass("dropdown-open"),
                      r()(this).parent().find(".dropdown").slideToggle();
                  }),
                  r()(".dropdown-btn").on("click", function () {
                    r()(this).parent().siblings().find(".dropdown").slideUp(),
                      r()(this)
                        .parent()
                        .siblings()
                        .removeClass("dropdown-open"),
                      r()(this).parent().toggleClass("dropdown-open"),
                      r()(this).parent().find(".dropdown").slideToggle();
                  })),
                r()(window).ready(function () {
                  window.location.href.indexOf("cart") > -1 &&
                    r()(".header__promobar afterpay-placement").remove();
                }),
                r()(".nav__cart_button").on("click", function () {
                  e.cart.fadeIn();
                  document
                    .querySelector("body")
                    .classList.add("cart-sidebar--open");
                }),
                r()(document).on("click", ".cart-sidebar__close", function () {
                  e.cart.fadeOut();
                  document
                    .querySelector("body")
                    .classList.remove("cart-sidebar--open");
                }),
                l(".cart-sidebar__inner", ".nav__cart_button", function (t) {
                  r()(e.header).removeClass("header--nav-visible"),
                    r()(t).parent(".cart-sidebar").fadeOut(),
                    document
                      .querySelector("body")
                      .classList.remove("cart-sidebar--open");
                }),
                this.stickyHeader();
            },
          },
          {
            key: "toggleNav",
            value: function () {
              this.navToggler.toggleClass("nav-toggler--open"),
                this.navCollapse.fadeToggle(),
                r()(".header-overlay").fadeToggle(),
                this.header.toggleClass("header--nav-visible");
            },
          },
          {
            key: "stickyHeader",
            value: function () {
              var e = this,
                t = this.header.height(),
                n = r()(".header__sticky"),
                i = t - n.height();
              r()(window).on("scroll", function () {
                r()(window).scrollTop() >= i
                  ? (n.addClass("header__sticky--top"),
                    e.header.addClass("header--sticky"))
                  : (n.removeClass("header__sticky--top"),
                    e.header.removeClass("header--sticky"));
              }),
                r()("div#shopify-section-header-promobar")[0]
                  .childElementCount ||
                  r()("#shopify-section-header-promobar").remove();
            },
          },
        ]) && Ce(t.prototype, n),
        i && Ce(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function ke(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var Se = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.init();
        }
        var t, n, i;
        return (
          (t = e),
          (n = [
            {
              key: "init",
              value: function () {
                this.addToBag(),
                  this.addToCartButton(),
                  this.changeCartForm(),
                  this.CartchangeCartForm(),
                  this.changeCartVariant();
              },
            },
            {
              key: "addToBag",
              value: function () {
                r()(document).on("submit", ".AddToCartForm", function (e) {
                  e.preventDefault();
                  console.log("CLICKED 2")
                  var t = r()(this);
                  r.a.ajax({
                    url: "/cart/add.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: t.serialize(),
                    success: function () {
                      Ee(!1), r()(".cart-sidebar").fadeIn();
                      document
                        .querySelector("body")
                        .classList.add("cart-sidebar--open");
                    },
                  });
                });
              },
            },
            {
              key: "addToCartButton",
              value: function () {
                r()(document).on("click change", ".AddToCartBtn", function (e) {
                  console.log("CLICKED")
                  var t = r()(this).parents(".AddToCartForm").find(":input");
                  r.a.ajax({
                    url: "/cart/add.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: t.serialize(),
                    success: function () {
                      Ee(!1), r()(".cart-sidebar").fadeIn();
                      document
                        .querySelector("body")
                        .classList.add("cart-sidebar--open");
                    },
                  }),
                    t.prop("checked", !1);
                });
              },
            },
            {
              key: "changeCartForm",
              value: function () {
                r()("body").on("submit", ".ChangeCartForm", function (e) {
                  e.preventDefault();
                  var t = r()(this);
                  r.a.ajax({
                    url: "/cart/change.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: t.serialize(),
                    success: function () {
                      Ee(!1);
                    },
                  });
                });
              },
            },
            {
              key: "CartchangeCartForm",
              value: function () {
                r()("body").on("submit", ".Cart_ChangeCartForm", function (e) {
                  e.preventDefault();
                  var t = r()(this);
                  r.a.ajax({
                    url: "/cart/change.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: t.serialize(),
                    success: function () {
                      Ee(!1), location.reload();
                    },
                  });
                });
              },
            },
            {
              key: "changeCartVariant",
              value: function () {
                r()(document).on("change", ".cart-ctm-select", function (e) {
                  e.preventDefault();
                  var t = r()(this),
                    n = r()(".variant-list__item").parent().data("variant_id");
                  r.a.ajax({
                    url: "/cart/change.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: {
                      id: n,
                      quantity: 0,
                    },
                    success: function () {
                      r.a.ajax({
                        url: "/cart/add.js",
                        dataType: "json",
                        cache: !1,
                        type: "post",
                        data: t.serialize(),
                        success: function () {
                          Ee(!1);
                        },
                      });
                    },
                  });
                });
              },
            },
          ]) && ke(t.prototype, n),
          i && ke(t, i),
          Object.defineProperty(t, "prototype", {
            writable: !1,
          }),
          e
        );
      })(),
      Ee = function () {
        return r.a.ajax({
          url: "/cart?view=header",
          success: function (e) {
            r()(".cart-sidebar").html(r()(e).html()),
              r.a.ajax({
                url: "/cart.js",
                dataType: "json",
                cache: !1,
                type: "get",
                success: function (e) {
                  return r()(".cart-count").html(e.item_count);
                },
              }),
              l(".cart-sidebar__inner", ".nav__cart_button", function (e) {
                r()(e).parent(".cart-sidebar").fadeOut();
                document
                  .querySelector("body")
                  .classList.remove("cart-sidebar--open");
              }),
              new a.a(),
              me.initCartCarousel(),
              r()(".select").selectric({
                disableOnMobile: !1,
                nativeOnMobile: !1,
              });
          },
        });
      };

    function Oe(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }

    function Pe(e, t) {
      (e.prototype = Object.create(t.prototype)),
        (e.prototype.constructor = e),
        (e.__proto__ = t);
    }
    /*!
     * GSAP 3.10.4
     * https://greensock.com
     *
     * @license Copyright 2008-2022, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */
    r()(document).ready(function () {
      r()(".forgot-pwd-link").on("click", function (e) {
        e.preventDefault(),
          r()("#signIn").addClass("d-none"),
          r()("#forgotPwd").removeClass("d-none");
      }),
        r()(".cancel-link").on("click", function (e) {
          e.preventDefault(),
            r()("#signIn").removeClass("d-none"),
            r()("#forgotPwd").addClass("d-none");
        }),
        r()(window).width() <= 991.98 &&
          r()(".account-tab__label").on("click", function () {
            r()(".account-tab-nav__list").slideToggle(),
              r()(this).toggleClass("active");
          }),
        new _e({
          tabLink: ".account-tab-nav__link",
          tabContent: ".account-tab-item",
          activeClass: "active",
          onChange: function (e) {
            r()(window).width() <= 991.98 &&
              (r()(".account-tab__label").text(r()(e).text()),
              r()(".account-tab-nav__list").slideUp(),
              r()(".account-tab__label").removeClass("active"));
          },
        }),
        r()(".pass-visibility").on("click", function (e) {
          e.preventDefault(), r()(this).toggleClass("visible");
          var t = r()(this).parent().find("input");
          "password" === t.attr("type")
            ? t.attr("type", "text")
            : t.attr("type", "password");
        }),
        r()(".reset-pass--btn").on("click", function (e) {
          e.preventDefault(),
            r()("account-addressFilled") &&
              (r()("#forgotPwd").removeClass("d-none"),
              r()("#address, #password").addClass("d-none"),
              r()(".cancel-reset-link").on("click", function (e) {
                e.preventDefault(),
                  r()("#forgotPwd").addClass("d-none"),
                  r()("#address, #password").removeClass("d-none");
              })),
            r()("#forgotPwd").removeClass("d-none"),
            r()(".address-no").addClass("d-none");
        }),
        r()(document).on("click", ".js-order-link", function (e) {
          e.preventDefault();
          var t = e.target.hash;
          r()(".order-history").hide(), r()(t).show();
        }),
        r()(document).on("click", ".btn-backTo-orderHistory", function (e) {
          e.preventDefault(),
            r()(".order-history").show(),
            r()(".order-details").hide();
        });
    }),
      r()(document).ready(function () {
        r()(".collection-nav__link").on("click", function (e) {
          e.preventDefault(),
            r()(".collection-nav__link").removeClass("active"),
            r()(this).addClass("active"),
            r.a.ajax({
              type: "get",
              url: "/collections/".concat(
                r()(this).data("handle"),
                "?view=home"
              ),
              success: function (e) {
                r()(".collection-carousel").html(e),
                  new a.a(),
                  me.initCollectionCarousel();
              },
            });
        });
      });
    var Me,
      Ae,
      De,
      Ie,
      Le,
      je,
      Ne,
      Be,
      $e,
      ze,
      Re,
      He,
      Fe,
      qe = {
        autoSleep: 120,
        force3D: "auto",
        nullTargetWarn: 1,
        units: {
          lineHeight: "",
        },
      },
      We = {
        duration: 0.5,
        overwrite: !1,
        delay: 0,
      },
      Ve = 1e8,
      Ge = 2 * Math.PI,
      Xe = Ge / 4,
      Ye = 0,
      Ue = Math.sqrt,
      Qe = Math.cos,
      Je = Math.sin,
      Ke = function (e) {
        return "string" == typeof e;
      },
      Ze = function (e) {
        return "function" == typeof e;
      },
      et = function (e) {
        return "number" == typeof e;
      },
      tt = function (e) {
        return void 0 === e;
      },
      nt = function (e) {
        return "object" == typeof e;
      },
      it = function (e) {
        return !1 !== e;
      },
      rt = function () {
        return "undefined" != typeof window;
      },
      st = function (e) {
        return Ze(e) || Ke(e);
      },
      at =
        ("function" == typeof ArrayBuffer && ArrayBuffer.isView) ||
        function () {},
      ot = Array.isArray,
      lt = /(?:-?\.?\d|\.)+/gi,
      ct = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
      ut = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
      dt = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
      pt = /[+-]=-?[.\d]+/,
      ft = /[^,'"\[\]\s]+/gi,
      ht = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
      mt = {},
      gt = {},
      vt = function (e) {
        return (gt = qt(e, mt)) && Ai;
      },
      yt = function (e, t) {
        return console.warn(
          "Invalid property",
          e,
          "set to",
          t,
          "Missing plugin? gsap.registerPlugin()"
        );
      },
      bt = function (e, t) {
        return !t && console.warn(e);
      },
      _t = function (e, t) {
        return (e && (mt[e] = t) && gt && (gt[e] = t)) || mt;
      },
      wt = function () {
        return 0;
      },
      xt = {},
      Ct = [],
      Tt = {},
      kt = {},
      St = {},
      Et = 30,
      Ot = [],
      Pt = "",
      Mt = function (e) {
        var t,
          n,
          i = e[0];
        if ((nt(i) || Ze(i) || (e = [e]), !(t = (i._gsap || {}).harness))) {
          for (n = Ot.length; n-- && !Ot[n].targetTest(i); );
          t = Ot[n];
        }
        for (n = e.length; n--; )
          (e[n] && (e[n]._gsap || (e[n]._gsap = new ei(e[n], t)))) ||
            e.splice(n, 1);
        return e;
      },
      At = function (e) {
        return e._gsap || Mt(_n(e))[0]._gsap;
      },
      Dt = function (e, t, n) {
        return (n = e[t]) && Ze(n)
          ? e[t]()
          : (tt(n) && e.getAttribute && e.getAttribute(t)) || n;
      },
      It = function (e, t) {
        return (e = e.split(",")).forEach(t) || e;
      },
      Lt = function (e) {
        return Math.round(1e5 * e) / 1e5 || 0;
      },
      jt = function (e) {
        return Math.round(1e7 * e) / 1e7 || 0;
      },
      Nt = function (e, t) {
        var n = t.charAt(0),
          i = parseFloat(t.substr(2));
        return (
          (e = parseFloat(e)),
          "+" === n ? e + i : "-" === n ? e - i : "*" === n ? e * i : e / i
        );
      },
      Bt = function (e, t) {
        for (var n = t.length, i = 0; e.indexOf(t[i]) < 0 && ++i < n; );
        return i < n;
      },
      $t = function () {
        var e,
          t,
          n = Ct.length,
          i = Ct.slice(0);
        for (Tt = {}, Ct.length = 0, e = 0; e < n; e++)
          (t = i[e]) &&
            t._lazy &&
            (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
      },
      zt = function (e, t, n, i) {
        Ct.length && $t(), e.render(t, n, i), Ct.length && $t();
      },
      Rt = function (e) {
        var t = parseFloat(e);
        return (t || 0 === t) && (e + "").match(ft).length < 2
          ? t
          : Ke(e)
          ? e.trim()
          : e;
      },
      Ht = function (e) {
        return e;
      },
      Ft = function (e, t) {
        for (var n in t) n in e || (e[n] = t[n]);
        return e;
      },
      qt = function (e, t) {
        for (var n in t) e[n] = t[n];
        return e;
      },
      Wt = function e(t, n) {
        for (var i in n)
          "__proto__" !== i &&
            "constructor" !== i &&
            "prototype" !== i &&
            (t[i] = nt(n[i]) ? e(t[i] || (t[i] = {}), n[i]) : n[i]);
        return t;
      },
      Vt = function (e, t) {
        var n,
          i = {};
        for (n in e) n in t || (i[n] = e[n]);
        return i;
      },
      Gt = function (e) {
        var t,
          n = e.parent || Ae,
          i = e.keyframes
            ? ((t = ot(e.keyframes)),
              function (e, n) {
                for (var i in n)
                  i in e ||
                    ("duration" === i && t) ||
                    "ease" === i ||
                    (e[i] = n[i]);
              })
            : Ft;
        if (it(e.inherit))
          for (; n; ) i(e, n.vars.defaults), (n = n.parent || n._dp);
        return e;
      },
      Xt = function (e, t, n, i, r) {
        void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
        var s,
          a = e[i];
        if (r) for (s = t[r]; a && a[r] > s; ) a = a._prev;
        return (
          a
            ? ((t._next = a._next), (a._next = t))
            : ((t._next = e[n]), (e[n] = t)),
          t._next ? (t._next._prev = t) : (e[i] = t),
          (t._prev = a),
          (t.parent = t._dp = e),
          t
        );
      },
      Yt = function (e, t, n, i) {
        void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
        var r = t._prev,
          s = t._next;
        r ? (r._next = s) : e[n] === t && (e[n] = s),
          s ? (s._prev = r) : e[i] === t && (e[i] = r),
          (t._next = t._prev = t.parent = null);
      },
      Ut = function (e, t) {
        e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove(e),
          (e._act = 0);
      },
      Qt = function (e, t) {
        if (e && (!t || t._end > e._dur || t._start < 0))
          for (var n = e; n; ) (n._dirty = 1), (n = n.parent);
        return e;
      },
      Jt = function (e) {
        for (var t = e.parent; t && t.parent; )
          (t._dirty = 1), t.totalDuration(), (t = t.parent);
        return e;
      },
      Kt = function (e) {
        return e._repeat ? Zt(e._tTime, (e = e.duration() + e._rDelay)) * e : 0;
      },
      Zt = function (e, t) {
        var n = Math.floor((e /= t));
        return e && n === e ? n - 1 : n;
      },
      en = function (e, t) {
        return (
          (e - t._start) * t._ts +
          (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
        );
      },
      tn = function (e) {
        return (e._end = jt(
          e._start + (e._tDur / Math.abs(e._ts || e._rts || 1e-8) || 0)
        ));
      },
      nn = function (e, t) {
        var n = e._dp;
        return (
          n &&
            n.smoothChildTiming &&
            e._ts &&
            ((e._start = jt(
              n._time -
                (e._ts > 0
                  ? t / e._ts
                  : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)
            )),
            tn(e),
            n._dirty || Qt(n, e)),
          e
        );
      },
      rn = function (e, t) {
        var n;
        if (
          ((t._time || (t._initted && !t._dur)) &&
            ((n = en(e.rawTime(), t)),
            (!t._dur || mn(0, t.totalDuration(), n) - t._tTime > 1e-8) &&
              t.render(n, !0)),
          Qt(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
        ) {
          if (e._dur < e.duration())
            for (n = e; n._dp; )
              n.rawTime() >= 0 && n.totalTime(n._tTime), (n = n._dp);
          e._zTime = -1e-8;
        }
      },
      sn = function (e, t, n, i) {
        return (
          t.parent && Ut(t),
          (t._start = jt(
            (et(n) ? n : n || e !== Ae ? pn(e, n, t) : e._time) + t._delay
          )),
          (t._end = jt(
            t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)
          )),
          Xt(e, t, "_first", "_last", e._sort ? "_start" : 0),
          ln(t) || (e._recent = t),
          i || rn(e, t),
          e
        );
      },
      an = function (e, t) {
        return (
          (mt.ScrollTrigger || yt("scrollTrigger", t)) &&
          mt.ScrollTrigger.create(t, e)
        );
      },
      on = function (e, t, n, i) {
        return (
          li(e, t),
          e._initted
            ? !n &&
              e._pt &&
              ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) &&
              Ne !== Hn.frame
              ? (Ct.push(e), (e._lazy = [t, i]), 1)
              : void 0
            : 1
        );
      },
      ln = function (e) {
        var t = e.data;
        return "isFromStart" === t || "isStart" === t;
      },
      cn = function (e, t, n, i) {
        var r = e._repeat,
          s = jt(t) || 0,
          a = e._tTime / e._tDur;
        return (
          a && !i && (e._time *= s / e._dur),
          (e._dur = s),
          (e._tDur = r ? (r < 0 ? 1e10 : jt(s * (r + 1) + e._rDelay * r)) : s),
          a > 0 && !i ? nn(e, (e._tTime = e._tDur * a)) : e.parent && tn(e),
          n || Qt(e.parent, e),
          e
        );
      },
      un = function (e) {
        return e instanceof ni ? Qt(e) : cn(e, e._dur);
      },
      dn = {
        _start: 0,
        endTime: wt,
        totalDuration: wt,
      },
      pn = function e(t, n, i) {
        var r,
          s,
          a,
          o = t.labels,
          l = t._recent || dn,
          c = t.duration() >= Ve ? l.endTime(!1) : t._dur;
        return Ke(n) && (isNaN(n) || n in o)
          ? ((s = n.charAt(0)),
            (a = "%" === n.substr(-1)),
            (r = n.indexOf("=")),
            "<" === s || ">" === s
              ? (r >= 0 && (n = n.replace(/=/, "")),
                ("<" === s ? l._start : l.endTime(l._repeat >= 0)) +
                  (parseFloat(n.substr(1)) || 0) *
                    (a ? (r < 0 ? l : i).totalDuration() / 100 : 1))
              : r < 0
              ? (n in o || (o[n] = c), o[n])
              : ((s = parseFloat(n.charAt(r - 1) + n.substr(r + 1))),
                a && i && (s = (s / 100) * (ot(i) ? i[0] : i).totalDuration()),
                r > 1 ? e(t, n.substr(0, r - 1), i) + s : c + s))
          : null == n
          ? c
          : +n;
      },
      fn = function (e, t, n) {
        var i,
          r,
          s = et(t[1]),
          a = (s ? 2 : 1) + (e < 2 ? 0 : 1),
          o = t[a];
        if ((s && (o.duration = t[1]), (o.parent = n), e)) {
          for (i = o, r = n; r && !("immediateRender" in i); )
            (i = r.vars.defaults || {}), (r = it(r.vars.inherit) && r.parent);
          (o.immediateRender = it(i.immediateRender)),
            e < 2 ? (o.runBackwards = 1) : (o.startAt = t[a - 1]);
        }
        return new fi(t[0], o, t[a + 1]);
      },
      hn = function (e, t) {
        return e || 0 === e ? t(e) : t;
      },
      mn = function (e, t, n) {
        return n < e ? e : n > t ? t : n;
      },
      gn = function (e, t) {
        return Ke(e) && (t = ht.exec(e)) ? t[1] : "";
      },
      vn = [].slice,
      yn = function (e, t) {
        return (
          e &&
          nt(e) &&
          "length" in e &&
          ((!t && !e.length) || (e.length - 1 in e && nt(e[0]))) &&
          !e.nodeType &&
          e !== De
        );
      },
      bn = function (e, t, n) {
        return (
          void 0 === n && (n = []),
          e.forEach(function (e) {
            var i;
            return (Ke(e) && !t) || yn(e, 1)
              ? (i = n).push.apply(i, _n(e))
              : n.push(e);
          }) || n
        );
      },
      _n = function (e, t, n) {
        return !Ke(e) || n || (!Ie && Fn())
          ? ot(e)
            ? bn(e, n)
            : yn(e)
            ? vn.call(e, 0)
            : e
            ? [e]
            : []
          : vn.call((t || Le).querySelectorAll(e), 0);
      },
      wn = function (e) {
        return e.sort(function () {
          return 0.5 - Math.random();
        });
      },
      xn = function (e) {
        if (Ze(e)) return e;
        var t = nt(e)
            ? e
            : {
                each: e,
              },
          n = Un(t.ease),
          i = t.from || 0,
          r = parseFloat(t.base) || 0,
          s = {},
          a = i > 0 && i < 1,
          o = isNaN(i) || a,
          l = t.axis,
          c = i,
          u = i;
        return (
          Ke(i)
            ? (c = u =
                {
                  center: 0.5,
                  edges: 0.5,
                  end: 1,
                }[i] || 0)
            : !a && o && ((c = i[0]), (u = i[1])),
          function (e, a, d) {
            var p,
              f,
              h,
              m,
              g,
              v,
              y,
              b,
              _,
              w = (d || t).length,
              x = s[w];
            if (!x) {
              if (!(_ = "auto" === t.grid ? 0 : (t.grid || [1, Ve])[1])) {
                for (
                  y = -Ve;
                  y < (y = d[_++].getBoundingClientRect().left) && _ < w;

                );
                _--;
              }
              for (
                x = s[w] = [],
                  p = o ? Math.min(_, w) * c - 0.5 : i % _,
                  f = _ === Ve ? 0 : o ? (w * u) / _ - 0.5 : (i / _) | 0,
                  y = 0,
                  b = Ve,
                  v = 0;
                v < w;
                v++
              )
                (h = (v % _) - p),
                  (m = f - ((v / _) | 0)),
                  (x[v] = g =
                    l ? Math.abs("y" === l ? m : h) : Ue(h * h + m * m)),
                  g > y && (y = g),
                  g < b && (b = g);
              "random" === i && wn(x),
                (x.max = y - b),
                (x.min = b),
                (x.v = w =
                  (parseFloat(t.amount) ||
                    parseFloat(t.each) *
                      (_ > w
                        ? w - 1
                        : l
                        ? "y" === l
                          ? w / _
                          : _
                        : Math.max(_, w / _)) ||
                    0) * ("edges" === i ? -1 : 1)),
                (x.b = w < 0 ? r - w : r),
                (x.u = gn(t.amount || t.each) || 0),
                (n = n && w < 0 ? Xn(n) : n);
            }
            return (
              (w = (x[e] - x.min) / x.max || 0),
              jt(x.b + (n ? n(w) : w) * x.v) + x.u
            );
          }
        );
      },
      Cn = function (e) {
        var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
        return function (n) {
          var i = Math.round(parseFloat(n) / e) * e * t;
          return (i - (i % 1)) / t + (et(n) ? 0 : gn(n));
        };
      },
      Tn = function (e, t) {
        var n,
          i,
          r = ot(e);
        return (
          !r &&
            nt(e) &&
            ((n = r = e.radius || Ve),
            e.values
              ? ((e = _n(e.values)), (i = !et(e[0])) && (n *= n))
              : (e = Cn(e.increment))),
          hn(
            t,
            r
              ? Ze(e)
                ? function (t) {
                    return (i = e(t)), Math.abs(i - t) <= n ? i : t;
                  }
                : function (t) {
                    for (
                      var r,
                        s,
                        a = parseFloat(i ? t.x : t),
                        o = parseFloat(i ? t.y : 0),
                        l = Ve,
                        c = 0,
                        u = e.length;
                      u--;

                    )
                      (r = i
                        ? (r = e[u].x - a) * r + (s = e[u].y - o) * s
                        : Math.abs(e[u] - a)) < l && ((l = r), (c = u));
                    return (
                      (c = !n || l <= n ? e[c] : t),
                      i || c === t || et(t) ? c : c + gn(t)
                    );
                  }
              : Cn(e)
          )
        );
      },
      kn = function (e, t, n, i) {
        return hn(ot(e) ? !t : !0 === n ? !!(n = 0) : !i, function () {
          return ot(e)
            ? e[~~(Math.random() * e.length)]
            : (n = n || 1e-5) &&
                (i = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) &&
                Math.floor(
                  Math.round(
                    (e - n / 2 + Math.random() * (t - e + 0.99 * n)) / n
                  ) *
                    n *
                    i
                ) / i;
        });
      },
      Sn = function (e, t, n) {
        return hn(n, function (n) {
          return e[~~t(n)];
        });
      },
      En = function (e) {
        for (var t, n, i, r, s = 0, a = ""; ~(t = e.indexOf("random(", s)); )
          (i = e.indexOf(")", t)),
            (r = "[" === e.charAt(t + 7)),
            (n = e.substr(t + 7, i - t - 7).match(r ? ft : lt)),
            (a +=
              e.substr(s, t - s) +
              kn(r ? n : +n[0], r ? 0 : +n[1], +n[2] || 1e-5)),
            (s = i + 1);
        return a + e.substr(s, e.length - s);
      },
      On = function (e, t, n, i, r) {
        var s = t - e,
          a = i - n;
        return hn(r, function (t) {
          return n + (((t - e) / s) * a || 0);
        });
      },
      Pn = function (e, t, n) {
        var i,
          r,
          s,
          a = e.labels,
          o = Ve;
        for (i in a)
          (r = a[i] - t) < 0 == !!n &&
            r &&
            o > (r = Math.abs(r)) &&
            ((s = i), (o = r));
        return s;
      },
      Mn = function (e, t, n) {
        var i,
          r,
          s = e.vars,
          a = s[t];
        if (a)
          return (
            (i = s[t + "Params"]),
            (r = s.callbackScope || e),
            n && Ct.length && $t(),
            i ? a.apply(r, i) : a.call(r)
          );
      },
      An = function (e) {
        return (
          Ut(e),
          e.scrollTrigger && e.scrollTrigger.kill(!1),
          e.progress() < 1 && Mn(e, "onInterrupt"),
          e
        );
      },
      Dn = function (e) {
        var t = (e = (!e.name && e.default) || e).name,
          n = Ze(e),
          i =
            t && !n && e.init
              ? function () {
                  this._props = [];
                }
              : e,
          r = {
            init: wt,
            render: xi,
            add: ai,
            kill: Ti,
            modifier: Ci,
            rawVars: 0,
          },
          s = {
            targetTest: 0,
            get: 0,
            getSetter: yi,
            aliases: {},
            register: 0,
          };
        if ((Fn(), e !== i)) {
          if (kt[t]) return;
          Ft(i, Ft(Vt(e, r), s)),
            qt(i.prototype, qt(r, Vt(e, s))),
            (kt[(i.prop = t)] = i),
            e.targetTest && (Ot.push(i), (xt[t] = 1)),
            (t =
              ("css" === t ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) +
              "Plugin");
        }
        _t(t, i), e.register && e.register(Ai, i, Ei);
      },
      In = {
        aqua: [0, 255, 255],
        lime: [0, 255, 0],
        silver: [192, 192, 192],
        black: [0, 0, 0],
        maroon: [128, 0, 0],
        teal: [0, 128, 128],
        blue: [0, 0, 255],
        navy: [0, 0, 128],
        white: [255, 255, 255],
        olive: [128, 128, 0],
        yellow: [255, 255, 0],
        orange: [255, 165, 0],
        gray: [128, 128, 128],
        purple: [128, 0, 128],
        green: [0, 128, 0],
        red: [255, 0, 0],
        pink: [255, 192, 203],
        cyan: [0, 255, 255],
        transparent: [255, 255, 255, 0],
      },
      Ln = function (e, t, n) {
        return (
          (255 *
            (6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1
              ? t + (n - t) * e * 6
              : e < 0.5
              ? n
              : 3 * e < 2
              ? t + (n - t) * (2 / 3 - e) * 6
              : t) +
            0.5) |
          0
        );
      },
      jn = function (e, t, n) {
        var i,
          r,
          s,
          a,
          o,
          l,
          c,
          u,
          d,
          p,
          f = e ? (et(e) ? [e >> 16, (e >> 8) & 255, 255 & e] : 0) : In.black;
        if (!f) {
          if (("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), In[e]))
            f = In[e];
          else if ("#" === e.charAt(0)) {
            if (
              (e.length < 6 &&
                ((i = e.charAt(1)),
                (r = e.charAt(2)),
                (s = e.charAt(3)),
                (e =
                  "#" +
                  i +
                  i +
                  r +
                  r +
                  s +
                  s +
                  (5 === e.length ? e.charAt(4) + e.charAt(4) : ""))),
              9 === e.length)
            )
              return [
                (f = parseInt(e.substr(1, 6), 16)) >> 16,
                (f >> 8) & 255,
                255 & f,
                parseInt(e.substr(7), 16) / 255,
              ];
            f = [
              (e = parseInt(e.substr(1), 16)) >> 16,
              (e >> 8) & 255,
              255 & e,
            ];
          } else if ("hsl" === e.substr(0, 3))
            if (((f = p = e.match(lt)), t)) {
              if (~e.indexOf("="))
                return (f = e.match(ct)), n && f.length < 4 && (f[3] = 1), f;
            } else
              (a = (+f[0] % 360) / 360),
                (o = +f[1] / 100),
                (i =
                  2 * (l = +f[2] / 100) -
                  (r = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                f.length > 3 && (f[3] *= 1),
                (f[0] = Ln(a + 1 / 3, i, r)),
                (f[1] = Ln(a, i, r)),
                (f[2] = Ln(a - 1 / 3, i, r));
          else f = e.match(lt) || In.transparent;
          f = f.map(Number);
        }
        return (
          t &&
            !p &&
            ((i = f[0] / 255),
            (r = f[1] / 255),
            (s = f[2] / 255),
            (l = ((c = Math.max(i, r, s)) + (u = Math.min(i, r, s))) / 2),
            c === u
              ? (a = o = 0)
              : ((d = c - u),
                (o = l > 0.5 ? d / (2 - c - u) : d / (c + u)),
                (a =
                  c === i
                    ? (r - s) / d + (r < s ? 6 : 0)
                    : c === r
                    ? (s - i) / d + 2
                    : (i - r) / d + 4),
                (a *= 60)),
            (f[0] = ~~(a + 0.5)),
            (f[1] = ~~(100 * o + 0.5)),
            (f[2] = ~~(100 * l + 0.5))),
          n && f.length < 4 && (f[3] = 1),
          f
        );
      },
      Nn = function (e) {
        var t = [],
          n = [],
          i = -1;
        return (
          e.split($n).forEach(function (e) {
            var r = e.match(ut) || [];
            t.push.apply(t, r), n.push((i += r.length + 1));
          }),
          (t.c = n),
          t
        );
      },
      Bn = function (e, t, n) {
        var i,
          r,
          s,
          a,
          o = "",
          l = (e + o).match($n),
          c = t ? "hsla(" : "rgba(",
          u = 0;
        if (!l) return e;
        if (
          ((l = l.map(function (e) {
            return (
              (e = jn(e, t, 1)) &&
              c +
                (t
                  ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3]
                  : e.join(",")) +
                ")"
            );
          })),
          n && ((s = Nn(e)), (i = n.c).join(o) !== s.c.join(o)))
        )
          for (a = (r = e.replace($n, "1").split(ut)).length - 1; u < a; u++)
            o +=
              r[u] +
              (~i.indexOf(u)
                ? l.shift() || c + "0,0,0,0)"
                : (s.length ? s : l.length ? l : n).shift());
        if (!r)
          for (a = (r = e.split($n)).length - 1; u < a; u++) o += r[u] + l[u];
        return o + r[a];
      },
      $n = (function () {
        var e,
          t =
            "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
        for (e in In) t += "|" + e + "\\b";
        return new RegExp(t + ")", "gi");
      })(),
      zn = /hsl[a]?\(/,
      Rn = function (e) {
        var t,
          n = e.join(" ");
        if ((($n.lastIndex = 0), $n.test(n)))
          return (
            (t = zn.test(n)),
            (e[1] = Bn(e[1], t)),
            (e[0] = Bn(e[0], t, Nn(e[1]))),
            !0
          );
      },
      Hn = (function () {
        var e,
          t,
          n,
          i,
          r,
          s,
          a = Date.now,
          o = 500,
          l = 33,
          c = a(),
          u = c,
          d = 1e3 / 240,
          p = d,
          f = [],
          h = function n(h) {
            var m,
              g,
              v,
              y,
              b = a() - u,
              _ = !0 === h;
            if (
              (b > o && (c += b - l),
              ((m = (v = (u += b) - c) - p) > 0 || _) &&
                ((y = ++i.frame),
                (r = v - 1e3 * i.time),
                (i.time = v /= 1e3),
                (p += m + (m >= d ? 4 : d - m)),
                (g = 1)),
              _ || (e = t(n)),
              g)
            )
              for (s = 0; s < f.length; s++) f[s](v, r, y, h);
          };
        return (i = {
          time: 0,
          frame: 0,
          tick: function () {
            h(!0);
          },
          deltaRatio: function (e) {
            return r / (1e3 / (e || 60));
          },
          wake: function () {
            je &&
              (!Ie &&
                rt() &&
                ((De = Ie = window),
                (Le = De.document || {}),
                (mt.gsap = Ai),
                (De.gsapVersions || (De.gsapVersions = [])).push(Ai.version),
                vt(gt || De.GreenSockGlobals || (!De.gsap && De) || {}),
                (n = De.requestAnimationFrame)),
              e && i.sleep(),
              (t =
                n ||
                function (e) {
                  return setTimeout(e, (p - 1e3 * i.time + 1) | 0);
                }),
              ($e = 1),
              h(2));
          },
          sleep: function () {
            (n ? De.cancelAnimationFrame : clearTimeout)(e), ($e = 0), (t = wt);
          },
          lagSmoothing: function (e, t) {
            (o = e || 1 / 1e-8), (l = Math.min(t, o, 0));
          },
          fps: function (e) {
            (d = 1e3 / (e || 240)), (p = 1e3 * i.time + d);
          },
          add: function (e, t, n) {
            var r = t
              ? function (t, n, s, a) {
                  e(t, n, s, a), i.remove(r);
                }
              : e;
            return i.remove(e), f[n ? "unshift" : "push"](r), Fn(), r;
          },
          remove: function (e, t) {
            ~(t = f.indexOf(e)) && f.splice(t, 1) && s >= t && s--;
          },
          _listeners: f,
        });
      })(),
      Fn = function () {
        return !$e && Hn.wake();
      },
      qn = {},
      Wn = /^[\d.\-M][\d.\-,\s]/,
      Vn = /["']/g,
      Gn = function (e) {
        for (
          var t,
            n,
            i,
            r = {},
            s = e.substr(1, e.length - 3).split(":"),
            a = s[0],
            o = 1,
            l = s.length;
          o < l;
          o++
        )
          (n = s[o]),
            (t = o !== l - 1 ? n.lastIndexOf(",") : n.length),
            (i = n.substr(0, t)),
            (r[a] = isNaN(i) ? i.replace(Vn, "").trim() : +i),
            (a = n.substr(t + 1).trim());
        return r;
      },
      Xn = function (e) {
        return function (t) {
          return 1 - e(1 - t);
        };
      },
      Yn = function e(t, n) {
        for (var i, r = t._first; r; )
          r instanceof ni
            ? e(r, n)
            : !r.vars.yoyoEase ||
              (r._yoyo && r._repeat) ||
              r._yoyo === n ||
              (r.timeline
                ? e(r.timeline, n)
                : ((i = r._ease),
                  (r._ease = r._yEase),
                  (r._yEase = i),
                  (r._yoyo = n))),
            (r = r._next);
      },
      Un = function (e, t) {
        return (
          (e &&
            (Ze(e)
              ? e
              : qn[e] ||
                (function (e) {
                  var t,
                    n,
                    i,
                    r,
                    s = (e + "").split("("),
                    a = qn[s[0]];
                  return a && s.length > 1 && a.config
                    ? a.config.apply(
                        null,
                        ~e.indexOf("{")
                          ? [Gn(s[1])]
                          : ((t = e),
                            (n = t.indexOf("(") + 1),
                            (i = t.indexOf(")")),
                            (r = t.indexOf("(", n)),
                            t.substring(
                              n,
                              ~r && r < i ? t.indexOf(")", i + 1) : i
                            ))
                              .split(",")
                              .map(Rt)
                      )
                    : qn._CE && Wn.test(e)
                    ? qn._CE("", e)
                    : a;
                })(e))) ||
          t
        );
      },
      Qn = function (e, t, n, i) {
        void 0 === n &&
          (n = function (e) {
            return 1 - t(1 - e);
          }),
          void 0 === i &&
            (i = function (e) {
              return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
            });
        var r,
          s = {
            easeIn: t,
            easeOut: n,
            easeInOut: i,
          };
        return (
          It(e, function (e) {
            for (var t in ((qn[e] = mt[e] = s),
            (qn[(r = e.toLowerCase())] = n),
            s))
              qn[
                r +
                  ("easeIn" === t ? ".in" : "easeOut" === t ? ".out" : ".inOut")
              ] = qn[e + "." + t] = s[t];
          }),
          s
        );
      },
      Jn = function (e) {
        return function (t) {
          return t < 0.5 ? (1 - e(1 - 2 * t)) / 2 : 0.5 + e(2 * (t - 0.5)) / 2;
        };
      },
      Kn = function e(t, n, i) {
        var r = n >= 1 ? n : 1,
          s = (i || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1),
          a = (s / Ge) * (Math.asin(1 / r) || 0),
          o = function (e) {
            return 1 === e ? 1 : r * Math.pow(2, -10 * e) * Je((e - a) * s) + 1;
          },
          l =
            "out" === t
              ? o
              : "in" === t
              ? function (e) {
                  return 1 - o(1 - e);
                }
              : Jn(o);
        return (
          (s = Ge / s),
          (l.config = function (n, i) {
            return e(t, n, i);
          }),
          l
        );
      },
      Zn = function e(t, n) {
        void 0 === n && (n = 1.70158);
        var i = function (e) {
            return e ? --e * e * ((n + 1) * e + n) + 1 : 0;
          },
          r =
            "out" === t
              ? i
              : "in" === t
              ? function (e) {
                  return 1 - i(1 - e);
                }
              : Jn(i);
        return (
          (r.config = function (n) {
            return e(t, n);
          }),
          r
        );
      };
    It("Linear,Quad,Cubic,Quart,Quint,Strong", function (e, t) {
      var n = t < 5 ? t + 1 : t;
      Qn(
        e + ",Power" + (n - 1),
        t
          ? function (e) {
              return Math.pow(e, n);
            }
          : function (e) {
              return e;
            },
        function (e) {
          return 1 - Math.pow(1 - e, n);
        },
        function (e) {
          return e < 0.5
            ? Math.pow(2 * e, n) / 2
            : 1 - Math.pow(2 * (1 - e), n) / 2;
        }
      );
    }),
      (qn.Linear.easeNone = qn.none = qn.Linear.easeIn),
      Qn("Elastic", Kn("in"), Kn("out"), Kn()),
      (ze = 7.5625),
      (He = 1 / (Re = 2.75)),
      Qn(
        "Bounce",
        function (e) {
          return 1 - Fe(1 - e);
        },
        (Fe = function (e) {
          return e < He
            ? ze * e * e
            : e < 0.7272727272727273
            ? ze * Math.pow(e - 1.5 / Re, 2) + 0.75
            : e < 0.9090909090909092
            ? ze * (e -= 2.25 / Re) * e + 0.9375
            : ze * Math.pow(e - 2.625 / Re, 2) + 0.984375;
        })
      ),
      Qn("Expo", function (e) {
        return e ? Math.pow(2, 10 * (e - 1)) : 0;
      }),
      Qn("Circ", function (e) {
        return -(Ue(1 - e * e) - 1);
      }),
      Qn("Sine", function (e) {
        return 1 === e ? 1 : 1 - Qe(e * Xe);
      }),
      Qn("Back", Zn("in"), Zn("out"), Zn()),
      (qn.SteppedEase =
        qn.steps =
        mt.SteppedEase =
          {
            config: function (e, t) {
              void 0 === e && (e = 1);
              var n = 1 / e,
                i = e + (t ? 0 : 1),
                r = t ? 1 : 0;
              return function (e) {
                return (((i * mn(0, 1 - 1e-8, e)) | 0) + r) * n;
              };
            },
          }),
      (We.ease = qn["quad.out"]),
      It(
        "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
        function (e) {
          return (Pt += e + "," + e + "Params,");
        }
      );
    var ei = function (e, t) {
        (this.id = Ye++),
          (e._gsap = this),
          (this.target = e),
          (this.harness = t),
          (this.get = t ? t.get : Dt),
          (this.set = t ? t.getSetter : yi);
      },
      ti = (function () {
        function e(e) {
          (this.vars = e),
            (this._delay = +e.delay || 0),
            (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) &&
              ((this._rDelay = e.repeatDelay || 0),
              (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
            (this._ts = 1),
            cn(this, +e.duration, 1, 1),
            (this.data = e.data),
            $e || Hn.wake();
        }
        var t = e.prototype;
        return (
          (t.delay = function (e) {
            return e || 0 === e
              ? (this.parent &&
                  this.parent.smoothChildTiming &&
                  this.startTime(this._start + e - this._delay),
                (this._delay = e),
                this)
              : this._delay;
          }),
          (t.duration = function (e) {
            return arguments.length
              ? this.totalDuration(
                  this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e
                )
              : this.totalDuration() && this._dur;
          }),
          (t.totalDuration = function (e) {
            return arguments.length
              ? ((this._dirty = 0),
                cn(
                  this,
                  this._repeat < 0
                    ? e
                    : (e - this._repeat * this._rDelay) / (this._repeat + 1)
                ))
              : this._tDur;
          }),
          (t.totalTime = function (e, t) {
            if ((Fn(), !arguments.length)) return this._tTime;
            var n = this._dp;
            if (n && n.smoothChildTiming && this._ts) {
              for (
                nn(this, e), !n._dp || n.parent || rn(n, this);
                n && n.parent;

              )
                n.parent._time !==
                  n._start +
                    (n._ts >= 0
                      ? n._tTime / n._ts
                      : (n.totalDuration() - n._tTime) / -n._ts) &&
                  n.totalTime(n._tTime, !0),
                  (n = n.parent);
              !this.parent &&
                this._dp.autoRemoveChildren &&
                ((this._ts > 0 && e < this._tDur) ||
                  (this._ts < 0 && e > 0) ||
                  (!this._tDur && !e)) &&
                sn(this._dp, this, this._start - this._delay);
            }
            return (
              (this._tTime !== e ||
                (!this._dur && !t) ||
                (this._initted && 1e-8 === Math.abs(this._zTime)) ||
                (!e && !this._initted && (this.add || this._ptLookup))) &&
                (this._ts || (this._pTime = e), zt(this, e, t)),
              this
            );
          }),
          (t.time = function (e, t) {
            return arguments.length
              ? this.totalTime(
                  Math.min(this.totalDuration(), e + Kt(this)) %
                    (this._dur + this._rDelay) || (e ? this._dur : 0),
                  t
                )
              : this._time;
          }),
          (t.totalProgress = function (e, t) {
            return arguments.length
              ? this.totalTime(this.totalDuration() * e, t)
              : this.totalDuration()
              ? Math.min(1, this._tTime / this._tDur)
              : this.ratio;
          }),
          (t.progress = function (e, t) {
            return arguments.length
              ? this.totalTime(
                  this.duration() *
                    (!this._yoyo || 1 & this.iteration() ? e : 1 - e) +
                    Kt(this),
                  t
                )
              : this.duration()
              ? Math.min(1, this._time / this._dur)
              : this.ratio;
          }),
          (t.iteration = function (e, t) {
            var n = this.duration() + this._rDelay;
            return arguments.length
              ? this.totalTime(this._time + (e - 1) * n, t)
              : this._repeat
              ? Zt(this._tTime, n) + 1
              : 1;
          }),
          (t.timeScale = function (e) {
            if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
            if (this._rts === e) return this;
            var t =
              this.parent && this._ts
                ? en(this.parent._time, this)
                : this._tTime;
            return (
              (this._rts = +e || 0),
              (this._ts = this._ps || -1e-8 === e ? 0 : this._rts),
              this.totalTime(mn(-this._delay, this._tDur, t), !0),
              tn(this),
              Jt(this)
            );
          }),
          (t.paused = function (e) {
            return arguments.length
              ? (this._ps !== e &&
                  ((this._ps = e),
                  e
                    ? ((this._pTime =
                        this._tTime || Math.max(-this._delay, this.rawTime())),
                      (this._ts = this._act = 0))
                    : (Fn(),
                      (this._ts = this._rts),
                      this.totalTime(
                        this.parent && !this.parent.smoothChildTiming
                          ? this.rawTime()
                          : this._tTime || this._pTime,
                        1 === this.progress() &&
                          1e-8 !== Math.abs(this._zTime) &&
                          (this._tTime -= 1e-8)
                      ))),
                this)
              : this._ps;
          }),
          (t.startTime = function (e) {
            if (arguments.length) {
              this._start = e;
              var t = this.parent || this._dp;
              return (
                t && (t._sort || !this.parent) && sn(t, this, e - this._delay),
                this
              );
            }
            return this._start;
          }),
          (t.endTime = function (e) {
            return (
              this._start +
              (it(e) ? this.totalDuration() : this.duration()) /
                Math.abs(this._ts || 1)
            );
          }),
          (t.rawTime = function (e) {
            var t = this.parent || this._dp;
            return t
              ? e &&
                (!this._ts ||
                  (this._repeat && this._time && this.totalProgress() < 1))
                ? this._tTime % (this._dur + this._rDelay)
                : this._ts
                ? en(t.rawTime(e), this)
                : this._tTime
              : this._tTime;
          }),
          (t.globalTime = function (e) {
            for (var t = this, n = arguments.length ? e : t.rawTime(); t; )
              (n = t._start + n / (t._ts || 1)), (t = t._dp);
            return n;
          }),
          (t.repeat = function (e) {
            return arguments.length
              ? ((this._repeat = e === 1 / 0 ? -2 : e), un(this))
              : -2 === this._repeat
              ? 1 / 0
              : this._repeat;
          }),
          (t.repeatDelay = function (e) {
            if (arguments.length) {
              var t = this._time;
              return (this._rDelay = e), un(this), t ? this.time(t) : this;
            }
            return this._rDelay;
          }),
          (t.yoyo = function (e) {
            return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
          }),
          (t.seek = function (e, t) {
            return this.totalTime(pn(this, e), it(t));
          }),
          (t.restart = function (e, t) {
            return this.play().totalTime(e ? -this._delay : 0, it(t));
          }),
          (t.play = function (e, t) {
            return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
          }),
          (t.reverse = function (e, t) {
            return (
              null != e && this.seek(e || this.totalDuration(), t),
              this.reversed(!0).paused(!1)
            );
          }),
          (t.pause = function (e, t) {
            return null != e && this.seek(e, t), this.paused(!0);
          }),
          (t.resume = function () {
            return this.paused(!1);
          }),
          (t.reversed = function (e) {
            return arguments.length
              ? (!!e !== this.reversed() &&
                  this.timeScale(-this._rts || (e ? -1e-8 : 0)),
                this)
              : this._rts < 0;
          }),
          (t.invalidate = function () {
            return (this._initted = this._act = 0), (this._zTime = -1e-8), this;
          }),
          (t.isActive = function () {
            var e,
              t = this.parent || this._dp,
              n = this._start;
            return !(
              t &&
              !(
                this._ts &&
                this._initted &&
                t.isActive() &&
                (e = t.rawTime(!0)) >= n &&
                e < this.endTime(!0) - 1e-8
              )
            );
          }),
          (t.eventCallback = function (e, t, n) {
            var i = this.vars;
            return arguments.length > 1
              ? (t
                  ? ((i[e] = t),
                    n && (i[e + "Params"] = n),
                    "onUpdate" === e && (this._onUpdate = t))
                  : delete i[e],
                this)
              : i[e];
          }),
          (t.then = function (e) {
            var t = this;
            return new Promise(function (n) {
              var i = Ze(e) ? e : Ht,
                r = function () {
                  var e = t.then;
                  (t.then = null),
                    Ze(i) && (i = i(t)) && (i.then || i === t) && (t.then = e),
                    n(i),
                    (t.then = e);
                };
              (t._initted && 1 === t.totalProgress() && t._ts >= 0) ||
              (!t._tTime && t._ts < 0)
                ? r()
                : (t._prom = r);
            });
          }),
          (t.kill = function () {
            An(this);
          }),
          e
        );
      })();
    Ft(ti.prototype, {
      _time: 0,
      _start: 0,
      _end: 0,
      _tTime: 0,
      _tDur: 0,
      _dirty: 0,
      _repeat: 0,
      _yoyo: !1,
      parent: null,
      _initted: !1,
      _rDelay: 0,
      _ts: 1,
      _dp: 0,
      ratio: 0,
      _zTime: -1e-8,
      _prom: 0,
      _ps: !1,
      _rts: 1,
    });
    var ni = (function (e) {
      function t(t, n) {
        var i;
        return (
          void 0 === t && (t = {}),
          ((i = e.call(this, t) || this).labels = {}),
          (i.smoothChildTiming = !!t.smoothChildTiming),
          (i.autoRemoveChildren = !!t.autoRemoveChildren),
          (i._sort = it(t.sortChildren)),
          Ae && sn(t.parent || Ae, Oe(i), n),
          t.reversed && i.reverse(),
          t.paused && i.paused(!0),
          t.scrollTrigger && an(Oe(i), t.scrollTrigger),
          i
        );
      }
      Pe(t, e);
      var n = t.prototype;
      return (
        (n.to = function (e, t, n) {
          return fn(0, arguments, this), this;
        }),
        (n.from = function (e, t, n) {
          return fn(1, arguments, this), this;
        }),
        (n.fromTo = function (e, t, n, i) {
          return fn(2, arguments, this), this;
        }),
        (n.set = function (e, t, n) {
          return (
            (t.duration = 0),
            (t.parent = this),
            Gt(t).repeatDelay || (t.repeat = 0),
            (t.immediateRender = !!t.immediateRender),
            new fi(e, t, pn(this, n), 1),
            this
          );
        }),
        (n.call = function (e, t, n) {
          return sn(this, fi.delayedCall(0, e, t), n);
        }),
        (n.staggerTo = function (e, t, n, i, r, s, a) {
          return (
            (n.duration = t),
            (n.stagger = n.stagger || i),
            (n.onComplete = s),
            (n.onCompleteParams = a),
            (n.parent = this),
            new fi(e, n, pn(this, r)),
            this
          );
        }),
        (n.staggerFrom = function (e, t, n, i, r, s, a) {
          return (
            (n.runBackwards = 1),
            (Gt(n).immediateRender = it(n.immediateRender)),
            this.staggerTo(e, t, n, i, r, s, a)
          );
        }),
        (n.staggerFromTo = function (e, t, n, i, r, s, a, o) {
          return (
            (i.startAt = n),
            (Gt(i).immediateRender = it(i.immediateRender)),
            this.staggerTo(e, t, i, r, s, a, o)
          );
        }),
        (n.render = function (e, t, n) {
          var i,
            r,
            s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m = this._time,
            g = this._dirty ? this.totalDuration() : this._tDur,
            v = this._dur,
            y = e <= 0 ? 0 : jt(e),
            b = this._zTime < 0 != e < 0 && (this._initted || !v);
          if (
            (this !== Ae && y > g && e >= 0 && (y = g),
            y !== this._tTime || n || b)
          ) {
            if (
              (m !== this._time &&
                v &&
                ((y += this._time - m), (e += this._time - m)),
              (i = y),
              (d = this._start),
              (l = !(u = this._ts)),
              b && (v || (m = this._zTime), (e || !t) && (this._zTime = e)),
              this._repeat)
            ) {
              if (
                ((f = this._yoyo),
                (o = v + this._rDelay),
                this._repeat < -1 && e < 0)
              )
                return this.totalTime(100 * o + e, t, n);
              if (
                ((i = jt(y % o)),
                y === g
                  ? ((a = this._repeat), (i = v))
                  : ((a = ~~(y / o)) && a === y / o && ((i = v), a--),
                    i > v && (i = v)),
                (p = Zt(this._tTime, o)),
                !m && this._tTime && p !== a && (p = a),
                f && 1 & a && ((i = v - i), (h = 1)),
                a !== p && !this._lock)
              ) {
                var _ = f && 1 & p,
                  w = _ === (f && 1 & a);
                if (
                  (a < p && (_ = !_),
                  (m = _ ? 0 : v),
                  (this._lock = 1),
                  (this.render(m || (h ? 0 : jt(a * o)), t, !v)._lock = 0),
                  (this._tTime = y),
                  !t && this.parent && Mn(this, "onRepeat"),
                  this.vars.repeatRefresh &&
                    !h &&
                    (this.invalidate()._lock = 1),
                  (m && m !== this._time) ||
                    l !== !this._ts ||
                    (this.vars.onRepeat && !this.parent && !this._act))
                )
                  return this;
                if (
                  ((v = this._dur),
                  (g = this._tDur),
                  w &&
                    ((this._lock = 2),
                    (m = _ ? v : -1e-4),
                    this.render(m, !0),
                    this.vars.repeatRefresh && !h && this.invalidate()),
                  (this._lock = 0),
                  !this._ts && !l)
                )
                  return this;
                Yn(this, h);
              }
            }
            if (
              (this._hasPause &&
                !this._forcing &&
                this._lock < 2 &&
                (c = (function (e, t, n) {
                  var i;
                  if (n > t)
                    for (i = e._first; i && i._start <= n; ) {
                      if ("isPause" === i.data && i._start > t) return i;
                      i = i._next;
                    }
                  else
                    for (i = e._last; i && i._start >= n; ) {
                      if ("isPause" === i.data && i._start < t) return i;
                      i = i._prev;
                    }
                })(this, jt(m), jt(i))) &&
                (y -= i - (i = c._start)),
              (this._tTime = y),
              (this._time = i),
              (this._act = !u),
              this._initted ||
                ((this._onUpdate = this.vars.onUpdate),
                (this._initted = 1),
                (this._zTime = e),
                (m = 0)),
              !m && i && !t && (Mn(this, "onStart"), this._tTime !== y))
            )
              return this;
            if (i >= m && e >= 0)
              for (r = this._first; r; ) {
                if (
                  ((s = r._next), (r._act || i >= r._start) && r._ts && c !== r)
                ) {
                  if (r.parent !== this) return this.render(e, t, n);
                  if (
                    (r.render(
                      r._ts > 0
                        ? (i - r._start) * r._ts
                        : (r._dirty ? r.totalDuration() : r._tDur) +
                            (i - r._start) * r._ts,
                      t,
                      n
                    ),
                    i !== this._time || (!this._ts && !l))
                  ) {
                    (c = 0), s && (y += this._zTime = -1e-8);
                    break;
                  }
                }
                r = s;
              }
            else {
              r = this._last;
              for (var x = e < 0 ? e : i; r; ) {
                if (
                  ((s = r._prev), (r._act || x <= r._end) && r._ts && c !== r)
                ) {
                  if (r.parent !== this) return this.render(e, t, n);
                  if (
                    (r.render(
                      r._ts > 0
                        ? (x - r._start) * r._ts
                        : (r._dirty ? r.totalDuration() : r._tDur) +
                            (x - r._start) * r._ts,
                      t,
                      n
                    ),
                    i !== this._time || (!this._ts && !l))
                  ) {
                    (c = 0), s && (y += this._zTime = x ? -1e-8 : 1e-8);
                    break;
                  }
                }
                r = s;
              }
            }
            if (
              c &&
              !t &&
              (this.pause(),
              (c.render(i >= m ? 0 : -1e-8)._zTime = i >= m ? 1 : -1),
              this._ts)
            )
              return (this._start = d), tn(this), this.render(e, t, n);
            this._onUpdate && !t && Mn(this, "onUpdate", !0),
              ((y === g && this._tTime >= this.totalDuration()) || (!y && m)) &&
                ((d !== this._start && Math.abs(u) === Math.abs(this._ts)) ||
                  this._lock ||
                  ((e || !v) &&
                    ((y === g && this._ts > 0) || (!y && this._ts < 0)) &&
                    Ut(this, 1),
                  t ||
                    (e < 0 && !m) ||
                    (!y && !m && g) ||
                    (Mn(
                      this,
                      y === g && e >= 0 ? "onComplete" : "onReverseComplete",
                      !0
                    ),
                    this._prom &&
                      !(y < g && this.timeScale() > 0) &&
                      this._prom())));
          }
          return this;
        }),
        (n.add = function (e, t) {
          var n = this;
          if ((et(t) || (t = pn(this, t, e)), !(e instanceof ti))) {
            if (ot(e))
              return (
                e.forEach(function (e) {
                  return n.add(e, t);
                }),
                this
              );
            if (Ke(e)) return this.addLabel(e, t);
            if (!Ze(e)) return this;
            e = fi.delayedCall(0, e);
          }
          return this !== e ? sn(this, e, t) : this;
        }),
        (n.getChildren = function (e, t, n, i) {
          void 0 === e && (e = !0),
            void 0 === t && (t = !0),
            void 0 === n && (n = !0),
            void 0 === i && (i = -Ve);
          for (var r = [], s = this._first; s; )
            s._start >= i &&
              (s instanceof fi
                ? t && r.push(s)
                : (n && r.push(s),
                  e && r.push.apply(r, s.getChildren(!0, t, n)))),
              (s = s._next);
          return r;
        }),
        (n.getById = function (e) {
          for (var t = this.getChildren(1, 1, 1), n = t.length; n--; )
            if (t[n].vars.id === e) return t[n];
        }),
        (n.remove = function (e) {
          return Ke(e)
            ? this.removeLabel(e)
            : Ze(e)
            ? this.killTweensOf(e)
            : (Yt(this, e),
              e === this._recent && (this._recent = this._last),
              Qt(this));
        }),
        (n.totalTime = function (t, n) {
          return arguments.length
            ? ((this._forcing = 1),
              !this._dp &&
                this._ts &&
                (this._start = jt(
                  Hn.time -
                    (this._ts > 0
                      ? t / this._ts
                      : (this.totalDuration() - t) / -this._ts)
                )),
              e.prototype.totalTime.call(this, t, n),
              (this._forcing = 0),
              this)
            : this._tTime;
        }),
        (n.addLabel = function (e, t) {
          return (this.labels[e] = pn(this, t)), this;
        }),
        (n.removeLabel = function (e) {
          return delete this.labels[e], this;
        }),
        (n.addPause = function (e, t, n) {
          var i = fi.delayedCall(0, t || wt, n);
          return (
            (i.data = "isPause"), (this._hasPause = 1), sn(this, i, pn(this, e))
          );
        }),
        (n.removePause = function (e) {
          var t = this._first;
          for (e = pn(this, e); t; )
            t._start === e && "isPause" === t.data && Ut(t), (t = t._next);
        }),
        (n.killTweensOf = function (e, t, n) {
          for (var i = this.getTweensOf(e, n), r = i.length; r--; )
            ii !== i[r] && i[r].kill(e, t);
          return this;
        }),
        (n.getTweensOf = function (e, t) {
          for (var n, i = [], r = _n(e), s = this._first, a = et(t); s; )
            s instanceof fi
              ? Bt(s._targets, r) &&
                (a
                  ? (!ii || (s._initted && s._ts)) &&
                    s.globalTime(0) <= t &&
                    s.globalTime(s.totalDuration()) > t
                  : !t || s.isActive()) &&
                i.push(s)
              : (n = s.getTweensOf(r, t)).length && i.push.apply(i, n),
              (s = s._next);
          return i;
        }),
        (n.tweenTo = function (e, t) {
          t = t || {};
          var n,
            i = this,
            r = pn(i, e),
            s = t,
            a = s.startAt,
            o = s.onStart,
            l = s.onStartParams,
            c = s.immediateRender,
            u = fi.to(
              i,
              Ft(
                {
                  ease: t.ease || "none",
                  lazy: !1,
                  immediateRender: !1,
                  time: r,
                  overwrite: "auto",
                  duration:
                    t.duration ||
                    Math.abs(
                      (r - (a && "time" in a ? a.time : i._time)) /
                        i.timeScale()
                    ) ||
                    1e-8,
                  onStart: function () {
                    if ((i.pause(), !n)) {
                      var e =
                        t.duration ||
                        Math.abs(
                          (r - (a && "time" in a ? a.time : i._time)) /
                            i.timeScale()
                        );
                      u._dur !== e && cn(u, e, 0, 1).render(u._time, !0, !0),
                        (n = 1);
                    }
                    o && o.apply(u, l || []);
                  },
                },
                t
              )
            );
          return c ? u.render(0) : u;
        }),
        (n.tweenFromTo = function (e, t, n) {
          return this.tweenTo(
            t,
            Ft(
              {
                startAt: {
                  time: pn(this, e),
                },
              },
              n
            )
          );
        }),
        (n.recent = function () {
          return this._recent;
        }),
        (n.nextLabel = function (e) {
          return void 0 === e && (e = this._time), Pn(this, pn(this, e));
        }),
        (n.previousLabel = function (e) {
          return void 0 === e && (e = this._time), Pn(this, pn(this, e), 1);
        }),
        (n.currentLabel = function (e) {
          return arguments.length
            ? this.seek(e, !0)
            : this.previousLabel(this._time + 1e-8);
        }),
        (n.shiftChildren = function (e, t, n) {
          void 0 === n && (n = 0);
          for (var i, r = this._first, s = this.labels; r; )
            r._start >= n && ((r._start += e), (r._end += e)), (r = r._next);
          if (t) for (i in s) s[i] >= n && (s[i] += e);
          return Qt(this);
        }),
        (n.invalidate = function () {
          var t = this._first;
          for (this._lock = 0; t; ) t.invalidate(), (t = t._next);
          return e.prototype.invalidate.call(this);
        }),
        (n.clear = function (e) {
          void 0 === e && (e = !0);
          for (var t, n = this._first; n; )
            (t = n._next), this.remove(n), (n = t);
          return (
            this._dp && (this._time = this._tTime = this._pTime = 0),
            e && (this.labels = {}),
            Qt(this)
          );
        }),
        (n.totalDuration = function (e) {
          var t,
            n,
            i,
            r = 0,
            s = this,
            a = s._last,
            o = Ve;
          if (arguments.length)
            return s.timeScale(
              (s._repeat < 0 ? s.duration() : s.totalDuration()) /
                (s.reversed() ? -e : e)
            );
          if (s._dirty) {
            for (i = s.parent; a; )
              (t = a._prev),
                a._dirty && a.totalDuration(),
                (n = a._start) > o && s._sort && a._ts && !s._lock
                  ? ((s._lock = 1), (sn(s, a, n - a._delay, 1)._lock = 0))
                  : (o = n),
                n < 0 &&
                  a._ts &&
                  ((r -= n),
                  ((!i && !s._dp) || (i && i.smoothChildTiming)) &&
                    ((s._start += n / s._ts), (s._time -= n), (s._tTime -= n)),
                  s.shiftChildren(-n, !1, -Infinity),
                  (o = 0)),
                a._end > r && a._ts && (r = a._end),
                (a = t);
            cn(s, s === Ae && s._time > r ? s._time : r, 1, 1), (s._dirty = 0);
          }
          return s._tDur;
        }),
        (t.updateRoot = function (e) {
          if (
            (Ae._ts && (zt(Ae, en(e, Ae)), (Ne = Hn.frame)), Hn.frame >= Et)
          ) {
            Et += qe.autoSleep || 120;
            var t = Ae._first;
            if ((!t || !t._ts) && qe.autoSleep && Hn._listeners.length < 2) {
              for (; t && !t._ts; ) t = t._next;
              t || Hn.sleep();
            }
          }
        }),
        t
      );
    })(ti);
    Ft(ni.prototype, {
      _lock: 0,
      _hasPause: 0,
      _forcing: 0,
    });
    var ii,
      ri,
      si = function (e, t, n, i, r, s, a) {
        var o,
          l,
          c,
          u,
          d,
          p,
          f,
          h,
          m = new Ei(this._pt, e, t, 0, 1, wi, null, r),
          g = 0,
          v = 0;
        for (
          m.b = n,
            m.e = i,
            n += "",
            (f = ~(i += "").indexOf("random(")) && (i = En(i)),
            s && (s((h = [n, i]), e, t), (n = h[0]), (i = h[1])),
            l = n.match(dt) || [];
          (o = dt.exec(i));

        )
          (u = o[0]),
            (d = i.substring(g, o.index)),
            c ? (c = (c + 1) % 5) : "rgba(" === d.substr(-5) && (c = 1),
            u !== l[v++] &&
              ((p = parseFloat(l[v - 1]) || 0),
              (m._pt = {
                _next: m._pt,
                p: d || 1 === v ? d : ",",
                s: p,
                c: "=" === u.charAt(1) ? Nt(p, u) - p : parseFloat(u) - p,
                m: c && c < 4 ? Math.round : 0,
              }),
              (g = dt.lastIndex));
        return (
          (m.c = g < i.length ? i.substring(g, i.length) : ""),
          (m.fp = a),
          (pt.test(i) || f) && (m.e = 0),
          (this._pt = m),
          m
        );
      },
      ai = function (e, t, n, i, r, s, a, o, l) {
        Ze(i) && (i = i(r || 0, e, s));
        var c,
          u = e[t],
          d =
            "get" !== n
              ? n
              : Ze(u)
              ? l
                ? e[
                    t.indexOf("set") || !Ze(e["get" + t.substr(3)])
                      ? t
                      : "get" + t.substr(3)
                  ](l)
                : e[t]()
              : u,
          p = Ze(u) ? (l ? gi : mi) : hi;
        if (
          (Ke(i) &&
            (~i.indexOf("random(") && (i = En(i)),
            "=" === i.charAt(1) &&
              ((c = Nt(d, i) + (gn(d) || 0)) || 0 === c) &&
              (i = c)),
          d !== i || ri)
        )
          return isNaN(d * i) || "" === i
            ? (!u && !(t in e) && yt(t, i),
              si.call(this, e, t, d, i, p, o || qe.stringFilter, l))
            : ((c = new Ei(
                this._pt,
                e,
                t,
                +d || 0,
                i - (d || 0),
                "boolean" == typeof u ? _i : bi,
                0,
                p
              )),
              l && (c.fp = l),
              a && c.modifier(a, this, e),
              (this._pt = c));
      },
      oi = function (e, t, n, i, r, s) {
        var a, o, l, c;
        if (
          kt[e] &&
          !1 !==
            (a = new kt[e]()).init(
              r,
              a.rawVars
                ? t[e]
                : (function (e, t, n, i, r) {
                    if (
                      (Ze(e) && (e = ui(e, r, t, n, i)),
                      !nt(e) || (e.style && e.nodeType) || ot(e) || at(e))
                    )
                      return Ke(e) ? ui(e, r, t, n, i) : e;
                    var s,
                      a = {};
                    for (s in e) a[s] = ui(e[s], r, t, n, i);
                    return a;
                  })(t[e], i, r, s, n),
              n,
              i,
              s
            ) &&
          ((n._pt = o = new Ei(n._pt, r, e, 0, 1, a.render, a, 0, a.priority)),
          n !== Be)
        )
          for (
            l = n._ptLookup[n._targets.indexOf(r)], c = a._props.length;
            c--;

          )
            l[a._props[c]] = o;
        return a;
      },
      li = function e(t, n) {
        var i,
          r,
          s,
          a,
          o,
          l,
          c,
          u,
          d,
          p,
          f,
          h,
          m,
          g = t.vars,
          v = g.ease,
          y = g.startAt,
          b = g.immediateRender,
          _ = g.lazy,
          w = g.onUpdate,
          x = g.onUpdateParams,
          C = g.callbackScope,
          T = g.runBackwards,
          k = g.yoyoEase,
          S = g.keyframes,
          E = g.autoRevert,
          O = t._dur,
          P = t._startAt,
          M = t._targets,
          A = t.parent,
          D = A && "nested" === A.data ? A.parent._targets : M,
          I = "auto" === t._overwrite && !Me,
          L = t.timeline;
        if (
          (L && (!S || !v) && (v = "none"),
          (t._ease = Un(v, We.ease)),
          (t._yEase = k ? Xn(Un(!0 === k ? v : k, We.ease)) : 0),
          k &&
            t._yoyo &&
            !t._repeat &&
            ((k = t._yEase), (t._yEase = t._ease), (t._ease = k)),
          (t._from = !L && !!g.runBackwards),
          !L || (S && !g.stagger))
        ) {
          if (
            ((h = (u = M[0] ? At(M[0]).harness : 0) && g[u.prop]),
            (i = Vt(g, xt)),
            P && (Ut(P.render(-1, !0)), (P._lazy = 0)),
            y)
          )
            if (
              (Ut(
                (t._startAt = fi.set(
                  M,
                  Ft(
                    {
                      data: "isStart",
                      overwrite: !1,
                      parent: A,
                      immediateRender: !0,
                      lazy: it(_),
                      startAt: null,
                      delay: 0,
                      onUpdate: w,
                      onUpdateParams: x,
                      callbackScope: C,
                      stagger: 0,
                    },
                    y
                  )
                ))
              ),
              n < 0 && !b && !E && t._startAt.render(-1, !0),
              b)
            ) {
              if ((n > 0 && !E && (t._startAt = 0), O && n <= 0))
                return void (n && (t._zTime = n));
            } else !1 === E && (t._startAt = 0);
          else if (T && O)
            if (P) !E && (t._startAt = 0);
            else if (
              (n && (b = !1),
              (s = Ft(
                {
                  overwrite: !1,
                  data: "isFromStart",
                  lazy: b && it(_),
                  immediateRender: b,
                  stagger: 0,
                  parent: A,
                },
                i
              )),
              h && (s[u.prop] = h),
              Ut((t._startAt = fi.set(M, s))),
              n < 0 && t._startAt.render(-1, !0),
              (t._zTime = n),
              b)
            ) {
              if (!n) return;
            } else e(t._startAt, 1e-8);
          for (
            t._pt = t._ptCache = 0, _ = (O && it(_)) || (_ && !O), r = 0;
            r < M.length;
            r++
          ) {
            if (
              ((c = (o = M[r])._gsap || Mt(M)[r]._gsap),
              (t._ptLookup[r] = p = {}),
              Tt[c.id] && Ct.length && $t(),
              (f = D === M ? r : D.indexOf(o)),
              u &&
                !1 !== (d = new u()).init(o, h || i, t, f, D) &&
                ((t._pt = a =
                  new Ei(t._pt, o, d.name, 0, 1, d.render, d, 0, d.priority)),
                d._props.forEach(function (e) {
                  p[e] = a;
                }),
                d.priority && (l = 1)),
              !u || h)
            )
              for (s in i)
                kt[s] && (d = oi(s, i, t, f, o, D))
                  ? d.priority && (l = 1)
                  : (p[s] = a =
                      ai.call(t, o, s, "get", i[s], f, D, 0, g.stringFilter));
            t._op && t._op[r] && t.kill(o, t._op[r]),
              I &&
                t._pt &&
                ((ii = t),
                Ae.killTweensOf(o, p, t.globalTime(n)),
                (m = !t.parent),
                (ii = 0)),
              t._pt && _ && (Tt[c.id] = 1);
          }
          l && Si(t), t._onInit && t._onInit(t);
        }
        (t._onUpdate = w),
          (t._initted = (!t._op || t._pt) && !m),
          S && n <= 0 && L.render(Ve, !0, !0);
      },
      ci = function (e, t, n, i) {
        var r,
          s,
          a = t.ease || i || "power1.inOut";
        if (ot(t))
          (s = n[e] || (n[e] = [])),
            t.forEach(function (e, n) {
              return s.push({
                t: (n / (t.length - 1)) * 100,
                v: e,
                e: a,
              });
            });
        else
          for (r in t)
            (s = n[r] || (n[r] = [])),
              "ease" === r ||
                s.push({
                  t: parseFloat(e),
                  v: t[r],
                  e: a,
                });
      },
      ui = function (e, t, n, i, r) {
        return Ze(e)
          ? e.call(t, n, i, r)
          : Ke(e) && ~e.indexOf("random(")
          ? En(e)
          : e;
      },
      di = Pt + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
      pi = {};
    It(di + ",id,stagger,delay,duration,paused,scrollTrigger", function (e) {
      return (pi[e] = 1);
    });
    var fi = (function (e) {
      function t(t, n, i, r) {
        var s;
        "number" == typeof n && ((i.duration = n), (n = i), (i = null));
        var a,
          o,
          l,
          c,
          u,
          d,
          p,
          f,
          h = (s = e.call(this, r ? n : Gt(n)) || this).vars,
          m = h.duration,
          g = h.delay,
          v = h.immediateRender,
          y = h.stagger,
          b = h.overwrite,
          _ = h.keyframes,
          w = h.defaults,
          x = h.scrollTrigger,
          C = h.yoyoEase,
          T = n.parent || Ae,
          k = (ot(t) || at(t) ? et(t[0]) : "length" in n) ? [t] : _n(t);
        if (
          ((s._targets = k.length
            ? Mt(k)
            : bt(
                "GSAP target " + t + " not found. https://greensock.com",
                !qe.nullTargetWarn
              ) || []),
          (s._ptLookup = []),
          (s._overwrite = b),
          _ || y || st(m) || st(g))
        ) {
          if (
            ((n = s.vars),
            (a = s.timeline =
              new ni({
                data: "nested",
                defaults: w || {},
              })).kill(),
            (a.parent = a._dp = Oe(s)),
            (a._start = 0),
            y || st(m) || st(g))
          ) {
            if (((c = k.length), (p = y && xn(y)), nt(y)))
              for (u in y) ~di.indexOf(u) && (f || (f = {}), (f[u] = y[u]));
            for (o = 0; o < c; o++)
              ((l = Vt(n, pi)).stagger = 0),
                C && (l.yoyoEase = C),
                f && qt(l, f),
                (d = k[o]),
                (l.duration = +ui(m, Oe(s), o, d, k)),
                (l.delay = (+ui(g, Oe(s), o, d, k) || 0) - s._delay),
                !y &&
                  1 === c &&
                  l.delay &&
                  ((s._delay = g = l.delay), (s._start += g), (l.delay = 0)),
                a.to(d, l, p ? p(o, d, k) : 0),
                (a._ease = qn.none);
            a.duration() ? (m = g = 0) : (s.timeline = 0);
          } else if (_) {
            Gt(
              Ft(a.vars.defaults, {
                ease: "none",
              })
            ),
              (a._ease = Un(_.ease || n.ease || "none"));
            var S,
              E,
              O,
              P = 0;
            if (ot(_))
              _.forEach(function (e) {
                return a.to(k, e, ">");
              });
            else {
              for (u in ((l = {}), _))
                "ease" === u || "easeEach" === u || ci(u, _[u], l, _.easeEach);
              for (u in l)
                for (
                  S = l[u].sort(function (e, t) {
                    return e.t - t.t;
                  }),
                    P = 0,
                    o = 0;
                  o < S.length;
                  o++
                )
                  ((O = {
                    ease: (E = S[o]).e,
                    duration: ((E.t - (o ? S[o - 1].t : 0)) / 100) * m,
                  })[u] = E.v),
                    a.to(k, O, P),
                    (P += O.duration);
              a.duration() < m &&
                a.to(
                  {},
                  {
                    duration: m - a.duration(),
                  }
                );
            }
          }
          m || s.duration((m = a.duration()));
        } else s.timeline = 0;
        return (
          !0 !== b || Me || ((ii = Oe(s)), Ae.killTweensOf(k), (ii = 0)),
          sn(T, Oe(s), i),
          n.reversed && s.reverse(),
          n.paused && s.paused(!0),
          (v ||
            (!m &&
              !_ &&
              s._start === jt(T._time) &&
              it(v) &&
              (function e(t) {
                return !t || (t._ts && e(t.parent));
              })(Oe(s)) &&
              "nested" !== T.data)) &&
            ((s._tTime = -1e-8), s.render(Math.max(0, -g))),
          x && an(Oe(s), x),
          s
        );
      }
      Pe(t, e);
      var n = t.prototype;
      return (
        (n.render = function (e, t, n) {
          var i,
            r,
            s,
            a,
            o,
            l,
            c,
            u,
            d,
            p = this._time,
            f = this._tDur,
            h = this._dur,
            m = e > f - 1e-8 && e >= 0 ? f : e < 1e-8 ? 0 : e;
          if (h) {
            if (
              m !== this._tTime ||
              !e ||
              n ||
              (!this._initted && this._tTime) ||
              (this._startAt && this._zTime < 0 != e < 0)
            ) {
              if (((i = m), (u = this.timeline), this._repeat)) {
                if (((a = h + this._rDelay), this._repeat < -1 && e < 0))
                  return this.totalTime(100 * a + e, t, n);
                if (
                  ((i = jt(m % a)),
                  m === f
                    ? ((s = this._repeat), (i = h))
                    : ((s = ~~(m / a)) && s === m / a && ((i = h), s--),
                      i > h && (i = h)),
                  (l = this._yoyo && 1 & s) && ((d = this._yEase), (i = h - i)),
                  (o = Zt(this._tTime, a)),
                  i === p && !n && this._initted)
                )
                  return (this._tTime = m), this;
                s !== o &&
                  (u && this._yEase && Yn(u, l),
                  !this.vars.repeatRefresh ||
                    l ||
                    this._lock ||
                    ((this._lock = n = 1),
                    (this.render(jt(a * s), !0).invalidate()._lock = 0)));
              }
              if (!this._initted) {
                if (on(this, e < 0 ? e : i, n, t))
                  return (this._tTime = 0), this;
                if (p !== this._time) return this;
                if (h !== this._dur) return this.render(e, t, n);
              }
              if (
                ((this._tTime = m),
                (this._time = i),
                !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                (this.ratio = c = (d || this._ease)(i / h)),
                this._from && (this.ratio = c = 1 - c),
                i && !p && !t && (Mn(this, "onStart"), this._tTime !== m))
              )
                return this;
              for (r = this._pt; r; ) r.r(c, r.d), (r = r._next);
              (u &&
                u.render(
                  e < 0 ? e : !i && l ? -1e-8 : u._dur * u._ease(i / this._dur),
                  t,
                  n
                )) ||
                (this._startAt && (this._zTime = e)),
                this._onUpdate &&
                  !t &&
                  (e < 0 && this._startAt && this._startAt.render(e, !0, n),
                  Mn(this, "onUpdate")),
                this._repeat &&
                  s !== o &&
                  this.vars.onRepeat &&
                  !t &&
                  this.parent &&
                  Mn(this, "onRepeat"),
                (m !== this._tDur && m) ||
                  this._tTime !== m ||
                  (e < 0 &&
                    this._startAt &&
                    !this._onUpdate &&
                    this._startAt.render(e, !0, !0),
                  (e || !h) &&
                    ((m === this._tDur && this._ts > 0) ||
                      (!m && this._ts < 0)) &&
                    Ut(this, 1),
                  t ||
                    (e < 0 && !p) ||
                    (!m && !p) ||
                    (Mn(this, m === f ? "onComplete" : "onReverseComplete", !0),
                    this._prom &&
                      !(m < f && this.timeScale() > 0) &&
                      this._prom()));
            }
          } else
            !(function (e, t, n, i) {
              var r,
                s,
                a,
                o = e.ratio,
                l =
                  t < 0 ||
                  (!t &&
                    ((!e._start &&
                      (function e(t) {
                        var n = t.parent;
                        return (
                          n &&
                          n._ts &&
                          n._initted &&
                          !n._lock &&
                          (n.rawTime() < 0 || e(n))
                        );
                      })(e) &&
                      (e._initted || !ln(e))) ||
                      ((e._ts < 0 || e._dp._ts < 0) && !ln(e))))
                    ? 0
                    : 1,
                c = e._rDelay,
                u = 0;
              if (
                (c &&
                  e._repeat &&
                  ((u = mn(0, e._tDur, t)),
                  (s = Zt(u, c)),
                  e._yoyo && 1 & s && (l = 1 - l),
                  s !== Zt(e._tTime, c) &&
                    ((o = 1 - l),
                    e.vars.repeatRefresh && e._initted && e.invalidate())),
                l !== o || i || 1e-8 === e._zTime || (!t && e._zTime))
              ) {
                if (!e._initted && on(e, t, i, n)) return;
                for (
                  a = e._zTime,
                    e._zTime = t || (n ? 1e-8 : 0),
                    n || (n = t && !a),
                    e.ratio = l,
                    e._from && (l = 1 - l),
                    e._time = 0,
                    e._tTime = u,
                    r = e._pt;
                  r;

                )
                  r.r(l, r.d), (r = r._next);
                e._startAt && t < 0 && e._startAt.render(t, !0, !0),
                  e._onUpdate && !n && Mn(e, "onUpdate"),
                  u && e._repeat && !n && e.parent && Mn(e, "onRepeat"),
                  (t >= e._tDur || t < 0) &&
                    e.ratio === l &&
                    (l && Ut(e, 1),
                    n ||
                      (Mn(e, l ? "onComplete" : "onReverseComplete", !0),
                      e._prom && e._prom()));
              } else e._zTime || (e._zTime = t);
            })(this, e, t, n);
          return this;
        }),
        (n.targets = function () {
          return this._targets;
        }),
        (n.invalidate = function () {
          return (
            (this._pt =
              this._op =
              this._startAt =
              this._onUpdate =
              this._lazy =
              this.ratio =
                0),
            (this._ptLookup = []),
            this.timeline && this.timeline.invalidate(),
            e.prototype.invalidate.call(this)
          );
        }),
        (n.resetTo = function (e, t, n, i) {
          $e || Hn.wake(), this._ts || this.play();
          var r = Math.min(
            this._dur,
            (this._dp._time - this._start) * this._ts
          );
          return (
            this._initted || li(this, r),
            (function (e, t, n, i, r, s, a) {
              var o,
                l,
                c,
                u = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
              if (!u)
                for (
                  u = e._ptCache[t] = [],
                    l = e._ptLookup,
                    c = e._targets.length;
                  c--;

                ) {
                  if ((o = l[c][t]) && o.d && o.d._pt)
                    for (o = o.d._pt; o && o.p !== t; ) o = o._next;
                  if (!o)
                    return (ri = 1), (e.vars[t] = "+=0"), li(e, a), (ri = 0), 1;
                  u.push(o);
                }
              for (c = u.length; c--; )
                ((o = u[c]).s =
                  (!i && 0 !== i) || r ? o.s + (i || 0) + s * o.c : i),
                  (o.c = n - o.s),
                  o.e && (o.e = Lt(n) + gn(o.e)),
                  o.b && (o.b = o.s + gn(o.b));
            })(this, e, t, n, i, this._ease(r / this._dur), r)
              ? this.resetTo(e, t, n, i)
              : (nn(this, 0),
                this.parent ||
                  Xt(
                    this._dp,
                    this,
                    "_first",
                    "_last",
                    this._dp._sort ? "_start" : 0
                  ),
                this.render(0))
          );
        }),
        (n.kill = function (e, t) {
          if ((void 0 === t && (t = "all"), !(e || (t && "all" !== t))))
            return (this._lazy = this._pt = 0), this.parent ? An(this) : this;
          if (this.timeline) {
            var n = this.timeline.totalDuration();
            return (
              this.timeline.killTweensOf(e, t, ii && !0 !== ii.vars.overwrite)
                ._first || An(this),
              this.parent &&
                n !== this.timeline.totalDuration() &&
                cn(this, (this._dur * this.timeline._tDur) / n, 0, 1),
              this
            );
          }
          var i,
            r,
            s,
            a,
            o,
            l,
            c,
            u = this._targets,
            d = e ? _n(e) : u,
            p = this._ptLookup,
            f = this._pt;
          if (
            (!t || "all" === t) &&
            (function (e, t) {
              for (
                var n = e.length, i = n === t.length;
                i && n-- && e[n] === t[n];

              );
              return n < 0;
            })(u, d)
          )
            return "all" === t && (this._pt = 0), An(this);
          for (
            i = this._op = this._op || [],
              "all" !== t &&
                (Ke(t) &&
                  ((o = {}),
                  It(t, function (e) {
                    return (o[e] = 1);
                  }),
                  (t = o)),
                (t = (function (e, t) {
                  var n,
                    i,
                    r,
                    s,
                    a = e[0] ? At(e[0]).harness : 0,
                    o = a && a.aliases;
                  if (!o) return t;
                  for (i in ((n = qt({}, t)), o))
                    if ((i in n))
                      for (r = (s = o[i].split(",")).length; r--; )
                        n[s[r]] = n[i];
                  return n;
                })(u, t))),
              c = u.length;
            c--;

          )
            if (~d.indexOf(u[c]))
              for (o in ((r = p[c]),
              "all" === t
                ? ((i[c] = t), (a = r), (s = {}))
                : ((s = i[c] = i[c] || {}), (a = t)),
              a))
                (l = r && r[o]) &&
                  (("kill" in l.d && !0 !== l.d.kill(o)) || Yt(this, l, "_pt"),
                  delete r[o]),
                  "all" !== s && (s[o] = 1);
          return this._initted && !this._pt && f && An(this), this;
        }),
        (t.to = function (e, n) {
          return new t(e, n, arguments[2]);
        }),
        (t.from = function (e, t) {
          return fn(1, arguments);
        }),
        (t.delayedCall = function (e, n, i, r) {
          return new t(n, 0, {
            immediateRender: !1,
            lazy: !1,
            overwrite: !1,
            delay: e,
            onComplete: n,
            onReverseComplete: n,
            onCompleteParams: i,
            onReverseCompleteParams: i,
            callbackScope: r,
          });
        }),
        (t.fromTo = function (e, t, n) {
          return fn(2, arguments);
        }),
        (t.set = function (e, n) {
          return (n.duration = 0), n.repeatDelay || (n.repeat = 0), new t(e, n);
        }),
        (t.killTweensOf = function (e, t, n) {
          return Ae.killTweensOf(e, t, n);
        }),
        t
      );
    })(ti);
    Ft(fi.prototype, {
      _targets: [],
      _lazy: 0,
      _startAt: 0,
      _op: 0,
      _onInit: 0,
    }),
      It("staggerTo,staggerFrom,staggerFromTo", function (e) {
        fi[e] = function () {
          var t = new ni(),
            n = vn.call(arguments, 0);
          return (
            n.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, n)
          );
        };
      });
    var hi = function (e, t, n) {
        return (e[t] = n);
      },
      mi = function (e, t, n) {
        return e[t](n);
      },
      gi = function (e, t, n, i) {
        return e[t](i.fp, n);
      },
      vi = function (e, t, n) {
        return e.setAttribute(t, n);
      },
      yi = function (e, t) {
        return Ze(e[t]) ? mi : tt(e[t]) && e.setAttribute ? vi : hi;
      },
      bi = function (e, t) {
        return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
      },
      _i = function (e, t) {
        return t.set(t.t, t.p, !!(t.s + t.c * e), t);
      },
      wi = function (e, t) {
        var n = t._pt,
          i = "";
        if (!e && t.b) i = t.b;
        else if (1 === e && t.e) i = t.e;
        else {
          for (; n; )
            (i =
              n.p +
              (n.m
                ? n.m(n.s + n.c * e)
                : Math.round(1e4 * (n.s + n.c * e)) / 1e4) +
              i),
              (n = n._next);
          i += t.c;
        }
        t.set(t.t, t.p, i, t);
      },
      xi = function (e, t) {
        for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
      },
      Ci = function (e, t, n, i) {
        for (var r, s = this._pt; s; )
          (r = s._next), s.p === i && s.modifier(e, t, n), (s = r);
      },
      Ti = function (e) {
        for (var t, n, i = this._pt; i; )
          (n = i._next),
            (i.p === e && !i.op) || i.op === e
              ? Yt(this, i, "_pt")
              : i.dep || (t = 1),
            (i = n);
        return !t;
      },
      ki = function (e, t, n, i) {
        i.mSet(e, t, i.m.call(i.tween, n, i.mt), i);
      },
      Si = function (e) {
        for (var t, n, i, r, s = e._pt; s; ) {
          for (t = s._next, n = i; n && n.pr > s.pr; ) n = n._next;
          (s._prev = n ? n._prev : r) ? (s._prev._next = s) : (i = s),
            (s._next = n) ? (n._prev = s) : (r = s),
            (s = t);
        }
        e._pt = i;
      },
      Ei = (function () {
        function e(e, t, n, i, r, s, a, o, l) {
          (this.t = t),
            (this.s = i),
            (this.c = r),
            (this.p = n),
            (this.r = s || bi),
            (this.d = a || this),
            (this.set = o || hi),
            (this.pr = l || 0),
            (this._next = e),
            e && (e._prev = this);
        }
        return (
          (e.prototype.modifier = function (e, t, n) {
            (this.mSet = this.mSet || this.set),
              (this.set = ki),
              (this.m = e),
              (this.mt = n),
              (this.tween = t);
          }),
          e
        );
      })();
    It(
      Pt +
        "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
      function (e) {
        return (xt[e] = 1);
      }
    ),
      (mt.TweenMax = mt.TweenLite = fi),
      (mt.TimelineLite = mt.TimelineMax = ni),
      (Ae = new ni({
        sortChildren: !1,
        defaults: We,
        autoRemoveChildren: !0,
        id: "root",
        smoothChildTiming: !0,
      })),
      (qe.stringFilter = Rn);
    var Oi = {
      registerPlugin: function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        t.forEach(function (e) {
          return Dn(e);
        });
      },
      timeline: function (e) {
        return new ni(e);
      },
      getTweensOf: function (e, t) {
        return Ae.getTweensOf(e, t);
      },
      getProperty: function (e, t, n, i) {
        Ke(e) && (e = _n(e)[0]);
        var r = At(e || {}).get,
          s = n ? Ht : Rt;
        return (
          "native" === n && (n = ""),
          e
            ? t
              ? s(((kt[t] && kt[t].get) || r)(e, t, n, i))
              : function (t, n, i) {
                  return s(((kt[t] && kt[t].get) || r)(e, t, n, i));
                }
            : e
        );
      },
      quickSetter: function (e, t, n) {
        if ((e = _n(e)).length > 1) {
          var i = e.map(function (e) {
              return Ai.quickSetter(e, t, n);
            }),
            r = i.length;
          return function (e) {
            for (var t = r; t--; ) i[t](e);
          };
        }
        e = e[0] || {};
        var s = kt[t],
          a = At(e),
          o = (a.harness && (a.harness.aliases || {})[t]) || t,
          l = s
            ? function (t) {
                var i = new s();
                (Be._pt = 0),
                  i.init(e, n ? t + n : t, Be, 0, [e]),
                  i.render(1, i),
                  Be._pt && xi(1, Be);
              }
            : a.set(e, o);
        return s
          ? l
          : function (t) {
              return l(e, o, n ? t + n : t, a, 1);
            };
      },
      quickTo: function (e, t, n) {
        var i,
          r = Ai.to(
            e,
            qt((((i = {})[t] = "+=0.1"), (i.paused = !0), i), n || {})
          ),
          s = function (e, n, i) {
            return r.resetTo(t, e, n, i);
          };
        return (s.tween = r), s;
      },
      isTweening: function (e) {
        return Ae.getTweensOf(e, !0).length > 0;
      },
      defaults: function (e) {
        return e && e.ease && (e.ease = Un(e.ease, We.ease)), Wt(We, e || {});
      },
      config: function (e) {
        return Wt(qe, e || {});
      },
      registerEffect: function (e) {
        var t = e.name,
          n = e.effect,
          i = e.plugins,
          r = e.defaults,
          s = e.extendTimeline;
        (i || "").split(",").forEach(function (e) {
          return (
            e &&
            !kt[e] &&
            !mt[e] &&
            bt(t + " effect requires " + e + " plugin.")
          );
        }),
          (St[t] = function (e, t, i) {
            return n(_n(e), Ft(t || {}, r), i);
          }),
          s &&
            (ni.prototype[t] = function (e, n, i) {
              return this.add(St[t](e, nt(n) ? n : (i = n) && {}, this), i);
            });
      },
      registerEase: function (e, t) {
        qn[e] = Un(t);
      },
      parseEase: function (e, t) {
        return arguments.length ? Un(e, t) : qn;
      },
      getById: function (e) {
        return Ae.getById(e);
      },
      exportRoot: function (e, t) {
        void 0 === e && (e = {});
        var n,
          i,
          r = new ni(e);
        for (
          r.smoothChildTiming = it(e.smoothChildTiming),
            Ae.remove(r),
            r._dp = 0,
            r._time = r._tTime = Ae._time,
            n = Ae._first;
          n;

        )
          (i = n._next),
            (!t &&
              !n._dur &&
              n instanceof fi &&
              n.vars.onComplete === n._targets[0]) ||
              sn(r, n, n._start - n._delay),
            (n = i);
        return sn(Ae, r, 0), r;
      },
      utils: {
        wrap: function e(t, n, i) {
          var r = n - t;
          return ot(t)
            ? Sn(t, e(0, t.length), n)
            : hn(i, function (e) {
                return ((r + ((e - t) % r)) % r) + t;
              });
        },
        wrapYoyo: function e(t, n, i) {
          var r = n - t,
            s = 2 * r;
          return ot(t)
            ? Sn(t, e(0, t.length - 1), n)
            : hn(i, function (e) {
                return t + ((e = (s + ((e - t) % s)) % s || 0) > r ? s - e : e);
              });
        },
        distribute: xn,
        random: kn,
        snap: Tn,
        normalize: function (e, t, n) {
          return On(e, t, 0, 1, n);
        },
        getUnit: gn,
        clamp: function (e, t, n) {
          return hn(n, function (n) {
            return mn(e, t, n);
          });
        },
        splitColor: jn,
        toArray: _n,
        selector: function (e) {
          return (
            (e = _n(e)[0] || bt("Invalid scope") || {}),
            function (t) {
              var n = e.current || e.nativeElement || e;
              return _n(
                t,
                n.querySelectorAll
                  ? n
                  : n === e
                  ? bt("Invalid scope") || Le.createElement("div")
                  : e
              );
            }
          );
        },
        mapRange: On,
        pipe: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          return function (e) {
            return t.reduce(function (e, t) {
              return t(e);
            }, e);
          };
        },
        unitize: function (e, t) {
          return function (n) {
            return e(parseFloat(n)) + (t || gn(n));
          };
        },
        interpolate: function e(t, n, i, r) {
          var s = isNaN(t + n)
            ? 0
            : function (e) {
                return (1 - e) * t + e * n;
              };
          if (!s) {
            var a,
              o,
              l,
              c,
              u,
              d = Ke(t),
              p = {};
            if ((!0 === i && (r = 1) && (i = null), d))
              (t = {
                p: t,
              }),
                (n = {
                  p: n,
                });
            else if (ot(t) && !ot(n)) {
              for (l = [], c = t.length, u = c - 2, o = 1; o < c; o++)
                l.push(e(t[o - 1], t[o]));
              c--,
                (s = function (e) {
                  e *= c;
                  var t = Math.min(u, ~~e);
                  return l[t](e - t);
                }),
                (i = n);
            } else r || (t = qt(ot(t) ? [] : {}, t));
            if (!l) {
              for (a in n) ai.call(p, t, a, "get", n[a]);
              s = function (e) {
                return xi(e, p) || (d ? t.p : t);
              };
            }
          }
          return hn(i, s);
        },
        shuffle: wn,
      },
      install: vt,
      effects: St,
      ticker: Hn,
      updateRoot: ni.updateRoot,
      plugins: kt,
      globalTimeline: Ae,
      core: {
        PropTween: Ei,
        globals: _t,
        Tween: fi,
        Timeline: ni,
        Animation: ti,
        getCache: At,
        _removeLinkedListItem: Yt,
        suppressOverwrites: function (e) {
          return (Me = e);
        },
      },
    };
    It("to,from,fromTo,delayedCall,set,killTweensOf", function (e) {
      return (Oi[e] = fi[e]);
    }),
      Hn.add(ni.updateRoot),
      (Be = Oi.to(
        {},
        {
          duration: 0,
        }
      ));
    var Pi = function (e, t) {
        for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; )
          n = n._next;
        return n;
      },
      Mi = function (e, t) {
        return {
          name: e,
          rawVars: 1,
          init: function (e, n, i) {
            i._onInit = function (e) {
              var i, r;
              if (
                (Ke(n) &&
                  ((i = {}),
                  It(n, function (e) {
                    return (i[e] = 1);
                  }),
                  (n = i)),
                t)
              ) {
                for (r in ((i = {}), n)) i[r] = t(n[r]);
                n = i;
              }
              !(function (e, t) {
                var n,
                  i,
                  r,
                  s = e._targets;
                for (n in t)
                  for (i = s.length; i--; )
                    (r = e._ptLookup[i][n]) &&
                      (r = r.d) &&
                      (r._pt && (r = Pi(r, n)),
                      r && r.modifier && r.modifier(t[n], e, s[i], n));
              })(e, n);
            };
          },
        };
      },
      Ai =
        Oi.registerPlugin(
          {
            name: "attr",
            init: function (e, t, n, i, r) {
              var s, a;
              for (s in t)
                (a = this.add(
                  e,
                  "setAttribute",
                  (e.getAttribute(s) || 0) + "",
                  t[s],
                  i,
                  r,
                  0,
                  0,
                  s
                )) && (a.op = s),
                  this._props.push(s);
            },
          },
          {
            name: "endArray",
            init: function (e, t) {
              for (var n = t.length; n--; ) this.add(e, n, e[n] || 0, t[n]);
            },
          },
          Mi("roundProps", Cn),
          Mi("modifiers"),
          Mi("snap", Tn)
        ) || Oi;
    (fi.version = ni.version = Ai.version = "3.10.4"), (je = 1), rt() && Fn();
    qn.Power0,
      qn.Power1,
      qn.Power2,
      qn.Power3,
      qn.Power4,
      qn.Linear,
      qn.Quad,
      qn.Cubic,
      qn.Quart,
      qn.Quint,
      qn.Strong,
      qn.Elastic,
      qn.Back,
      qn.SteppedEase,
      qn.Bounce,
      qn.Sine,
      qn.Expo,
      qn.Circ;
    /*!
     * CSSPlugin 3.10.4
     * https://greensock.com
     *
     * Copyright 2008-2022, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */
    var Di,
      Ii,
      Li,
      ji,
      Ni,
      Bi,
      $i,
      zi = {},
      Ri = 180 / Math.PI,
      Hi = Math.PI / 180,
      Fi = Math.atan2,
      qi = /([A-Z])/g,
      Wi = /(left|right|width|margin|padding|x)/i,
      Vi = /[\s,\(]\S/,
      Gi = {
        autoAlpha: "opacity,visibility",
        scale: "scaleX,scaleY",
        alpha: "opacity",
      },
      Xi = function (e, t) {
        return t.set(
          t.t,
          t.p,
          Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
          t
        );
      },
      Yi = function (e, t) {
        return t.set(
          t.t,
          t.p,
          1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
          t
        );
      },
      Ui = function (e, t) {
        return t.set(
          t.t,
          t.p,
          e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b,
          t
        );
      },
      Qi = function (e, t) {
        var n = t.s + t.c * e;
        t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
      },
      Ji = function (e, t) {
        return t.set(t.t, t.p, e ? t.e : t.b, t);
      },
      Ki = function (e, t) {
        return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
      },
      Zi = function (e, t, n) {
        return (e.style[t] = n);
      },
      er = function (e, t, n) {
        return e.style.setProperty(t, n);
      },
      tr = function (e, t, n) {
        return (e._gsap[t] = n);
      },
      nr = function (e, t, n) {
        return (e._gsap.scaleX = e._gsap.scaleY = n);
      },
      ir = function (e, t, n, i, r) {
        var s = e._gsap;
        (s.scaleX = s.scaleY = n), s.renderTransform(r, s);
      },
      rr = function (e, t, n, i, r) {
        var s = e._gsap;
        (s[t] = n), s.renderTransform(r, s);
      },
      sr = "transform",
      ar = sr + "Origin",
      or = function (e, t) {
        var n = Ii.createElementNS
          ? Ii.createElementNS(
              (t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
              e
            )
          : Ii.createElement(e);
        return n.style ? n : Ii.createElement(e);
      },
      lr = function e(t, n, i) {
        var r = getComputedStyle(t);
        return (
          r[n] ||
          r.getPropertyValue(n.replace(qi, "-$1").toLowerCase()) ||
          r.getPropertyValue(n) ||
          (!i && e(t, ur(n) || n, 1)) ||
          ""
        );
      },
      cr = "O,Moz,ms,Ms,Webkit".split(","),
      ur = function (e, t, n) {
        var i = (t || Ni).style,
          r = 5;
        if (e in i && !n) return e;
        for (
          e = e.charAt(0).toUpperCase() + e.substr(1);
          r-- && !(cr[r] + e in i);

        );
        return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? cr[r] : "") + e;
      },
      dr = function () {
        "undefined" != typeof window &&
          window.document &&
          ((Di = window),
          (Ii = Di.document),
          (Li = Ii.documentElement),
          (Ni = or("div") || {
            style: {},
          }),
          or("div"),
          (sr = ur(sr)),
          (ar = sr + "Origin"),
          (Ni.style.cssText =
            "border-width:0;line-height:0;position:absolute;padding:0"),
          ($i = !!ur("perspective")),
          (ji = 1));
      },
      pr = function e(t) {
        var n,
          i = or(
            "svg",
            (this.ownerSVGElement &&
              this.ownerSVGElement.getAttribute("xmlns")) ||
              "http://www.w3.org/2000/svg"
          ),
          r = this.parentNode,
          s = this.nextSibling,
          a = this.style.cssText;
        if (
          (Li.appendChild(i),
          i.appendChild(this),
          (this.style.display = "block"),
          t)
        )
          try {
            (n = this.getBBox()),
              (this._gsapBBox = this.getBBox),
              (this.getBBox = e);
          } catch (e) {}
        else this._gsapBBox && (n = this._gsapBBox());
        return (
          r && (s ? r.insertBefore(this, s) : r.appendChild(this)),
          Li.removeChild(i),
          (this.style.cssText = a),
          n
        );
      },
      fr = function (e, t) {
        for (var n = t.length; n--; )
          if (e.hasAttribute(t[n])) return e.getAttribute(t[n]);
      },
      hr = function (e) {
        var t;
        try {
          t = e.getBBox();
        } catch (n) {
          t = pr.call(e, !0);
        }
        return (
          (t && (t.width || t.height)) ||
            e.getBBox === pr ||
            (t = pr.call(e, !0)),
          !t || t.width || t.x || t.y
            ? t
            : {
                x: +fr(e, ["x", "cx", "x1"]) || 0,
                y: +fr(e, ["y", "cy", "y1"]) || 0,
                width: 0,
                height: 0,
              }
        );
      },
      mr = function (e) {
        return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !hr(e));
      },
      gr = function (e, t) {
        if (t) {
          var n = e.style;
          t in zi && t !== ar && (t = sr),
            n.removeProperty
              ? (("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6)) ||
                  (t = "-" + t),
                n.removeProperty(t.replace(qi, "-$1").toLowerCase()))
              : n.removeAttribute(t);
        }
      },
      vr = function (e, t, n, i, r, s) {
        var a = new Ei(e._pt, t, n, 0, 1, s ? Ki : Ji);
        return (e._pt = a), (a.b = i), (a.e = r), e._props.push(n), a;
      },
      yr = {
        deg: 1,
        rad: 1,
        turn: 1,
      },
      br = function e(t, n, i, r) {
        var s,
          a,
          o,
          l,
          c = parseFloat(i) || 0,
          u = (i + "").trim().substr((c + "").length) || "px",
          d = Ni.style,
          p = Wi.test(n),
          f = "svg" === t.tagName.toLowerCase(),
          h = (f ? "client" : "offset") + (p ? "Width" : "Height"),
          m = "px" === r,
          g = "%" === r;
        return r === u || !c || yr[r] || yr[u]
          ? c
          : ("px" !== u && !m && (c = e(t, n, i, "px")),
            (l = t.getCTM && mr(t)),
            (!g && "%" !== u) || (!zi[n] && !~n.indexOf("adius"))
              ? ((d[p ? "width" : "height"] = 100 + (m ? u : r)),
                (a =
                  ~n.indexOf("adius") || ("em" === r && t.appendChild && !f)
                    ? t
                    : t.parentNode),
                l && (a = (t.ownerSVGElement || {}).parentNode),
                (a && a !== Ii && a.appendChild) || (a = Ii.body),
                (o = a._gsap) && g && o.width && p && o.time === Hn.time
                  ? Lt((c / o.width) * 100)
                  : ((g || "%" === u) && (d.position = lr(t, "position")),
                    a === t && (d.position = "static"),
                    a.appendChild(Ni),
                    (s = Ni[h]),
                    a.removeChild(Ni),
                    (d.position = "absolute"),
                    p && g && (((o = At(a)).time = Hn.time), (o.width = a[h])),
                    Lt(m ? (s * c) / 100 : s && c ? (100 / s) * c : 0)))
              : ((s = l ? t.getBBox()[p ? "width" : "height"] : t[h]),
                Lt(g ? (c / s) * 100 : (c / 100) * s)));
      },
      _r = function (e, t, n, i) {
        var r;
        return (
          ji || dr(),
          t in Gi &&
            "transform" !== t &&
            ~(t = Gi[t]).indexOf(",") &&
            (t = t.split(",")[0]),
          zi[t] && "transform" !== t
            ? ((r = Ar(e, i)),
              (r =
                "transformOrigin" !== t
                  ? r[t]
                  : r.svg
                  ? r.origin
                  : Dr(lr(e, ar)) + " " + r.zOrigin + "px"))
            : (!(r = e.style[t]) ||
                "auto" === r ||
                i ||
                ~(r + "").indexOf("calc(")) &&
              (r =
                (Tr[t] && Tr[t](e, t, n)) ||
                lr(e, t) ||
                Dt(e, t) ||
                ("opacity" === t ? 1 : 0)),
          n && !~(r + "").trim().indexOf(" ") ? br(e, t, r, n) + n : r
        );
      },
      wr = function (e, t, n, i) {
        if (!n || "none" === n) {
          var r = ur(t, e, 1),
            s = r && lr(e, r, 1);
          s && s !== n
            ? ((t = r), (n = s))
            : "borderColor" === t && (n = lr(e, "borderTopColor"));
        }
        var a,
          o,
          l,
          c,
          u,
          d,
          p,
          f,
          h,
          m,
          g,
          v = new Ei(this._pt, e.style, t, 0, 1, wi),
          y = 0,
          b = 0;
        if (
          ((v.b = n),
          (v.e = i),
          (n += ""),
          "auto" === (i += "") &&
            ((e.style[t] = i), (i = lr(e, t) || i), (e.style[t] = n)),
          Rn((a = [n, i])),
          (i = a[1]),
          (l = (n = a[0]).match(ut) || []),
          (i.match(ut) || []).length)
        ) {
          for (; (o = ut.exec(i)); )
            (p = o[0]),
              (h = i.substring(y, o.index)),
              u
                ? (u = (u + 1) % 5)
                : ("rgba(" !== h.substr(-5) && "hsla(" !== h.substr(-5)) ||
                  (u = 1),
              p !== (d = l[b++] || "") &&
                ((c = parseFloat(d) || 0),
                (g = d.substr((c + "").length)),
                "=" === p.charAt(1) && (p = Nt(c, p) + g),
                (f = parseFloat(p)),
                (m = p.substr((f + "").length)),
                (y = ut.lastIndex - m.length),
                m ||
                  ((m = m || qe.units[t] || g),
                  y === i.length && ((i += m), (v.e += m))),
                g !== m && (c = br(e, t, d, m) || 0),
                (v._pt = {
                  _next: v._pt,
                  p: h || 1 === b ? h : ",",
                  s: c,
                  c: f - c,
                  m: (u && u < 4) || "zIndex" === t ? Math.round : 0,
                }));
          v.c = y < i.length ? i.substring(y, i.length) : "";
        } else v.r = "display" === t && "none" === i ? Ki : Ji;
        return pt.test(i) && (v.e = 0), (this._pt = v), v;
      },
      xr = {
        top: "0%",
        bottom: "100%",
        left: "0%",
        right: "100%",
        center: "50%",
      },
      Cr = function (e, t) {
        if (t.tween && t.tween._time === t.tween._dur) {
          var n,
            i,
            r,
            s = t.t,
            a = s.style,
            o = t.u,
            l = s._gsap;
          if ("all" === o || !0 === o) (a.cssText = ""), (i = 1);
          else
            for (r = (o = o.split(",")).length; --r > -1; )
              (n = o[r]),
                zi[n] && ((i = 1), (n = "transformOrigin" === n ? ar : sr)),
                gr(s, n);
          i &&
            (gr(s, sr),
            l &&
              (l.svg && s.removeAttribute("transform"),
              Ar(s, 1),
              (l.uncache = 1)));
        }
      },
      Tr = {
        clearProps: function (e, t, n, i, r) {
          if ("isFromStart" !== r.data) {
            var s = (e._pt = new Ei(e._pt, t, n, 0, 0, Cr));
            return (s.u = i), (s.pr = -10), (s.tween = r), e._props.push(n), 1;
          }
        },
      },
      kr = [1, 0, 0, 1, 0, 0],
      Sr = {},
      Er = function (e) {
        return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e;
      },
      Or = function (e) {
        var t = lr(e, sr);
        return Er(t) ? kr : t.substr(7).match(ct).map(Lt);
      },
      Pr = function (e, t) {
        var n,
          i,
          r,
          s,
          a = e._gsap || At(e),
          o = e.style,
          l = Or(e);
        return a.svg && e.getAttribute("transform")
          ? "1,0,0,1,0,0" ===
            (l = [
              (r = e.transform.baseVal.consolidate().matrix).a,
              r.b,
              r.c,
              r.d,
              r.e,
              r.f,
            ]).join(",")
            ? kr
            : l
          : (l !== kr ||
              e.offsetParent ||
              e === Li ||
              a.svg ||
              ((r = o.display),
              (o.display = "block"),
              ((n = e.parentNode) && e.offsetParent) ||
                ((s = 1), (i = e.nextSibling), Li.appendChild(e)),
              (l = Or(e)),
              r ? (o.display = r) : gr(e, "display"),
              s &&
                (i
                  ? n.insertBefore(e, i)
                  : n
                  ? n.appendChild(e)
                  : Li.removeChild(e))),
            t && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
      },
      Mr = function (e, t, n, i, r, s) {
        var a,
          o,
          l,
          c = e._gsap,
          u = r || Pr(e, !0),
          d = c.xOrigin || 0,
          p = c.yOrigin || 0,
          f = c.xOffset || 0,
          h = c.yOffset || 0,
          m = u[0],
          g = u[1],
          v = u[2],
          y = u[3],
          b = u[4],
          _ = u[5],
          w = t.split(" "),
          x = parseFloat(w[0]) || 0,
          C = parseFloat(w[1]) || 0;
        n
          ? u !== kr &&
            (o = m * y - g * v) &&
            ((l = x * (-g / o) + C * (m / o) - (m * _ - g * b) / o),
            (x = x * (y / o) + C * (-v / o) + (v * _ - y * b) / o),
            (C = l))
          : ((x =
              (a = hr(e)).x + (~w[0].indexOf("%") ? (x / 100) * a.width : x)),
            (C =
              a.y + (~(w[1] || w[0]).indexOf("%") ? (C / 100) * a.height : C))),
          i || (!1 !== i && c.smooth)
            ? ((b = x - d),
              (_ = C - p),
              (c.xOffset = f + (b * m + _ * v) - b),
              (c.yOffset = h + (b * g + _ * y) - _))
            : (c.xOffset = c.yOffset = 0),
          (c.xOrigin = x),
          (c.yOrigin = C),
          (c.smooth = !!i),
          (c.origin = t),
          (c.originIsAbsolute = !!n),
          (e.style[ar] = "0px 0px"),
          s &&
            (vr(s, c, "xOrigin", d, x),
            vr(s, c, "yOrigin", p, C),
            vr(s, c, "xOffset", f, c.xOffset),
            vr(s, c, "yOffset", h, c.yOffset)),
          e.setAttribute("data-svg-origin", x + " " + C);
      },
      Ar = function (e, t) {
        var n = e._gsap || new ei(e);
        if ("x" in n && !t && !n.uncache) return n;
        var i,
          r,
          s,
          a,
          o,
          l,
          c,
          u,
          d,
          p,
          f,
          h,
          m,
          g,
          v,
          y,
          b,
          _,
          w,
          x,
          C,
          T,
          k,
          S,
          E,
          O,
          P,
          M,
          A,
          D,
          I,
          L,
          j = e.style,
          N = n.scaleX < 0,
          B = lr(e, ar) || "0";
        return (
          (i = r = s = l = c = u = d = p = f = 0),
          (a = o = 1),
          (n.svg = !(!e.getCTM || !mr(e))),
          (g = Pr(e, n.svg)),
          n.svg &&
            ((S =
              (!n.uncache || "0px 0px" === B) &&
              !t &&
              e.getAttribute("data-svg-origin")),
            Mr(e, S || B, !!S || n.originIsAbsolute, !1 !== n.smooth, g)),
          (h = n.xOrigin || 0),
          (m = n.yOrigin || 0),
          g !== kr &&
            ((_ = g[0]),
            (w = g[1]),
            (x = g[2]),
            (C = g[3]),
            (i = T = g[4]),
            (r = k = g[5]),
            6 === g.length
              ? ((a = Math.sqrt(_ * _ + w * w)),
                (o = Math.sqrt(C * C + x * x)),
                (l = _ || w ? Fi(w, _) * Ri : 0),
                (d = x || C ? Fi(x, C) * Ri + l : 0) &&
                  (o *= Math.abs(Math.cos(d * Hi))),
                n.svg &&
                  ((i -= h - (h * _ + m * x)), (r -= m - (h * w + m * C))))
              : ((L = g[6]),
                (D = g[7]),
                (P = g[8]),
                (M = g[9]),
                (A = g[10]),
                (I = g[11]),
                (i = g[12]),
                (r = g[13]),
                (s = g[14]),
                (c = (v = Fi(L, A)) * Ri),
                v &&
                  ((S = T * (y = Math.cos(-v)) + P * (b = Math.sin(-v))),
                  (E = k * y + M * b),
                  (O = L * y + A * b),
                  (P = T * -b + P * y),
                  (M = k * -b + M * y),
                  (A = L * -b + A * y),
                  (I = D * -b + I * y),
                  (T = S),
                  (k = E),
                  (L = O)),
                (u = (v = Fi(-x, A)) * Ri),
                v &&
                  ((y = Math.cos(-v)),
                  (I = C * (b = Math.sin(-v)) + I * y),
                  (_ = S = _ * y - P * b),
                  (w = E = w * y - M * b),
                  (x = O = x * y - A * b)),
                (l = (v = Fi(w, _)) * Ri),
                v &&
                  ((S = _ * (y = Math.cos(v)) + w * (b = Math.sin(v))),
                  (E = T * y + k * b),
                  (w = w * y - _ * b),
                  (k = k * y - T * b),
                  (_ = S),
                  (T = E)),
                c &&
                  Math.abs(c) + Math.abs(l) > 359.9 &&
                  ((c = l = 0), (u = 180 - u)),
                (a = Lt(Math.sqrt(_ * _ + w * w + x * x))),
                (o = Lt(Math.sqrt(k * k + L * L))),
                (v = Fi(T, k)),
                (d = Math.abs(v) > 2e-4 ? v * Ri : 0),
                (f = I ? 1 / (I < 0 ? -I : I) : 0)),
            n.svg &&
              ((S = e.getAttribute("transform")),
              (n.forceCSS = e.setAttribute("transform", "") || !Er(lr(e, sr))),
              S && e.setAttribute("transform", S))),
          Math.abs(d) > 90 &&
            Math.abs(d) < 270 &&
            (N
              ? ((a *= -1),
                (d += l <= 0 ? 180 : -180),
                (l += l <= 0 ? 180 : -180))
              : ((o *= -1), (d += d <= 0 ? 180 : -180))),
          (t = t || n.uncache),
          (n.x =
            i -
            ((n.xPercent =
              i &&
              ((!t && n.xPercent) ||
                (Math.round(e.offsetWidth / 2) === Math.round(-i) ? -50 : 0)))
              ? (e.offsetWidth * n.xPercent) / 100
              : 0) +
            "px"),
          (n.y =
            r -
            ((n.yPercent =
              r &&
              ((!t && n.yPercent) ||
                (Math.round(e.offsetHeight / 2) === Math.round(-r) ? -50 : 0)))
              ? (e.offsetHeight * n.yPercent) / 100
              : 0) +
            "px"),
          (n.z = s + "px"),
          (n.scaleX = Lt(a)),
          (n.scaleY = Lt(o)),
          (n.rotation = Lt(l) + "deg"),
          (n.rotationX = Lt(c) + "deg"),
          (n.rotationY = Lt(u) + "deg"),
          (n.skewX = d + "deg"),
          (n.skewY = p + "deg"),
          (n.transformPerspective = f + "px"),
          (n.zOrigin = parseFloat(B.split(" ")[2]) || 0) && (j[ar] = Dr(B)),
          (n.xOffset = n.yOffset = 0),
          (n.force3D = qe.force3D),
          (n.renderTransform = n.svg ? Nr : $i ? jr : Lr),
          (n.uncache = 0),
          n
        );
      },
      Dr = function (e) {
        return (e = e.split(" "))[0] + " " + e[1];
      },
      Ir = function (e, t, n) {
        var i = gn(t);
        return Lt(parseFloat(t) + parseFloat(br(e, "x", n + "px", i))) + i;
      },
      Lr = function (e, t) {
        (t.z = "0px"),
          (t.rotationY = t.rotationX = "0deg"),
          (t.force3D = 0),
          jr(e, t);
      },
      jr = function (e, t) {
        var n = t || this,
          i = n.xPercent,
          r = n.yPercent,
          s = n.x,
          a = n.y,
          o = n.z,
          l = n.rotation,
          c = n.rotationY,
          u = n.rotationX,
          d = n.skewX,
          p = n.skewY,
          f = n.scaleX,
          h = n.scaleY,
          m = n.transformPerspective,
          g = n.force3D,
          v = n.target,
          y = n.zOrigin,
          b = "",
          _ = ("auto" === g && e && 1 !== e) || !0 === g;
        if (y && ("0deg" !== u || "0deg" !== c)) {
          var w,
            x = parseFloat(c) * Hi,
            C = Math.sin(x),
            T = Math.cos(x);
          (x = parseFloat(u) * Hi),
            (w = Math.cos(x)),
            (s = Ir(v, s, C * w * -y)),
            (a = Ir(v, a, -Math.sin(x) * -y)),
            (o = Ir(v, o, T * w * -y + y));
        }
        "0px" !== m && (b += "perspective(" + m + ") "),
          (i || r) && (b += "translate(" + i + "%, " + r + "%) "),
          (_ || "0px" !== s || "0px" !== a || "0px" !== o) &&
            (b +=
              "0px" !== o || _
                ? "translate3d(" + s + ", " + a + ", " + o + ") "
                : "translate(" + s + ", " + a + ") "),
          "0deg" !== l && (b += "rotate(" + l + ") "),
          "0deg" !== c && (b += "rotateY(" + c + ") "),
          "0deg" !== u && (b += "rotateX(" + u + ") "),
          ("0deg" === d && "0deg" === p) ||
            (b += "skew(" + d + ", " + p + ") "),
          (1 === f && 1 === h) || (b += "scale(" + f + ", " + h + ") "),
          (v.style[sr] = b || "translate(0, 0)");
      },
      Nr = function (e, t) {
        var n,
          i,
          r,
          s,
          a,
          o = t || this,
          l = o.xPercent,
          c = o.yPercent,
          u = o.x,
          d = o.y,
          p = o.rotation,
          f = o.skewX,
          h = o.skewY,
          m = o.scaleX,
          g = o.scaleY,
          v = o.target,
          y = o.xOrigin,
          b = o.yOrigin,
          _ = o.xOffset,
          w = o.yOffset,
          x = o.forceCSS,
          C = parseFloat(u),
          T = parseFloat(d);
        (p = parseFloat(p)),
          (f = parseFloat(f)),
          (h = parseFloat(h)) && ((f += h = parseFloat(h)), (p += h)),
          p || f
            ? ((p *= Hi),
              (f *= Hi),
              (n = Math.cos(p) * m),
              (i = Math.sin(p) * m),
              (r = Math.sin(p - f) * -g),
              (s = Math.cos(p - f) * g),
              f &&
                ((h *= Hi),
                (a = Math.tan(f - h)),
                (r *= a = Math.sqrt(1 + a * a)),
                (s *= a),
                h &&
                  ((a = Math.tan(h)),
                  (n *= a = Math.sqrt(1 + a * a)),
                  (i *= a))),
              (n = Lt(n)),
              (i = Lt(i)),
              (r = Lt(r)),
              (s = Lt(s)))
            : ((n = m), (s = g), (i = r = 0)),
          ((C && !~(u + "").indexOf("px")) ||
            (T && !~(d + "").indexOf("px"))) &&
            ((C = br(v, "x", u, "px")), (T = br(v, "y", d, "px"))),
          (y || b || _ || w) &&
            ((C = Lt(C + y - (y * n + b * r) + _)),
            (T = Lt(T + b - (y * i + b * s) + w))),
          (l || c) &&
            ((a = v.getBBox()),
            (C = Lt(C + (l / 100) * a.width)),
            (T = Lt(T + (c / 100) * a.height))),
          (a =
            "matrix(" +
            n +
            "," +
            i +
            "," +
            r +
            "," +
            s +
            "," +
            C +
            "," +
            T +
            ")"),
          v.setAttribute("transform", a),
          x && (v.style[sr] = a);
      },
      Br = function (e, t, n, i, r) {
        var s,
          a,
          o = Ke(r),
          l = parseFloat(r) * (o && ~r.indexOf("rad") ? Ri : 1) - i,
          c = i + l + "deg";
        return (
          o &&
            ("short" === (s = r.split("_")[1]) &&
              (l %= 360) !== l % 180 &&
              (l += l < 0 ? 360 : -360),
            "cw" === s && l < 0
              ? (l = ((l + 36e9) % 360) - 360 * ~~(l / 360))
              : "ccw" === s &&
                l > 0 &&
                (l = ((l - 36e9) % 360) - 360 * ~~(l / 360))),
          (e._pt = a = new Ei(e._pt, t, n, i, l, Yi)),
          (a.e = c),
          (a.u = "deg"),
          e._props.push(n),
          a
        );
      },
      $r = function (e, t) {
        for (var n in t) e[n] = t[n];
        return e;
      },
      zr = function (e, t, n) {
        var i,
          r,
          s,
          a,
          o,
          l,
          c,
          u = $r({}, n._gsap),
          d = n.style;
        for (r in (u.svg
          ? ((s = n.getAttribute("transform")),
            n.setAttribute("transform", ""),
            (d[sr] = t),
            (i = Ar(n, 1)),
            gr(n, sr),
            n.setAttribute("transform", s))
          : ((s = getComputedStyle(n)[sr]),
            (d[sr] = t),
            (i = Ar(n, 1)),
            (d[sr] = s)),
        zi))
          (s = u[r]) !== (a = i[r]) &&
            "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 &&
            ((o = gn(s) !== (c = gn(a)) ? br(n, r, s, c) : parseFloat(s)),
            (l = parseFloat(a)),
            (e._pt = new Ei(e._pt, i, r, o, l - o, Xi)),
            (e._pt.u = c || 0),
            e._props.push(r));
        $r(i, u);
      };
    It("padding,margin,Width,Radius", function (e, t) {
      var n = "Top",
        i = "Right",
        r = "Bottom",
        s = "Left",
        a = (t < 3 ? [n, i, r, s] : [n + s, n + i, r + i, r + s]).map(function (
          n
        ) {
          return t < 2 ? e + n : "border" + n + e;
        });
      Tr[t > 1 ? "border" + e : e] = function (e, t, n, i, r) {
        var s, o;
        if (arguments.length < 4)
          return (
            (s = a.map(function (t) {
              return _r(e, t, n);
            })),
            5 === (o = s.join(" ")).split(s[0]).length ? s[0] : o
          );
        (s = (i + "").split(" ")),
          (o = {}),
          a.forEach(function (e, t) {
            return (o[e] = s[t] = s[t] || s[((t - 1) / 2) | 0]);
          }),
          e.init(t, o, r);
      };
    });
    var Rr,
      Hr,
      Fr = {
        name: "css",
        register: dr,
        targetTest: function (e) {
          return e.style && e.nodeType;
        },
        init: function (e, t, n, i, r) {
          var s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g,
            v,
            y,
            b,
            _,
            w,
            x,
            C,
            T = this._props,
            k = e.style,
            S = n.vars.startAt;
          for (d in (ji || dr(), t))
            if (
              "autoRound" !== d &&
              ((a = t[d]), !kt[d] || !oi(d, t, n, i, e, r))
            )
              if (
                ((c = typeof a),
                (u = Tr[d]),
                "function" === c && (c = typeof (a = a.call(n, i, e, r))),
                "string" === c && ~a.indexOf("random(") && (a = En(a)),
                u)
              )
                u(this, e, d, a, n) && (b = 1);
              else if ("--" === d.substr(0, 2))
                (s = (getComputedStyle(e).getPropertyValue(d) + "").trim()),
                  (a += ""),
                  ($n.lastIndex = 0),
                  $n.test(s) || ((p = gn(s)), (f = gn(a))),
                  f ? p !== f && (s = br(e, d, s, f) + f) : p && (a += p),
                  this.add(k, "setProperty", s, a, i, r, 0, 0, d),
                  T.push(d);
              else if ("undefined" !== c) {
                if (
                  (S && d in S
                    ? ((s =
                        "function" == typeof S[d]
                          ? S[d].call(n, i, e, r)
                          : S[d]),
                      Ke(s) && ~s.indexOf("random(") && (s = En(s)),
                      gn(s + "") || (s += qe.units[d] || gn(_r(e, d)) || ""),
                      "=" === (s + "").charAt(1) && (s = _r(e, d)))
                    : (s = _r(e, d)),
                  (l = parseFloat(s)),
                  (h =
                    "string" === c && "=" === a.charAt(1) && a.substr(0, 2)) &&
                    (a = a.substr(2)),
                  (o = parseFloat(a)),
                  d in Gi &&
                    ("autoAlpha" === d &&
                      (1 === l &&
                        "hidden" === _r(e, "visibility") &&
                        o &&
                        (l = 0),
                      vr(
                        this,
                        k,
                        "visibility",
                        l ? "inherit" : "hidden",
                        o ? "inherit" : "hidden",
                        !o
                      )),
                    "scale" !== d &&
                      "transform" !== d &&
                      ~(d = Gi[d]).indexOf(",") &&
                      (d = d.split(",")[0])),
                  (m = d in zi))
                )
                  if (
                    (g ||
                      (((v = e._gsap).renderTransform && !t.parseTransform) ||
                        Ar(e, t.parseTransform),
                      (y = !1 !== t.smoothOrigin && v.smooth),
                      ((g = this._pt =
                        new Ei(
                          this._pt,
                          k,
                          sr,
                          0,
                          1,
                          v.renderTransform,
                          v,
                          0,
                          -1
                        )).dep = 1)),
                    "scale" === d)
                  )
                    (this._pt = new Ei(
                      this._pt,
                      v,
                      "scaleY",
                      v.scaleY,
                      (h ? Nt(v.scaleY, h + o) : o) - v.scaleY || 0
                    )),
                      T.push("scaleY", d),
                      (d += "X");
                  else {
                    if ("transformOrigin" === d) {
                      (w = void 0),
                        (x = void 0),
                        (C = void 0),
                        (w = (_ = a).split(" ")),
                        (x = w[0]),
                        (C = w[1] || "50%"),
                        ("top" !== x &&
                          "bottom" !== x &&
                          "left" !== C &&
                          "right" !== C) ||
                          ((_ = x), (x = C), (C = _)),
                        (w[0] = xr[x] || x),
                        (w[1] = xr[C] || C),
                        (a = w.join(" ")),
                        v.svg
                          ? Mr(e, a, 0, y, 0, this)
                          : ((f = parseFloat(a.split(" ")[2]) || 0) !==
                              v.zOrigin && vr(this, v, "zOrigin", v.zOrigin, f),
                            vr(this, k, d, Dr(s), Dr(a)));
                      continue;
                    }
                    if ("svgOrigin" === d) {
                      Mr(e, a, 1, y, 0, this);
                      continue;
                    }
                    if (d in Sr) {
                      Br(this, v, d, l, h ? Nt(l, h + a) : a);
                      continue;
                    }
                    if ("smoothOrigin" === d) {
                      vr(this, v, "smooth", v.smooth, a);
                      continue;
                    }
                    if ("force3D" === d) {
                      v[d] = a;
                      continue;
                    }
                    if ("transform" === d) {
                      zr(this, a, e);
                      continue;
                    }
                  }
                else d in k || (d = ur(d) || d);
                if (
                  m ||
                  ((o || 0 === o) && (l || 0 === l) && !Vi.test(a) && d in k)
                )
                  o || (o = 0),
                    (p = (s + "").substr((l + "").length)) !==
                      (f = gn(a) || (d in qe.units ? qe.units[d] : p)) &&
                      (l = br(e, d, s, f)),
                    (this._pt = new Ei(
                      this._pt,
                      m ? v : k,
                      d,
                      l,
                      (h ? Nt(l, h + o) : o) - l,
                      m || ("px" !== f && "zIndex" !== d) || !1 === t.autoRound
                        ? Xi
                        : Qi
                    )),
                    (this._pt.u = f || 0),
                    p !== f &&
                      "%" !== f &&
                      ((this._pt.b = s), (this._pt.r = Ui));
                else if (d in k) wr.call(this, e, d, s, h ? h + a : a);
                else {
                  if (!(d in e)) {
                    yt(d, a);
                    continue;
                  }
                  this.add(e, d, s || e[d], h ? h + a : a, i, r);
                }
                T.push(d);
              }
          b && Si(this);
        },
        get: _r,
        aliases: Gi,
        getSetter: function (e, t, n) {
          var i = Gi[t];
          return (
            i && i.indexOf(",") < 0 && (t = i),
            t in zi && t !== ar && (e._gsap.x || _r(e, "x"))
              ? n && Bi === n
                ? "scale" === t
                  ? nr
                  : tr
                : (Bi = n || {}) && ("scale" === t ? ir : rr)
              : e.style && !tt(e.style[t])
              ? Zi
              : ~t.indexOf("-")
              ? er
              : yi(e, t)
          );
        },
        core: {
          _removeProperty: gr,
          _getMatrix: Pr,
        },
      };
    (Ai.utils.checkPrefix = ur),
      (Hr = It(
        "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," +
          (Rr = "rotation,rotationX,rotationY,skewX,skewY") +
          ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
        function (e) {
          zi[e] = 1;
        }
      )),
      It(Rr, function (e) {
        (qe.units[e] = "deg"), (Sr[e] = 1);
      }),
      (Gi[Hr[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Rr),
      It(
        "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
        function (e) {
          var t = e.split(":");
          Gi[t[1]] = Hr[t[0]];
        }
      ),
      It(
        "x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
        function (e) {
          qe.units[e] = "px";
        }
      ),
      Ai.registerPlugin(Fr);
    var qr = Ai.registerPlugin(Fr) || Ai;
    qr.core.Tween;

    function Wr(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    /*!
     * Observer 3.10.4
     * https://greensock.com
     *
     * @license Copyright 2008-2022, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */
    var Vr,
      Gr,
      Xr,
      Yr,
      Ur,
      Qr,
      Jr,
      Kr,
      Zr,
      es,
      ts,
      ns,
      is = function () {
        return (
          Vr ||
          ("undefined" != typeof window &&
            (Vr = window.gsap) &&
            Vr.registerPlugin &&
            Vr)
        );
      },
      rs = 1,
      ss = [],
      as = [],
      os = [],
      ls = Date.now,
      cs = function (e, t) {
        return t;
      },
      us = function (e, t) {
        return ~os.indexOf(e) && os[os.indexOf(e) + 1][t];
      },
      ds = function (e) {
        return !!~es.indexOf(e);
      },
      ps = function (e, t, n, i, r) {
        return e.addEventListener(t, n, {
          passive: !i,
          capture: !!r,
        });
      },
      fs = function (e, t, n, i) {
        return e.removeEventListener(t, n, !!i);
      },
      hs = function () {
        return (ts && ts.isPressed) || as.cache++;
      },
      ms = function (e, t) {
        var n = function n(i) {
          if (i || 0 === i) {
            rs && (Xr.history.scrollRestoration = "manual");
            var r = ts && ts.isPressed;
            (i = n.v = Math.round(i) || (ts && ts.iOS ? 1 : 0)),
              e(i),
              (n.cacheID = as.cache),
              r && cs("ss", i);
          } else
            (t || as.cache !== n.cacheID || cs("ref")) &&
              ((n.cacheID = as.cache), (n.v = e()));
          return n.v + n.offset;
        };
        return (n.offset = 0), e && n;
      },
      gs = {
        s: "scrollLeft",
        p: "left",
        p2: "Left",
        os: "right",
        os2: "Right",
        d: "width",
        d2: "Width",
        a: "x",
        sc: ms(function (e) {
          return arguments.length
            ? Xr.scrollTo(e, vs.sc())
            : Xr.pageXOffset ||
                Yr.scrollLeft ||
                Ur.scrollLeft ||
                Qr.scrollLeft ||
                0;
        }),
      },
      vs = {
        s: "scrollTop",
        p: "top",
        p2: "Top",
        os: "bottom",
        os2: "Bottom",
        d: "height",
        d2: "Height",
        a: "y",
        op: gs,
        sc: ms(function (e) {
          return arguments.length
            ? Xr.scrollTo(gs.sc(), e)
            : Xr.pageYOffset ||
                Yr.scrollTop ||
                Ur.scrollTop ||
                Qr.scrollTop ||
                0;
        }),
      },
      ys = function (e) {
        return (
          Vr.utils.toArray(e)[0] ||
          ("string" == typeof e && !1 !== Vr.config().nullTargetWarn
            ? console.warn("Element not found:", e)
            : null)
        );
      },
      bs = function (e, t) {
        var n = t.s,
          i = t.sc,
          r = as.indexOf(e),
          s = i === vs.sc ? 1 : 2;
        return (
          !~r && (r = as.push(e) - 1),
          as[r + s] ||
            (as[r + s] =
              ms(us(e, n), !0) ||
              (ds(e)
                ? i
                : ms(function (t) {
                    return arguments.length ? (e[n] = t) : e[n];
                  })))
        );
      },
      _s = function (e, t, n) {
        var i = e,
          r = e,
          s = ls(),
          a = s,
          o = t || 50,
          l = Math.max(500, 3 * o),
          c = function (e, t) {
            var l = ls();
            t || l - s > o
              ? ((r = i), (i = e), (a = s), (s = l))
              : n
              ? (i += e)
              : (i = r + ((e - r) / (l - a)) * (s - a));
          };
        return {
          update: c,
          reset: function () {
            (r = i = n ? 0 : i), (a = s = 0);
          },
          getVelocity: function (e) {
            var t = a,
              o = r,
              u = ls();
            return (
              (e || 0 === e) && e !== i && c(e),
              s === a || u - a > l
                ? 0
                : ((i + (n ? o : -o)) / ((n ? u : s) - t)) * 1e3
            );
          },
        };
      },
      ws = function (e, t) {
        return (
          t && !e._gsapAllow && e.preventDefault(),
          e.changedTouches ? e.changedTouches[0] : e
        );
      },
      xs = function (e) {
        var t = Math.max.apply(Math, e),
          n = Math.min.apply(Math, e);
        return Math.abs(t) >= Math.abs(n) ? t : n;
      },
      Cs = function () {
        (Zr = Vr.core.globals().ScrollTrigger) &&
          Zr.core &&
          (function () {
            var e = Zr.core,
              t = e.bridge || {},
              n = e._scrollers,
              i = e._proxies;
            n.push.apply(n, as),
              i.push.apply(i, os),
              (as = n),
              (os = i),
              (cs = function (e, n) {
                return t[e](n);
              });
          })();
      },
      Ts = function (e) {
        return (
          (Vr = e || is()) &&
            "undefined" != typeof document &&
            document.body &&
            ((Xr = window),
            (Yr = document),
            (Ur = Yr.documentElement),
            (Qr = Yr.body),
            (es = [Xr, Yr, Ur, Qr]),
            Vr.utils.clamp,
            (Kr = "onpointerenter" in Qr ? "pointer" : "mouse"),
            (Jr = ks.isTouch =
              Xr.matchMedia &&
              Xr.matchMedia("(hover: none), (pointer: coarse)").matches
                ? 1
                : "ontouchstart" in Xr ||
                  navigator.maxTouchPoints > 0 ||
                  navigator.msMaxTouchPoints > 0
                ? 2
                : 0),
            (ns = ks.eventTypes =
              (
                "ontouchstart" in Ur
                  ? "touchstart,touchmove,touchcancel,touchend"
                  : "onpointerdown" in Ur
                  ? "pointerdown,pointermove,pointercancel,pointerup"
                  : "mousedown,mousemove,mouseup,mouseup"
              ).split(",")),
            setTimeout(function () {
              return (rs = 0);
            }, 500),
            Cs(),
            (Gr = 1)),
          Gr
        );
      };
    (gs.op = vs), (as.cache = 0);
    var ks = (function () {
      function e(e) {
        this.init(e);
      }
      var t, n, i;
      return (
        (e.prototype.init = function (e) {
          Gr || Ts(Vr) || console.warn("Please gsap.registerPlugin(Observer)"),
            Zr || Cs();
          var t = e.tolerance,
            n = e.dragMinimum,
            i = e.type,
            r = e.target,
            s = e.lineHeight,
            a = e.debounce,
            o = e.preventDefault,
            l = e.onStop,
            c = e.onStopDelay,
            u = e.ignore,
            d = e.wheelSpeed,
            p = e.event,
            f = e.onDragStart,
            h = e.onDragEnd,
            m = e.onDrag,
            g = e.onPress,
            v = e.onRelease,
            y = e.onRight,
            b = e.onLeft,
            _ = e.onUp,
            w = e.onDown,
            x = e.onChangeX,
            C = e.onChangeY,
            T = e.onChange,
            k = e.onToggleX,
            S = e.onToggleY,
            E = e.onHover,
            O = e.onHoverEnd,
            P = e.onMove,
            M = e.ignoreCheck,
            A = e.isNormalizer,
            D = e.onGestureStart,
            I = e.onGestureEnd,
            L = e.onWheel,
            j = e.onEnable,
            N = e.onDisable,
            B = e.onClick,
            $ = e.scrollSpeed,
            z = e.capture,
            R = e.allowClicks,
            H = e.lockAxis,
            F = e.onLockAxis;
          (this.target = r = ys(r) || Ur),
            (this.vars = e),
            u && (u = Vr.utils.toArray(u)),
            (t = t || 0),
            (n = n || 0),
            (d = d || 1),
            ($ = $ || 1),
            (i = i || "wheel,touch,pointer"),
            (a = !1 !== a),
            s || (s = parseFloat(Xr.getComputedStyle(Qr).lineHeight) || 22);
          var q,
            W,
            V,
            G,
            X,
            Y,
            U,
            Q = this,
            J = 0,
            K = 0,
            Z = bs(r, gs),
            ee = bs(r, vs),
            te = Z(),
            ne = ee(),
            ie =
              ~i.indexOf("touch") &&
              !~i.indexOf("pointer") &&
              "pointerdown" === ns[0],
            re = ds(r),
            se = r.ownerDocument || Yr,
            ae = [0, 0, 0],
            oe = [0, 0, 0],
            le = 0,
            ce = function () {
              return (le = ls());
            },
            ue = function (e, t) {
              return (
                ((Q.event = e) && u && ~u.indexOf(e.target)) ||
                (t && ie && "touch" !== e.pointerType) ||
                (M && M(e, t))
              );
            },
            de = function () {
              var e = (Q.deltaX = xs(ae)),
                n = (Q.deltaY = xs(oe)),
                i = Math.abs(e) >= t,
                r = Math.abs(n) >= t;
              T && (i || r) && T(Q, e, n, ae, oe),
                i &&
                  (y && Q.deltaX > 0 && y(Q),
                  b && Q.deltaX < 0 && b(Q),
                  x && x(Q),
                  k && Q.deltaX < 0 != J < 0 && k(Q),
                  (J = Q.deltaX),
                  (ae[0] = ae[1] = ae[2] = 0)),
                r &&
                  (w && Q.deltaY > 0 && w(Q),
                  _ && Q.deltaY < 0 && _(Q),
                  C && C(Q),
                  S && Q.deltaY < 0 != K < 0 && S(Q),
                  (K = Q.deltaY),
                  (oe[0] = oe[1] = oe[2] = 0)),
                (G || V) &&
                  (P && P(Q),
                  F && Y && F(Q),
                  V && (m(Q), (V = !1)),
                  (G = Y = !1)),
                X && (L(Q), (X = !1)),
                (q = 0);
            },
            pe = function (e, t, n) {
              (ae[n] += e),
                (oe[n] += t),
                Q._vx.update(e),
                Q._vy.update(t),
                a ? q || (q = requestAnimationFrame(de)) : de();
            },
            fe = function (e, t) {
              "y" !== U && ((ae[2] += e), Q._vx.update(e, !0)),
                "x" !== U && ((oe[2] += t), Q._vy.update(t, !0)),
                H &&
                  !U &&
                  ((Q.axis = U = Math.abs(e) > Math.abs(t) ? "x" : "y"),
                  (Y = !0)),
                a ? q || (q = requestAnimationFrame(de)) : de();
            },
            he = function (e) {
              if (!ue(e, 1)) {
                var t = (e = ws(e, o)).clientX,
                  i = e.clientY,
                  r = t - Q.x,
                  s = i - Q.y,
                  a = Q.isDragging;
                (Q.x = t),
                  (Q.y = i),
                  (a ||
                    Math.abs(Q.startX - t) >= n ||
                    Math.abs(Q.startY - i) >= n) &&
                    (m && (V = !0),
                    a || (Q.isDragging = !0),
                    fe(r, s),
                    a || (f && f(Q)));
              }
            },
            me = (Q.onPress = function (e) {
              ue(e, 1) ||
                ((Q.axis = U = null),
                W.pause(),
                (Q.isPressed = !0),
                (e = ws(e)),
                (J = K = 0),
                (Q.startX = Q.x = e.clientX),
                (Q.startY = Q.y = e.clientY),
                Q._vx.reset(),
                Q._vy.reset(),
                ps(A ? r : se, ns[1], he, o, !0),
                (Q.deltaX = Q.deltaY = 0),
                g && g(Q));
            }),
            ge = function (e) {
              if (!ue(e, 1)) {
                fs(A ? r : se, ns[1], he, !0);
                var t =
                    Q.isDragging &&
                    (Math.abs(Q.x - Q.startX) > 3 ||
                      Math.abs(Q.y - Q.startY) > 3),
                  n = ws(e);
                t ||
                  (Q._vx.reset(),
                  Q._vy.reset(),
                  o &&
                    R &&
                    Vr.delayedCall(0.08, function () {
                      if (ls() - le > 300 && !e.defaultPrevented)
                        if (e.target.click) e.target.click();
                        else if (se.createEvent) {
                          var t = se.createEvent("MouseEvents");
                          t.initMouseEvent(
                            "click",
                            !0,
                            !0,
                            Xr,
                            1,
                            n.screenX,
                            n.screenY,
                            n.clientX,
                            n.clientY,
                            !1,
                            !1,
                            !1,
                            !1,
                            0,
                            null
                          ),
                            e.target.dispatchEvent(t);
                        }
                    })),
                  (Q.isDragging = Q.isGesturing = Q.isPressed = !1),
                  l && !A && W.restart(!0),
                  h && t && h(Q),
                  v && v(Q, t);
              }
            },
            ve = function (e) {
              return (
                e.touches &&
                e.touches.length > 1 &&
                (Q.isGesturing = !0) &&
                D(e, Q.isDragging)
              );
            },
            ye = function () {
              return (Q.isGesturing = !1) || I(Q);
            },
            be = function (e) {
              if (!ue(e)) {
                var t = Z(),
                  n = ee();
                pe((t - te) * $, (n - ne) * $, 1),
                  (te = t),
                  (ne = n),
                  l && W.restart(!0);
              }
            },
            _e = function (e) {
              if (!ue(e)) {
                (e = ws(e, o)), L && (X = !0);
                var t =
                  (1 === e.deltaMode
                    ? s
                    : 2 === e.deltaMode
                    ? Xr.innerHeight
                    : 1) * d;
                pe(e.deltaX * t, e.deltaY * t, 0), l && !A && W.restart(!0);
              }
            },
            we = function (e) {
              if (!ue(e)) {
                var t = e.clientX,
                  n = e.clientY,
                  i = t - Q.x,
                  r = n - Q.y;
                (Q.x = t), (Q.y = n), (G = !0), (i || r) && fe(i, r);
              }
            },
            xe = function (e) {
              (Q.event = e), E(Q);
            },
            Ce = function (e) {
              (Q.event = e), O(Q);
            },
            Te = function (e) {
              return ue(e) || (ws(e, o) && B(Q));
            };
          (W = Q._dc =
            Vr.delayedCall(c || 0.25, function () {
              Q._vx.reset(), Q._vy.reset(), W.pause(), l && l(Q);
            }).pause()),
            (Q.deltaX = Q.deltaY = 0),
            (Q._vx = _s(0, 50, !0)),
            (Q._vy = _s(0, 50, !0)),
            (Q.scrollX = Z),
            (Q.scrollY = ee),
            (Q.isDragging = Q.isGesturing = Q.isPressed = !1),
            (Q.enable = function (e) {
              return (
                Q.isEnabled ||
                  (ps(re ? se : r, "scroll", hs),
                  i.indexOf("scroll") >= 0 &&
                    ps(re ? se : r, "scroll", be, o, z),
                  i.indexOf("wheel") >= 0 && ps(r, "wheel", _e, o, z),
                  ((i.indexOf("touch") >= 0 && Jr) ||
                    i.indexOf("pointer") >= 0) &&
                    (ps(r, ns[0], me, o, z),
                    ps(se, ns[2], ge),
                    ps(se, ns[3], ge),
                    R && ps(r, "click", ce, !1, !0),
                    B && ps(r, "click", Te),
                    D && ps(se, "gesturestart", ve),
                    I && ps(se, "gestureend", ye),
                    E && ps(r, Kr + "enter", xe),
                    O && ps(r, Kr + "leave", Ce),
                    P && ps(r, Kr + "move", we)),
                  (Q.isEnabled = !0),
                  e && e.type && me(e),
                  j && j(Q)),
                Q
              );
            }),
            (Q.disable = function () {
              Q.isEnabled &&
                (ss.filter(function (e) {
                  return e !== Q && ds(e.target);
                }).length || fs(re ? se : r, "scroll", hs),
                Q.isPressed &&
                  (Q._vx.reset(), Q._vy.reset(), fs(A ? r : se, ns[1], he, !0)),
                fs(re ? se : r, "scroll", be, z),
                fs(r, "wheel", _e, z),
                fs(r, ns[0], me, z),
                fs(se, ns[2], ge),
                fs(se, ns[3], ge),
                fs(r, "click", ce, !0),
                fs(r, "click", Te),
                fs(se, "gesturestart", ve),
                fs(se, "gestureend", ye),
                fs(r, Kr + "enter", xe),
                fs(r, Kr + "leave", Ce),
                fs(r, Kr + "move", we),
                (Q.isEnabled = Q.isPressed = Q.isDragging = !1),
                N && N(Q));
            }),
            (Q.kill = function () {
              Q.disable();
              var e = ss.indexOf(Q);
              e >= 0 && ss.splice(e, 1), ts === Q && (ts = 0);
            }),
            ss.push(Q),
            A && ds(r) && (ts = Q),
            Q.enable(p);
        }),
        (t = e),
        (n = [
          {
            key: "velocityX",
            get: function () {
              return this._vx.getVelocity();
            },
          },
          {
            key: "velocityY",
            get: function () {
              return this._vy.getVelocity();
            },
          },
        ]) && Wr(t.prototype, n),
        i && Wr(t, i),
        e
      );
    })();
    (ks.version = "3.10.4"),
      (ks.create = function (e) {
        return new ks(e);
      }),
      (ks.register = Ts),
      (ks.getAll = function () {
        return ss.slice();
      }),
      (ks.getById = function (e) {
        return ss.filter(function (t) {
          return t.vars.id === e;
        })[0];
      }),
      is() && Vr.registerPlugin(ks);
    /*!
     * ScrollTrigger 3.10.4
     * https://greensock.com
     *
     * @license Copyright 2008-2022, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */
    var Ss,
      Es,
      Os,
      Ps,
      Ms,
      As,
      Ds,
      Is,
      Ls,
      js,
      Ns,
      Bs,
      $s,
      zs,
      Rs,
      Hs,
      Fs,
      qs,
      Ws,
      Vs,
      Gs,
      Xs,
      Ys,
      Us,
      Qs,
      Js,
      Ks,
      Zs,
      ea,
      ta,
      na,
      ia,
      ra,
      sa = 1,
      aa = Date.now,
      oa = aa(),
      la = 0,
      ca = 0,
      ua = function () {
        return (zs = 1);
      },
      da = function () {
        return (zs = 0);
      },
      pa = function (e) {
        return e;
      },
      fa = function (e) {
        return Math.round(1e5 * e) / 1e5 || 0;
      },
      ha = function () {
        return "undefined" != typeof window;
      },
      ma = function () {
        return Ss || (ha() && (Ss = window.gsap) && Ss.registerPlugin && Ss);
      },
      ga = function (e) {
        return !!~Ds.indexOf(e);
      },
      va = function (e) {
        return (
          us(e, "getBoundingClientRect") ||
          (ga(e)
            ? function () {
                return (
                  (wo.width = Os.innerWidth), (wo.height = Os.innerHeight), wo
                );
              }
            : function () {
                return Ia(e);
              })
        );
      },
      ya = function (e, t) {
        var n = t.s,
          i = t.d2,
          r = t.d,
          s = t.a;
        return (n = "scroll" + i) && (s = us(e, n))
          ? s() - va(e)()[r]
          : ga(e)
          ? (Ms[n] || As[n]) -
            (Os["inner" + i] || Ms["client" + i] || As["client" + i])
          : e[n] - e["offset" + i];
      },
      ba = function (e, t) {
        for (var n = 0; n < Ws.length; n += 3)
          (!t || ~t.indexOf(Ws[n + 1])) && e(Ws[n], Ws[n + 1], Ws[n + 2]);
      },
      _a = function (e) {
        return "string" == typeof e;
      },
      wa = function (e) {
        return "function" == typeof e;
      },
      xa = function (e) {
        return "number" == typeof e;
      },
      Ca = function (e) {
        return "object" == typeof e;
      },
      Ta = function (e) {
        return wa(e) && e();
      },
      ka = function (e, t) {
        return function () {
          var n = Ta(e),
            i = Ta(t);
          return function () {
            Ta(n), Ta(i);
          };
        };
      },
      Sa = function (e, t, n) {
        return e && e.progress(t ? 0 : 1) && n && e.pause();
      },
      Ea = function (e, t) {
        if (e.enabled) {
          var n = t(e);
          n && n.totalTime && (e.callbackAnimation = n);
        }
      },
      Oa = Math.abs,
      Pa = "padding",
      Ma = "px",
      Aa = function (e) {
        return Os.getComputedStyle(e);
      },
      Da = function (e, t) {
        for (var n in t) n in e || (e[n] = t[n]);
        return e;
      },
      Ia = function (e, t) {
        var n =
            t &&
            "matrix(1, 0, 0, 1, 0, 0)" !== Aa(e)[Rs] &&
            Ss.to(e, {
              x: 0,
              y: 0,
              xPercent: 0,
              yPercent: 0,
              rotation: 0,
              rotationX: 0,
              rotationY: 0,
              scale: 1,
              skewX: 0,
              skewY: 0,
            }).progress(1),
          i = e.getBoundingClientRect();
        return n && n.progress(0).kill(), i;
      },
      La = function (e, t) {
        var n = t.d2;
        return e["offset" + n] || e["client" + n] || 0;
      },
      ja = function (e) {
        var t,
          n = [],
          i = e.labels,
          r = e.duration();
        for (t in i) n.push(i[t] / r);
        return n;
      },
      Na = function (e) {
        var t = Ss.utils.snap(e),
          n =
            Array.isArray(e) &&
            e.slice(0).sort(function (e, t) {
              return e - t;
            });
        return n
          ? function (e, i, r) {
              var s;
              if ((void 0 === r && (r = 0.001), !i)) return t(e);
              if (i > 0) {
                for (e -= r, s = 0; s < n.length; s++)
                  if (n[s] >= e) return n[s];
                return n[s - 1];
              }
              for (s = n.length, e += r; s--; ) if (n[s] <= e) return n[s];
              return n[0];
            }
          : function (n, i, r) {
              void 0 === r && (r = 0.001);
              var s = t(n);
              return !i || Math.abs(s - n) < r || s - n < 0 == i < 0
                ? s
                : t(i < 0 ? n - e : n + e);
            };
      },
      Ba = function (e, t, n, i) {
        return n.split(",").forEach(function (n) {
          return e(t, n, i);
        });
      },
      $a = function (e, t, n, i, r) {
        return e.addEventListener(t, n, {
          passive: !i,
          capture: !!r,
        });
      },
      za = function (e, t, n, i) {
        return e.removeEventListener(t, n, !!i);
      },
      Ra = function (e, t, n) {
        return n && n.wheelHandler && e(t, "wheel", n);
      },
      Ha = {
        startColor: "green",
        endColor: "red",
        indent: 0,
        fontSize: "16px",
        fontWeight: "normal",
      },
      Fa = {
        toggleActions: "play",
        anticipatePin: 0,
      },
      qa = {
        top: 0,
        left: 0,
        center: 0.5,
        bottom: 1,
        right: 1,
      },
      Wa = function (e, t) {
        if (_a(e)) {
          var n = e.indexOf("="),
            i = ~n ? +(e.charAt(n - 1) + 1) * parseFloat(e.substr(n + 1)) : 0;
          ~n &&
            (e.indexOf("%") > n && (i *= t / 100), (e = e.substr(0, n - 1))),
            (e =
              i +
              (e in qa
                ? qa[e] * t
                : ~e.indexOf("%")
                ? (parseFloat(e) * t) / 100
                : parseFloat(e) || 0));
        }
        return e;
      },
      Va = function (e, t, n, i, r, s, a, o) {
        var l = r.startColor,
          c = r.endColor,
          u = r.fontSize,
          d = r.indent,
          p = r.fontWeight,
          f = Ps.createElement("div"),
          h = ga(n) || "fixed" === us(n, "pinType"),
          m = -1 !== e.indexOf("scroller"),
          g = h ? As : n,
          v = -1 !== e.indexOf("start"),
          y = v ? l : c,
          b =
            "border-color:" +
            y +
            ";font-size:" +
            u +
            ";color:" +
            y +
            ";font-weight:" +
            p +
            ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
        return (
          (b += "position:" + ((m || o) && h ? "fixed;" : "absolute;")),
          (m || o || !h) &&
            (b +=
              (i === vs ? "right" : "bottom") +
              ":" +
              (s + parseFloat(d)) +
              "px;"),
          a &&
            (b +=
              "box-sizing:border-box;text-align:left;width:" +
              a.offsetWidth +
              "px;"),
          (f._isStart = v),
          f.setAttribute(
            "class",
            "gsap-marker-" + e + (t ? " marker-" + t : "")
          ),
          (f.style.cssText = b),
          (f.innerText = t || 0 === t ? e + "-" + t : e),
          g.children[0] ? g.insertBefore(f, g.children[0]) : g.appendChild(f),
          (f._offset = f["offset" + i.op.d2]),
          Ga(f, 0, i, v),
          f
        );
      },
      Ga = function (e, t, n, i) {
        var r = {
            display: "block",
          },
          s = n[i ? "os2" : "p2"],
          a = n[i ? "p2" : "os2"];
        (e._isFlipped = i),
          (r[n.a + "Percent"] = i ? -100 : 0),
          (r[n.a] = i ? "1px" : 0),
          (r["border" + s + "Width"] = 1),
          (r["border" + a + "Width"] = 0),
          (r[n.p] = t + "px"),
          Ss.set(e, r);
      },
      Xa = [],
      Ya = {},
      Ua = function () {
        return aa() - la > 34 && ho();
      },
      Qa = function () {
        (!Ys || !Ys.isPressed || Ys.startX > As.clientWidth) &&
          (as.cache++,
          ea || (ea = requestAnimationFrame(ho)),
          la || ro("scrollStart"),
          (la = aa()));
      },
      Ja = function () {
        (Js = Os.innerWidth), (Qs = Os.innerHeight);
      },
      Ka = function () {
        as.cache++,
          !$s &&
            !Xs &&
            !Ps.fullscreenElement &&
            !Ps.webkitFullscreenElement &&
            (!Us ||
              Js !== Os.innerWidth ||
              Math.abs(Os.innerHeight - Qs) > 0.25 * Os.innerHeight) &&
            Is.restart(!0);
      },
      Za = {},
      eo = [],
      to = [],
      no = function (e) {
        var t,
          n = Ss.ticker.frame,
          i = [],
          r = 0;
        if (na !== n || sa) {
          for (oo(); r < to.length; r += 4)
            (t = Os.matchMedia(to[r]).matches) !== to[r + 3] &&
              ((to[r + 3] = t),
              t ? i.push(r) : oo(1, to[r]) || (wa(to[r + 2]) && to[r + 2]()));
          for (ao(), r = 0; r < i.length; r++)
            (t = i[r]), (ta = to[t]), (to[t + 2] = to[t + 1](e));
          (ta = 0), Es && uo(0, 1), (na = n), ro("matchMedia");
        }
      },
      io = function e() {
        return za(So, "scrollEnd", e) || uo(!0);
      },
      ro = function (e) {
        return (
          (Za[e] &&
            Za[e].map(function (e) {
              return e();
            })) ||
          eo
        );
      },
      so = [],
      ao = function (e) {
        for (var t = 0; t < so.length; t += 5)
          (e && so[t + 4] !== e) ||
            ((so[t].style.cssText = so[t + 1]),
            so[t].getBBox && so[t].setAttribute("transform", so[t + 2] || ""),
            (so[t + 3].uncache = 1));
      },
      oo = function (e, t) {
        var n;
        for (Hs = 0; Hs < Xa.length; Hs++)
          (n = Xa[Hs]), (t && n.media !== t) || (e ? n.kill(1) : n.revert());
        t && ao(t), t || ro("revert");
      },
      lo = function () {
        return (
          as.cache++ &&
          as.forEach(function (e) {
            return "function" == typeof e && (e.rec = 0);
          })
        );
      },
      co = 0,
      uo = function (e, t) {
        if (!la || e) {
          ia = !0;
          var n = ro("refreshInit");
          Vs && So.sort(),
            t || oo(),
            Xa.slice(0).forEach(function (e) {
              return e.refresh();
            }),
            Xa.forEach(function (e) {
              return (
                "max" === e.vars.end &&
                e.setPositions(e.start, ya(e.scroller, e._dir))
              );
            }),
            n.forEach(function (e) {
              return e && e.render && e.render(-1);
            }),
            lo(),
            Is.pause(),
            co++,
            (ia = !1),
            ro("refresh");
        } else $a(So, "scrollEnd", io);
      },
      po = 0,
      fo = 1,
      ho = function () {
        if (!ia) {
          (So.isUpdating = !0), ra && ra.update(0);
          var e = Xa.length,
            t = aa(),
            n = t - oa >= 50,
            i = e && Xa[0].scroll();
          if (
            ((fo = po > i ? -1 : 1),
            (po = i),
            n &&
              (la && !zs && t - la > 200 && ((la = 0), ro("scrollEnd")),
              (Ns = oa),
              (oa = t)),
            fo < 0)
          ) {
            for (Hs = e; Hs-- > 0; ) Xa[Hs] && Xa[Hs].update(0, n);
            fo = 1;
          } else for (Hs = 0; Hs < e; Hs++) Xa[Hs] && Xa[Hs].update(0, n);
          So.isUpdating = !1;
        }
        ea = 0;
      },
      mo = [
        "left",
        "top",
        "bottom",
        "right",
        "marginBottom",
        "marginRight",
        "marginTop",
        "marginLeft",
        "display",
        "flexShrink",
        "float",
        "zIndex",
        "gridColumnStart",
        "gridColumnEnd",
        "gridRowStart",
        "gridRowEnd",
        "gridArea",
        "justifySelf",
        "alignSelf",
        "placeSelf",
        "order",
      ],
      go = mo.concat([
        "width",
        "height",
        "boxSizing",
        "maxWidth",
        "maxHeight",
        "position",
        "margin",
        Pa,
        Pa + "Top",
        Pa + "Right",
        Pa + "Bottom",
        Pa + "Left",
      ]),
      vo = function (e, t, n, i) {
        if (e.parentNode !== t) {
          for (var r, s = mo.length, a = t.style, o = e.style; s--; )
            a[(r = mo[s])] = n[r];
          (a.position = "absolute" === n.position ? "absolute" : "relative"),
            "inline" === n.display && (a.display = "inline-block"),
            (o.bottom = o.right = a.flexBasis = "auto"),
            (a.overflow = "visible"),
            (a.boxSizing = "border-box"),
            (a.width = La(e, gs) + Ma),
            (a.height = La(e, vs) + Ma),
            (a[Pa] = o.margin = o.top = o.left = "0"),
            bo(i),
            (o.width = o.maxWidth = n.width),
            (o.height = o.maxHeight = n.height),
            (o[Pa] = n[Pa]),
            e.parentNode.insertBefore(t, e),
            t.appendChild(e);
        }
      },
      yo = /([A-Z])/g,
      bo = function (e) {
        if (e) {
          var t,
            n,
            i = e.t.style,
            r = e.length,
            s = 0;
          for ((e.t._gsap || Ss.core.getCache(e.t)).uncache = 1; s < r; s += 2)
            (n = e[s + 1]),
              (t = e[s]),
              n
                ? (i[t] = n)
                : i[t] && i.removeProperty(t.replace(yo, "-$1").toLowerCase());
        }
      },
      _o = function (e) {
        for (var t = go.length, n = e.style, i = [], r = 0; r < t; r++)
          i.push(go[r], n[go[r]]);
        return (i.t = e), i;
      },
      wo = {
        left: 0,
        top: 0,
      },
      xo = function (e, t, n, i, r, s, a, o, l, c, u, d, p) {
        wa(e) && (e = e(o)),
          _a(e) &&
            "max" === e.substr(0, 3) &&
            (e = d + ("=" === e.charAt(4) ? Wa("0" + e.substr(3), n) : 0));
        var f,
          h,
          m,
          g = p ? p.time() : 0;
        if ((p && p.seek(0), xa(e))) a && Ga(a, n, i, !0);
        else {
          wa(t) && (t = t(o));
          var v,
            y,
            b,
            _,
            w = e.split(" ");
          (m = ys(t) || As),
            ((v = Ia(m) || {}) && (v.left || v.top)) ||
              "none" !== Aa(m).display ||
              ((_ = m.style.display),
              (m.style.display = "block"),
              (v = Ia(m)),
              _ ? (m.style.display = _) : m.style.removeProperty("display")),
            (y = Wa(w[0], v[i.d])),
            (b = Wa(w[1] || "0", n)),
            (e = v[i.p] - l[i.p] - c + y + r - b),
            a && Ga(a, b, i, n - b < 20 || (a._isStart && b > 20)),
            (n -= n - b);
        }
        if (s) {
          var x = e + n,
            C = s._isStart;
          (f = "scroll" + i.d2),
            Ga(
              s,
              x,
              i,
              (C && x > 20) ||
                (!C && (u ? Math.max(As[f], Ms[f]) : s.parentNode[f]) <= x + 1)
            ),
            u &&
              ((l = Ia(a)),
              u && (s.style[i.op.p] = l[i.op.p] - i.op.m - s._offset + Ma));
        }
        return (
          p &&
            m &&
            ((f = Ia(m)),
            p.seek(d),
            (h = Ia(m)),
            (p._caScrollDist = f[i.p] - h[i.p]),
            (e = (e / p._caScrollDist) * d)),
          p && p.seek(g),
          p ? e : Math.round(e)
        );
      },
      Co = /(webkit|moz|length|cssText|inset)/i,
      To = function (e, t, n, i) {
        if (e.parentNode !== t) {
          var r,
            s,
            a = e.style;
          if (t === As) {
            for (r in ((e._stOrig = a.cssText), (s = Aa(e))))
              +r ||
                Co.test(r) ||
                !s[r] ||
                "string" != typeof a[r] ||
                "0" === r ||
                (a[r] = s[r]);
            (a.top = n), (a.left = i);
          } else a.cssText = e._stOrig;
          (Ss.core.getCache(e).uncache = 1), t.appendChild(e);
        }
      },
      ko = function (e, t) {
        var n,
          i,
          r = bs(e, t),
          s = "_scroll" + t.p2,
          a = function t(a, o, l, c, u) {
            var d = t.tween,
              p = o.onComplete,
              f = {};
            return (
              (l = l || r()),
              (u = (c && u) || 0),
              (c = c || a - l),
              d && d.kill(),
              (n = Math.round(l)),
              (o[s] = a),
              (o.modifiers = f),
              (f[s] = function (e) {
                return (
                  (e = fa(r())) !== n &&
                  e !== i &&
                  Math.abs(e - n) > 2 &&
                  Math.abs(e - i) > 2
                    ? (d.kill(), (t.tween = 0))
                    : (e = l + c * d.ratio + u * d.ratio * d.ratio),
                  (i = n),
                  (n = fa(e))
                );
              }),
              (o.onComplete = function () {
                (t.tween = 0), p && p.call(d);
              }),
              (d = t.tween = Ss.to(e, o))
            );
          };
        return (
          (e[s] = r),
          (r.wheelHandler = function () {
            return a.tween && a.tween.kill() && (a.tween = 0);
          }),
          $a(e, "wheel", r.wheelHandler),
          a
        );
      },
      So = (function () {
        function e(t, n) {
          Es ||
            e.register(Ss) ||
            console.warn("Please gsap.registerPlugin(ScrollTrigger)"),
            this.init(t, n);
        }
        return (
          (e.prototype.init = function (t, n) {
            if (
              ((this.progress = this.start = 0),
              this.vars && this.kill(!0, !0),
              ca)
            ) {
              var i,
                r,
                s,
                a,
                o,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                g,
                v,
                y,
                b,
                _,
                w,
                x,
                C,
                T,
                k,
                S,
                E,
                O,
                P,
                M,
                A,
                D,
                I,
                L,
                j,
                N,
                B,
                $,
                z,
                R,
                H,
                F,
                q,
                W = (t = Da(
                  _a(t) || xa(t) || t.nodeType
                    ? {
                        trigger: t,
                      }
                    : t,
                  Fa
                )),
                V = W.onUpdate,
                G = W.toggleClass,
                X = W.id,
                Y = W.onToggle,
                U = W.onRefresh,
                Q = W.scrub,
                J = W.trigger,
                K = W.pin,
                Z = W.pinSpacing,
                ee = W.invalidateOnRefresh,
                te = W.anticipatePin,
                ne = W.onScrubComplete,
                ie = W.onSnapComplete,
                re = W.once,
                se = W.snap,
                ae = W.pinReparent,
                oe = W.pinSpacer,
                le = W.containerAnimation,
                ce = W.fastScrollEnd,
                ue = W.preventOverlaps,
                de =
                  t.horizontal || (t.containerAnimation && !1 !== t.horizontal)
                    ? gs
                    : vs,
                pe = !Q && 0 !== Q,
                fe = ys(t.scroller || Os),
                he = Ss.core.getCache(fe),
                me = ga(fe),
                ge =
                  "fixed" ===
                  ("pinType" in t
                    ? t.pinType
                    : us(fe, "pinType") || (me && "fixed")),
                ve = [t.onEnter, t.onLeave, t.onEnterBack, t.onLeaveBack],
                ye = pe && t.toggleActions.split(" "),
                be = "markers" in t ? t.markers : Fa.markers,
                _e = me
                  ? 0
                  : parseFloat(Aa(fe)["border" + de.p2 + "Width"]) || 0,
                we = this,
                xe =
                  t.onRefreshInit &&
                  function () {
                    return t.onRefreshInit(we);
                  },
                Ce = (function (e, t, n) {
                  var i = n.d,
                    r = n.d2,
                    s = n.a;
                  return (s = us(e, "getBoundingClientRect"))
                    ? function () {
                        return s()[i];
                      }
                    : function () {
                        return (t ? Os["inner" + r] : e["client" + r]) || 0;
                      };
                })(fe, me, de),
                Te = (function (e, t) {
                  return !t || ~os.indexOf(e)
                    ? va(e)
                    : function () {
                        return wo;
                      };
                })(fe, me),
                ke = 0,
                Se = 0,
                Ee = bs(fe, de);
              if (
                ((we.media = ta),
                (we._dir = de),
                (te *= 45),
                (we.scroller = fe),
                (we.scroll = le ? le.time.bind(le) : Ee),
                (a = Ee()),
                (we.vars = t),
                (n = n || t.animation),
                "refreshPriority" in t &&
                  ((Vs = 1), -9999 === t.refreshPriority && (ra = we)),
                (he.tweenScroll = he.tweenScroll || {
                  top: ko(fe, vs),
                  left: ko(fe, gs),
                }),
                (we.tweenTo = i = he.tweenScroll[de.p]),
                (we.scrubDuration = function (e) {
                  (I = xa(e) && e)
                    ? D
                      ? D.duration(e)
                      : (D = Ss.to(n, {
                          ease: "expo",
                          totalProgress: "+=0.001",
                          duration: I,
                          paused: !0,
                          onComplete: function () {
                            return ne && ne(we);
                          },
                        }))
                    : (D && D.progress(1).kill(), (D = 0));
                }),
                n &&
                  ((n.vars.lazy = !1),
                  n._initted ||
                    (!1 !== n.vars.immediateRender &&
                      !1 !== t.immediateRender &&
                      n.render(0, !0, !0)),
                  (we.animation = n.pause()),
                  (n.scrollTrigger = we),
                  we.scrubDuration(Q),
                  (M = 0),
                  X || (X = n.vars.id)),
                Xa.push(we),
                se &&
                  ((Ca(se) && !se.push) ||
                    (se = {
                      snapTo: se,
                    }),
                  "scrollBehavior" in As.style &&
                    Ss.set(me ? [As, Ms] : fe, {
                      scrollBehavior: "auto",
                    }),
                  (s = wa(se.snapTo)
                    ? se.snapTo
                    : "labels" === se.snapTo
                    ? (function (e) {
                        return function (t) {
                          return Ss.utils.snap(ja(e), t);
                        };
                      })(n)
                    : "labelsDirectional" === se.snapTo
                    ? ((H = n),
                      function (e, t) {
                        return Na(ja(H))(e, t.direction);
                      })
                    : !1 !== se.directional
                    ? function (e, t) {
                        return Na(se.snapTo)(
                          e,
                          aa() - Se < 500 ? 0 : t.direction
                        );
                      }
                    : Ss.utils.snap(se.snapTo)),
                  (L = se.duration || {
                    min: 0.1,
                    max: 2,
                  }),
                  (L = Ca(L) ? js(L.min, L.max) : js(L, L)),
                  (j = Ss.delayedCall(se.delay || I / 2 || 0.1, function () {
                    var e = Ee(),
                      t = aa() - Se < 500,
                      r = i.tween;
                    if (
                      !(t || Math.abs(we.getVelocity()) < 10) ||
                      r ||
                      zs ||
                      ke === e
                    )
                      we.isActive && ke !== e && j.restart(!0);
                    else {
                      var a = (e - l) / m,
                        o = n && !pe ? n.totalProgress() : a,
                        u = t ? 0 : ((o - A) / (aa() - Ns)) * 1e3 || 0,
                        d = Ss.utils.clamp(-a, 1 - a, (Oa(u / 2) * u) / 0.185),
                        p = a + (!1 === se.inertia ? 0 : d),
                        f = js(0, 1, s(p, we)),
                        h = Math.round(l + f * m),
                        g = se,
                        v = g.onStart,
                        y = g.onInterrupt,
                        b = g.onComplete;
                      if (e <= c && e >= l && h !== e) {
                        if (r && !r._initted && r.data <= Oa(h - e)) return;
                        !1 === se.inertia && (d = f - a),
                          i(
                            h,
                            {
                              duration: L(
                                Oa(
                                  (0.185 * Math.max(Oa(p - o), Oa(f - o))) /
                                    u /
                                    0.05 || 0
                                )
                              ),
                              ease: se.ease || "power3",
                              data: Oa(h - e),
                              onInterrupt: function () {
                                return j.restart(!0) && y && y(we);
                              },
                              onComplete: function () {
                                we.update(),
                                  (ke = Ee()),
                                  (M = A =
                                    n && !pe ? n.totalProgress() : we.progress),
                                  ie && ie(we),
                                  b && b(we);
                              },
                            },
                            e,
                            d * m,
                            h - e - d * m
                          ),
                          v && v(we, i.tween);
                      }
                    }
                  }).pause())),
                X && (Ya[X] = we),
                (R =
                  (J = we.trigger = ys(J || K)) &&
                  J._gsap &&
                  J._gsap.stRevert) && (R = R(we)),
                (K = !0 === K ? J : ys(K)),
                _a(G) &&
                  (G = {
                    targets: J,
                    className: G,
                  }),
                K &&
                  (!1 === Z ||
                    "margin" === Z ||
                    (Z = !(!Z && "flex" === Aa(K.parentNode).display) && Pa),
                  (we.pin = K),
                  !1 !== t.force3D &&
                    Ss.set(K, {
                      force3D: !0,
                    }),
                  (r = Ss.core.getCache(K)).spacer
                    ? (g = r.pinState)
                    : (oe &&
                        ((oe = ys(oe)) &&
                          !oe.nodeType &&
                          (oe = oe.current || oe.nativeElement),
                        (r.spacerIsNative = !!oe),
                        oe && (r.spacerState = _o(oe))),
                      (r.spacer = b = oe || Ps.createElement("div")),
                      b.classList.add("pin-spacer"),
                      X && b.classList.add("pin-spacer-" + X),
                      (r.pinState = g = _o(K))),
                  (we.spacer = b = r.spacer),
                  (P = Aa(K)),
                  (k = P[Z + de.os2]),
                  (w = Ss.getProperty(K)),
                  (x = Ss.quickSetter(K, de.a, Ma)),
                  vo(K, b, P),
                  (y = _o(K))),
                be)
              ) {
                (h = Ca(be) ? Da(be, Ha) : Ha),
                  (p = Va("scroller-start", X, fe, de, h, 0)),
                  (f = Va("scroller-end", X, fe, de, h, 0, p)),
                  (_ = p["offset" + de.op.d2]);
                var Oe = ys(us(fe, "content") || fe);
                (u = this.markerStart = Va("start", X, Oe, de, h, _, 0, le)),
                  (d = this.markerEnd = Va("end", X, Oe, de, h, _, 0, le)),
                  le && (z = Ss.quickSetter([u, d], de.a, Ma)),
                  ge ||
                    (os.length && !0 === us(fe, "fixedMarkers")) ||
                    ((q = Aa((F = me ? As : fe)).position),
                    (F.style.position =
                      "absolute" === q || "fixed" === q ? q : "relative"),
                    Ss.set([p, f], {
                      force3D: !0,
                    }),
                    (E = Ss.quickSetter(p, de.a, Ma)),
                    (O = Ss.quickSetter(f, de.a, Ma)));
              }
              if (le) {
                var Pe = le.vars.onUpdate,
                  Me = le.vars.onUpdateParams;
                le.eventCallback("onUpdate", function () {
                  we.update(0, 0, 1), Pe && Pe.apply(Me || []);
                });
              }
              (we.previous = function () {
                return Xa[Xa.indexOf(we) - 1];
              }),
                (we.next = function () {
                  return Xa[Xa.indexOf(we) + 1];
                }),
                (we.revert = function (e) {
                  var t = !1 !== e || !we.enabled,
                    i = $s;
                  t !== we.isReverted &&
                    (t &&
                      (we.scroll.rec || !$s || !ia || (we.scroll.rec = Ee()),
                      (B = Math.max(Ee(), we.scroll.rec || 0)),
                      (N = we.progress),
                      ($ = n && n.progress())),
                    u &&
                      [u, d, p, f].forEach(function (e) {
                        return (e.style.display = t ? "none" : "block");
                      }),
                    t && ($s = 1),
                    we.update(t),
                    ($s = i),
                    K &&
                      (t
                        ? (function (e, t, n) {
                            bo(n);
                            var i = e._gsap;
                            if (i.spacerIsNative) bo(i.spacerState);
                            else if (e.parentNode === t) {
                              var r = t.parentNode;
                              r && (r.insertBefore(e, t), r.removeChild(t));
                            }
                          })(K, b, g)
                        : (!ae || !we.isActive) && vo(K, b, Aa(K), S)),
                    (we.isReverted = t));
                }),
                (we.refresh = function (r, s) {
                  if ((!$s && we.enabled) || s)
                    if (K && r && la) $a(e, "scrollEnd", io);
                    else {
                      !ia && xe && xe(we),
                        ($s = 1),
                        (Se = aa()),
                        i.tween && (i.tween.kill(), (i.tween = 0)),
                        D && D.pause(),
                        ee && n && n.time(-0.01, !0).invalidate(),
                        we.isReverted || we.revert();
                      for (
                        var h,
                          _,
                          x,
                          k,
                          E,
                          O,
                          P,
                          M,
                          A,
                          I,
                          L = Ce(),
                          z = Te(),
                          R = le ? le.duration() : ya(fe, de),
                          H = 0,
                          F = 0,
                          q = t.end,
                          W = t.endTrigger || J,
                          V =
                            t.start ||
                            (0 !== t.start && J ? (K ? "0 0" : "0 100%") : 0),
                          G = (we.pinnedContainer =
                            t.pinnedContainer && ys(t.pinnedContainer)),
                          X = (J && Math.max(0, Xa.indexOf(we))) || 0,
                          Y = X;
                        Y--;

                      )
                        (O = Xa[Y]).end || O.refresh(0, 1) || ($s = 1),
                          !(P = O.pin) ||
                            (P !== J && P !== K) ||
                            O.isReverted ||
                            (I || (I = []), I.unshift(O), O.revert()),
                          O !== Xa[Y] && (X--, Y--);
                      for (
                        wa(V) && (V = V(we)),
                          l =
                            xo(V, J, L, de, Ee(), u, p, we, z, _e, ge, R, le) ||
                            (K ? -0.001 : 0),
                          wa(q) && (q = q(we)),
                          _a(q) &&
                            !q.indexOf("+=") &&
                            (~q.indexOf(" ")
                              ? (q = (_a(V) ? V.split(" ")[0] : "") + q)
                              : ((H = Wa(q.substr(2), L)),
                                (q = _a(V) ? V : l + H),
                                (W = J))),
                          c =
                            Math.max(
                              l,
                              xo(
                                q || (W ? "100% 0" : R),
                                W,
                                L,
                                de,
                                Ee() + H,
                                d,
                                f,
                                we,
                                z,
                                _e,
                                ge,
                                R,
                                le
                              )
                            ) || -0.001,
                          m = c - l || ((l -= 0.01) && 0.001),
                          H = 0,
                          Y = X;
                        Y--;

                      )
                        (P = (O = Xa[Y]).pin) &&
                          O.start - O._pinPush < l &&
                          !le &&
                          O.end > 0 &&
                          ((h = O.end - O.start),
                          (P !== J && P !== G) ||
                            xa(V) ||
                            (H += h * (1 - O.progress)),
                          P === K && (F += h));
                      if (
                        ((l += H),
                        (c += H),
                        (we._pinPush = F),
                        u &&
                          H &&
                          (((h = {})[de.a] = "+=" + H),
                          G && (h[de.p] = "-=" + Ee()),
                          Ss.set([u, d], h)),
                        K)
                      )
                        (h = Aa(K)),
                          (k = de === vs),
                          (x = Ee()),
                          (C = parseFloat(w(de.a)) + F),
                          !R &&
                            c > 1 &&
                            ((me ? As : fe).style["overflow-" + de.a] =
                              "scroll"),
                          vo(K, b, h),
                          (y = _o(K)),
                          (_ = Ia(K, !0)),
                          (M = ge && bs(fe, k ? gs : vs)()),
                          Z &&
                            (((S = [Z + de.os2, m + F + Ma]).t = b),
                            (Y = Z === Pa ? La(K, de) + m + F : 0) &&
                              S.push(de.d, Y + Ma),
                            bo(S),
                            ge && Ee(B)),
                          ge &&
                            (((E = {
                              top: _.top + (k ? x - l : M) + Ma,
                              left: _.left + (k ? M : x - l) + Ma,
                              boxSizing: "border-box",
                              position: "fixed",
                            }).width = E.maxWidth =
                              Math.ceil(_.width) + Ma),
                            (E.height = E.maxHeight = Math.ceil(_.height) + Ma),
                            (E.margin =
                              E.marginTop =
                              E.marginRight =
                              E.marginBottom =
                              E.marginLeft =
                                "0"),
                            (E[Pa] = h[Pa]),
                            (E[Pa + "Top"] = h[Pa + "Top"]),
                            (E[Pa + "Right"] = h[Pa + "Right"]),
                            (E[Pa + "Bottom"] = h[Pa + "Bottom"]),
                            (E[Pa + "Left"] = h[Pa + "Left"]),
                            (v = (function (e, t, n) {
                              for (
                                var i, r = [], s = e.length, a = n ? 8 : 0;
                                a < s;
                                a += 2
                              )
                                (i = e[a]), r.push(i, i in t ? t[i] : e[a + 1]);
                              return (r.t = e.t), r;
                            })(g, E, ae))),
                          n
                            ? ((A = n._initted),
                              Gs(1),
                              n.render(n.duration(), !0, !0),
                              (T = w(de.a) - C + m + F),
                              m !== T && ge && v.splice(v.length - 2, 2),
                              n.render(0, !0, !0),
                              A || n.invalidate(),
                              Gs(0))
                            : (T = m);
                      else if (J && Ee() && !le)
                        for (_ = J.parentNode; _ && _ !== As; )
                          _._pinOffset &&
                            ((l -= _._pinOffset), (c -= _._pinOffset)),
                            (_ = _.parentNode);
                      I &&
                        I.forEach(function (e) {
                          return e.revert(!1);
                        }),
                        (we.start = l),
                        (we.end = c),
                        (a = o = Ee()),
                        le || (a < B && Ee(B), (we.scroll.rec = 0)),
                        we.revert(!1),
                        j &&
                          ((ke = -1),
                          we.isActive && Ee(l + m * N),
                          j.restart(!0)),
                        ($s = 0),
                        n &&
                          pe &&
                          (n._initted || $) &&
                          n.progress() !== $ &&
                          n.progress($, !0).render(n.time(), !0, !0),
                        (N !== we.progress || le) &&
                          (n && !pe && n.totalProgress(N, !0),
                          (we.progress = N),
                          we.update(0, 0, 1)),
                        K && Z && (b._pinOffset = Math.round(we.progress * T)),
                        U && U(we);
                    }
                }),
                (we.getVelocity = function () {
                  return ((Ee() - o) / (aa() - Ns)) * 1e3 || 0;
                }),
                (we.endAnimation = function () {
                  Sa(we.callbackAnimation),
                    n &&
                      (D
                        ? D.progress(1)
                        : n.paused()
                        ? pe || Sa(n, we.direction < 0, 1)
                        : Sa(n, n.reversed()));
                }),
                (we.labelToScroll = function (e) {
                  return (
                    (n &&
                      n.labels &&
                      (l || we.refresh() || l) +
                        (n.labels[e] / n.duration()) * m) ||
                    0
                  );
                }),
                (we.getTrailing = function (e) {
                  var t = Xa.indexOf(we),
                    n =
                      we.direction > 0
                        ? Xa.slice(0, t).reverse()
                        : Xa.slice(t + 1);
                  return (
                    _a(e)
                      ? n.filter(function (t) {
                          return t.vars.preventOverlaps === e;
                        })
                      : n
                  ).filter(function (e) {
                    return we.direction > 0 ? e.end <= l : e.start >= c;
                  });
                }),
                (we.update = function (e, t, r) {
                  if (!le || r || e) {
                    var s,
                      u,
                      d,
                      f,
                      h,
                      g,
                      _,
                      w = we.scroll(),
                      S = e ? 0 : (w - l) / m,
                      P = S < 0 ? 0 : S > 1 ? 1 : S || 0,
                      I = we.progress;
                    if (
                      (t &&
                        ((o = a),
                        (a = le ? Ee() : w),
                        se &&
                          ((A = M), (M = n && !pe ? n.totalProgress() : P))),
                      te &&
                        !P &&
                        K &&
                        !$s &&
                        !sa &&
                        la &&
                        l < w + ((w - o) / (aa() - Ns)) * te &&
                        (P = 1e-4),
                      P !== I && we.enabled)
                    ) {
                      if (
                        ((f =
                          (h =
                            (s = we.isActive = !!P && P < 1) !==
                            (!!I && I < 1)) || !!P != !!I),
                        (we.direction = P > I ? 1 : -1),
                        (we.progress = P),
                        f &&
                          !$s &&
                          ((u = P && !I ? 0 : 1 === P ? 1 : 1 === I ? 2 : 3),
                          pe &&
                            ((d =
                              (!h && "none" !== ye[u + 1] && ye[u + 1]) ||
                              ye[u]),
                            (_ =
                              n &&
                              ("complete" === d || "reset" === d || d in n)))),
                        ue &&
                          (h || _) &&
                          (_ || Q || !n) &&
                          (wa(ue)
                            ? ue(we)
                            : we.getTrailing(ue).forEach(function (e) {
                                return e.endAnimation();
                              })),
                        pe ||
                          (!D || $s || sa
                            ? n && n.totalProgress(P, !!$s)
                            : ((le || (ra && ra !== we)) &&
                                D.render(D._dp._time - D._start),
                              D.resetTo
                                ? D.resetTo(
                                    "totalProgress",
                                    P,
                                    n._tTime / n._tDur
                                  )
                                : ((D.vars.totalProgress = P),
                                  D.invalidate().restart()))),
                        K)
                      )
                        if ((e && Z && (b.style[Z + de.os2] = k), ge)) {
                          if (f) {
                            if (
                              ((g =
                                !e &&
                                P > I &&
                                c + 1 > w &&
                                w + 1 >= ya(fe, de)),
                              ae)
                            )
                              if (e || (!s && !g)) To(K, b);
                              else {
                                var L = Ia(K, !0),
                                  N = w - l;
                                To(
                                  K,
                                  As,
                                  L.top + (de === vs ? N : 0) + Ma,
                                  L.left + (de === vs ? 0 : N) + Ma
                                );
                              }
                            bo(s || g ? v : y),
                              (T !== m && P < 1 && s) ||
                                x(C + (1 !== P || g ? 0 : T));
                          }
                        } else x(fa(C + T * P));
                      se && !i.tween && !$s && !sa && j.restart(!0),
                        G &&
                          (h || (re && P && (P < 1 || !Zs))) &&
                          Ls(G.targets).forEach(function (e) {
                            return e.classList[s || re ? "add" : "remove"](
                              G.className
                            );
                          }),
                        V && !pe && !e && V(we),
                        f && !$s
                          ? (pe &&
                              (_ &&
                                ("complete" === d
                                  ? n.pause().totalProgress(1)
                                  : "reset" === d
                                  ? n.restart(!0).pause()
                                  : "restart" === d
                                  ? n.restart(!0)
                                  : n[d]()),
                              V && V(we)),
                            (!h && Zs) ||
                              (Y && h && Ea(we, Y),
                              ve[u] && Ea(we, ve[u]),
                              re && (1 === P ? we.kill(!1, 1) : (ve[u] = 0)),
                              h ||
                                (ve[(u = 1 === P ? 1 : 3)] && Ea(we, ve[u]))),
                            ce &&
                              !s &&
                              Math.abs(we.getVelocity()) >
                                (xa(ce) ? ce : 2500) &&
                              (Sa(we.callbackAnimation),
                              D ? D.progress(1) : Sa(n, !P, 1)))
                          : pe && V && !$s && V(we);
                    }
                    if (O) {
                      var B = le
                        ? (w / le.duration()) * (le._caScrollDist || 0)
                        : w;
                      E(B + (p._isFlipped ? 1 : 0)), O(B);
                    }
                    z && z((-w / le.duration()) * (le._caScrollDist || 0));
                  }
                }),
                (we.enable = function (t, n) {
                  we.enabled ||
                    ((we.enabled = !0),
                    $a(fe, "resize", Ka),
                    $a(me ? Ps : fe, "scroll", Qa),
                    xe && $a(e, "refreshInit", xe),
                    !1 !== t && ((we.progress = N = 0), (a = o = ke = Ee())),
                    !1 !== n && we.refresh());
                }),
                (we.getTween = function (e) {
                  return e && i ? i.tween : D;
                }),
                (we.setPositions = function (e, t) {
                  K && ((C += e - l), (T += t - e - m)),
                    (we.start = l = e),
                    (we.end = c = t),
                    (m = t - e),
                    we.update();
                }),
                (we.disable = function (t, n) {
                  if (
                    we.enabled &&
                    (!1 !== t && we.revert(),
                    (we.enabled = we.isActive = !1),
                    n || (D && D.pause()),
                    (B = 0),
                    r && (r.uncache = 1),
                    xe && za(e, "refreshInit", xe),
                    j &&
                      (j.pause(), i.tween && i.tween.kill() && (i.tween = 0)),
                    !me)
                  ) {
                    for (var s = Xa.length; s--; )
                      if (Xa[s].scroller === fe && Xa[s] !== we) return;
                    za(fe, "resize", Ka), za(fe, "scroll", Qa);
                  }
                }),
                (we.kill = function (e, i) {
                  we.disable(e, i), D && !i && D.kill(), X && delete Ya[X];
                  var s = Xa.indexOf(we);
                  s >= 0 && Xa.splice(s, 1),
                    s === Hs && fo > 0 && Hs--,
                    (s = 0),
                    Xa.forEach(function (e) {
                      return e.scroller === we.scroller && (s = 1);
                    }),
                    s || (we.scroll.rec = 0),
                    n &&
                      ((n.scrollTrigger = null),
                      e && n.render(-1),
                      i || n.kill()),
                    u &&
                      [u, d, p, f].forEach(function (e) {
                        return e.parentNode && e.parentNode.removeChild(e);
                      }),
                    ra === we && (ra = 0),
                    K &&
                      (r && (r.uncache = 1),
                      (s = 0),
                      Xa.forEach(function (e) {
                        return e.pin === K && s++;
                      }),
                      s || (r.spacer = 0)),
                    t.onKill && t.onKill(we);
                }),
                we.enable(!1, !1),
                R && R(we),
                n && n.add && !m
                  ? Ss.delayedCall(0.01, function () {
                      return l || c || we.refresh();
                    }) &&
                    (m = 0.01) &&
                    (l = c = 0)
                  : we.refresh();
            } else this.update = this.refresh = this.kill = pa;
          }),
          (e.register = function (t) {
            return (
              Es ||
                ((Ss = t || ma()),
                ha() && window.document && e.enable(),
                (Es = ca)),
              Es
            );
          }),
          (e.defaults = function (e) {
            if (e) for (var t in e) Fa[t] = e[t];
            return Fa;
          }),
          (e.disable = function (e, t) {
            (ca = 0),
              Xa.forEach(function (n) {
                return n[t ? "kill" : "disable"](e);
              }),
              za(Os, "wheel", Qa),
              za(Ps, "scroll", Qa),
              clearInterval(Bs),
              za(Ps, "touchcancel", pa),
              za(As, "touchstart", pa),
              Ba(za, Ps, "pointerdown,touchstart,mousedown", ua),
              Ba(za, Ps, "pointerup,touchend,mouseup", da),
              Is.kill(),
              ba(za);
            for (var n = 0; n < as.length; n += 3)
              Ra(za, as[n], as[n + 1]), Ra(za, as[n], as[n + 2]);
          }),
          (e.enable = function () {
            if (
              ((Os = window),
              (Ps = document),
              (Ms = Ps.documentElement),
              (As = Ps.body),
              Ss &&
                ((Ls = Ss.utils.toArray),
                (js = Ss.utils.clamp),
                (Gs = Ss.core.suppressOverwrites || pa),
                Ss.core.globals("ScrollTrigger", e),
                As))
            ) {
              (ca = 1),
                ks.register(Ss),
                (e.isTouch = ks.isTouch),
                (Ks =
                  ks.isTouch &&
                  /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
                $a(Os, "wheel", Qa),
                (Ds = [Os, Ps, Ms, As]),
                e.matchMedia({
                  "(orientation: portrait)": function () {
                    return Ja(), Ja;
                  },
                }),
                $a(Ps, "scroll", Qa);
              var t,
                n,
                i = As.style,
                r = i.borderTopStyle;
              for (
                i.borderTopStyle = "solid",
                  t = Ia(As),
                  vs.m = Math.round(t.top + vs.sc()) || 0,
                  gs.m = Math.round(t.left + gs.sc()) || 0,
                  r
                    ? (i.borderTopStyle = r)
                    : i.removeProperty("border-top-style"),
                  Bs = setInterval(Ua, 250),
                  Ss.delayedCall(0.5, function () {
                    return (sa = 0);
                  }),
                  $a(Ps, "touchcancel", pa),
                  $a(As, "touchstart", pa),
                  Ba($a, Ps, "pointerdown,touchstart,mousedown", ua),
                  Ba($a, Ps, "pointerup,touchend,mouseup", da),
                  Rs = Ss.utils.checkPrefix("transform"),
                  go.push(Rs),
                  Es = aa(),
                  Is = Ss.delayedCall(0.2, uo).pause(),
                  Ws = [
                    Ps,
                    "visibilitychange",
                    function () {
                      var e = Os.innerWidth,
                        t = Os.innerHeight;
                      Ps.hidden
                        ? ((Fs = e), (qs = t))
                        : (Fs === e && qs === t) || Ka();
                    },
                    Ps,
                    "DOMContentLoaded",
                    uo,
                    Os,
                    "load",
                    uo,
                    Os,
                    "resize",
                    Ka,
                  ],
                  ba($a),
                  Xa.forEach(function (e) {
                    return e.enable(0, 1);
                  }),
                  n = 0;
                n < as.length;
                n += 3
              )
                Ra(za, as[n], as[n + 1]), Ra(za, as[n], as[n + 2]);
            }
          }),
          (e.config = function (t) {
            "limitCallbacks" in t && (Zs = !!t.limitCallbacks);
            var n = t.syncInterval;
            (n && clearInterval(Bs)) || ((Bs = n) && setInterval(Ua, n)),
              "ignoreMobileResize" in t &&
                (Us = 1 === e.isTouch && t.ignoreMobileResize),
              "autoRefreshEvents" in t &&
                (ba(za) || ba($a, t.autoRefreshEvents || "none"),
                (Xs = -1 === (t.autoRefreshEvents + "").indexOf("resize")));
          }),
          (e.scrollerProxy = function (e, t) {
            var n = ys(e),
              i = as.indexOf(n),
              r = ga(n);
            ~i && as.splice(i, r ? 6 : 2),
              t && (r ? os.unshift(Os, t, As, t, Ms, t) : os.unshift(n, t));
          }),
          (e.matchMedia = function (e) {
            var t, n, i, r, s;
            for (n in e)
              (i = to.indexOf(n)),
                (r = e[n]),
                (ta = n),
                "all" === n
                  ? r()
                  : (t = Os.matchMedia(n)) &&
                    (t.matches && (s = r()),
                    ~i
                      ? ((to[i + 1] = ka(to[i + 1], r)),
                        (to[i + 2] = ka(to[i + 2], s)))
                      : ((i = to.length),
                        to.push(n, r, s),
                        t.addListener
                          ? t.addListener(no)
                          : t.addEventListener("change", no)),
                    (to[i + 3] = t.matches)),
                (ta = 0);
            return to;
          }),
          (e.clearMatchMedia = function (e) {
            e || (to.length = 0), (e = to.indexOf(e)) >= 0 && to.splice(e, 4);
          }),
          (e.isInViewport = function (e, t, n) {
            var i = (_a(e) ? ys(e) : e).getBoundingClientRect(),
              r = i[n ? "width" : "height"] * t || 0;
            return n
              ? i.right - r > 0 && i.left + r < Os.innerWidth
              : i.bottom - r > 0 && i.top + r < Os.innerHeight;
          }),
          (e.positionInViewport = function (e, t, n) {
            _a(e) && (e = ys(e));
            var i = e.getBoundingClientRect(),
              r = i[n ? "width" : "height"],
              s =
                null == t
                  ? r / 2
                  : t in qa
                  ? qa[t] * r
                  : ~t.indexOf("%")
                  ? (parseFloat(t) * r) / 100
                  : parseFloat(t) || 0;
            return n
              ? (i.left + s) / Os.innerWidth
              : (i.top + s) / Os.innerHeight;
          }),
          e
        );
      })();
    (So.version = "3.10.4"),
      (So.saveStyles = function (e) {
        return e
          ? Ls(e).forEach(function (e) {
              if (e && e.style) {
                var t = so.indexOf(e);
                t >= 0 && so.splice(t, 5),
                  so.push(
                    e,
                    e.style.cssText,
                    e.getBBox && e.getAttribute("transform"),
                    Ss.core.getCache(e),
                    ta
                  );
              }
            })
          : so;
      }),
      (So.revert = function (e, t) {
        return oo(!e, t);
      }),
      (So.create = function (e, t) {
        return new So(e, t);
      }),
      (So.refresh = function (e) {
        return e ? Ka() : (Es || So.register()) && uo(!0);
      }),
      (So.update = ho),
      (So.clearScrollMemory = lo),
      (So.maxScroll = function (e, t) {
        return ya(e, t ? gs : vs);
      }),
      (So.getScrollFunc = function (e, t) {
        return bs(ys(e), t ? gs : vs);
      }),
      (So.getById = function (e) {
        return Ya[e];
      }),
      (So.getAll = function () {
        return Xa.filter(function (e) {
          return "ScrollSmoother" !== e.vars.id;
        });
      }),
      (So.isScrolling = function () {
        return !!la;
      }),
      (So.snapDirectional = Na),
      (So.addEventListener = function (e, t) {
        var n = Za[e] || (Za[e] = []);
        ~n.indexOf(t) || n.push(t);
      }),
      (So.removeEventListener = function (e, t) {
        var n = Za[e],
          i = n && n.indexOf(t);
        i >= 0 && n.splice(i, 1);
      }),
      (So.batch = function (e, t) {
        var n,
          i = [],
          r = {},
          s = t.interval || 0.016,
          a = t.batchMax || 1e9,
          o = function (e, t) {
            var n = [],
              i = [],
              r = Ss.delayedCall(s, function () {
                t(n, i), (n = []), (i = []);
              }).pause();
            return function (e) {
              n.length || r.restart(!0),
                n.push(e.trigger),
                i.push(e),
                a <= n.length && r.progress(1);
            };
          };
        for (n in t)
          r[n] =
            "on" === n.substr(0, 2) && wa(t[n]) && "onRefreshInit" !== n
              ? o(0, t[n])
              : t[n];
        return (
          wa(a) &&
            ((a = a()),
            $a(So, "refresh", function () {
              return (a = t.batchMax());
            })),
          Ls(e).forEach(function (e) {
            var t = {};
            for (n in r) t[n] = r[n];
            (t.trigger = e), i.push(So.create(t));
          }),
          i
        );
      });
    var Eo,
      Oo,
      Po = function (e, t, n, i) {
        return (
          t > i ? e(i) : t < 0 && e(0),
          n > i ? (i - t) / (n - t) : n < 0 ? t / (t - n) : 1
        );
      },
      Mo = function e(t, n) {
        !0 === n
          ? t.style.removeProperty("touch-action")
          : (t.style.touchAction =
              !0 === n
                ? "auto"
                : n
                ? "pan-" + n + (ks.isTouch ? " pinch-zoom" : "")
                : "none"),
          t === Ms && e(As, n);
      },
      Ao = {
        auto: 1,
        scroll: 1,
      },
      Do = function (e) {
        var t,
          n = e.event,
          i = e.target,
          r = e.axis,
          s = (n.changedTouches ? n.changedTouches[0] : n).target,
          a = s._gsap || Ss.core.getCache(s),
          o = aa();
        if (!a._isScrollT || o - a._isScrollT > 2e3) {
          for (; s && s.scrollHeight <= s.clientHeight; ) s = s.parentNode;
          (a._isScroll =
            s &&
            !ga(s) &&
            s !== i &&
            (Ao[(t = Aa(s)).overflowY] || Ao[t.overflowX])),
            (a._isScrollT = o);
        }
        (a._isScroll || "x" === r) && (n._gsapAllow = !0);
      },
      Io = function (e, t, n, i) {
        return ks.create({
          target: e,
          capture: !0,
          debounce: !1,
          lockAxis: !0,
          type: t,
          onWheel: (i = i && Do),
          onPress: i,
          onDrag: i,
          onScroll: i,
          onEnable: function () {
            return n && $a(Ps, ks.eventTypes[0], jo, !1, !0);
          },
          onDisable: function () {
            return za(Ps, ks.eventTypes[0], jo, !0);
          },
        });
      },
      Lo = /(input|label|select|textarea)/i,
      jo = function (e) {
        var t = Lo.test(e.target.tagName);
        (t || Eo) && ((e._gsapAllow = !0), (Eo = t));
      },
      No = function (e) {
        Ca(e) || (e = {}),
          (e.preventDefault = e.isNormalizer = e.allowClicks = !0),
          e.type || (e.type = "wheel,touch"),
          (e.debounce = !!e.debounce),
          (e.id = e.id || "normalizer");
        var t,
          n,
          i,
          r,
          s,
          a,
          o,
          l,
          c = e,
          u = c.normalizeScrollX,
          d = c.momentum,
          p = c.allowNestedScroll,
          f = ys(e.target) || Ms,
          h = Ss.core.globals().ScrollSmoother,
          m =
            Ks &&
            ((e.content && ys(e.content)) ||
              (h && h.get() && h.get().content())),
          g = bs(f, vs),
          v = bs(f, gs),
          y = 1,
          b =
            (ks.isTouch && Os.visualViewport
              ? Os.visualViewport.scale * Os.visualViewport.width
              : Os.outerWidth) / Os.innerWidth,
          _ = 0,
          w = wa(d)
            ? function () {
                return d(t);
              }
            : function () {
                return d || 2.8;
              },
          x = Io(f, e.type, !0, p),
          C = function () {
            return (i = !1);
          },
          T = pa,
          k = pa,
          S = function () {
            (n = ya(f, vs)),
              (k = js(Ks ? 1 : 0, n)),
              u && (T = js(0, ya(f, gs))),
              (r = co);
          },
          E = function () {
            S(),
              s.isActive() &&
                s.vars.scrollY > n &&
                (g() > n ? s.progress(1) && g(n) : s.resetTo("scrollY", n));
          };
        return (
          (e.ignoreCheck = function (e) {
            return (
              (Ks &&
                "touchmove" === e.type &&
                (function () {
                  if (i) {
                    requestAnimationFrame(C);
                    var e = fa(t.deltaY / 2),
                      n = k(g.v - e);
                    return (
                      m &&
                        n !== g.v + g.offset &&
                        ((g.offset = n - g.v),
                        (m.style.transform = "translateY(" + -g.offset + "px)"),
                        m._gsap && (m._gsap.y = -g.offset + "px"),
                        (g.cacheID = as.cache),
                        ho()),
                      !0
                    );
                  }
                  m &&
                    ((m.style.transform = "translateY(0px)"),
                    (g.offset = g.cacheID = 0),
                    m._gsap && (m._gsap.y = "0px")),
                    (i = !0);
                })()) ||
              (y > 1.05 && "touchstart" !== e.type) ||
              t.isGesturing ||
              (e.touches && e.touches.length > 1)
            );
          }),
          (e.onPress = function () {
            var e = y;
            (y = fa(((Os.visualViewport && Os.visualViewport.scale) || 1) / b)),
              s.pause(),
              e !== y && Mo(f, y > 1.01 || (!u && "x")),
              (i = !1),
              (a = v()),
              (o = g()),
              S(),
              (r = co);
          }),
          (e.onRelease = e.onGestureStart =
            function (e, t) {
              if (
                (m &&
                  ((m.style.transform = "translateY(0px)"),
                  (g.offset = g.cacheID = 0),
                  m._gsap && (m._gsap.y = "0px")),
                t)
              ) {
                as.cache++;
                var i,
                  r,
                  a = w();
                u &&
                  ((r = (i = v()) + (0.05 * a * -e.velocityX) / 0.227),
                  (a *= Po(v, i, r, ya(f, gs))),
                  (s.vars.scrollX = T(r))),
                  (r = (i = g()) + (0.05 * a * -e.velocityY) / 0.227),
                  (a *= Po(g, i, r, ya(f, vs))),
                  (s.vars.scrollY = k(r)),
                  s.invalidate().duration(a).play(0.01),
                  ((Ks && s.vars.scrollY >= n) || i >= n - 1) &&
                    Ss.to(
                      {},
                      {
                        onUpdate: E,
                        duration: a,
                      }
                    );
              } else l.restart(!0);
            }),
          (e.onWheel = function () {
            s._ts && s.pause(), aa() - _ > 1e3 && ((r = 0), (_ = aa()));
          }),
          (e.onChange = function (e, t, n, i, s) {
            co !== r && S(),
              t &&
                u &&
                v(T(i[2] === t ? a + (e.startX - e.x) : v() + t - i[1])),
              n && g(k(s[2] === n ? o + (e.startY - e.y) : g() + n - s[1])),
              ho();
          }),
          (e.onEnable = function () {
            Mo(f, !u && "x"), $a(Os, "resize", E), x.enable();
          }),
          (e.onDisable = function () {
            Mo(f, !0), za(Os, "resize", E), x.kill();
          }),
          ((t = new ks(e)).iOS = Ks),
          Ks && !g() && g(1),
          (l = t._dc),
          (s = Ss.to(t, {
            ease: "power4",
            paused: !0,
            scrollX: u ? "+=0.1" : "+=0",
            scrollY: "+=0.1",
            onComplete: l.vars.onComplete,
          })),
          t
        );
      };

    function Bo(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }

    function $o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    (So.sort = function (e) {
      return Xa.sort(
        e ||
          function (e, t) {
            return (
              -1e6 * (e.vars.refreshPriority || 0) +
              e.start -
              (t.start + -1e6 * (t.vars.refreshPriority || 0))
            );
          }
      );
    }),
      (So.observe = function (e) {
        return new ks(e);
      }),
      (So.normalizeScroll = function (e) {
        if (void 0 === e) return Ys;
        if (!0 === e && Ys) return Ys.enable();
        if (!1 === e) return Ys && Ys.kill();
        var t = e instanceof ks ? e : No(e);
        return (
          Ys && Ys.target === t.target && Ys.kill(), ga(t.target) && (Ys = t), t
        );
      }),
      (So.core = {
        _getVelocityProp: _s,
        _inputObserver: Io,
        _scrollers: as,
        _proxies: os,
        bridge: {
          ss: function () {
            la || ro("scrollStart"), (la = aa());
          },
          ref: function () {
            return $s;
          },
        },
      }),
      ma() && Ss.registerPlugin(So),
      qr.registerPlugin(So);
    var zo,
      Ro = "manual",
      Ho = (function () {
        function e() {
          var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
          Bo(this, e), (Oo = t), this.init(), this.sorting(), this.filter();
        }
        var t, n, i;
        return (
          (t = e),
          (n = [
            {
              key: "init",
              value: function () {
                this.loadMore(), this.toggleScrollTopBtn();
              },
            },
            {
              key: "filter",
              value: function () {
                var e = r()(".price-checkbox"),
                  t = r()(".min-price"),
                  n = r()(".max-price");
                e.on("change", function () {
                  var e = r()(".price-checkbox:checked"),
                    i = r()(e[0]).val(),
                    s = r()(e[e.length - 1]).val();
                  i
                    ? ((i = (i = i.replaceAll("$", "")).includes("+")
                        ? i.replaceAll("+", "")
                        : i.split(" - ")[0]),
                      t.val(i))
                    : t.val(""),
                    s
                      ? ((s = s.replaceAll("$", "").split(" - ")[1]), n.val(s))
                      : n.val("");
                });
                var i = r()(".select-filter"),
                  s = r()(".filter-form");
                i.on("change", function () {
                  s.submit();
                });
              },
            },
            {
              key: "sorting",
              value: function () {
                var e = r()("#shop-featured"),
                  t = r()(".filter-form");
                e.on("change", function () {
                  var e = r()("#sort-by-input");
                  (Ro = r()(this).val()), e.val(Ro), t.submit();
                });
              },
            },
            {
              key: "loadMoreAjax",
              value: function (e) {
                var t = "view=prod3&page=".concat(Oo),
                  n = location.search ? location.search.split("&view")[0] : "",
                  i = n
                    ? "".concat(location.pathname, "/").concat(n, "&").concat(t)
                    : "".concat(location.pathname, "?").concat(t);
                r.a.ajax({
                  type: "get",
                  url: i,
                  success: function (t) {
                    r()(".shop--grid").append(t),
                      Oo >= e.data("total-pages") && e.hide(),
                      new a.a(),
                      So.refresh();
                  },
                });
              },
            },
            {
              key: "loadMore",
              value: function () {
                var e = this,
                  t = r()(".load--more");
                1 === Oo && (Oo++, this.loadMoreAjax(t)),
                  t.length &&
                    (r()(window).scroll(function () {
                      r()(window).scrollTop() > t.position().top - 150 &&
                        Oo < t.data("total-pages") &&
                        (Oo++, e.loadMoreAjax(t));
                    }),
                    t.on("click", function (n) {
                      n.preventDefault(), Oo++, e.loadMoreAjax(t);
                    }));
              },
            },
            {
              key: "toggleScrollTopBtn",
              value: function () {
                var $btn = r()("#toTop");
                // hide on init
                $btn.hide();

                // on scroll: show/hide (throttled)
                r()(window).on(
                  "scroll",
                  o(function () {
                    r()(window).scrollTop() >= 250
                      ? $btn.fadeIn()
                      : $btn.fadeOut();
                  }, 30)
                );

                // on click: smooth scroll to top
                $btn.on("click", function (e) {
                  e.preventDefault();
                  r()("html, body").animate({ scrollTop: 0 }, 400);
                });
              },
            },
          ]) && $o(t.prototype, n),
          i && $o(t, i),
          Object.defineProperty(t, "prototype", {
            writable: !1,
          }),
          e
        );
      })();

    function Fo(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }

    function qo(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var Wo = (function () {
      function e() {
        var t =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        Fo(this, e), (zo = t), this.init();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              this.loadMore();
            },
          },
          {
            key: "loadMoreAjax",
            value: function (e) {
              if ("front" == r()(".blog-feed__blogs").data("pagination")) {
                var t = r()(".blog-feed__link.d-none");
                t.length || e.hide(),
                  t.each(function (e) {
                    e < 6 && r()(this).removeClass("d-none");
                  });
              } else
                zo < e.data("total-pages") &&
                  (zo++,
                  r.a.ajax({
                    type: "get",
                    url: "/blogs/"
                      .concat(e.data("handle"), "?view=article-single&page=")
                      .concat(zo),
                    success: function (t) {
                      r()(".blog-feed__blogs").append(t),
                        zo >= e.data("total-pages") && e.hide(),
                        new a.a();
                    },
                  }));
            },
          },
          {
            key: "loadMore",
            value: function () {
              var e = this,
                t = r()(".blog-feed__loading");
              t.length &&
                (r()(window).scroll(function () {
                  r()(window).scrollTop() + r()(window).height() >
                    t.position().top + 150 && e.loadMoreAjax(t);
                }),
                t.on("click", function (n) {
                  n.preventDefault(), e.loadMoreAjax(t);
                }));
            },
          },
        ]) && qo(t.prototype, n),
        i && qo(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function Vo(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var Go = (function () {
      function e() {
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          this.init();
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              this.serviceTabs();
            },
          },
          {
            key: "serviceTabs",
            value: function () {
              r()(".tab--button").on("click", function (e) {
                r()(".location__services--content").hide(),
                  r()(r()(this).attr("href")).show(),
                  r()(this).addClass("active"),
                  r()(this).siblings().removeClass("active"),
                  e.preventDefault();
              });
            },
          },
        ]) && Vo(t.prototype, n),
        i && Vo(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();

    function Xo(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    var Yo = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            this.soldoutInit();
        }
        var t, n, i;
        return (
          (t = e),
          (n = [
            {
              key: "soldoutInit",
              value: function () {
                r()(document).on(
                  "click",
                  "[data-soldout-button]",
                  function (e) {
                    e.preventDefault();
                    console.log("BIS CLICK");
                    var $button = r()(this);
                    var $modal = r()("#modal-soldout");
                    var parent = $button.closest('[is="rm-form"]');
                    var hasError = false;
                    console.log(parent);
                    $modal.find('[name="variant"]').val($button.data("variant-id"));
                    $modal.find('[name="product"]').val($button.data("product-id"));
                    $modal.find("#bis-title").html($button.data("product-title"));
                    if (parent != undefined) {
                      var labels = parent[0].querySelectorAll('.option__label');
                      labels.forEach(function (label) {
                        var text = label.textContent || label.innerText;
                        console.log(text)
                        if (/choose/i.test(text)) {
                          parent[0].classList.add('error');
                          hasError = true;
                        }
                      });
                    }

                    if (hasError) {
                      return;
                    }
                    $modal.fadeIn();
                  }
                ),
                  r()(document).on(
                    "submit",
                    "[data-soldout-form]",
                    function (e) {
                      e.preventDefault();
                      var t = r()(this),
                        n = encodeURIComponent(t.find('[name="email"]').val()),
                        i = encodeURIComponent(t.find('[name="shop"]').val()),
                        s = t.find('[name="product"]').val(),
                        a = t.find('[name="variant"]').val();
                      r.a.ajax({
                        url: "https://app.backinstock.org/stock_notification/create.json?notification[email]=".concat(
                          n
                        ),
                        cache: !1,
                        type: "get",
                        data: {
                          callback: "_BIS.JSONP1655206145379",
                          shop: i,
                          "notification[channel]": "email",
                          "notification[product_no]": s,
                          "notification[quantity_required]": 1,
                          "notification[accepts_marketing]": !1,
                          "notification[customer_utc_offset]": -14400,
                          "variant[variant_no]": a,
                        },
                        success: function (e) {
                          r()(".get-notified").fadeOut(0),
                            r()(".thanks-msg").fadeIn();
                        },
                      });
                    }
                  ),
                  r()(".modal__close").on("click", function () {
                    r()(".modal").fadeOut();
                  }),
                  l(".modal__content", ".pdp_out", function (e) {
                    r()(e).parent(".modal").fadeOut();
                  });
              },
            },
          ]) && Xo(t.prototype, n),
          i && Xo(t, i),
          Object.defineProperty(t, "prototype", {
            writable: !1,
          }),
          e
        );
      })(),
      Uo = function (e, t) {
        var n;
        return (
          e.val()
            ? ((n = e.val()),
              String(n)
                .toLowerCase()
                .match(
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                ) || t.push("Please insert a valid email address."))
            : t.push("The Email address is required."),
          t
        );
      },
      Qo = function (e, t) {
        return (
          e.val().length < 8 &&
            t.push("The Password must be at least 8 characters."),
          t
        );
      },
      Jo = function (e, t) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
        return e.val().trim() || t.push("The ".concat(n, " is required.")), t;
      };

    function Ko(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t &&
          (i = i.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, i);
      }
      return n;
    }

    function Zo(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? Ko(Object(n), !0).forEach(function (t) {
              el(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : Ko(Object(n)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(n, t)
              );
            });
      }
      return e;
    }

    function el(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }

    function tl(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          var n =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null == n) return;
          var i,
            r,
            s = [],
            a = !0,
            o = !1;
          try {
            for (
              n = n.call(e);
              !(a = (i = n.next()).done) &&
              (s.push(i.value), !t || s.length !== t);
              a = !0
            );
          } catch (e) {
            (o = !0), (r = e);
          } finally {
            try {
              a || null == n.return || n.return();
            } finally {
              if (o) throw r;
            }
          }
          return s;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return nl(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if (
            "Arguments" === n ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return nl(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }

    function nl(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
      return i;
    }

    function il(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    r()(document).ready(function () {
      r()(".reg-form--button").on("click", function (e) {
        e.preventDefault();
        var t = r()(this).parents("form"),
          n = t.find(".all-error-mgs");
        n.text("").addClass("d-none");
        var i = [];
        if (
          ((i = Jo(t.find(".input-first_name"), i, "First Name")),
          (i = Jo(t.find(".input-last_name"), i, "Last Name")),
          (i = Jo(t.find(".input-phone"), i, "Phone")),
          (i = Uo(t.find(".input-email"), i)),
          (i = Qo(t.find(".input-password"), i)).length > 0)
        )
          return (
            i.forEach(function (e) {
              n.append(e + "<br>");
            }),
            n.removeClass("d-none"),
            !1
          );
        t.submit();
      }),
        r()(".reg-input--valid").on("input change", function () {
          var e = r()(this).parents("form"),
            t = [];
          (t = Jo(e.find(".input--first_name"), t, "First Name")),
            (t = Jo(e.find(".input--last_name"), t, "Last Name")),
            (t = Jo(e.find(".input--phone"), t, "Phone")),
            (t = Uo(e.find(".input--email"), t)),
            (t = Qo(
              e.find(".input--password"),
              e.find(".input--password_confirmation")
            )).length > 0
              ? e.find(".reg-form--button").removeClass("btn-disabled")
              : e.find(".reg-form--button").addClass("btn-disabled");
        }),
        r()(".log-form--button").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if (
            ((i = Uo(t.find(".input--email"), i)),
            (i = Jo(t.find(".input--password"), i, "Password")).length > 0)
          )
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        }),
        r()(".log-input--valid").on("input change", function () {
          var e = r()(this).parents("form"),
            t = [];
          (t = Uo(e.find(".input--email"), t)),
            (t = Jo(e.find(".input--password"), t, "Password")).length > 0
              ? e.find(".log-form--button").removeClass("btn-disabled")
              : e.find(".log-form--button").addClass("btn-disabled");
        }),
        r()(".reset-form--button").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if ((i = Uo(t.find(".input--email"), i)).length > 0)
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        }),
        r()(".reset-input--valid").on("input change", function () {
          var e = r()(this).parents("form"),
            t = [];
          (t = Uo(e.find(".input--email"), t)).length > 0
            ? e.find(".reset-form--button").removeClass("btn-disabled")
            : e.find(".reset-form--button").addClass("btn-disabled");
        }),
        r()(".account-form--button").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if (
            ((i = Jo(t.find(".input--first_name"), i, "First Name")),
            (i = Jo(t.find(".input--last_name"), i, "Last Name")),
            (i = Jo(t.find(".input--address_line"), i, "Address line 1")),
            (i = Jo(t.find(".input--city_line"), i, "City")),
            (i = Jo(t.find(".input--zipcode_line"), i, "Zipcode")).length > 0)
          )
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        }),
        r()(".account-form--edit--button").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if (
            ((i = Jo(t.find(".input--first_name"), i, "First Name")),
            (i = Jo(t.find(".input--last_name"), i, "Last Name")),
            (i = Jo(t.find(".input--address_line"), i, "Address line 1")),
            (i = Jo(t.find(".input--city_line"), i, "City")),
            (i = Jo(t.find(".input--zipcode_line"), i, "Zipcode")).length > 0)
          )
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        }),
        r()(".account-input--valid").on("input change", function () {
          var e = r()(this).parents("form"),
            t = [];
          (t = Jo(e.find(".input--first_name"), t, "First Name")),
            (t = Jo(e.find(".input--last_name"), t, "Last Name")),
            (t = Jo(e.find(".input--address_line"), t, "Address line 1")),
            (t = Jo(e.find(".input--city_line"), t, "City")),
            (t = Jo(e.find(".input--zipcode_line"), t, "Zipcode")).length > 0
              ? e.find(".account-form--button").removeClass("btn-disabled")
              : e.find(".account-form--button").addClass("btn-disabled");
        }),
        r()(".soldOut-form--button").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if ((i = Uo(t.find(".soldOut--email"), i)).length > 0)
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        }),
        r()(".reset_pwd").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if (
            (i = (function (e, t, n) {
              return (
                e.val().length < 8 &&
                  n.push("The Password must be at least 8 characters."),
                e.val() !== t.val() && n.push("Passwords should match!"),
                n
              );
            })(
              t.find(".input--password"),
              t.find(".input--password_confirmation"),
              i
            )).length > 0
          )
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        }),
        r()(".contact_form_submit").on("click", function (e) {
          e.preventDefault();
          var t = r()(this).parents("form"),
            n = t.find(".all-error-mgs");
          n.text("").addClass("d-none");
          var i = [];
          if (
            ((i = Jo(t.find(".input--first_name"), i, "First Name")),
            (i = Jo(t.find(".input--last_name"), i, "Last Name")),
            (i = Uo(t.find(".input--email"), i)),
            (i = Jo(t.find(".form-select"), i, "Subject")),
            (i = Jo(t.find(".form-row-textarea"), i, "Message")).length > 0)
          )
            return (
              i.forEach(function (e) {
                n.append(e + "<br>");
              }),
              n.removeClass("d-none"),
              !1
            );
          t.submit();
        });
    });
    var rl = (function () {
      function e() {
        var t = this;
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.customProduct = []),
          (this.$totalPriceSpan = r()("#total-price")),
          (this.$addToCartForm = r()(".AddToCartForm")),
          (this.thickness = null),
          this.init(),
          r()(".metal .custom-card__input").on("change", function (e) {
            var n = r()(e.currentTarget),
              i = n.parent().attr("id"),
              s = n.parent().data("metal-title");
            n.is(":checked")
              ? (t.pickItem.call(t, [
                  n,
                  {
                    limit: 1,
                    type: "metal",
                    id: i,
                  },
                ]),
                n
                  .parents("li")
                  .siblings()
                  .find(".custom-card__input")
                  .prop("checked", !1),
                r()(".chains-products").hide(),
                r()(".charms-products").hide(),
                r()("#".concat(s, "-chains")).show(),
                r()("#".concat(s, "-charms")).show(),
                r()('.custom-build__step[data-id="chain"]').show(),
                r()('.custom-build__step[data-id="metal"]').hide(),
                r()(".charm-headers a")
                  .removeClass("active")
                  .first()
                  .addClass("active"))
              : n.is(":checked") ||
                (t.removeItem(i),
                r()("#".concat(s, "-chains")).hide(),
                r()("#".concat(s, "-charms")).hide());
          }),
          r()(".custom-card").each(function (e, t) {
            var n = r()(t).find(".variant__btn").length,
              i = r()(t).find(".custom-card__input"),
              s = r()(t).find(".custom-card__label");
            n > 1 && (i.attr("disabled", !0), s.prop("disabled", !0));
          }),
          r()(".chain .custom-card__input").on("change", function (e) {
            var n,
              i = r()(e.target),
              s = i.parent(".chain"),
              a = s.attr("id"),
              o = s.find(".variant__btn").length,
              l = i.parents(".chains-products").data("limit") || 1,
              c = 0,
              u = null,
              d = t.customProduct.filter(function (e) {
                return "chain" === e.type;
              });
            if (o <= 1 && i.is(":checked")) {
              if (
                ((c = Number(s.find(".variant__btn").data("price"))),
                (u = Number(s.find(".variant__btn").data("discount-price"))),
                (n = s.find(".variant__btn").data("v-id")),
                t.pickItem.call(t, [
                  i,
                  {
                    limit: l,
                    type: "chain",
                    id: a,
                    price: c,
                    discountPrice: u,
                    vId: n,
                  },
                ]),
                s.find(".variant__btn").addClass("active"),
                i.addClass("changed"),
                d.length >= l)
              ) {
                var p = d[d.length - 1].id;
                r()(".chain").each(function (e, t) {
                  r()(t).attr("id") === p &&
                    (r()(t).find(".custom-card__input").prop("checked", !1),
                    r()(t).find(".variant__btn").removeClass("active"),
                    r()(t).find(".variant__btn").length > 1 &&
                      r()(t).find(".custom-card__input").attr("disabled", !0));
                });
              }
            } else
              i.is(":checked") ||
                (t.removeItem(a),
                r()(".variant__btn").removeClass("active"),
                o > 1 && i.attr("disabled", !0));
          }),
          r()(".chain .variant__btn").on("click", function (e) {
            var n = r()(e.currentTarget),
              i = n.data("p-id"),
              s = n.data("v-id"),
              a = n.data("price"),
              o = n.data("discount-price"),
              l = n.parents(".chain"),
              c = l.find(".variant__btn").length,
              u = l.find(".custom-card__input"),
              d = n.parents(".chains-products").data("limit") || 1;
            if (
              ((t.thickness = l.data("thickness")),
              r()(".custom-card.charm").hide(),
              r()(
                '.custom-card.charm[data-thickness="'.concat(t.thickness, '"]')
              ).show(),
              r()(".charm-headers a")
                .removeClass("active")
                .first()
                .addClass("active"),
              r()('.custom-build__step[data-id="chain"]').hide(),
              r()('.custom-build__step[data-id="charm"]').show(),
              d <= 1)
            )
              r()(".variant__btn").removeClass("active");
            else {
              r()('.variant__btn[data-p-id="'.concat(i, '"]')).removeClass(
                "active"
              );
              var p = t.customProduct.filter(function (e) {
                return "chain" === e.type;
              });
              if (p.length >= d) {
                var f = p[p.length - 1].id;
                r()(".chain").each(function (e, t) {
                  r()(t).attr("id") === f &&
                    (r()(t).find(".custom-card__input").prop("checked", !1),
                    r()(t).find(".variant__btn").removeClass("active"),
                    r()(t).find(".variant__btn").length > 1 &&
                      r()(t).find(".custom-card__input").attr("disabled", !0));
                });
              }
            }
            n.addClass("active"),
              u.attr("disabled", !1),
              u.prop("checked") || u.click(),
              u.prop("checked") &&
                (t.pickItem.call(t, [
                  u,
                  {
                    limit: d,
                    type: "chain",
                    id: "chain-product-".concat(i),
                    price: a,
                    discountPrice: o,
                    vId: s,
                  },
                ]),
                d <= 1 &&
                  u
                    .parent(".chain")
                    .siblings(".chain")
                    .find(".custom-card__input")
                    .prop("checked", !1),
                c > 1 && u.attr("disabled", !0));
          }),
          r()(".radio-btn").on("click", function (e) {
            var n = r()(e.currentTarget).parents(".custom-card"),
              i = n.attr("id"),
              s = n.find(".variant__btn"),
              a = n.find(".custom-card__input");
            a.is(":checked") &&
              s.length > 1 &&
              (a.attr("disabled", !1),
              t.removeItem(i),
              a.prop("checked", !1),
              r()(s).removeClass("active"),
              a.attr("disabled", !0));
          }),
          r()(".charm .custom-card__input").on("change", function (e) {
            var n = r()(e.currentTarget),
              i = n.parent(".charm"),
              s = i.find(".variant__btn").length,
              a = i.attr("id"),
              o = t.customProduct.filter(function (e) {
                return "charm" === e.type;
              });
            if (o.length >= 5) {
              var l = o[o.length - 1].id;
              r()(".charm").each(function (e, t) {
                r()(t).attr("id") === l &&
                  (r()(t).find(".custom-card__input").prop("checked", !1),
                  r()(t).find(".variant__btn").removeClass("active"));
              });
            }
            var c = 0,
              u = null,
              d = n.data("v-id");
            n.is(":checked")
              ? (s <= 1 &&
                  (i.find(".variant__btn").addClass("active"),
                  (c = Number(i.find(".variant__btn").data("price"))),
                  (u = Number(i.find(".variant__btn").data("discount-price"))),
                  (d = i.find(".variant__btn").data("v-id"))),
                t.pickItem.call(t, [
                  n,
                  {
                    limit: 5,
                    type: "charm",
                    id: a,
                    price: c,
                    discountPrice: u,
                    vId: d,
                  },
                ]))
              : n.is(":checked") ||
                (t.removeItem(a),
                i.find(".variant__btn").removeClass("active"));
          }),
          r()(".charm .variant__btn").on("click", function (e) {
            var n = r()(e.currentTarget),
              i = n.parents(".charm").find(".variant__btn").length,
              s = n.data("p-id"),
              a = n.data("v-id"),
              o = n.data("price"),
              l = n.data("discount-price"),
              c = r()("#charm-product-".concat(s, "-checkbox"));
            if (
              (n.siblings(".variant__btn").removeClass("active"),
              n.addClass("active"),
              c.attr("disabled", !1),
              c.prop("checked", !0),
              c.prop("checked"))
            ) {
              var u = t.customProduct.filter(function (e) {
                return "charm" === e.type;
              });
              if (u.length >= 5) {
                var d = u[u.length - 1].id;
                r()(".charm").each(function (e, t) {
                  r()(t).attr("id") === d &&
                    r()(t).find(".custom-card__input").prop("checked", !1);
                });
              }
              t.pickItem.call(t, [
                c,
                {
                  limit: 5,
                  type: "charm",
                  id: "charm-product-".concat(s),
                  price: o,
                  discountPrice: l,
                  vId: a,
                },
              ]),
                i > 1 && c.attr("disabled", !0);
            }
          }),
          r()(".charm-headers a").on("click", function (e) {
            var n = r()(e.currentTarget),
              i = n.parents(".charm-headers"),
              s = n.data("category");
            i.find("a").removeClass("active"),
              n.addClass("active"),
              r()(".custom-card.charm").hide(),
              "category-all" === s
                ? r()(
                    '.custom-card.charm[data-thickness="'.concat(
                      t.thickness,
                      '"]'
                    )
                  ).show()
                : r()(
                    ".custom-card.charm."
                      .concat(s, '[data-thickness="')
                      .concat(t.thickness, '"]')
                  ).show();
          }),
          r()("#engrave-text").on("keyup", function () {
            r()(".custom-engrave-head")
              .find(".char-counter > span")
              .text(15 - r()(this).val().length);
          }),
          r()("#engrave-instructions-text").on("keyup", function () {
            r()(".custom-engrave-instructions")
              .find(".char-counter > span")
              .text(25 - r()(this).val().length);
          }),
          r()(document).on("click", ".open-engrave", function (e) {
            var t = r()(e.currentTarget).parents(".charm").attr("id");
            r()("#engrave-text").val(""),
              r()("#font-type").val("Helvetica"),
              r()("#engrave-instructions-text").val(""),
              r()(".custom-engrave-head").find(".char-counter > span").text(15),
              r()(".custom-engrave-instructions")
                .find(".char-counter > span")
                .text(25),
              r()(".custom-engrave-modal").attr("data-pr-id", t),
              r()(".close-engrave").attr("data-pr-id", t),
              r()(".custom-engrave-modal-wrapper").show();
          }),
          r()(".custom-engrave-modal").on("submit", function (e) {
            e.preventDefault();
            var n = r()(e.currentTarget),
              i = n.data("pr-id"),
              s = n.serializeArray(),
              a = t.customProduct.findIndex(function (e) {
                return e.id === i;
              });
            a > -1 && (t.customProduct[a].properties = s),
              t.addToCart(),
              r()(".custom-engrave-modal-wrapper").hide();
          }),
          r()(".close-engrave").on("click", function (e) {
            var n = r()(e.currentTarget).data("pr-id"),
              i = r()("#".concat(n));
            t.removeItem(n),
              i.find(".variant__btn").removeClass("active"),
              i.find(".custom-card__input").prop("checked", !1),
              r()(".custom-engrave-modal").removeAttr("data-pr-id"),
              r()(".close-engrave").removeAttr("data-pr-id"),
              r()(".custom-engrave-modal-wrapper").hide();
          });
      }
      var t, n, i;
      return (
        (t = e),
        (n = [
          {
            key: "init",
            value: function () {
              r()(".custom-build__nav-link").on("click", function () {
                var e = r()(this).attr("href").replace("#", "");
                r()(".custom-build__step").each(function (t, n) {
                  r()(n).data("id") === e
                    ? r()(n).fadeIn(0)
                    : r()(n).fadeOut(0);
                });
              }),
                this.calcTotalPrice(),
                this.sortCharms(),
                r()(".custom-plp-atcBtn").attr("disabled", !0);
            },
          },
          {
            key: "pickItem",
            value: function (e) {
              var t = tl(e, 2),
                n = t[0],
                i = t[1],
                r = n.parent().find(".custom-card__img").attr("src"),
                s = i.id,
                a = i.price,
                o = i.discountPrice,
                l = i.vId,
                c = this.customProduct.filter(function (e) {
                  return e.type === i.type;
                }),
                u = c.find(function (e) {
                  return e.type === i.type && e.id === s;
                });
              if (u)
                return (
                  (this.customProduct = this.customProduct.map(function (e) {
                    return e.id === u.id
                      ? Zo(
                          Zo({}, e),
                          {},
                          {
                            price: a,
                            vId: l,
                          }
                        )
                      : e;
                  })),
                  this.calcTotalPrice(),
                  void this.addToCart()
                );
              var d = c.length - 1;
              c.length < i.limit
                ? this.customProduct.push({
                    img: r,
                    type: i.type,
                    id: s,
                    price: a,
                    discountPrice: o,
                    vId: l,
                  })
                : (c.splice(d, 1, {
                    img: r,
                    type: i.type,
                    id: s,
                    price: a,
                    vId: l,
                  }),
                  (this.customProduct = this.customProduct
                    .filter(function (e) {
                      return e.type !== i.type;
                    })
                    .concat(c))),
                this.customProduct.length &&
                  (this.renderPickedElements(), this.updateNavLinkStatus()),
                this.toggleTextContent(),
                this.activeAtcBtn(),
                this.addToCart();
            },
          },
          {
            key: "renderPickedElements",
            value: function () {
              var e = r()(".charms"),
                t = r()(".chains"),
                n = this.customProduct.filter(function (e) {
                  return "charm" === e.type;
                }),
                i = this.customProduct.filter(function (e) {
                  return "chain" === e.type;
                });

              function s(e) {
                var t = "",
                  n = e
                    .map(function (e, n) {
                      if (0 !== n)
                        return '<img class="'
                          .concat(
                            e.type + "_img " + e.type + "_img-" + n,
                            '" src="'
                          )
                          .concat(e.img, '" id="')
                          .concat(e.id, '-image" alt="')
                          .concat(e.type, '">');
                      t += '<img class="first-img '
                        .concat(
                          e.type + "_img " + e.type + "_img-" + n,
                          '" src="'
                        )
                        .concat(e.img, '" id="')
                        .concat(e.id, '-image" alt="')
                        .concat(e.type, '">');
                    })
                    .join("");
                return "".concat(t, '<div class="group">').concat(n, "</div>");
              }
              t.html(s(i)),
                e.html(s(n)),
                this.calcTotalPrice(),
                this.addToCart();
            },
          },
          {
            key: "toggleTextContent",
            value: function () {
              this.customProduct.filter(function (e) {
                return "metal" !== e.type;
              })
                ? r()(".custom-build__text span").hide(0)
                : r()(".custom-build__text span").fadeIn(0);
            },
          },
          {
            key: "updateNavLinkStatus",
            value: function () {
              var e = this;
              r()(".custom-build__nav-link").each(function (t, n) {
                var i,
                  s = r()(n).attr("href").replace("#", ""),
                  a =
                    ((i = s),
                    e.customProduct.some(function (e) {
                      return e.type === i;
                    })),
                  o = r()(n).parent().next().find(".custom-build__nav-link");
                a
                  ? (r()(n).addClass("filled"), o.addClass("allowed"))
                  : (r()(n).removeClass("filled"), o.removeClass("allowed"));
              });
            },
          },
          {
            key: "removeItem",
            value: function (e) {
              (this.customProduct = this.customProduct.filter(function (t) {
                return t.id !== e;
              })),
                this.renderPickedElements(),
                this.updateNavLinkStatus(),
                this.toggleTextContent(),
                this.activeAtcBtn();
            },
          },
          {
            key: "calcTotalPrice",
            value: function () {
              var e = this.customProduct.filter(function (e) {
                  return "metal" !== e.type;
                }),
                t =
                  e.reduce(function (e, t) {
                    return e + t.price;
                  }, 0) / 100,
                n =
                  e.reduce(function (e, t) {
                    return (
                      t.discountPrice
                        ? (e += parseFloat(t.discountPrice))
                        : (e += t.price),
                      e
                    );
                  }, 0) / 100;
              n < t
                ? r()("#total-price").html(
                    "$".concat(n, " <del>$").concat(t, "</del>")
                  )
                : r()("#total-price").html("$".concat(t));
            },
          },
          {
            key: "addToCart",
            value: function () {
              var e = this.customProduct
                .filter(function (e) {
                  return "metal" !== e.type;
                })
                .map(function (e) {
                  var t = "",
                    n = e.id.replace(/[^0-9]+/, "");
                  return (
                    (t += '<input class="'
                      .concat(
                        e.type,
                        '-input" type="hidden" name="items[][id]" data-pId="'
                      )
                      .concat(n, '" value="')
                      .concat(e.vId, '">')),
                    e.properties &&
                      e.properties.forEach(function (i) {
                        var r = i.name,
                          s = i.value;
                        t += '<input class="'
                          .concat(
                            e.type,
                            '-input" type="hidden" name="items[][properties]['
                          )
                          .concat(r, ']" data-pId="')
                          .concat(n, '" value="')
                          .concat(s, '">');
                      }),
                    t
                  );
                })
                .join("");
              r()("#addToCartInput-group").html(e);
            },
          },
          {
            key: "activeAtcBtn",
            value: function () {
              Array.from(r()(".custom-build__nav-link"))
                .slice(0, -1)
                .every(function (e) {
                  return r()(e).hasClass("filled");
                })
                ? r()(".custom-plp-atcBtn")
                    .removeClass("disabled")
                    .attr("disabled", !1)
                : r()(".custom-plp-atcBtn")
                    .addClass("disabled")
                    .attr("disabled", !0);
            },
          },
          {
            key: "sortCharms",
            value: function () {
              r()(".charms-products").each(function (e, t) {
                r()(t)
                  .find(".custom-card.charm")
                  .sort(function (e, t) {
                    return r()(e).find(".pr-title").text() <
                      r()(t).find(".pr-title").text()
                      ? -1
                      : 1;
                  })
                  .appendTo(r()(t).find(".custom-build__step-inner-row"));
              });
            },
          },
        ]) && il(t.prototype, n),
        i && il(t, i),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })();
    (window.$ = r.a),
      r()(document).ready(function () {
        new a.a();
        new Te(), new Se();
        var e = new h();
        new u(),
          new Ho(),
          new Wo(),
          new Go(),
          new rl(),
          e.init(),
          me.initPromoBar(),
          me.initHeroSlider(),
          me.initCollectionCarousel(),
          me.shopBundleCarousel(),
          me.initJournalCarousel(),
          me.initPdpCarousel(),
          me.initPdpPairCarousel(),
          me.initRecentViewSlider(),
          me.initShopBundle(),
          me.initInstagram(),
          me.initCartCarousel(),
          me.initShopLookCarousel(),
          me.initLocations(),
          me.initBoutiqueSlider(),
          (window.initRecentViewSlider = function () {
            me.initRecentViewSlider();
          }),
          new xe(),
          new Yo(),
          r()(".js-filter").on("click", function () {
            r()(".plp .sidebar").fadeToggle();
          }),
          r()(".filter__close").on("click", function () {
            r()(".plp .sidebar").fadeOut();
          }),
          new ve({
            ele: ".sidebar__item",
            accHead: ".sidebar__head",
            accBody: ".sidebar__nav",
            activeClass: "sidebar__item--open",
            showOne: !1,
          }),
          new ve({
            ele: ".accordion",
            accHead: ".accordion__head",
            accBody: ".accordion__body",
            activeClass: "open",
            showOne: !0,
          });
        var t = r()(".header__main").outerHeight();
        r()(".layout-nav__link").click(function () {
          if (
            location.pathname.replace(/^\//, "") ==
              this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
          ) {
            var e = r()(this.hash);
            if (
              (e = e.length ? e : r()("[name=" + this.hash.slice(1) + "]"))
                .length
            )
              return (
                r()("html,body").animate(
                  {
                    scrollTop: e.offset().top - t,
                  },
                  1e3
                ),
                !1
              );
          }
        }),
          r()("#toTop").on("click", function () {
            r()("html, body").animate(
              {
                scrollTop: 0,
              },
              1e3
            );
          }),
          r()(document).on("click", ".modal", function (e) {
            r()(e.target).closest(".modal__content").length ||
              r()(this).fadeOut();
          });
      }),
      r()(window).on("load", function () {
        var e = r()(".currency-selector__dropdown"),
          t = e.val();
        e.selectric({
          disableOnMobile: !1,
          nativeOnMobile: !1,
          onBeforeOpen: function (e) {
            t = r()(e).val();
          },
          onChange: function (e) {
            var n = r()(e).val();
            n != t && ((t = n), r()(e).trigger("change"));
          },
        });
      });
  },
]);

if (!customElements.get("rm-image")) {
  customElements.define(
    "rm-image",
    class RMimage extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector("img");
        if (this.image?.complete) {
          this.fadeIn();
        } else {
          let counter = 0;
          let image_checker = setInterval(() => {
            this.image = this.querySelector("img");
            if (this.image?.complete) {
              this.fadeIn();
              clearInterval(image_checker);
            }
            counter += 1;
            if (counter == 300) {
              this.fadeIn();
              clearInterval(image_checker);
            }
          }, 10);
        }
      }
      fadeIn() {
        if (this.isInViewport(this.image)) {
          this.classList.add("loaded");
        } else {
          const options = {
            root: null, // set document viewport as root
            rootMargin: "0px", // margin around root
            threshold: 0.1, // 1.0 means that when 100% of the target is visible
            //inside the root, then observer callback is invoked.
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio > 0) {
                this.classList.add("loaded");
              }
            });
          }, options);
          observer.observe(this);
        }
      }
      isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const elem_top = rect.top;
        const elem_bottom = elem_top + element.offsetHeight;
        const screen_top = window.scrollY;
        const screen_bottom = window.scrollY + window.innerHeight;
        var in_view = false;
        if (
          elem_top >= screen_top &&
          elem_top <= screen_bottom &&
          rect.top > 0
        ) {
          in_view = true;
        } else if (
          elem_bottom <= screen_bottom &&
          elem_bottom > screen_top &&
          rect.top > 0
        ) {
          in_view = true;
        }
        return in_view;
      }
    }
  );
}
if (!customElements.get("video-media")) {
  customElements.define("video-media",class VideoMedia extends HTMLElement {
    constructor() {
      super();
      this.posterImages = this.querySelectorAll('.poster-image');
      this.mobileVideo = this.querySelector('video.mobile, .mobile video');
      this.desktopVideo = this.querySelector('video.desktop, .desktop video');
      this.videos = this.querySelectorAll('video');
      this.muteControl = this.querySelector('.control-container');

      if (this.muteControl != undefined) {
        this.muteControl.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (window.clientWidth > 768) {
            this.desktopVideo.muted = (this.dataset.muteState == "true") ? false : true;
          } else {
            this.mobileVideo.muted = (this.dataset.muteState == "true") ? false : true;
          }
          // e.currentTarget.muted = (this.dataset.muteState == "true") ? false : true;
          this.dataset.muteState = (this.dataset.muteState == "true") ? false : true;
          console.log("click")
        })
      }
      this.posterImages.forEach((poster) => {
          poster.addEventListener('click', () => {
              if (Array.from(poster.classList).includes('mobile')) {
                  this.mobileVideo?.play();
              } else if (Array.from(poster.classList).includes('desktop')) {
                  this.desktopVideo?.play();
              } else {
                  this.querySelector('video')?.play();
              }
              poster.style.display = "none";
            
          })
      })

      this.videos.forEach(video => {
        video.volume = parseFloat(this.dataset.volume) / 100;
        if (video.getAttribute('autoplayvideo') == "true" && video.getAttribute('autoplay') != "true") {
          video.muted = true;
          this.observeVideo(video);
        }
        if (video.getAttribute('autoplayvideo') == "true") {
          video.closest('.rm-image-columns__video-container')?.classList.add('interactable');
          video.addEventListener('click', this.toggleMute.bind(this));
        }
      });
    }

    toggleMute(e) {
      e.currentTarget.muted = (this.dataset.muteState == "true") ? false : true;
      this.dataset.muteState = (this.dataset.muteState == "true") ? false : true;
    }

    observeVideo(video) {
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play?.().catch(() => {});
            observerInstance.unobserve(video);
          }
        });
      }, { rootMargin: "200px 0px" });

      observer.observe(video);
    }
  })
}
document.addEventListener("DOMContentLoaded", function () {
  initBIS();
  initAutoPlayVideo();

  function initBIS() {
    let BIS_trigger_buttons = document.querySelectorAll(
      ".BIS_trigger, [data-soldout-button]"
    );
    let counter = 0;
    let checker = setInterval(() => {
      counter += 1;
      if (typeof BIS !== "undefined") {
        console.log("CLEAR BIS");
        // BIS.popup.show()
        clearInterval(checker);
        BIS_trigger_buttons.forEach(function (button) {
          button.removeAttribute("disabled");
        });
      }
      if (counter == 500) {
        console.log("BIS not found");
        clearInterval(checker);
      }
    }, 100);

  }
});

function initAutoPlayVideo() {
  let videos = document.querySelectorAll('video[autoplay="autoplay"]');
  videos.forEach((video) => {
    if (video.paused || video.ended) {
      video.play();
    }
  });
}